export const zh = {
  "0x000030": {
    "description": "关节1运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节1运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节1运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x000031": {
    "description": "关节1到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节1到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节1到达正软限位",
    "isShowConfirm": "1"
  },
  "0x000032": {
    "description": "关节1到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节1到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节1到达负软限位",
    "isShowConfirm": "1"
  },
  "0x000033": {
    "description": "关节1即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节1到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节1即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x000034": {
    "description": "关节1即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节1到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节1即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x000035": {
    "description": "JOG目标位置超过关节1正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节1正软限位",
    "isShowConfirm": "1"
  },
  "0x000036": {
    "description": "JOG目标位置超过关节1负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节1负软限位",
    "isShowConfirm": "1"
  },
  "0x000037": {
    "description": "关节1加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节1加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节1加速度过大",
    "isShowConfirm": "1"
  },
  "0x000042": {
    "description": "关节1即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节1即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x000061": {
    "description": "关节1检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节1检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节1检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x000200": {
    "description": "安装角度设置超过阈值",
    "type": "0",
    "isShowOTA": "0",
    "reason": "安装角度设置超过阈值",
    "action": "请检查安装角度并重新设置。",
    "tittle": "安装角度设置超过阈值",
    "isShowConfirm": "0"
  },
  "0x000250": {
    "description": "当前无法设置轨迹规划器",
    "type": "0",
    "isShowOTA": "0",
    "reason": "当前无法设置轨迹规划器",
    "action": "请稍后重试。",
    "tittle": "当前无法设置轨迹规划器",
    "isShowConfirm": "0"
  },
  "0x000350": {
    "description": "当前不在SERVO模式中",
    "type": "0",
    "isShowOTA": "0",
    "reason": "当前不在SERVO模式中",
    "action": "请先进入SERVO模式后，再尝试当前操作。",
    "tittle": "当前不在SERVO模式中",
    "isShowConfirm": "0"
  },
  "0x000351": {
    "description": "不可以在SERVO模式中设置滤波器。",
    "type": "0",
    "isShowOTA": "0",
    "reason": "不可以在SERVO模式中设置滤波器。",
    "action": "请先退出SERVO模式后，再尝试设置滤波器。",
    "tittle": "不可以在SERVO模式中设置滤波器。",
    "isShowConfirm": "0"
  },
  "0x000352": {
    "description": "SERVO指令参数无效",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVO指令参数无效",
    "action": "请确认参数是否在范围内后再重新设置。",
    "tittle": "SERVO指令参数无效",
    "isShowConfirm": "0"
  },
  "0x000353": {
    "description": "SERVO滤波器参数无效",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVO滤波器参数无效",
    "action": "请确认参数是否在范围内后再重新设置。",
    "tittle": "SERVO滤波器参数无效",
    "isShowConfirm": "0"
  },
  "0x000400": {
    "description": "IO序号超过范围",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IO序号超过范围",
    "action": "请确认参数是否在范围内后再重新设置",
    "tittle": "IO序号超过范围",
    "isShowConfirm": "0"
  },
  "0x000401": {
    "description": "IO类型超过范围",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IO类型超过范围",
    "action": "请确认参数是否在范围内后再重新设置",
    "tittle": "IO类型超过范围",
    "isShowConfirm": "0"
  },
  "0x000450": {
    "description": "别名已经存在",
    "type": "0",
    "isShowOTA": "0",
    "reason": "别名已经存在",
    "action": "请检查并重新设置。",
    "tittle": "别名已经存在",
    "isShowConfirm": "0"
  },
  "0x000500": {
    "description": "碰撞等级超过范围",
    "type": "0",
    "isShowOTA": "0",
    "reason": "碰撞等级超过范围",
    "action": "请确认参数是否在范围内后再重新设置。",
    "tittle": "碰撞等级超过范围",
    "isShowConfirm": "0"
  },
  "0x000550": {
    "description": "逆解失败",
    "type": "0",
    "isShowOTA": "0",
    "reason": "逆解失败",
    "action": "请检查点位等相关参数后重试。",
    "tittle": "逆解失败",
    "isShowConfirm": "0"
  },
  "0x001002": {
    "description": "关节1CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节1CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x001003": {
    "description": "关节 1 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 1 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x001004": {
    "description": "关节1 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0x010030": {
    "description": "关节2运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节2运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节2运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x010031": {
    "description": "关节2到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节2到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节2到达正软限位",
    "isShowConfirm": "1"
  },
  "0x010032": {
    "description": "关节2到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节2到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节2到达负软限位",
    "isShowConfirm": "1"
  },
  "0x010033": {
    "description": "关节2即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节2到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节2即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x010034": {
    "description": "关节2即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节2到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节2即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x010035": {
    "description": "JOG目标位置超过关节2正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节2正软限位",
    "isShowConfirm": "1"
  },
  "0x010036": {
    "description": "JOG目标位置超过关节2负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节2负软限位",
    "isShowConfirm": "1"
  },
  "0x010037": {
    "description": "关节2加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节2加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节2加速度过大",
    "isShowConfirm": "1"
  },
  "0x010042": {
    "description": "关节2即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节2即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x010061": {
    "description": "关节2检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节2检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节2检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x011002": {
    "description": "关节2CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节2CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x011003": {
    "description": "关节 2 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 2 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x011004": {
    "description": "关节2 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0x020030": {
    "description": "关节3运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节3运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节3运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x020031": {
    "description": "关节3到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节3到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节3到达正软限位",
    "isShowConfirm": "1"
  },
  "0x020032": {
    "description": "关节3到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节3到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节3到达负软限位",
    "isShowConfirm": "1"
  },
  "0x020033": {
    "description": "关节3即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节3到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节3即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x020034": {
    "description": "关节3即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节3到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节3即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x020035": {
    "description": "JOG目标位置超过关节3正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节3正软限位",
    "isShowConfirm": "1"
  },
  "0x020036": {
    "description": "JOG目标位置超过关节3负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节3负软限位",
    "isShowConfirm": "1"
  },
  "0x020037": {
    "description": "关节3加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节3加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节3加速度过大",
    "isShowConfirm": "1"
  },
  "0x020042": {
    "description": "关节3即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节3即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x020061": {
    "description": "关节3检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节3检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节3检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x021002": {
    "description": "关节3CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节3CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x021003": {
    "description": "关节 3 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 3 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x021004": {
    "description": "关节3 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0x030030": {
    "description": "关节4运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节4运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节4运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x030031": {
    "description": "关节4到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节4到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节4到达正软限位",
    "isShowConfirm": "1"
  },
  "0x030032": {
    "description": "关节4到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节4到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节4到达负软限位",
    "isShowConfirm": "1"
  },
  "0x030033": {
    "description": "关节4即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节4到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节4即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x030034": {
    "description": "关节4即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节4到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节4即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x030035": {
    "description": "JOG目标位置超过关节4正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节4正软限位",
    "isShowConfirm": "1"
  },
  "0x030036": {
    "description": "JOG目标位置超过关节4负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节4负软限位",
    "isShowConfirm": "1"
  },
  "0x030037": {
    "description": "关节4加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节4加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节4加速度过大",
    "isShowConfirm": "1"
  },
  "0x030042": {
    "description": "关节4即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节4即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x030061": {
    "description": "关节4检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节4检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节4检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x031002": {
    "description": "关节4CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节4CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x031003": {
    "description": "关节 4 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 4 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x031004": {
    "description": "关节4 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0x040030": {
    "description": "关节5运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节5运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节5运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x040031": {
    "description": "关节5到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节5到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节5到达正软限位",
    "isShowConfirm": "1"
  },
  "0x040032": {
    "description": "关节5到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节5到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节5到达负软限位",
    "isShowConfirm": "1"
  },
  "0x040033": {
    "description": "关节5即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节5到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节5即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x040034": {
    "description": "关节5即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节5到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节5即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x040035": {
    "description": "JOG目标位置超过关节5正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节5正软限位",
    "isShowConfirm": "1"
  },
  "0x040036": {
    "description": "JOG目标位置超过关节5负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节5负软限位",
    "isShowConfirm": "1"
  },
  "0x040037": {
    "description": "关节5加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节5加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节5加速度过大",
    "isShowConfirm": "1"
  },
  "0x040042": {
    "description": "关节5即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节5即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x040061": {
    "description": "关节5检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节5检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节5检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x041002": {
    "description": "关节5CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节5CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x041003": {
    "description": "关节 5 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 5 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x041004": {
    "description": "关节5 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0x050030": {
    "description": "关节6运动速度超过限制",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节6运动速度超过限制。该错误一般在控制器下发指令超出关节实际限速时报错。",
    "action": "1.请确认当前机器人的速度约束是否被人为修改提高过，是的话联系JAKA技术人员\n2.如果未修改过但报错，请确认降低速度或加速度约束是否能够消除现象；如果仍然出现，请将相应诊断信息导出，并联系JAKA技术服务人员。",
    "tittle": "关节6运动速度超过限制",
    "isShowConfirm": "1"
  },
  "0x050031": {
    "description": "关节6到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节6到达正软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节6到达正软限位",
    "isShowConfirm": "1"
  },
  "0x050032": {
    "description": "关节6到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节6到达负软限位，机器人运动过程中触发机器人限位。",
    "action": "请检查机器人对应关节角度值，是否已到达限位。如是请修改作业路径。",
    "tittle": "关节6到达负软限位",
    "isShowConfirm": "1"
  },
  "0x050033": {
    "description": "关节6即将到达正软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节6到达正软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节6即将到达正软限位",
    "isShowConfirm": "1"
  },
  "0x050034": {
    "description": "关节6即将到达负软限位",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节6到达负软限位附近,若继续运行机器人,将触发机器人限位。",
    "action": "请检查机器人目标点位所对应的关节角度值是否已到达限位。如是请修改作业路径",
    "tittle": "关节6即将到达负软限位",
    "isShowConfirm": "1"
  },
  "0x050035": {
    "description": "JOG目标位置超过关节6正软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节6正软限位",
    "isShowConfirm": "1"
  },
  "0x050036": {
    "description": "JOG目标位置超过关节6负软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行运动，当运动的目标点超出机器人关节设置的限位值时，会出现此报警",
    "action": "1.请检查机器人安全设置中关节限位值是否被修改。\n2.请检查目标点是否合理，若不合理，请修改目标点位置。",
    "tittle": "JOG目标位置超过关节6负软限位",
    "isShowConfirm": "1"
  },
  "0x050037": {
    "description": "关节6加速度过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手动控制（JOG）机器人进行笛卡尔空间运动时，引起关节6加速度过大。",
    "action": "1.请使机器人关节运动远离报错位置，再尝试笛卡尔空间JOG。",
    "tittle": "关节6加速度过大",
    "isShowConfirm": "1"
  },
  "0x050042": {
    "description": "关节6即将达到软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6即将达到软限位。",
    "action": "检查当前机器人关节状态，是否即将到达关节限位，建议往非超限方向运动，请在示教页面将即将超限关节jog回关节限位范围内，或在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "关节6即将达到软限位",
    "isShowConfirm": "1"
  },
  "0x050061": {
    "description": "关节6检测到碰撞并停止运动",
    "type": "2",
    "isShowOTA": "1",
    "reason": "关节6检测到碰撞并停止运动",
    "action": "1.检查现场环境，确实是否发生了真实的碰撞。如是，请优化作业程序；\n2.如果发生误报碰撞，请检查负载、安装角度是否设置正确；\n3.手动控制报错关节运动检查对应关节是否存在内部卡塞。",
    "tittle": "关节6检测到碰撞并停止运动",
    "isShowConfirm": "1"
  },
  "0x051002": {
    "description": "关节6CAN连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6CAN总线异常导致数据获取失败或超时导致报错提示",
    "action": "1.将机器人下电下使能，打开报错关节闷盖，检查关节内部CAN线是否存在异常。\n2.请联系技术人员咨询。",
    "tittle": "关节6CAN连接异常",
    "isShowConfirm": "1"
  },
  "0x051003": {
    "description": "关节 6 驱动器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体上电后，关节一驱动板无信号返回控制器",
    "action": "App监控界面查看关节一的监控电压、电流、温度是否存在数据显示，当本体上电正常时存在数值显示情况，若无数值显示请联系技术人员协助处理。",
    "tittle": "关节 6 驱动器故障",
    "isShowConfirm": "1"
  },
  "0x051004": {
    "description": "关节6 跟随误差过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6 跟随误差过大",
    "isShowConfirm": "1"
  },
  "0xE0000": {
    "description": "没有错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "没有错误",
    "action": "没有错误",
    "tittle": "没有错误",
    "isShowConfirm": "0"
  },
  "0xE0001": {
    "description": "gRPC调用异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "gRPC调用异常",
    "action": "请联系JAKA技术人员咨询。",
    "tittle": "gRPC调用异常",
    "isShowConfirm": "0"
  },
  "0xE0002": {
    "description": "密码错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "登录（登出）失败，密码错误",
    "action": "请检查密码输入是否正确，输入错误请重新输入正确的密码",
    "tittle": "密码错误",
    "isShowConfirm": "0"
  },
  "0xE0003": {
    "description": "用户名错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "登录（登出）失败，用户名错误",
    "action": "请检查用户名输入是否正确，输入错误请重新输入正确的用户名。",
    "tittle": "用户名错误",
    "isShowConfirm": "0"
  },
  "0xE0004": {
    "description": "重复登录",
    "type": "1",
    "isShowOTA": "1",
    "reason": "重复登录",
    "action": "请确认在别的终端已下线后再登录。",
    "tittle": "重复登录",
    "isShowConfirm": "0"
  },
  "0xE0005": {
    "description": "用户尚未登录",
    "type": "1",
    "isShowOTA": "1",
    "reason": "用户尚未登录",
    "action": "请登录用户名和密码后再执行操作。",
    "tittle": "用户尚未登录",
    "isShowConfirm": "0"
  },
  "0xE0006": {
    "description": "关节最小限位太小或者最大限位太大或者最小限位大于最大限位。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节最小限位太小或者最大限位太大或者最小限位大于最大限位。",
    "action": "请调整关节限位至合适位置后再进行操作。",
    "tittle": "关节限位异常",
    "isShowConfirm": "0"
  },
  "0xE0007": {
    "description": "运动学逆解失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "运动学逆解失败",
    "action": "机器人逆解失败，请重新示教机器人。",
    "tittle": "运动学逆解失败",
    "isShowConfirm": "0"
  },
  "0xE0008": {
    "description": "运动学正解失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "运动学正解失败",
    "action": "请联系JAKA技术人员咨询。",
    "tittle": "运动学正解失败",
    "isShowConfirm": "0"
  },
  "0xE0009": {
    "description": "找不到文件或者文件夹",
    "type": "1",
    "isShowOTA": "1",
    "reason": "找不到文件或者文件夹",
    "action": "请确认文件或者文件夹存在后再操作。",
    "tittle": "找不到文件或者文件夹",
    "isShowConfirm": "0"
  },
  "0xE000A": {
    "description": "MD5检测没有匹配",
    "type": "1",
    "isShowOTA": "1",
    "reason": "MD5检测没有匹配",
    "action": "请检查MD5校验是否正确。",
    "tittle": "MD5检测没有匹配",
    "isShowConfirm": "0"
  },
  "0xE000B": {
    "description": "计算工具中心点失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "计算工具中心点失败",
    "action": "工具坐标系计算错误，请检查设置的工具坐标系是否正确",
    "tittle": "计算工具中心点失败",
    "isShowConfirm": "0"
  },
  "0xE000C": {
    "description": "无效的参数",
    "type": "1",
    "isShowOTA": "1",
    "reason": "无效的参数",
    "action": "参数不正确，请修改为正确的参数后进行操作。",
    "tittle": "无效的参数",
    "isShowConfirm": "0"
  },
  "0xE000D": {
    "description": "太多的输出绑定到相同的状态",
    "type": "1",
    "isShowOTA": "1",
    "reason": "太多的输出绑定到相同的状态",
    "action": "请修改DI、DO状态，使之输出正常。",
    "tittle": "太多的输出绑定到相同的状态",
    "isShowConfirm": "0"
  },
  "0xE000E": {
    "description": "变量别名已存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "变量别名已存在",
    "action": "请重新修改变量别名后再进行操作。",
    "tittle": "变量别名已存在",
    "isShowConfirm": "0"
  },
  "0xE000F": {
    "description": "参数值超出范围",
    "type": "1",
    "isShowOTA": "1",
    "reason": "参数值超出范围",
    "action": "请修改参数值到合适的范围内后再进行操作。",
    "tittle": "参数值超出范围",
    "isShowConfirm": "0"
  },
  "0xE0010": {
    "description": "消息ID超出范围",
    "type": "1",
    "isShowOTA": "1",
    "reason": "消息ID超出范围",
    "action": "请修改消息ID至合适范围内。",
    "tittle": "消息ID超出范围",
    "isShowConfirm": "0"
  },
  "0xE0011": {
    "description": "字符串不应超过16个字符",
    "type": "1",
    "isShowOTA": "1",
    "reason": "字符串不应超过16个字符",
    "action": "请检查字符串长度是否超过了16个字符，修改至16个字符内后再操作。",
    "tittle": "字符串不应超过16个字符",
    "isShowConfirm": "0"
  },
  "0xE0012": {
    "description": "没有操作权限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "没有操作权限",
    "action": "没有操作权限，请重新登录切换权限后再进行操作。",
    "tittle": "没有操作权限",
    "isShowConfirm": "0"
  },
  "0xE0013": {
    "description": "用户权限等级不正确",
    "type": "1",
    "isShowOTA": "1",
    "reason": "用户权限等级不正确",
    "action": "操作权限不够，请重新登录切换权限后再进行操作。",
    "tittle": "用户权限等级不正确",
    "isShowConfirm": "0"
  },
  "0xE0014": {
    "description": "用户名已经存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "用户名已经存在",
    "action": "请修改用户名后再登录。",
    "tittle": "用户名已经存在",
    "isShowConfirm": "0"
  },
  "0xE0015": {
    "description": "升级安装包不正确",
    "type": "1",
    "isShowOTA": "1",
    "reason": "升级安装包不正确",
    "action": "请检查安装包名称是否正确",
    "tittle": "升级安装包不正确",
    "isShowConfirm": "0"
  },
  "0xE0016": {
    "description": "不支持jog坐标系",
    "type": "1",
    "isShowOTA": "1",
    "reason": "不支持jog坐标系",
    "action": "请检查是否支持jog坐标系，修改正确后再进行操作。",
    "tittle": "不支持jog坐标系",
    "isShowConfirm": "0"
  },
  "0xE0017": {
    "description": "当前不支持该模式",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当前不支持该模式",
    "action": "请检查机器人是否支持当前模式，切换至正确的模式后再进行操作。",
    "tittle": "当前不支持该模式",
    "isShowConfirm": "0"
  },
  "0xE0018": {
    "description": "机器人正在移动",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人正在移动",
    "action": "请检查机器人是否正在移动，应使机器人处于停止状态再进行操作。",
    "tittle": "机器人正在移动",
    "isShowConfirm": "0"
  },
  "0xE0019": {
    "description": "作业运行时无法执行作业加载",
    "type": "1",
    "isShowOTA": "1",
    "reason": "作业运行时无法执行作业加载",
    "action": "程序正在运行，停止运行的程序后再打开程序。",
    "tittle": "作业运行时无法执行作业加载",
    "isShowConfirm": "0"
  },
  "0xE001A": {
    "description": "当前引脚被其他功能占用",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当前引脚被其他功能占用",
    "action": "请查看当前引脚是否被其他功能占用。",
    "tittle": "当前引脚被其他功能占用",
    "isShowConfirm": "0"
  },
  "0xE001B": {
    "description": "衰减模式下无法设置各级衰减倍率",
    "type": "1",
    "isShowOTA": "1",
    "reason": "衰减模式下无法设置各级衰减倍率",
    "action": "请查看当前是否处于缩减模式下，应该在非缩减模式下设置各级衰减倍率。",
    "tittle": "衰减模式下无法设置各级衰减倍率",
    "isShowConfirm": "0"
  },
  "0xE001C": {
    "description": "轨迹复现时生成jks脚本失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "轨迹复现时生成jks脚本失败",
    "action": "请查看脚本文件是否正确",
    "tittle": "轨迹复现时生成jks脚本失败",
    "isShowConfirm": "0"
  },
  "0xE001D": {
    "description": "只有一个TIO RS485通道可以使用力矩传感器",
    "type": "1",
    "isShowOTA": "1",
    "reason": "只有一个TIO RS485通道可以使用力矩传感器",
    "action": "请检查TIO RS485通道是否被多个通道使用修改成一个通道后再进行操作。",
    "tittle": "只有一个TIO RS485通道可以使用力矩传感器",
    "isShowConfirm": "0"
  },
  "0xE001E": {
    "description": "力矩传感器通道切换失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "力矩传感器通道切换失败",
    "action": "请检查力矩传感器是否正在工作，停止工作后再进行操作。",
    "tittle": "力矩传感器通道切换失败",
    "isShowConfirm": "0"
  },
  "0xE001F": {
    "description": "机器人流水号不正确",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人流水号不正确",
    "action": "请检查机器人流水号是否正确，修改为正确的机器人流水号后再进行操作",
    "tittle": "机器人流水号不正确",
    "isShowConfirm": "0"
  },
  "0xE0020": {
    "description": "redis服务未启动",
    "type": "1",
    "isShowOTA": "1",
    "reason": "redis服务未启动",
    "action": "请检查redis服务器是否正在运行，确保redis运行后再进行操作。",
    "tittle": "redis服务未启动",
    "isShowConfirm": "0"
  },
  "0xE0021": {
    "description": "未知的机器人模型",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未知的机器人模型",
    "action": "请检查机器人模型是否正确",
    "tittle": "未知的机器人模型",
    "isShowConfirm": "0"
  },
  "0xE0022": {
    "description": "扩展IO模块数量或扩展IO索引超出范围",
    "type": "1",
    "isShowOTA": "1",
    "reason": "扩展IO模块数量或扩展IO索引超出范围\n扩展IO模块数量最大值：8\n扩展IO DI/DO 索引范围： 0~64\n扩展IO AI/AO 索引范围 ：0~31",
    "action": "请检查扩展IO模块或者扩展IO索引号是否正确后再进行操作。",
    "tittle": "扩展IO模块数量或扩展IO索引超出范围",
    "isShowConfirm": "0"
  },
  "0xE0023": {
    "description": "'轨迹记录'指令在单步调试模式下不支持",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'轨迹记录'指令在单步调试模式下不支持",
    "action": "请移除'轨迹记录'指令后再尝试",
    "tittle": "'轨迹记录'指令在单步调试模式下不支持",
    "isShowConfirm": "0"
  },
  "0xE0026": {
    "description": "仿真模式下不允许此操作",
    "type": "1",
    "isShowOTA": "1",
    "reason": "仿真模式下不允许此操作",
    "action": "请退出仿真模式后再试",
    "tittle": "仿真模式下不允许此操作",
    "isShowConfirm": "0"
  },
  "0xE0027": {
    "description": "读取网络配置文件失败。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "读取网络配置文件失败。",
    "action": "请再次尝试设置，若仍出现，联系技术人员检查网络配置文件",
    "tittle": "读取网络配置文件失败",
    "isShowConfirm": "0"
  },
  "0xE0028": {
    "description": "太多的输入绑定到相同的功能",
    "type": "1",
    "isShowOTA": "1",
    "reason": "太多的输入绑定到相同的功能",
    "action": "请检查并修改功能DI配置。",
    "tittle": "太多的输入绑定到相同的功能",
    "isShowConfirm": "0"
  },
  "0xE002A": {
    "description": "程序正在运行，不允许删除文件",
    "type": "1",
    "isShowOTA": "1",
    "reason": "程序正在运行，不允许删除文件",
    "action": "程序正在运行，不允许删除文件",
    "tittle": "程序正在运行，不允许删除文件",
    "isShowConfirm": "0"
  },
  "0xE002B": {
    "description": "导入配置文件失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "导入配置文件失败",
    "action": "导入配置文件失败",
    "tittle": "导入配置文件失败",
    "isShowConfirm": "0"
  },
  "0xE002C": {
    "description": "不支持此功能接口",
    "type": "1",
    "isShowOTA": "1",
    "reason": "不支持此功能接口",
    "action": "不支持此功能接口",
    "tittle": "不支持此功能接口",
    "isShowConfirm": "0"
  },
  "0xE002D": {
    "description": "功能设置失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "功能设置失败",
    "action": "功能设置失败",
    "tittle": "功能设置失败",
    "isShowConfirm": "0"
  },
  "0xE002E": {
    "description": "输入/输出引脚不匹配",
    "type": "1",
    "isShowOTA": "1",
    "reason": "输入/输出引脚不匹配",
    "action": "输入/输出引脚不匹配",
    "tittle": "输入/输出引脚不匹配",
    "isShowConfirm": "0"
  },
  "0xE002F": {
    "description": "获取控制柜磁盘信息失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "磁盘硬件异常或磁盘空间已满",
    "action": "请稍候重试",
    "tittle": "获取控制柜磁盘信息失败",
    "isShowConfirm": "0"
  },
  "0xE0030": {
    "description": "该机器人模型不支持仿真",
    "type": "1",
    "isShowOTA": "1",
    "reason": "该机器人模型不支持仿真",
    "action": "请检查机器人模型是否正确, 或更新控制器版本",
    "tittle": "该机器人模型不支持仿真",
    "isShowConfirm": "0"
  },
  "0xE0031": {
    "description": "用户坐标系标定失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "选择的标定点位不合适导致用户坐标系标定失败。",
    "action": "请重新设置合适的示教点位。",
    "tittle": "用户坐标系标定失败",
    "isShowConfirm": "0"
  },
  "0xE0033": {
    "description": "用户名或密码错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "用户名或密码错误。",
    "action": "请重新输入正确的用户名和密码。",
    "tittle": "用户密码校验失败",
    "isShowConfirm": "0"
  },
  "0xE0034": {
    "description": "获取对齐目标位姿失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "获取对齐目标位姿失败",
    "action": "无法获取对齐目标位姿",
    "tittle": "获取对齐目标位姿失败",
    "isShowConfirm": "0"
  },
  "0xE0064": {
    "description": "检测到碰，请确认环境是否安全。",
    "type": "2",
    "isShowOTA": "1",
    "reason": "检测到碰，请确认环境是否安全。",
    "action": "检测到碰，请确认环境是否安全。",
    "tittle": "检测到碰，请确认环境是否安全。",
    "isShowConfirm": "0"
  },
  "0xE03E8": {
    "description": "AddOn启动数目超过限制",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn启动数目超过限制",
    "action": "AddOn启动数目查过限制，请先清理部分AddOn后再进行操作。",
    "tittle": "AddOn启动数目超过限制",
    "isShowConfirm": "0"
  },
  "0xE03E9": {
    "description": "AddOn服务开启失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn服务开启失败",
    "action": "AddOn服务开启失败，请检查AddOn配置是否正确再进行操作。",
    "tittle": "AddOn服务开启失败",
    "isShowConfirm": "0"
  },
  "0xE03EA": {
    "description": "AddOn服务关闭失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn服务关闭失败",
    "action": "AddOn服务关闭失败，请检查AddOn配置是否正确再进行操作。",
    "tittle": "AddOn服务关闭失败",
    "isShowConfirm": "0"
  },
  "0xE03EB": {
    "description": "配置文件无效",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件无效",
    "action": "请检查AddOn配置文件是否正确后再进行操作。",
    "tittle": "配置文件无效",
    "isShowConfirm": "0"
  },
  "0xE03EC": {
    "description": "AddOn服务不存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn服务不存在",
    "action": "未检测到对应的AddOn，AddOn可能已经被移动或者删除，请刷新后重试。",
    "tittle": "AddOn服务不存在",
    "isShowConfirm": "0"
  },
  "0xE03ED": {
    "description": "AddOn配置不存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn配置不存在",
    "action": "AddOn配置不存在，请确认当前软件版本，并联系JAKA技术服务人员。",
    "tittle": "AddOn配置不存在",
    "isShowConfirm": "0"
  },
  "0xE03EE": {
    "description": "配置文件中 AddOn 规范未知",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中 AddOn 规范未知",
    "action": "未能识别AddOn配置的convention配置项，请检查配置convention是否正确。",
    "tittle": "配置文件中 AddOn 规范未知",
    "isShowConfirm": "0"
  },
  "0xE03EF": {
    "description": "配置文件中AddOn类型错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中AddOn类型错误",
    "action": "未能识别AddOn配置的type配置项，请确认type为1~3范围内的数字。",
    "tittle": "配置文件中AddOn类型错误",
    "isShowConfirm": "0"
  },
  "0xE03F0": {
    "description": "配置文件编程语言错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件编程语言错误",
    "action": "未能识别AddOn配置中的language，请确认language配置是否正确。",
    "tittle": "配置文件编程语言错误",
    "isShowConfirm": "0"
  },
  "0xE03F1": {
    "description": "配置文件中AddOn程序入口错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中AddOn程序入口错误",
    "action": "未能识别AddOn配置中的language，请确保service不为空且service字节数少于50",
    "tittle": "配置文件中AddOn程序入口错误",
    "isShowConfirm": "0"
  },
  "0xE03F2": {
    "description": "配置文件中自启动配置错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中自启动配置错误",
    "action": "未能识别AddOn配置中的serviceenable配置项，请确保serviceenable为True或False",
    "tittle": "配置文件中自启动配置错误",
    "isShowConfirm": "0"
  },
  "0xE03F3": {
    "description": "配置文件缺少必须的配置项",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件缺少必须的配置项",
    "action": "AddOn配置文件中缺少必要的配置项，请检查配置文件是否正确",
    "tittle": "配置文件缺少必须的配置项",
    "isShowConfirm": "0"
  },
  "0xE03F4": {
    "description": "配置文件中AddOn中名称配置出错",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中AddOn中名称配置出错",
    "action": "AddOn配置文件中Name字节数超过40字节，请确认配置正确后重试。",
    "tittle": "配置文件中AddOn中名称配置出错",
    "isShowConfirm": "0"
  },
  "0xE03F5": {
    "description": "配置文件中 AddOn 描述出错",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中 AddOn 描述出错",
    "action": "AddOn配置文件中description字节数超过40字节，请确认配置正确后重试。",
    "tittle": "配置文件中 AddOn 描述出错",
    "isShowConfirm": "0"
  },
  "0xE03F6": {
    "description": "AddOn版本无法识别",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn版本无法识别",
    "action": "未能识别AddOn配置中的version，请确认配置正确后重试。",
    "tittle": "AddOn版本无法识别",
    "isShowConfirm": "0"
  },
  "0xE03F7": {
    "description": "配置文件中AddOn中Url出错",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置文件中AddOn中Url出错",
    "action": "AddOn配置文件中的url解析失败，请确认配置正确后重试。",
    "tittle": "配置文件中AddOn中Url出错",
    "isShowConfirm": "0"
  },
  "0xE03F8": {
    "description": "分配端口号发生异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "分配端口号发生异常",
    "action": "AddOn端口分配失败，请确认配置文件正确后，联系节卡技术人员支持。",
    "tittle": "分配端口号发生异常",
    "isShowConfirm": "0"
  },
  "0xE03F9": {
    "description": "AddOn服务正在运行",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn服务正在运行",
    "action": "AddOn服务正在运行，请先停止后重新当前操作。",
    "tittle": "AddOn服务正在运行",
    "isShowConfirm": "0"
  },
  "0xE03FA": {
    "description": "目录已经存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "目录已经存在",
    "action": "请检查目录是不是已经存在，选择正确的目录后再进行操作。",
    "tittle": "目录已经存在",
    "isShowConfirm": "0"
  },
  "0xE03FB": {
    "description": "IP地址已经存在",
    "type": "1",
    "isShowOTA": "1",
    "reason": "IP地址已经存在",
    "action": "请检查IP地址是否已经存在，修改为正确的IP地址后再进行操作。",
    "tittle": "IP地址已经存在",
    "isShowConfirm": "0"
  },
  "0xE03FC": {
    "description": "计算安全姿态相关参数失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "计算安全姿态相关参数失败",
    "action": "请重新设置工具的安全姿态",
    "tittle": "计算安全姿态相关参数失败",
    "isShowConfirm": "0"
  },
  "0xE044C": {
    "description": "校验文件不匹配",
    "type": "1",
    "isShowOTA": "1",
    "reason": "校验文件不匹配",
    "action": "请检查文件是否配对，或重新下载升级程序",
    "tittle": "校验文件不匹配",
    "isShowConfirm": "0"
  },
  "0xE044D": {
    "description": "密码错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "密码错误",
    "action": "请输入正确的密码",
    "tittle": "密码错误",
    "isShowConfirm": "0"
  },
  "0xE044E": {
    "description": "两次密码输入不一致",
    "type": "1",
    "isShowOTA": "1",
    "reason": "两次密码输入不一致",
    "action": "请两次密码输入一致",
    "tittle": "两次密码输入不一致",
    "isShowConfirm": "0"
  },
  "0xE044F": {
    "description": "首次登录需要重置密码",
    "type": "1",
    "isShowOTA": "1",
    "reason": "首次登录需要重置密码",
    "action": "请重置密码后再进行登录操作。",
    "tittle": "首次登录需要重置密码",
    "isShowConfirm": "0"
  },
  "0xE0450": {
    "description": "修改密码不能与上一次相同",
    "type": "1",
    "isShowOTA": "1",
    "reason": "修改密码不能与上一次相同",
    "action": "请修改为与上次不同的密码。",
    "tittle": "修改密码不能与上一次相同",
    "isShowConfirm": "0"
  },
  "0xE0451": {
    "description": "账户未激活",
    "type": "1",
    "isShowOTA": "1",
    "reason": "账户未激活",
    "action": "账户未激活，请联系设备管理员",
    "tittle": "账户未激活",
    "isShowConfirm": "0"
  },
  "0xE0452": {
    "description": "无法激活账号",
    "type": "1",
    "isShowOTA": "1",
    "reason": "无法激活账号",
    "action": "无法激活账号，错误的账号名称，请联系设备管理员",
    "tittle": "无法激活账号",
    "isShowConfirm": "0"
  },
  "0xE0453": {
    "description": "AddOn正在安装",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn正在安装",
    "action": "AddOn安装进行中，请稍后重试。",
    "tittle": "AddOn正在安装",
    "isShowConfirm": "0"
  },
  "0xE0454": {
    "description": "AddOn安装失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn安装失败",
    "action": "AddOn安装失败，请确认AddOn安装包正确后重试。",
    "tittle": "AddOn安装失败",
    "isShowConfirm": "0"
  },
  "0xE0455": {
    "description": "AddOn包过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn包过大",
    "action": "AddOn安装包过大或包内文件过多，导致安装超时，请减少安装包体积和文件数量后重试。",
    "tittle": "AddOn包过大",
    "isShowConfirm": "0"
  },
  "0xE0456": {
    "description": "错误状态下切换手自动模式。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "错误状态下切换手自动模式。",
    "action": "在错误状态下（机器人在移动、运行程序、拖动中时）切换操作模式。",
    "tittle": "错误状态下切换手自动模式。",
    "isShowConfirm": "0"
  },
  "0xE0457": {
    "description": "输入的字符串中存在不支持的字符。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "输入的字符串中存在不支持的字符。",
    "action": "修改输入的参数后再次尝试。",
    "tittle": "输入的字符串中存在不支持的字符。",
    "isShowConfirm": "0"
  },
  "0xE04B0": {
    "description": "急停状态无法升级",
    "type": "1",
    "isShowOTA": "0",
    "reason": "急停状态无法升级",
    "action": "急停状态无法升级",
    "tittle": "急停状态无法升级",
    "isShowConfirm": "0"
  },
  "0xEFFFF": {
    "description": "未知错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未知错误",
    "action": "请联系JAKA技术人员咨询。",
    "tittle": "未知错误",
    "isShowConfirm": "0"
  },
  "0x0F0001": {
    "description": "机器人本体当前没有通电",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器执行指令时，检测到机器人未上电",
    "action": "确认机器人本体电源是否打开；如果机器人本体电源未打开，请首先打开机器人本体电源",
    "tittle": "机器人本体未上电",
    "isShowConfirm": "1"
  },
  "0x0F0002": {
    "description": "机器人当前没有使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器执行指令时检测到机器人未使能",
    "action": "确认机器人使能是否打开；如果未打开，请先开启机器人使能",
    "tittle": "机器人未使能",
    "isShowConfirm": "1"
  },
  "0x0F0003": {
    "description": "当前模式下无法进行此操作。当前在{0}模式，不允许执行{1}命令",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人在特定的操作模式下，才可以执行某些操作，该操作不属于机器人当前模式的范围内。",
    "action": "先退出当前模式，再进行该操作。",
    "tittle": "当前模式下无法进行此操作",
    "isShowConfirm": "1"
  },
  "0x0F0004": {
    "description": "运动学逆解计算失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运动学逆解计算失败，原因如下：\n1.给定笛卡尔空间位姿超出机器人可达空间；\n2.给定笛卡尔空间位姿在给定的参考角度确定的解空间内无解。",
    "action": "1.在手动界面中进入坐标编辑界面，输入点位信息进行验证；\n2.手动jog，检查机器人目标点或目标路径位姿姿态是否可达，如果可达请更换姿态进行运动学逆解计算。",
    "tittle": "运动学逆解计算失败",
    "isShowConfirm": "1"
  },
  "0x0F0005": {
    "description": "位置设置过大",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "位置设置过大",
    "isShowConfirm": "1"
  },
  "0x0F0006": {
    "description": "机器人关节达到正的硬限位 不可运动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "JOG运动时，机器人已经到达限位，但指令仍然往限位方向运动。",
    "action": "检查机器人当前位置是否已到达限位，机器人运动无法超过限位。",
    "tittle": "机器人关节达到正的硬限位",
    "isShowConfirm": "1"
  },
  "0x0F0007": {
    "description": "机器人关节达到负的硬限位 不可运动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "JOG运动时，机器人已经到达限位，但指令仍然往限位方向运动。",
    "action": "检查机器人当前位置是否已到达限位，机器人运动无法超过限位。",
    "tittle": "机器人关节达到负的硬限位",
    "isShowConfirm": "1"
  },
  "0x0F0008": {
    "description": "机器人关节达到正的软限位 不可运动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "JOG运动时，机器人已经到达限位，但指令仍然往限位方向运动。",
    "action": "检查机器人当前位置是否已到达限位，机器人运动无法超过限位。",
    "tittle": "机器人关节达到正的软限位",
    "isShowConfirm": "1"
  },
  "0x0F0009": {
    "description": "机器人关节达到负的软限位 不可运动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "JOG运动时，机器人已经到达限位，但指令仍然往限位方向运动。",
    "action": "检查机器人当前位置是否已到达限位，机器人运动无法超过限位。",
    "tittle": "机器人关节达到负的软限位",
    "isShowConfirm": "1"
  },
  "0x0F000A": {
    "description": "目标位置超过最大位置限制",
    "type": "1",
    "isShowOTA": "0",
    "reason": "笛卡尔空间运动给定的指令位置超过轴的最大限制。",
    "action": "请检查给定笛卡尔空间目标是否超过臂展范围。",
    "tittle": "笛卡尔目标位置超过最大位置限制",
    "isShowConfirm": "1"
  },
  "0x0F000B": {
    "description": "目标位置超过最小位置限制",
    "type": "1",
    "isShowOTA": "0",
    "reason": "笛卡尔空间运动给定的指令位置超过轴的最小限制。",
    "action": "请检查给定笛卡尔空间目标是否超过臂展范围。",
    "tittle": "笛卡尔目标位置超过最小位置限制",
    "isShowConfirm": "1"
  },
  "0x0F000E": {
    "description": "Home过程中无法手动操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人回零设置过程中进行了机器人的手动运动控制。 ",
    "action": "确认机器人当前是否正在回零，如是则等待机器人回零过程完成后继续操作。",
    "tittle": "关节回零过程中无法进行手动操作",
    "isShowConfirm": "1"
  },
  "0x0F000F": {
    "description": "指令关节索引无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制笛卡尔空间单轴或者关节空间单关节运动时，给定轴/关节索引无效导致。",
    "action": "请检查指令中所给索引是否正确；如果指令正确，请导出日志联系JAKA技术服务人员。",
    "tittle": "指令关节索引无效",
    "isShowConfirm": "1"
  },
  "0x0F0010": {
    "description": "运动指令速度无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "内部预留",
    "action": "请确认是否为调试版本；并导出诊断联系厂商",
    "tittle": "运动指令速度无效",
    "isShowConfirm": "1"
  },
  "0x0F0011": {
    "description": "运动指令目标位置超过机器限制",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节运动、或直线运动的目标位置超过机器人的限位。    ",
    "action": "手动jog ，检查目标位置是否可达，是否会超过关节限位。",
    "tittle": "运动指令目标位置超过机器限制",
    "isShowConfirm": "1"
  },
  "0x0F0012": {
    "description": "非关节模式不能进行home操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "非关节模式不能进行home操作",
    "isShowConfirm": "1"
  },
  "0x0F0013": {
    "description": "Home正在进行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "home正在进行",
    "isShowConfirm": "1"
  },
  "0x0F0014": {
    "description": "退出保护模式失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "退出保护模式失败",
    "isShowConfirm": "1"
  },
  "0x0F0015": {
    "description": "机器人未启动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "机器人未启动",
    "isShowConfirm": "1"
  },
  "0x0F0016": {
    "description": "机器人关节处于软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人关节处于软限位，无法完成指令操作。",
    "action": "检查当前机器人关节状态，是否已到达关节限位，若已到达，无法继续运动朝超限方向运动，只能往非超限方向运动，请在示教页面将超限关节jog回关节限位范围内，或在设置页面修改限位。",
    "tittle": "机器人关节处于软限位",
    "isShowConfirm": "1"
  },
  "0x0F0017": {
    "description": "运动指令目标位置不可达",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运动指令目标位置不可达。",
    "action": "目标位置超出工作范围或处于奇异点。 手动操作检查是否能关节运动到目标点，如果可以，考虑改变当前机器人的姿态，从其它的路径或姿态到达目标点。",
    "tittle": "运动指令目标位置不可达",
    "isShowConfirm": "1"
  },
  "0x0F0018": {
    "description": "到达奇异点保护性停止",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人在运动路径中即将达到奇异构型，无法继续进行笛卡尔空间运动。该错误一般在计算逆解时出错或者计算逆解与上一周期处于不同解空间时报出。",
    "action": "检查当前机器人路径及姿态是否可达，如不可达，更换初始姿态或路径来到达目标位置。如确认指令路径没有问题，请收集相关数据并联系JAKA技术服务人员。",
    "tittle": "到达奇异点保护性停止",
    "isShowConfirm": "1"
  },
  "0x0F0019": {
    "description": "CAN设备初始化失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "CAN设备初始化失败。",
    "action": "离线仿真环境下，没有CAN设备导致报错，后续优化。实际机器环境下，请重启机器人，若持续出现请联系JAKA技术服务人员。",
    "tittle": "CAN设备初始化失败",
    "isShowConfirm": "1"
  },
  "0x0F001A": {
    "description": "一键升级超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "一键升级时间过长",
    "action": "请检查网络情况以及设备情况后再进行作业。",
    "tittle": "一键升级超时",
    "isShowConfirm": "1"
  },
  "0x0F001B": {
    "description": "一键升级异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "一键升级失败",
    "action": "请检查一键升级包的来源与有效性。",
    "tittle": "一键升级异常",
    "isShowConfirm": "1"
  },
  "0x0F001C": {
    "description": "控制器启动过程中检测到关节限位数据异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "请修改关节限位值",
    "tittle": "控制器启动过程中检测到关节限位数据异常",
    "isShowConfirm": "1"
  },
  "0x0F001D": {
    "description": "机器人上电超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上电过程存在异常",
    "action": "请检查CAN通信是否正常后再次尝试重新上电",
    "tittle": "机器人上电超时",
    "isShowConfirm": "1"
  },
  "0x0F001E": {
    "description": "机器人运动过程中运动学逆解得到的关节角度不符合预期值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人在运动过程中若关节位置变化异常则报该错，一般在计算逆解时出错或者计算逆解与上一周期差值异常时出现。",
    "action": "检查当前机器人路径及姿态是否可达或处于奇异位置附近,如是,请更换初始姿态或路径。如确认指令路径没有问题,请收集相关数据并联系JAKA技术服务人员。",
    "tittle": "机器人运动过程中运动学逆解异常",
    "isShowConfirm": "1"
  },
  "0x0F001F": {
    "description": "固件升级进度长时间未更新。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "固件升级程序运行过程中可能出现未知异常。",
    "action": "控制柜将在10秒后自动重启，待控制器重启后查看固件版本号是否更新，若未更新请尝试再次上传固件安装包进行升级 。",
    "tittle": "固件升级超时",
    "isShowConfirm": "1"
  },
  "0x0F0020": {
    "description": "直线运动到目标位置失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "直线运动到目标位置失败。一般笛卡尔运动（直线或圆弧运动）过程中经过奇异点时报出，尤其是初始点或终止点为奇异点时。",
    "action": "直线运动路径点或目标点不可达或经过奇异点，手动操作检查是否能关节运动到目标点，如果可以，考虑改变当前机器人的姿态，从其它的路径或姿态到达目标点。\n注意：由于程序指针会超前实际动作指针，因此该错误提示可能会提前触发，即解析到了但还未执行到对应行时就会报出。在处理该问题时请检查作业程序中后续指令是否基于当前位置皆可达。",
    "tittle": "直线运动到目标位置失败",
    "isShowConfirm": "1"
  },
  "0x0F0021": {
    "description": "不支持该型号机器人。出现该问题时，机器人的DH参数、动力学参数以及各项限制均可能错误，谨慎上使能控制。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器版本过低，未支持后续的机器人机型。机器人型号未写入本体。",
    "action": "APP信息页面查看机器人序列号，联系JAKA获取支持的软件版本。",
    "tittle": "不支持该型号机器人",
    "isShowConfirm": "1"
  },
  "0x0F0022": {
    "description": "机器人序列号无效",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人序列号无效。控制器软件支持特定的机器人型号，特定的机器人型号具有特定的编码规则。实际机器上机器人的序列号从伺服读出，如果序列号不满足支持的型号与规则，则会报错。",
    "action": "APP信息页面查看机器人序列号，查看机器人本体实际序列号，检查序列号是否配置正确。如序列号正确，请联系JAKA获取最新版本。",
    "tittle": "机器人序列号无效",
    "isShowConfirm": "1"
  },
  "0x0F0023": {
    "description": "负载辨识轨迹索引无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "系统内部发送错误",
    "action": "重新进行负载辨识；更新控制器；联系JAKA获取支持",
    "tittle": "负载辨识轨迹索引无效",
    "isShowConfirm": "1"
  },
  "0x0F0024": {
    "description": "倍率模式下无法设置倍率",
    "type": "2",
    "isShowOTA": "0",
    "reason": "倍率模式下无法设置倍率。该错误一般在机器人处于倍率模式或者保护性停止模式下进行倍率设置。",
    "action": "请检查机器人当前是否处于倍率模式，如果是请先退出倍率模式，再设置倍率；如果机器人未处于倍率模式，请确认当前软件版本，并联系JAKA技术服务人员。",
    "tittle": "倍率模式下无法设置倍率",
    "isShowConfirm": "1"
  },
  "0x0F0025": {
    "description": "负载辨识轨迹定义不满足规范",
    "type": "1",
    "isShowOTA": "0",
    "reason": "负载辨识轨迹定义不满足规范。机器人负载辨识需要满足一定的约束以保证辨识结果的准确性。用户输入不满足提示要求时，会提示该问题。",
    "action": "请按照APP负载辨识界面的提示的轨迹规范进行操作，重新进行负载辨识。",
    "tittle": "负载辨识轨迹定义不满足规范",
    "isShowConfirm": "1"
  },
  "0x0F0026": {
    "description": "关闭电源之前请下使能",
    "type": "2",
    "isShowOTA": "0",
    "reason": "关闭电源之前请下使能",
    "action": "请先下使能再关闭电源。",
    "tittle": "关闭电源之前请下使能",
    "isShowConfirm": "1"
  },
  "0x0F0027": {
    "description": "程序运行期间不能下使能",
    "type": "2",
    "isShowOTA": "0",
    "reason": "程序运行期间不能下使能。",
    "action": "请先停止程序，再下使能。",
    "tittle": "程序运行期间不能下使能",
    "isShowConfirm": "1"
  },
  "0x0F0028": {
    "description": "负载设置存在偏差请检查",
    "type": "1",
    "isShowOTA": "0",
    "reason": "负载设置存在偏差请检查。机器人上使能后进行负载自检。如果机器人实际输出力矩与前馈力矩偏差超出一定范围时，则报该错误并下使能。",
    "action": "1.请检查负载质量和质心设置是否正确。\n2.请检查机器人型号、序列号是否正确识别。\n3.请检查安装角度是否正确。",
    "tittle": "负载设置存在偏差",
    "isShowConfirm": "1"
  },
  "0x0F0029": {
    "description": "执行圆弧运动指令失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "圆弧运动示教的三点共线或有奇异位置",
    "action": "1. 请检查圆弧运动的起点、中间点、终点是否重合；\n2. 请检查圆弧运动的起点、中间点、终点是否是奇异位置。",
    "tittle": "执行圆弧运动指令失败",
    "isShowConfirm": "1"
  },
  "0x0F0030": {
    "description": "关节速度限制被设置为0",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节速度的限制值为0或接近0",
    "action": "检查APP安全设置界面中的\"关节速度限制\"值是否有被设置为0°/s",
    "tittle": "关节速度限制被设置为0",
    "isShowConfirm": "1"
  },
  "0x0F0031": {
    "description": "三位置使能限制",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全设置中配置并开启三位置使能安全功能。",
    "action": "三位置使能安全功能对于机器人控制存在约束情况，请检查三位置开关状态，或根据安全情况选择关闭三位置使能功能。",
    "tittle": "三位置使能限制",
    "isShowConfirm": "1"
  },
  "0x0F0032": {
    "description": "无法对直线或圆弧运动外的运动类型进行跟踪",
    "type": "1",
    "isShowOTA": "1",
    "reason": "传送带跟踪只能对笛卡尔空间运动类型进行跟踪，而传送带跟踪模块中嵌套了直线运动和圆弧运动以外的运动类型。",
    "action": "请检查传送带跟踪中是否嵌套了非直线运动和圆弧运动的其他运动类型模块。",
    "tittle": "传送带跟踪不支持非直线或圆弧运动类型",
    "isShowConfirm": "1"
  },
  "0x0F0033": {
    "description": "检测到奇异点",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人在运动路径中即将达到奇异构型，无法继续进行笛卡尔空间运动。运动过程中逆解出现异常。在有外部跟踪或补偿时，如柔顺控制或传送带跟踪时，也可能由于外部输入异常导致该报错。",
    "action": "1.检查当前机器人路径及姿态是否可达，如不可达，更换初始姿态或路径来到达目标位置或者改变目标点的姿态；\n2.如果当前处于力控柔顺控制，请检查是否有异常外力以排除影响；\n3.如果当前处于传送带跟踪状态，请检查传送带速度、以及编码器反馈是否正常，较大的波动会产生该问题",
    "tittle": "检测到奇异点",
    "isShowConfirm": "1"
  },
  "0x0F0034": {
    "description": "检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "JOINTG6": "关节6动量碰撞报警",
        "JOINTG4": "关节4动量碰撞报警",
        "JOINTG5": "关节5动量碰撞报警",
        "END": "机械臂末端传感器",
        "JOINTG3": "关节3动量碰撞报警",
        "JOINTG1": "关节1动量碰撞报警",
        "SENSOR_WRONG_DATA": "传感器数据错误",
        "JOINTP3": "关节3伺服碰撞报警",
        "JOINTP2": "关节2伺服碰撞报警",
        "JOINTP1": "关节1伺服碰撞报警",
        "BASE": "机械臂底座传感器",
        "JOINTP6": "关节6伺服碰撞报警",
        "JOINTP5": "关节5伺服碰撞报警",
        "JOINTP4": "关节4伺服碰撞报警",
        "JOINTG2": "关节2动量碰撞报警"
      }
    },
    "reason": "系统检测到碰撞报警，碰撞原因：<0>。",
    "action": "1. 检查机器人周围是否有干涉，是否发生了碰撞。\n2. 检查机器人序列号、型号是否正确识别。\n3. 检查机器人负载、安装角度是否正确设置。\n4. 如果使用了力矩传感器，请检查传感器的最大力限制是否合适。",
    "tittle": "检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0035": {
    "description": "超过姿态限制",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配置并开启了工具姿态限制，且当前姿态超出限制值。",
    "action": "请检查当前机器人运动轨迹是否在工具限制设置范围内。或尝试修改安全参数中工具限制中活动范围大小。",
    "tittle": "超过姿态限制",
    "isShowConfirm": "1"
  },
  "0x0F0036": {
    "description": "工具末端超过最大位置偏差限制",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人工具末端实际位置与指令位置之间偏差超过设置的偏差限制值。",
    "action": "请检查机器人运动是否偏离指令位置，或增大用户配置文件中的偏差限制值设置。",
    "tittle": "工具末端超过最大位置偏差限制",
    "isShowConfirm": "1"
  },
  "0x0F0037": {
    "description": "工具末端线速度超过最大速度限制",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节运动时机器人末端线速度超过所设置的末端最大线速度限制值。",
    "action": "请检查APP\"安全设置\"--\"碰撞保护\"界面的TCP速度限制是否正确；如TCP速度限制值没有问题请降低关节运动指令速度和加速度。",
    "tittle": "工具末端线速度超过最大速度限制",
    "isShowConfirm": "1"
  },
  "0x0F0038": {
    "description": "执行关节运动指令失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节运动段设置不合理",
    "action": "请确认当前机器人关节位置和目标关节位置是否正确",
    "tittle": "执行关节运动指令失败",
    "isShowConfirm": "1"
  },
  "0x0F0039": {
    "description": "TCP标定示教点重复",
    "type": "1",
    "isShowOTA": "0",
    "reason": "示教点中存在两个或两个以上示教点重合",
    "action": "请重新标定TCP，并确保没有重合的点位",
    "tittle": "TCP标定示教点重复",
    "isShowConfirm": "1"
  },
  "0x0F003A": {
    "description": "机器人运动过程中不允许关闭使能",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人运动过程中不允许关闭使能",
    "action": "请先停止操作机器人再关闭使能",
    "tittle": "机器人运动过程中不允许关闭使能",
    "isShowConfirm": "1"
  },
  "0x0F003B": {
    "description": "机器人已上电，无需重复上电",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人已上电，无需重复上电",
    "action": "机器人已上电，无需重复上电",
    "tittle": "机器人已上电，无需重复上电",
    "isShowConfirm": "0"
  },
  "0x0F003C": {
    "description": "机器人已使能，无需重复使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人已使能，无需重复使能",
    "action": "机器人已使能，无需重复使能",
    "tittle": "机器人已使能，无需重复使能",
    "isShowConfirm": "0"
  },
  "0x0F003D": {
    "description": "TCP坐标系的标定有示教点在同一条直线上的情况",
    "type": "1",
    "isShowOTA": "0",
    "reason": "示教点位在同一直线上会导致无法计算TCP的姿态。",
    "action": "请重新设置合适的示教点位。",
    "tittle": "TCP坐标系的标定有示教点在同一条直线上的情况",
    "isShowConfirm": "1"
  },
  "0x0F003E": {
    "description": "TCP坐标系的标定误差超过预设阈值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TCP坐标系的标定误差超过预设阈值。",
    "action": "请重新设置合适的示教点位。",
    "tittle": "TCP坐标系的标定误差超过预设阈值",
    "isShowConfirm": "1"
  },
  "0x0F003F": {
    "description": "TCP坐标系的标定坐标超出了工作空间",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TCP坐标系的标定坐标超出了工作空间",
    "action": "请重新设置合适的示教点位。",
    "tittle": "TCP坐标系的标定坐标超出了工作空间",
    "isShowConfirm": "1"
  },
  "0x0F0040": {
    "description": "在软限位上无法进入拖拽模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在软限位上无法进入拖拽模式。",
    "action": "检查当前机器人关节状态，是否已到达关节限位，若已到达，无法继续运动朝超限方向运动，只能往非超限方向运动，请在示教页面将超限关节jog回关节限位范围内，或在设置页面修改限位。",
    "tittle": "在软限位上无法进入拖拽模式",
    "isShowConfirm": "1"
  },
  "0x0F0041": {
    "description": "拖拽超出软限位将退出拖拽",
    "type": "1",
    "isShowOTA": "0",
    "reason": "拖拽超出软限位将退出拖拽。该提示一般在拖拽超过限位。",
    "action": "检查当前机器人关节状态，机器人无法继续运动朝超限方向运动，只能往非超限方向运动，可以将超限拖拽回关节限位范围内，或这退出拖拽模式，在设置页面修改软限位，增大关节的软限位范围，但软限位的设置范围不能超过硬限位。",
    "tittle": "拖拽超出软限位将退出拖拽",
    "isShowConfirm": "1"
  },
  "0x0F0042": {
    "description": "设置柔顺参数失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法在开启工具拖拽或恒力柔顺控制的状态下设置柔顺参数或手感参数。",
    "action": "请先关闭恒力柔顺控制以及工具拖拽再修改柔顺参数或手感参数。",
    "tittle": "力控参数设置失败",
    "isShowConfirm": "1"
  },
  "0x0F0043": {
    "description": "机器人未使能无法进入拖拽",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人未使能无法进入拖拽。机器人未使能的状态下检测到拖拽指令触发。",
    "action": "请检查机器人是否上电上使能；请检查是否是由于外部误触发拖拽按键。",
    "tittle": "机器人未使能无法进入拖拽",
    "isShowConfirm": "1"
  },
  "0x0F0044": {
    "description": "机器人目前不处于空闲状态，无法进入拖拽",
    "type": "2",
    "isShowOTA": "0",
    "reason": "拖拽模式要求机器人处于空闲静止状态下才可切换。",
    "action": "请检查机器人是否正在运动、正在运行程序、正在工具拖拽模式下、或处于错误状态下，然后根据情况停止当前的作业或恢复机器人的错误状态，再尝试进入拖拽。",
    "tittle": "机器人当前无法进入拖拽",
    "isShowConfirm": "1"
  },
  "0x0F0045": {
    "description": "关节力矩超限无法进入拖拽",
    "type": "1",
    "isShowOTA": "1",
    "reason": "有关节力矩超限无法进入拖拽。一般来说是拖拽速度太快或者碰撞过于灵敏造成的。",
    "action": "降低拖拽速度或者在设置界面将碰撞等级设置高一些。",
    "tittle": "关节力矩超限无法进入拖拽",
    "isShowConfirm": "1"
  },
  "0x0F0046": {
    "description": "拖拽按钮已屏蔽无法进入拖拽",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人末端拖拽按钮（FREE）功能被禁用，无法使用末端按钮（FREE）进行拖拽操作。",
    "action": "请检查[设置-硬件与通讯-辅助硬件设置]中是否将拖拽功能禁用，若禁用请开启此功能。",
    "tittle": "拖拽按钮已屏蔽无法进入拖拽",
    "isShowConfirm": "0"
  },
  "0x0F0047": {
    "description": "程序暂停/恢复按钮已屏蔽",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人末端顶部按钮程序暂停/恢复功能被禁用，无法使用顶部按钮进行程序暂停/恢复操作。",
    "action": "请检查软件硬件与通讯-辅助硬件设置中是否将程序暂停/恢复功能禁用，若禁用请开启此功能。",
    "tittle": "程序暂停/恢复按钮已屏蔽",
    "isShowConfirm": "0"
  },
  "0x0F0048": {
    "description": "point按钮已屏蔽无法记录点位",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人末端点位示教按钮（POINT）功能被禁用，无法使用末端按钮（POINT）进行点位示教操作。",
    "action": "请检查软件硬件与通讯-辅助硬件设置中是否将点位记录功能禁用，若禁用请开启此功能。",
    "tittle": "point按钮已屏蔽无法记录点位",
    "isShowConfirm": "0"
  },
  "0x0F0049": {
    "description": "仿真模式下无法进入拖拽模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "仿真模式下无法进入拖拽模式",
    "action": "检查机器人运行模式，退出仿真后可以进入拖拽模式",
    "tittle": "仿真模式下无法进入拖拽模式",
    "isShowConfirm": "1"
  },
  "0x0F004A": {
    "description": "设置柔顺参数失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法在程序中开启力控的条件下直接关闭某个方向的力控",
    "action": "请检查程序中是否开启了力控，且在开启状态下取消了某个力控方向的勾选。如若，请关闭力控重试",
    "tittle": "力控参数设置失败",
    "isShowConfirm": "1"
  },
  "0x0F004B": {
    "description": "程序运行中禁止手动校零力传感器",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行中禁止手动校零力传感器",
    "action": "请终止当前正在运行的程序或等待程序运行结束后再操作",
    "tittle": "力传感器校零失败",
    "isShowConfirm": "1"
  },
  "0x0F004C": {
    "description": "无法启动工具拖拽",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前正处于本体关节拖拽模式下，此模式与工具拖拽存在冲突，无法直接启动工具拖拽",
    "action": "请退出关节拖拽模式后再启动工具拖拽",
    "tittle": "无法启动工具拖拽",
    "isShowConfirm": "1"
  },
  "0x0F004D": {
    "description": "恒力柔顺控制意外关闭",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人处于伺服运动模式下并且已经开启了恒力柔顺控制，在退出伺服运动模式前尝试关闭恒力柔顺控制会触发此报错",
    "action": "当前运动已终止，请检查程序逻辑确保先退出伺服运动模式再关闭恒力柔顺控制",
    "tittle": "恒力柔顺控制意外关闭",
    "isShowConfirm": "1"
  },
  "0x0F004E": {
    "description": "无法启动工具拖拽",
    "type": "1",
    "isShowOTA": "0",
    "reason": "工具拖拽必须在机器人正常使能且空闲状态下开启。机器人处于自动模式，或处于关节拖拽模式，或处于各类异常状态时无法开启工具拖拽。",
    "action": "确保机器人状态再启动工具拖拽",
    "tittle": "无法启动工具拖拽",
    "isShowConfirm": "1"
  },
  "0x0F004F": {
    "description": "奇异位置附近运行直线或圆弧运动时关节加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "笛卡尔空间运动时关节的加速度过大，尤其在机器人奇异位置附近运行直线或圆弧运动时容易出现该问题",
    "action": "降低直线或圆弧运动的加速度与速度，或改变路径运行",
    "tittle": "奇异位置附近预判停止",
    "isShowConfirm": "1"
  },
  "0x0F0050": {
    "description": "力传感器未就绪，无法使用力控功能。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "力传感器未就绪，无法使用力控功能。该问题一般出现在使用到力控功能时检测到力传感器未运行。",
    "action": "请检查是否开启了力传感器。",
    "tittle": "力传感器未就绪",
    "isShowConfirm": "1"
  },
  "0x0F0051": {
    "description": "工具拖拽模式下无法关闭力传感器",
    "type": "2",
    "isShowOTA": "0",
    "reason": "在打开工具拖拽之后，禁止直接关闭力传感器。",
    "action": "如需关闭传感器，请先退出工具拖拽，再关闭传感器",
    "tittle": "工具拖拽模式下无法关闭力传感器",
    "isShowConfirm": "1"
  },
  "0x0F0052": {
    "description": "工具拖拽过程中力传感器故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "工具拖拽过程中力传感器故障。可能原因为控制器与外部力传感器之间的通讯链路断开。",
    "action": "请先检查力传感器通讯状态是否正常，包括硬件连接线和软件配置。",
    "tittle": "工具拖拽过程中力传感器故障",
    "isShowConfirm": "1"
  },
  "0x0F0053": {
    "description": "传感器校零期间禁止进入力控模式。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "传感器校零尚未完成。",
    "action": "传感器校零过程大约需要0.5秒，请等待校零完成后再进入力控模式。",
    "tittle": "传感器校零期间禁止进入力控模式",
    "isShowConfirm": "1"
  },
  "0x0F0054": {
    "description": "程序运行期间无法执行单步运行操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "程序运行期间无法执行单步运行操作。",
    "action": "如果您要使用单步调试功能，可以先停止运行当前程序，再进行单步调试。",
    "tittle": "程序运行期间无法执行单步运行操作",
    "isShowConfirm": "1"
  },
  "0x0F0055": {
    "description": "机器人运动期间不能设置碰撞灵敏度",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人运动期间不能设置碰撞灵敏度。",
    "action": "先停止运动，再设置灵敏度。",
    "tittle": "机器人运动期间不能设置碰撞灵敏度",
    "isShowConfirm": "1"
  },
  "0x0F0056": {
    "description": "扩展IO模块未运行 无法访问",
    "type": "1",
    "isShowOTA": "0",
    "reason": "扩展IO模块未运行 无法访问。",
    "action": "在IO监控界面检查扩展IO模块是否处于运行状态。",
    "tittle": "扩展IO模块未运行",
    "isShowConfirm": "1"
  },
  "0x0F0057": {
    "description": "机器人运动时无法使能或关闭动力学前馈",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人运动时无法使能或关闭动力学前馈，此错误只有在使用二次开发接口的时候才会出现。",
    "action": "先停止当前机器人的运动，再设置机器人的动力学前馈。",
    "tittle": "无法设置动力学前馈",
    "isShowConfirm": "1"
  },
  "0x0F0058": {
    "description": "未检测到功能使用许可",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未检测到功能使用许可。部分功能的启用需要软件授权，若功能使用过程中检测到软件未授权，则提示该错误。",
    "action": "联系JAKA工作人员购买功能使用许可。",
    "tittle": "未检测到功能使用许可",
    "isShowConfirm": "1"
  },
  "0x0F0059": {
    "description": "保护性停止复位失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保护性停止复位失败。该错误一般在进行保护性停止复位操作时检测到保护性停止的功能输入仍然处于触发状态。",
    "action": "请查看功能IO是否触发了保护性停止，如是请先退出保护性停止模式再进行保护性停止复位操作。",
    "tittle": "保护性停止复位失败",
    "isShowConfirm": "1"
  },
  "0x0F005A": {
    "description": "拒绝设置安全参数操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当机器人不在手动模式下或在手动模式下处于移动或工具拖拽开启的状态时，禁止设置安全参数。",
    "action": "停止运动/关闭工具拖拽，并且切换机器人至手动模式下再进行安全参数配置。",
    "tittle": "拒绝设置安全参数操作",
    "isShowConfirm": "1"
  },
  "0x0F005B": {
    "description": "拒绝设置安全参数操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当机器人在使能状态下，禁止设置安全参数。",
    "action": "请先将机器人下使能再进行安全参数配置。",
    "tittle": "拒绝设置安全参数操作",
    "isShowConfirm": "1"
  },
  "0x0F005C": {
    "description": "设置的安全参数不在合理范围内,安全参数设置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "设置的安全参数数值超出功能支持范围",
    "action": "请修改安全参数至合理范围内再次进行设置",
    "tittle": "安全参数数值异常",
    "isShowConfirm": "1"
  },
  "0x0F005D": {
    "description": "拒绝设置安全参数操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当机器人程序正在执行时，禁止设置安全参数。",
    "action": "请停止程序后再进行安全参数配置。",
    "tittle": "拒绝设置安全参数操作",
    "isShowConfirm": "1"
  },
  "0x0F005E": {
    "description": "<0>超过机型参数范围限制",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "MomentumLimitReduce": "缩减模式动量限制",
        "TcpVelLimit": "机器人TCP速度限制",
        "StoppingDistance": "机器人停止距离",
        "StoppingTimeReduce": "缩减模式停止时间",
        "TcpVelReduce": "缩减模式TCP速度限制",
        "StoppingTime": "机器人停止时间",
        "StoppingDistReduce": "缩减模式停止距离",
        "MomentumLimit": "机器人动量限制",
        "ElbowVelLimitReduce": "缩减模式肘部速度限制",
        "RobotPowerLimit": "机器人功率限制",
        "PoewrLimitReduce": "缩减模式功率限制"
      }
    },
    "reason": "<0>超过机型参数范围限制",
    "action": "机器人序列号:{0}\n设置的<0>值:{1}\n<0>最小值：{2}\n<0>最大值：{3}\n在进行安全参数设置时，请确保<0>参数在可配置的范围内。\n确认无误后请点击\"确定\"按钮更新设置。",
    "tittle": "安全参数冲突",
    "isShowConfirm": "1"
  },
  "0x0F0060": {
    "description": "保护性停止模式下无法设置倍率",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保护性停止模式下无法设置倍率。",
    "action": "先退出保护性停止模式，再设置机器人的速度倍率。",
    "tittle": "保护性停止模式下无法设置倍率",
    "isShowConfirm": "1"
  },
  "0x0F0061": {
    "description": "用户坐标系标定失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "选择的标定点位不合适导致用户坐标系标定失败。",
    "action": "请重新设置合适的示教点位。",
    "tittle": "用户坐标系标定失败",
    "isShowConfirm": "1"
  },
  "0x0F0062": {
    "description": "TIO RS485通道力传感器模式未启用",
    "type": "2",
    "isShowOTA": "0",
    "reason": " TIO RS485通道力传感器模式未启用。启用TIO力传感器时检测到引脚复用配置异常。",
    "action": "当力传感器设置中选择传感器类型VI时，此时启用力传感器会检测TIO是否有通道被正确设置为力传感器模式。如未正确设置则报错上述信息，请检查相关配置。",
    "tittle": "TIO RS485通道力传感器模式未启用 ",
    "isShowConfirm": "1"
  },
  "0x0F0063": {
    "description": "TIO RS485配置不符合硬件要求",
    "type": "2",
    "isShowOTA": "0",
    "reason": "由于CAN通道带宽限制，TIO RS485配置需要满足如下规则：对于S系列机器人，仅允许复用1路485，且所有485通道均不可配置为力传感器模式；对于其他机型，仅允许1路485通道被设置为力传感器模式",
    "action": "如果在配置过程中弹出此报错，请检查配置是否符合规则后再重新配置。 如果在机器人开机或上电时弹出此提示，可能是由于切换机型导致用户配置与新机器不匹配，机器人上电时将自动忽略产生问题的用户配置并启用默认配置，如希望消除此提示，请进入IO面板/工具端， 重新配置一次DO和AI的功能设置以覆盖旧的配置。注意当前相关配置页面将显示已经强制更改过的设置，但此前保存的用户配置文件并未更新，可能与显示的不一致，需要手动点击确认设置之后才会更新。",
    "tittle": "TIO RS485配置不合法",
    "isShowConfirm": "1"
  },
  "0x0F0064": {
    "description": "通讯参数修改失败 使用此通道的力传感器正在运行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "修改TIO RS485通讯参数修改失败 使用此通道的力传感器正在运行。",
    "action": "力传感器运行时禁止修改其通讯参数。请先停止运行，再进行通讯参数修改操作。",
    "tittle": "通讯参数修改失败",
    "isShowConfirm": "1"
  },
  "0x0F0065": {
    "description": "信号量定义无效",
    "type": "2",
    "isShowOTA": "0",
    "reason": "信号量定义无效。末端Modbus夹爪的状态通过信号量机制进行查询，信号量的定义需满足一定的规范，包括名称、功能码、地址等。不满足定义规范时会提示该错误。",
    "action": "请检查当前TIO RS485通道ID是否正确，指定通道模式设置是否为Modbus RTU，功能码是否支持（目前仅支持功能码01，02，03，04）。",
    "tittle": "信号量定义无效",
    "isShowConfirm": "1"
  },
  "0x0F0066": {
    "description": "信号量超过最大支持数量（8个）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "受限于带宽，信号量的支持数量存在限制，最大支持8个，超出该数量会报错。",
    "action": "目前最多支持定义8个信号量，请删除不必要的信号量定义。",
    "tittle": "信号量超过最大支持数量",
    "isShowConfirm": "1"
  },
  "0x0F0067": {
    "description": "指定信号量不存在",
    "type": "2",
    "isShowOTA": "0",
    "reason": "指定信号量不存在。该错误一般在作业程序中引用了不存在的信号量。",
    "action": "请检查信号量相关的程序调用以及信号量定义，是否有引用未定义的信号量。",
    "tittle": "指定信号量不存在",
    "isShowConfirm": "1"
  },
  "0x0F0068": {
    "description": "发送TIO RS485指令失败 指令队列已满",
    "type": "2",
    "isShowOTA": "0",
    "reason": "指令队列已满， 发送TIO RS485指令失败。该问题一般出现在高频率的调用信号量刷新或者指令发送。",
    "action": "受限于CAN通讯带宽，TIO+相关的查询与设置指令均会进行缓冲。如应用层刷新速率高于该带宽，则会提示该信息。请降低作业程序或应用端的指令调用频率。",
    "tittle": "发送TIO RS485指令失败 ",
    "isShowConfirm": "1"
  },
  "0x0F0069": {
    "description": "接收TIO RS485指令反馈超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "接收TIO RS485指令反馈超时。该问题一般出现在控制器发出RS485指令后等待反馈超时。",
    "action": "请检查TIO+相关通讯设置是否正确；检查控制器与机器人之间通讯链路是否正常。",
    "tittle": "接收TIO RS485指令反馈超时  ",
    "isShowConfirm": "1"
  },
  "0x0F006A": {
    "description": "程序保存过程中检测到MoveZS 指令生成失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序保存过程中检测到MoveZS 指令的参数设置不正确。",
    "action": "检查程序中的MoveZS指令参数，确认'起始位置'、'结束位置'、'任意位置'三个参数无误后重新保存程序",
    "tittle": "指令生成失败",
    "isShowConfirm": "1"
  },
  "0x0F006B": {
    "description": "数字输出端口不可用",
    "type": "2",
    "isShowOTA": "0",
    "reason": "数字输出端口[{0}: Pin_{1} ]被设置为功能DO或安全DO,不允许当作通用DO修改",
    "action": "1.取消对[{2}: Pin_{3} ]上的功能配置；\n2.不要通过指令设置[{4}: Pin_{5} ]的状态",
    "tittle": "数字输出端口不可用",
    "isShowConfirm": "1"
  },
  "0x0F006C": {
    "description": "倍率模式下无法设置倍率",
    "type": "2",
    "isShowOTA": "0",
    "reason": "倍率模式下无法设置倍率。",
    "action": "先退出倍率模式，再设置机器人的速度倍率。",
    "tittle": "倍率模式下无法设置倍率",
    "isShowConfirm": "1"
  },
  "0x0F006D": {
    "description": "力传感器反馈数值超限",
    "type": "0",
    "isShowOTA": "0",
    "reason": "传感器反馈数值超过了最大的量程，传感器所受到的力或力矩太大。",
    "action": "请检查传感器的负载，使传感器所受到的力或力矩在合适范围内。",
    "tittle": "力传感器反馈数值超限",
    "isShowConfirm": "1"
  },
  "0x0F006E": {
    "description": "力传感器检测到外力",
    "type": "0",
    "isShowOTA": "0",
    "reason": "在进入工具拖拽模式时，传感器检测到大于3N或0.2Nm的外力。",
    "action": "请检查传感器是否受到外力，如果传感器没有受到外力影响，可能是传感器未进行校零或传感器的读数获取失败，从而导致机器人出现位置漂移。",
    "tittle": "力传感器检测到外力",
    "isShowConfirm": "1"
  },
  "0x0F006F": {
    "description": "正在调用<0>接口，该接口是旧版本控制器的接口，当前版本控制器已使用<1>接口替代。考虑到接口兼容性，此接口目前仍然保留，但未来版本可能会被移除。",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "SET_ADMITTANCE_FRAME": "设置导纳坐标系",
        "SET_COMPLIANCE_ENABLE": "传感器初始化",
        "SET_ADMITTANCE_CONFIG": "设置导纳参数"
      },
      "1": {
        "SET_FORCE_SENSOR_ZERO": "传感器校零",
        "SET_CSTF_DRAG_FRAME": "设置力控坐标系和工具拖拽坐标系",
        "SET_CSTF_DRAG_CONFIG": "设置恒力柔顺参数和工具拖拽参数"
      }
    },
    "reason": "使用部分特殊版本或使用版本不匹配的APP、SDK时可能会出现此警告信息。此警告信息不影响正常使用，仅作为提示。",
    "action": "当前接口已成功调用并已执行相关指令，此警告信息仅作为提示，不影响正常使用。若希望不再出现此提示，请参考版本发布说明选择合适的版本号, 更新APP或SDK版本。",
    "tittle": "正在调用兼容性接口",
    "isShowConfirm": "1"
  },
  "0x0F0070": {
    "description": "本体DH参数读取校验异常",
    "type": "2",
    "isShowOTA": "1",
    "reason": "上电时读取伺服端DH参数CRC错误",
    "action": "请重新上电，若无法解决或经常出现请升级伺服",
    "tittle": "机器人DH参数读取校验异常",
    "isShowConfirm": "1"
  },
  "0x0F0071": {
    "description": "动力学参数读取校验异常",
    "type": "2",
    "isShowOTA": "1",
    "reason": "上电时读取伺服端动力学参数CRC错误",
    "action": "请重新上电，若无法解决或经常出现请升级伺服",
    "tittle": "机器人动力学参数读取校验异常",
    "isShowConfirm": "1"
  },
  "0x0F0072": {
    "description": "正在从伺服读取D-H或动力学参数 无法使能机器人",
    "type": "2",
    "isShowOTA": "0",
    "reason": "正在从伺服读取 D-H或动力学参数 无法使能机器人。在机器人打开电源后立即上使能时，未读取到DH参数并报错。",
    "action": "打开电源后控制器会从伺服读取DH参数，期间禁止使能机器人。如等待后使能时依然出现，请检查控制器与机器人之间的通讯链路。如故障现象持续，联系JAKA技术人员。",
    "tittle": "伺服参数读取异常，使能失败",
    "isShowConfirm": "1"
  },
  "0x0F0073": {
    "description": "达到机器人动量限制",
    "type": "2",
    "isShowOTA": "0",
    "reason": "达到机器人动量限制。机器人安全界面可以设置机器人动量限制，达到该限制时会触发报警。",
    "action": "此错误为警告无需处理，当机器人动量的绝对值大于用户的设定阈值，机器人会自动进行倍率减速。",
    "tittle": "达到机器人动量限制",
    "isShowConfirm": "1"
  },
  "0x0F0074": {
    "description": "达到机器人TCP速度限制",
    "type": "1",
    "isShowOTA": "0",
    "reason": "达到机器人TCP速度限制。机器人安全界面可以设置机器人TCP速度限制，达到该限制时会触发报警。",
    "action": "此为通知性质的弹窗警告，可忽略，可以检查一下是否在安全设置界面下的碰撞保护当中进行了TCP速度限制。",
    "tittle": "达到机器人TCP速度限制  ",
    "isShowConfirm": "1"
  },
  "0x0F0075": {
    "description": "即将超出安全平面",
    "type": "2",
    "isShowOTA": "0",
    "reason": "即将超出安全平面，机器人只能在设置的安全平面范围内工作。",
    "action": "请确认安全平面设置是否符合实际；排查时可关闭安全平面功能或者控制器机器人朝安全平面内运动。",
    "tittle": "即将超出安全平面",
    "isShowConfirm": "1"
  },
  "0x0F0076": {
    "description": "伺服端DH参数版本号无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人运动学参数版本与控制器不兼容",
    "action": "请升级伺服或降级控制器",
    "tittle": "伺服端DH参数版本号无效",
    "isShowConfirm": "1"
  },
  "0x0F0077": {
    "description": "伺服端动力学参数版本号无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人动力学参数版本与控制器不兼容",
    "action": "请升级伺服或降级控制器",
    "tittle": "伺服端动力学参数版本号无效",
    "isShowConfirm": "1"
  },
  "0x0F0078": {
    "description": "伺服使能操作过于频繁",
    "type": "1",
    "isShowOTA": "0",
    "reason": "App主界面本体上使能按钮连续点击",
    "action": "App主界面本体上使能按钮按下后，1秒后观察本体末端呼吸灯是否由蓝色转变成绿色，正常为由蓝色变绿色，并伴随关节\"啪啪\"释放刹车声音",
    "tittle": "伺服使能操作过于频繁",
    "isShowConfirm": "1"
  },
  "0x0F0079": {
    "description": "无法切换仿真/真机模式 请关闭电源",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当机器人处于上电上使能状态时，使用APP切换机器人仿真/真机模式功能，提示报错",
    "action": "请将机器人处于下电下使能状态下后，进行修改仿真/真机模式切换功能。",
    "tittle": "无法切换仿真/真机模式 请关闭电源",
    "isShowConfirm": "1"
  },
  "0x0F007A": {
    "description": "不支持将两个网口的IP设置在同一网段",
    "type": "2",
    "isShowOTA": "0",
    "reason": "App设置界面网络配置界面IP地址设置到了10.5.5.X网络段，与控制器自带网络IP地址网段冲突",
    "action": "App设置界面网络配置界面IP设置不允许在10.5.5.X网络IP段。修改的为标准控制器的底部网口和MinCab的LAN2口IP地址，修改后为静态IP地址：网络配置参考设置格式：IP：192.168.10.120 子掩码：255.255.255.0 默认网关：192.168.10.1",
    "tittle": "不支持将两个网口的IP设置在同一网段",
    "isShowConfirm": "1"
  },
  "0x0F007B": {
    "description": "即将超出工具姿态安全限制",
    "type": "2",
    "isShowOTA": "0",
    "reason": "配置并开启了工具姿态限制，机器人即将超出工具姿态约束范围",
    "action": "控制机器人运动时，请在工具姿态约束范围内移动,或尝试修改安全参数中工具限制中活动范围大小。",
    "tittle": "即将超出工具姿态安全限制",
    "isShowConfirm": "1"
  },
  "0x0F007C": {
    "description": "无法切换仿真/真机模式 ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "虚拟机不支持此功能",
    "action": "虚拟机不支持此功能",
    "tittle": "无法切换仿真/真机模式 ",
    "isShowConfirm": "1"
  },
  "0x0F007D": {
    "description": "当前无法进行传感器校零",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法进行传感器校零操作，可能原因为：传感器已关闭、传感器已在校零中、或机器人正处于工具拖拽或恒力柔顺控制模式下。",
    "action": "请确保力传感器正常运行，且机器人不处于工具拖拽模式或恒力柔顺控制模式下后再进行校零。",
    "tittle": "当前无法进行传感器校零",
    "isShowConfirm": "1"
  },
  "0x0F007E": {
    "description": "缩减模式下无法设置倍率",
    "type": "2",
    "isShowOTA": "0",
    "reason": "缩减模式下无法设置倍率。",
    "action": "先退出缩减模式，再设置机器人的速度倍率。",
    "tittle": "缩减模式下无法设置倍率",
    "isShowConfirm": "1"
  },
  "0x0F007F": {
    "description": "机器人正处于拖拽模式下，不允许关闭使能。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人正处于拖拽模式下，不允许关闭使能。",
    "action": "请将机器人退出拖拽模式，再关闭使能。",
    "tittle": "机器人正处于拖拽模式下，不允许关闭使能",
    "isShowConfirm": "1"
  },
  "0x0F0080": {
    "description": "上电状态不允许切换机器人模型",
    "type": "2",
    "isShowOTA": "1",
    "reason": "当机器人处于上电状态时，使用APP机器人仿真/真机模式功能进行切换机器人型号模型，提示报错",
    "action": "请将机器人处于下电下使能状态下后，进行仿真/真机模式功能机型切换操作。",
    "tittle": "上电状态不允许切换机器人模型",
    "isShowConfirm": "1"
  },
  "0x0F0081": {
    "description": "机器人运动过程中不允许重置密码",
    "type": "2",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态下，进行用户权限密码修改操作，提示报错",
    "action": "请将机器人程序运动状态处于停止状态，再尝试进行用户权限密码修改操作。",
    "tittle": "机器人运动过程中不允许重置密码",
    "isShowConfirm": "1"
  },
  "0x0F0082": {
    "description": "请检查密码复位按钮是否正常",
    "type": "2",
    "isShowOTA": "1",
    "reason": "密码复位按钮功能异常。",
    "action": "请检查密码复位按钮是否正常，或联系技术服务人员。",
    "tittle": "请检查密码复位按钮是否正常",
    "isShowConfirm": "1"
  },
  "0x0F0083": {
    "description": "关节减速失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "无法自动纠正当前运动的关节速度低于限制速度",
    "action": "请提高安全设置中的限制速度或降低指令速度",
    "tittle": "关节减速失败",
    "isShowConfirm": "1"
  },
  "0x0F0084": {
    "description": "圆形传送带P1,P2,P3 三点共线",
    "type": "1",
    "isShowOTA": "1",
    "reason": "三点重合或共线时无法确定传送带圆心坐标系",
    "action": "请重新示教此三点，避免三点重合或共线",
    "tittle": "圆形传送带P1,P2,P3 三点共线",
    "isShowConfirm": "1"
  },
  "0x0F0085": {
    "description": "直线传送带跟踪方向为零",
    "type": "1",
    "isShowOTA": "1",
    "reason": "传送带方向为零时无法确定跟踪方向",
    "action": "请检查直线传送带跟踪指令块的传送带方向,避免示教的起点与终点重合或输入的XYZ值全是零",
    "tittle": "直线传送带跟踪方向为零",
    "isShowConfirm": "1"
  },
  "0x0F0086": {
    "description": "获取负载辨识结果失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1.辨识过程中辨识数据文件丢失； \n2.带载和不带载的轨迹不一致；\n3.辨识轨迹过短。",
    "action": "",
    "tittle": "获取负载辨识结果失败",
    "isShowConfirm": "1"
  },
  "0x0F0087": {
    "description": "时间最优规划寻优失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "使用时间最优进行规划时无法找到最优解",
    "action": "请降低指令速度后再次尝试或使用其他规划器进行运动规划",
    "tittle": "时间最优规划寻优失败",
    "isShowConfirm": "1"
  },
  "0x0F0088": {
    "description": "负载辨识仅支持正装",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "负载辨识仅支持正装",
    "isShowConfirm": "1"
  },
  "0x0F0089": {
    "description": "轨迹复现不支持急停后恢复程序运行，急停后将停止程序运行。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "轨迹复现不支持急停后恢复程序运行",
    "action": "轨迹复现不支持急停后恢复程序运行",
    "tittle": "无法执行急停后恢复程序运行",
    "isShowConfirm": "1"
  },
  "0x0F008A": {
    "description": "设置数字输出的IO引脚输入/输出类型存在冲突",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当IO引脚为输入类型时无法设置数字输出。",
    "action": "请确认被操作IO引脚为输出类型后再次进行设置数字输出操作。",
    "tittle": "设置数字输出失败",
    "isShowConfirm": "1"
  },
  "0x0F008B": {
    "description": "获取数字输入信号异常，无法根据此IO引脚的信号状态跳过运动指令。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当IO引脚为输出类型时无法获取数字输入。",
    "action": "请确认被操作IO引脚为输入类型后，再执行根据输入信号跳过运动指令操作。",
    "tittle": "获取数字输入信号跳过运动指令失败",
    "isShowConfirm": "1"
  },
  "0x0F008C": {
    "description": "IO索引超出范围，相关IO操作无效",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "IO索引超出范围",
    "isShowConfirm": "1"
  },
  "0x0F008E": {
    "description": "拒绝设置安全参数操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当机器人上电时，禁止设置安全IO相关功能.",
    "action": "请停止程序后再进行安全参数配置。",
    "tittle": "拒绝设置安全参数操作",
    "isShowConfirm": "1"
  },
  "0x0F008F": {
    "description": "机械臂使能和下使能的操作太过频繁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机械臂的伺服使能和下使能操作太过频繁，容易损坏机械臂的关节。",
    "action": "请调整机械臂使能的时间间隔，推荐使能间隔大于4秒。",
    "tittle": "机械臂使能和下使能的操作太过频繁",
    "isShowConfirm": "1"
  },
  "0x0F0090": {
    "description": "程序运行时无法切换手/自动模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行时无法切换手/自动模式",
    "action": "请先停止程序再切换操作模式",
    "tittle": "程序运行时无法切换手/自动模式",
    "isShowConfirm": "1"
  },
  "0x0F0091": {
    "description": "机器人运动时无法切换手/自动模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人运动时无法切换手/自动模式",
    "action": "请先停止运动再切换操作模式",
    "tittle": "机器人运动时无法切换手/自动模式",
    "isShowConfirm": "1"
  },
  "0x0F0092": {
    "description": "在手动模式下无法触发此DI功能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在手动模式下无法触发此DI功能",
    "action": "手动模式不支持此功能，请切换模式后重试",
    "tittle": "在手动模式下无法触发此DI功能",
    "isShowConfirm": "1"
  },
  "0x0F0093": {
    "description": "在自动模式下无法触发此DI功能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在自动模式下无法触发此DI功能",
    "action": "自动模式不支持此功能，请切换模式后重试",
    "tittle": "在自动模式下无法触发此DI功能",
    "isShowConfirm": "1"
  },
  "0x0F0094": {
    "description": "机器人拖拽时无法切换手/自动模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人拖拽时无法切换手/自动模式",
    "action": "请先停止拖拽再切换操作模式",
    "tittle": "机器人拖拽时无法切换手/自动模式",
    "isShowConfirm": "1"
  },
  "0x0F0095": {
    "description": "启动程序失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "在手动模式下无法自动触发启动程序信号",
    "action": "",
    "tittle": "启动程序失败",
    "isShowConfirm": "1"
  },
  "0x0F0096": {
    "description": "功能设置错误",
    "type": "2",
    "isShowOTA": "0",
    "reason": "在自动模式下触发自动运行程序信号后自动加载并运行配置的默认程序，需要配置正确的'默认程序'并开启'默认程序自动加载",
    "action": "1.在'设置'->'程序设置'页面，设置正确的'默认程序'，并启用'默认程序自动加载'\n2.'默认程序' 不可以为'none'.",
    "tittle": "自动启动程序功能设置错误",
    "isShowConfirm": "1"
  },
  "0x0F0097": {
    "description": "功能设置错误",
    "type": "2",
    "isShowOTA": "0",
    "reason": "'默认程序'和'默认程序自动加载'需要都被设置或都不被设置。都设置时，触发自动运行程序信号将会自动加载并运行配置的'默认程序'；都不设置时，触发自动运行程序信号将会运行当前已经打开的程序",
    "action": "1.在'设置'->'程序设置' 页面，正确设置'默认程序' 和 '默认程序自动加载'\n2.'默认程序' 不可以为'none'。",
    "tittle": "功能设置错误",
    "isShowConfirm": "1"
  },
  "0x0F0098": {
    "description": "自动使能失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "在手动模式下无法自动触发上使能信号",
    "action": "",
    "tittle": "自动使能失败",
    "isShowConfirm": "1"
  },
  "0x0F0099": {
    "description": "机器人上电状态下不允许执行该指令\n目标指令：{0}",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人上电状态下不允许执行该指令",
    "action": "请先下电然后再重新执行指令'{1}'",
    "tittle": "指令执行失败",
    "isShowConfirm": "1"
  },
  "0x0F00A0": {
    "description": "程序运行时无法设置PROFINET断连后程序状态",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行时无法设置PROFINET断连后程序状态",
    "action": "请先停止程序再设置参数",
    "tittle": "程序运行时无法设置PROFINET断连后程序状态",
    "isShowConfirm": "1"
  },
  "0x0F00A1": {
    "description": "程序运行时无法设置EtherNet/IP断连后程序状态",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行时无法设置EtherNet/IP断连后程序状态",
    "action": "请先停止程序再设置参数",
    "tittle": "程序运行时无法设置EtherNet/IP断连后程序状态",
    "isShowConfirm": "1"
  },
  "0x0F00A2": {
    "description": "检测到PROFINET断开连接，程序暂停",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到PROFINET断开连接，程序暂停",
    "action": "请检查PROFINET连接状态",
    "tittle": "检测到PROFINET断开连接，程序暂停",
    "isShowConfirm": "1"
  },
  "0x0F00A3": {
    "description": "检测到PROFINET断开连接，程序停止",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到PROFINET断开连接，程序停止",
    "action": "请检查PROFINET连接状态",
    "tittle": "检测到PROFINET断开连接，程序停止",
    "isShowConfirm": "1"
  },
  "0x0F00A4": {
    "description": "检测到EtherNet/IP断开连接，程序暂停",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到EtherNet/IP断开连接，程序暂停",
    "action": "请检查EtherNet/IP连接状态",
    "tittle": "检测到EtherNet/IP断开连接，程序暂停",
    "isShowConfirm": "1"
  },
  "0x0F00A5": {
    "description": "检测到EtherNet/IP断开连接，程序停止",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到EtherNet/IP断开连接，程序停止",
    "action": "请检查EtherNet/IP连接状态",
    "tittle": "检测到EtherNet/IP断开连接，程序停止",
    "isShowConfirm": "1"
  },
  "0x0F0100": {
    "description": "机器人功率超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "App碰撞设置界面功率设置小于机器人运动需求功率",
    "action": "App碰撞设置界面功率增大功率设置值，JAKA机型负载3KG参考值1000，负载5KG\\7KG参考值1500，负载12KG参考值2000，负载18KG参考值2000",
    "tittle": "机器人功率超限",
    "isShowConfirm": "1"
  },
  "0x0F0101": {
    "description": "机器人动量超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "App碰撞设置界面动量设置小于机器人运动需求动量",
    "action": "App碰撞设置界面增大动量设置值，JAKA机型负载3KG参考值5，负载5KG\\7KG参考值10，负载12KG参考值30，负载18KG参考值50",
    "tittle": "机器人动量超限",
    "isShowConfirm": "1"
  },
  "0x0F0102": {
    "description": "底座传感器检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "SP型号机器人，当机器人处于上使能状态时，底座传感器信号异常增大，超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "底座传感器检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0103": {
    "description": "末端力超限，1轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，1轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0104": {
    "description": "末端力超限，2轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，2轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0105": {
    "description": "末端力超限，3轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，3轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0106": {
    "description": "末端力超限，4轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，4轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0107": {
    "description": "末端力超限，5轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，5轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0108": {
    "description": "末端力超限，6轴检测到碰撞",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于程序运行状态中，关节电流突然增大超出设定阈值，提示报警。",
    "action": "1.查看机器是否碰撞到外围设备。\n2.查看机器人在运动过程中是否受到线缆拉扯。\n3.适当降低机器人的加速度\n4.核验机器人末端负载是否正确\n5.可尝试增大机器人碰撞等级",
    "tittle": "末端力超限，6轴检测到碰撞",
    "isShowConfirm": "1"
  },
  "0x0F0109": {
    "description": "安全平面设置点不允许共线或重合",
    "type": "1",
    "isShowOTA": "1",
    "reason": "安全平面设置需要有三个面点和一个安全点，这三个点都是笛卡尔坐标，当三个面点重合或者共线则报错，当安全点在安全面上则报错",
    "action": "请检查安全面点是否重合或者共线，检查安全点是否在安全平面上。",
    "tittle": "安全平面点设置错误",
    "isShowConfirm": "1"
  },
  "0x0F0110": {
    "description": "设置动力学参数必须打开电源",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人未上电",
    "action": "请检查机器人状态，打开机器人电源",
    "tittle": "无法设置动力学参数",
    "isShowConfirm": "1"
  },
  "0x0F0111": {
    "description": "在设置动力学参数的过程中，参数设置意外中断",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在设置动力学参数过程中，机器人与电控柜之间CAN通讯存在异常",
    "action": "1.请尝试将机器人下电下使能后，重新再次上电。\n2.请检查机器人与电控柜之间重载连接线是否存在连接异常问题",
    "tittle": "设置动力学参数中断",
    "isShowConfirm": "1"
  },
  "0x0F0112": {
    "description": "在设置动力学参数的过程中，参数设置超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在设置动力学参数过程中，机器人与电控柜之间CAN通讯存在异常",
    "action": "1.请尝试将机器人下电下使能后，重新再次上电。\n2.请检查机器人与电控柜之间重载连接线是否存在连接异常问题",
    "tittle": "设置动力学参数超时",
    "isShowConfirm": "1"
  },
  "0x0F0113": {
    "description": "本版本不再支持当前控制柜",
    "type": "2",
    "isShowOTA": "0",
    "reason": "v1.7.1之后的控制器软件将不再支持{0}",
    "action": "若确认要使用请更新到对应版本，如v1.5",
    "tittle": "不支持的控制柜类型",
    "isShowConfirm": "1"
  },
  "0x0F0114": {
    "description": "无法在下使能状态下进行负载辨识",
    "type": "2",
    "isShowOTA": "0",
    "reason": "无法在下使能状态下进行负载辨识",
    "action": "请先上使能再进行辨识",
    "tittle": "无法在下使能状态下进行负载辨识",
    "isShowConfirm": "1"
  },
  "0x0F0115": {
    "description": "获取底部或者Lan2网口ip失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "获取底部或者Lan2网口ip失败",
    "action": "请检查底部或者Lan2网口连接状态，虚拟机获取ip失败，暂时无法从虚拟机获取设置ip",
    "tittle": "获取底部或者Lan2网口ip失败",
    "isShowConfirm": "1"
  },
  "0x0F0116": {
    "description": "当前已安装AddOn数量已达上限 10 ",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前已安装AddOn数量已达上限 10",
    "action": "请先删除部分AddOn后再继续安装",
    "tittle": "AddOn数量超限",
    "isShowConfirm": "1"
  },
  "0x0F0117": {
    "description": "AddOn配置文件内service对应文件不存在",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn配置文件内service对应文件不存在",
    "action": "请检查AddOn安装包内service对应文件是否存在",
    "tittle": "AddOn服务不存在",
    "isShowConfirm": "1"
  },
  "0x0F0118": {
    "description": "AddOn端口查看空闲端口号失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn端口查看空闲端口号失败",
    "action": "请及时保存诊断日志，联系技术人员处理",
    "tittle": "AddOn端口查看空闲端口号失败",
    "isShowConfirm": "1"
  },
  "0x0F0119": {
    "description": "AddOn端口号分配失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn端口号分配失败",
    "action": "1.请在重启控制柜后尝试重新启动",
    "tittle": "AddOn端口号分配失败",
    "isShowConfirm": "1"
  },
  "0x0F011A": {
    "description": "无法对运行中的AddOn执行当前操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法对运行中的AddOn执行当前操作",
    "action": "无法对运行中的AddOn执行当前操作",
    "tittle": "AddOn操作失败",
    "isShowConfirm": "1"
  },
  "0x0F011B": {
    "description": "无法对已停止的AddOn执行当前操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法对已停止的AddOn执行当前操作",
    "action": "无法对已停止的AddOn执行当前操作",
    "tittle": "停止AddOn操作失败",
    "isShowConfirm": "1"
  },
  "0x0F011C": {
    "description": "存在不支持的AddOn操作指令",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器存在不支持的AddOn指令",
    "action": "升级控制器对应版本的AddOn管理器",
    "tittle": "未知的AddOn操作",
    "isShowConfirm": "1"
  },
  "0x0F011D": {
    "description": "系统内AddOn存在重复的端口占用",
    "type": "1",
    "isShowOTA": "0",
    "reason": "系统内AddOn存在重复的端口占用",
    "action": "1.尝试重启控制器能否解决\n2.请及时保存诊断日志，联系技术人员处理",
    "tittle": "系统AddOn端口重复",
    "isShowConfirm": "1"
  },
  "0x0F011E": {
    "description": "AddOn未知错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn未知错误",
    "action": "请及时保存诊断日志，联系技术人员处理",
    "tittle": "AddOn未知错误",
    "isShowConfirm": "1"
  },
  "0x0F011F": {
    "description": "无法对系统AddOn执行当前操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法对系统AddOn执行当前操作",
    "action": "无法对系统AddOn执行当前操作",
    "tittle": "非法的SystemAddOn操作",
    "isShowConfirm": "1"
  },
  "0x0F0120": {
    "description": "无法操作当前版本无法识别的AddOn",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn版本过低\n2.AddOn包格式存在错误",
    "action": "请检查AddOn安装包无误后重新安装",
    "tittle": "操作失效AddOn失败",
    "isShowConfirm": "1"
  },
  "0x0F0121": {
    "description": "AddOn内config.ini文件无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内config.ini文件无效",
    "action": "请联系AddOn开发人员,检查AddOn安装包无误后重新安装",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0122": {
    "description": "AddOn缺少必要的配置项",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 2.0/3.0 必要配置项[convention,description,version,type,languagetype,service,serviceenabled]\n2.AddOn convention 1.0 必要配置项[binname,description,version,enabled,type]",
    "action": "请联系AddOn开发人员,检查Addon缺少对应的配置项",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0123": {
    "description": "AddOn端口错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前错误未使用",
    "action": "当前错误未使用",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0124": {
    "description": "AddOn配置文件内Language无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 3.0支持language[javascript,python2,python,node-red]\n2.AddOn convention 2.0支持language[javascript,python2,python]\n3.AddOn convention 1.0支持language[python]",
    "action": "请检查AddOn安装包内convention是否支持对应的languageType",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0125": {
    "description": "AddOn配置文件中type错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 2.0/3.0支持type[1.自定义指令,2.自定义服务,3.自定义UI]",
    "action": "请联系AddOn开发人员,检查AddOn安装包是否支持对应的type",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0126": {
    "description": "AddOn配置文件中serviceenabled错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "serviceenabled应该为0或1",
    "action": "请联系AddOn开发人员,检查AddOn安装包配置serviceenabled是否满足要求",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0127": {
    "description": "AddOn配置文件中service错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.配置中service配置项缺失\n2.配置中service不为空且不能超过50",
    "action": "1.检查配置文件中service配置是否存在\n2.检查配置中service字节数长度",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F0128": {
    "description": "AddOn内配置文件无效或AddOn目录名无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.Addon配置文件中Name不能为空且不能超过40字节\n2.AddOn所在目录名称不可超过40字节",
    "action": "请联系AddOn开发人员,修改AddOn配置中name或修改AddOn所在目录名称",
    "tittle": "AddOn内配置文件无效或AddOn目录名无效",
    "isShowConfirm": "1"
  },
  "0x0F0129": {
    "description": "AddOn内配置文件中description无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内配置文件中description不应超过40字节",
    "action": "请联系AddOn开发人员,修改AddOn配置中Description",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F012A": {
    "description": "AddOn内配置文件中url无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内配置文件中url格式不正确",
    "action": "请联系AddOn开发人员,修改AddOn配置中url",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F012B": {
    "description": "AddOn内配置文件中convention无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前版本控制器不支持对应的convention版本AddOn",
    "action": "1.请联系AddOn开发人员，检查配置convention是否正确\n2.请更换其它支持该版本AddOn的控制器",
    "tittle": "AddOn内配置文件无效",
    "isShowConfirm": "1"
  },
  "0x0F012C": {
    "description": "AddOn安装包损坏或无法识别",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn安装包损坏或无法识别",
    "action": "检查AddOn安装包无误后重新安装",
    "tittle": "AddOn安装包错误",
    "isShowConfirm": "1"
  },
  "0x0F012D": {
    "description": "AddOn安装包移动失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "系统配置错误或代码存在错误",
    "action": "1.请联系技术人员更换控制器版本\n2.请联系技术人员更换系统镜像",
    "tittle": "AddOn安装包错误",
    "isShowConfirm": "1"
  },
  "0x0F012E": {
    "description": "AddOn包解压失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前仅支持AddOn.tar.gz格式压缩包",
    "action": "1.检查包格式是否正确\n2.检查包是否被损坏",
    "tittle": "AddOn安装包错误",
    "isShowConfirm": "1"
  },
  "0x0F012F": {
    "description": "当前正在安装另一个AddOn",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前正在安装另一个AddOn",
    "action": "1.请等待安装完成\n2.重启控制柜后再次尝试",
    "tittle": "AddOn安装包错误",
    "isShowConfirm": "1"
  },
  "0x0F0130": {
    "description": "当前无AddOn安装任务",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前无AddOn安装任务",
    "action": "不能在无安装AddOn任务时查询AddOn安装进度",
    "tittle": "当前无AddOn安装任务",
    "isShowConfirm": "1"
  },
  "0x0F0131": {
    "description": "AddOn安装包压缩错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "系统内部忙碌，无法读取对应文件",
    "action": "1.请在一段时间后重新尝试\n2.联系技术人员处理",
    "tittle": "AddOn安装包错误",
    "isShowConfirm": "1"
  },
  "0x0F0132": {
    "description": "AddOn包压缩或解压超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn包内文件过多或AddOn文件过大",
    "action": "1.请稍等一段时间后重新尝试\n2.更换其它控制器版本导出",
    "tittle": "AddOn包压缩或解压超时",
    "isShowConfirm": "1"
  },
  "0x0F0133": {
    "description": "AddOn安装包内文件缺失",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.确认config.ini文件存在\n2.确认其它必要文件是否存在\n3.确定文件目录结构是否可被识别",
    "action": "请联系AddOn开发人员,确认安装包无误后重试",
    "tittle": "AddOn安装包格式错误",
    "isShowConfirm": "1"
  },
  "0x0F0134": {
    "description": "分享程序成功",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo : {1}",
    "tittle": "分享程序成功",
    "isShowConfirm": "0"
  },
  "0x0F0135": {
    "description": "分享程序失败\nFrom: {0}\nTo : {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能的原因：\n1.分享的程序文件路径不正确，或程序文件不完整。\n2.被分享的程序文件在目标控制器中已存在。\n3.控制器无法访问目标控制器所在的IP地址。",
    "action": "1.确认目标控制器上不存在同名的程序文件。\n2.确认当前控制器（不是App所在主机）能够正常访问目标控制器。\n3.检查被分享的程序文件内容是否完整（文件夹对应的文件和子目录是否都存在）。",
    "tittle": "分享程序失败",
    "isShowConfirm": "1"
  },
  "0x0F0136": {
    "description": "机器人超出传送带最大跟踪距离",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人超出传送带跟踪设定的最大跟踪距离减速停止",
    "action": "1.请将最大跟踪距离参数调大或重新调整跟踪位置",
    "tittle": "机器人超出传送带最大跟踪距离",
    "isShowConfirm": "1"
  },
  "0x0F0137": {
    "description": "磁盘剩余空间不足. \n磁盘分区名称:{0}\n磁盘空间使用率:{1}% \n磁盘总空间:{2} MB   \n磁盘剩余空间:{3}MB",
    "type": "1",
    "isShowOTA": "0",
    "reason": "磁盘空间使用率超过80%, 剩余空间不够，在后续对文件进行磁盘写入时可能会存在丢失数据的风险。",
    "action": "1.清理过期的故障诊断文件。\n2.清理多余的作业程序文件程序备份文件。\n3. 清理多余的轨迹文件。 \n若执行以上操作后仍不能有效释放磁盘空间，请联系技术服务人员检查磁盘。",
    "tittle": "磁盘剩余空间不足预警",
    "isShowConfirm": "1"
  },
  "0x0F0138": {
    "description": "在使用传送带起始跟踪距离和距离补偿功能时, 首个运动不能是圆弧运动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当首个运动为圆弧运动时, 涉及到传送带距离补偿计算时会影响原有的圆弧轨迹",
    "action": "1.请将传送带的首个运动改为直线运动",
    "tittle": "在使用传送带起始跟踪距离和距离补偿功能时, 首个运动不能是圆弧运动",
    "isShowConfirm": "1"
  },
  "0x0F0140": {
    "description": "超出设定力值软限位",
    "type": "1",
    "isShowOTA": "0",
    "reason": "超出设定力值软限位",
    "action": "1. 请确认机器人末端是否与外部发生撞击。",
    "tittle": "超出设定力值软限位",
    "isShowConfirm": "1"
  },
  "0x0F0141": {
    "description": "超过传感器最大量程",
    "type": "1",
    "isShowOTA": "0",
    "reason": "超过传感器最大量程",
    "action": "1. 请确认机器人末端是否与外部发生撞击；传感器在发生猛烈撞击后可能发生不可逆损坏",
    "tittle": "超过传感器最大量程",
    "isShowConfirm": "1"
  },
  "0x0F0142": {
    "description": "Profinet通信在未使能状态",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Profinet通信未使能的情况下，无法对相关IO进行操作。",
    "action": "请先使能Profinet通信，再进行IO的操作。",
    "tittle": "Profinet通信在未使能状态",
    "isShowConfirm": "1"
  },
  "0x0F0143": {
    "description": "EtherNet/IP通信在未使能状态",
    "type": "2",
    "isShowOTA": "0",
    "reason": "EtherNet/IP通信未使能的情况下，无法对相关IO进行操作。",
    "action": "请先使能EtherNet/IP通信，再进行IO的操作。",
    "tittle": "EtherNet/IP通信在未使能状态",
    "isShowConfirm": "1"
  },
  "0x0F0144": {
    "description": "当前传感器的限位设置超过了该机型默认的软限位。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "当前传感器的限位设置超过了该机型默认的软限位。",
    "action": "当前设置的力或者力矩超过了该机型默认的软限位。请检查限位的值，保证限位的值在该机型允许的设置范围内。",
    "tittle": "传感器的限位设置超过了默认的软限位",
    "isShowConfirm": "1"
  },
  "0x0F0150": {
    "description": "控制系统启动阶段，识别安全控制板硬件型号失败。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "通信超时，安全控制板的CAN通信异常超时",
    "action": "1.请检查安全控制板的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "查询安全控制板硬件型号失败",
    "isShowConfirm": "1"
  },
  "0x0F0151": {
    "description": "设置安全控制板安全功能DI配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制器的CAN通信异常",
    "action": "1.请检查升级安全控制板固件版本是否为指定搭配版本 \n2.请检查安全控制器的CAN通信 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置安全控制板安全功能DI配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0152": {
    "description": "设置安全控制板安全功能DO配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制器的CAN通信异常",
    "action": "1.请检查升级安全控制板固件版本是否为指定搭配版本 \n 2.请检查安全控制器的CAN通信\n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置安全控制板安全功能DO配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0153": {
    "description": "设置安全控制板功率限制配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制板固件的CAN通信异常",
    "action": "1.请检查安全控制板的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置安全控制板功率限制配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0154": {
    "description": "向安全控制板同步工具坐标系失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "通信超时，安全控制板的CAN通信异常超时",
    "action": "1.请检查安全控制板的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "向安全控制板同步工具坐标系失败",
    "isShowConfirm": "1"
  },
  "0x0F0155": {
    "description": "设置控制柜序列号的CAB ID失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制器的CAN通信异常",
    "action": "1.请检查安全控制器的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置控制柜序列号失败",
    "isShowConfirm": "1"
  },
  "0x0F0156": {
    "description": "设置控制柜输出电压配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制器的CAN通信异常",
    "action": "1.请检查安全控制器的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置控制柜输出电压配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0157": {
    "description": "设置安全控制板停止时间配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制板的CAN通信异常",
    "action": "1.请检查安全控制板的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置安全控制板停止时间配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0158": {
    "description": "设置安全控制板停止距离配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置 \n2.安全控制板的CAN通信异常",
    "action": "1.请检查安全控制板的CAN通信 \n2.请检查升级安全控制板固件版本是否为指定搭配版本 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "设置安全控制板停止距离配置失败",
    "isShowConfirm": "1"
  },
  "0x0F0159": {
    "description": "设置安全控制板末端拖拽速度限制配置失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置。 \n2.安全控制板的CAN通信异常。",
    "action": "1.请检查安全控制板的CAN通信。 \n2.请检查升级安全控制板固件版本是否为指定搭配版本。 \n3.检查后仍然存在问题请联系技术服务人员咨询。",
    "tittle": "设置安全控制板末端拖拽速度限制配置失败",
    "isShowConfirm": "1"
  },
  "0x0F015A": {
    "description": "设置控制柜序列号的生产流水号失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置。 \n2.安全控制板的CAN通信异常。",
    "action": "1.请检查安全控制板的CAN通信。 \n2.请检查升级安全控制板固件版本是否为指定搭配版本。 \n3.检查后仍然存在问题请联系技术服务人员咨询。",
    "tittle": "设置控制柜序列号失败",
    "isShowConfirm": "1"
  },
  "0x0F015B": {
    "description": "设置控制柜序列号的生产日期失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板固件版本不支持此功能配置。 \n2.安全控制板的CAN通信异常。",
    "action": "1.请检查安全控制板的CAN通信。 \n2.请检查升级安全控制板固件版本是否为指定搭配版本。 \n3.检查后仍然存在问题请联系技术服务人员咨询。",
    "tittle": "设置控制柜序列号失败",
    "isShowConfirm": "1"
  },
  "0x0F015C": {
    "description": "设置控制柜IO输入/输出类型失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1.当前安全控制板版本不支持此功能配置。 \n2.安全控制板的CAN通信异常。",
    "action": "1.请检查安全控制板的CAN通信。 \n2.请检查升级安全控制板版本是否为指定搭配版本。 \n3.检查后仍然存在问题请联系技术服务人员咨询。",
    "tittle": "设置控制柜IO输入/输出类型失败",
    "isShowConfirm": "1"
  },
  "0x0F0160": {
    "description": "发送控制器版本号至安全控制板失败",
    "type": "2",
    "isShowOTA": "0",
    "reason": "向安全控制板发送版本号未收到反馈，安全控制板的CAN通信异常超时",
    "action": "1.请检查升级安全控制板固件版本是否为指定搭配版本 \n2.若确认为指定版本请检查安全控制板的CAN通信线路 \n3.检查后仍然存在问题请联系技术服务人员咨询",
    "tittle": "发送控制器版本号至安全控制板失败",
    "isShowConfirm": "1"
  },
  "0x0F0161": {
    "description": "安全控制板固件版本过低，安全功能将无法全部进行支持",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板固件版本过低，安全功能将无法全部进行支持",
    "action": "使用不匹配的安全控制板固件版本可能导致未知的安全风险，请对安全控制板固件进行升级，确保控制器与安全控制板固件版本搭配正确",
    "tittle": "安全控制板固件版本过低",
    "isShowConfirm": "1"
  },
  "0x0F0162": {
    "description": "SERVO版本过低，安全功能无法全部支持",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全功能适配的SERVO版本错误，部分安全功能无法进行支持",
    "action": "使用错误的SERVO版本可能导致安全风险，请对SERVO固件进行升级，确保控制器与SERVO版本搭配正确",
    "tittle": "SERVO版本错误",
    "isShowConfirm": "1"
  },
  "0x0F0163": {
    "description": "PROFINET 和 ETHERNET/IP 功能被禁用。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当前机器人型号不支持PROFINET、ETHERNET/IP功能。",
    "action": "如需使用PROFINET 和 ETHERNET/IP 功能，请重启控制柜并连接其他型号机器人。",
    "tittle": "PROFINET 和 ETHERNET/IP 功能被禁用",
    "isShowConfirm": "1"
  },
  "0x0F0170": {
    "description": "<0>与<1>参数冲突",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "CurrentTcpVelLimit": "当前的机器人TCP速度限制",
        "SettingStoppingDistance": "设置的机器人停止距离限制",
        "CurrentStoppingTime": "当前的机器人停止时间限制",
        "CurrentStoppingDistance": "当前的机器人停止距离限制",
        "CurrentPowerLimit": "当前的机器人功率限制",
        "CurrentMomentumLimit": "当前的机器人动量限制",
        "SettingMomentumLimit": "设置的机器人动量限制",
        "SettingStoppingTime": "设置的机器人停止时间限制",
        "SettingPowerLimit": "设置的机器人功率限制",
        "SettingTcpVelLimit": "设置的机器人TCP速度限制"
      },
      "1": {
        "SettingPoewrLimitReduce": "设置的缩减模式功率限制",
        "SettingStoppingDistReduce": "设置的缩减模式停止距离限制",
        "SettingStoppingTimeReduce": "设置的缩减模式停止时间限制",
        "CurrentTcpVelReduce": "当前的缩减模式TCP速度限制",
        "SettingMomentumLimitReduce": "设置的缩减模式动量限制",
        "CurrentPoewrLimitReduce": "当前的缩减模式功率限制",
        "CurrentStoppingTimeReduce": "当前的缩减模式停止时间限制",
        "SettingTcpVelReduce": "设置的缩减模式TCP速度限制",
        "CurrentMomentumLimitReduce": "当前的缩减模式动量限制",
        "CurrentStoppingDistReduce": "当前的缩减模式停止距离限制"
      },
      "2": {
        "<": "小于",
        ">": "大于"
      },
      "3": {
        "<": "小于",
        ">": "大于"
      }
    },
    "reason": "<0><2><1>\n",
    "action": "<0>：{0}\n<1>：{1}\n在进行安全参数设置时，请确保<0>参数<3><1>参数",
    "tittle": "安全参数冲突",
    "isShowConfirm": "1"
  },
  "0x0F0171": {
    "description": "负载配置参数存在异常，机器人无法使能",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人序列号:{0}\n负载参数最大值:{1}\n负载参数最小值:{2}\n当前负载参数:{3}",
    "action": "请设置负载参数至该机型适配范围后重新进行机器人使能",
    "tittle": "负载配置错误拒绝使能",
    "isShowConfirm": "1"
  },
  "0x0F0172": {
    "description": "有效负载配置参数值超出了该机型的适配范围",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人序列号:{0}\n负载参数最大值:{1}\n负载参数最小值:{2}\n设置的负载参数:{3}",
    "action": "请重新设置负载参数至该机型适配范围",
    "tittle": "有效负载配置参数值错误",
    "isShowConfirm": "1"
  },
  "0x0F0173": {
    "description": "机器人在未使能状态下，无法执行末端按钮操作",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人在未使能状态下，无法通过末端按钮执行以下操作：\n 1.程序暂停或启动\n 2.进入拖拽或工具拖拽模式 ",
    "action": "请保持机器人在使能状态下操作末端按钮。",
    "tittle": "机器人在未使能状态下，无法执行末端按钮操作",
    "isShowConfirm": "1"
  },
  "0x0F0174": {
    "description": "传送带跟踪的队列为空",
    "type": "2",
    "isShowOTA": "0",
    "reason": "使用传送带队列跟踪功能时，队列里面没有符合条件的目标",
    "action": "1.调整触发队列存取的位置，确保每次取值时队列不为空 2.排查队列指令中设置入队的条件是否有误",
    "tittle": "传送带跟踪的队列为空",
    "isShowConfirm": "0"
  },
  "0x0F0175": {
    "description": "跳过队列中超出最大跟踪距离的目标",
    "type": "2",
    "isShowOTA": "0",
    "reason": "队列中的目标超出了传送带设定的最大跟踪距离，将该目标删除，避免异常情况发生",
    "action": "1.调整传送带来料间隔或增加漏料措施",
    "tittle": "跳过队列中超出最大跟踪距离的目标",
    "isShowConfirm": "0"
  },
  "0x0F0176": {
    "description": "传送带跟踪的队列已满",
    "type": "2",
    "isShowOTA": "0",
    "reason": "使用传送带队列跟踪功能时，队列中符合条件的目标超出了最大值",
    "action": "1.调整传送带来料间隔",
    "tittle": "传送带跟踪的队列已满",
    "isShowConfirm": "0"
  },
  "0x0F0177": {
    "description": "密码验证失败次数过多",
    "type": "1",
    "isShowOTA": "1",
    "reason": "{0} 秒内 连续5次校验密码失败",
    "action": "{1} 秒内 连续5次校验密码失败，请{2}秒后再重试",
    "tittle": "密码验证失败次数过多",
    "isShowConfirm": "1"
  },
  "0x0F0180": {
    "description": "安全立方体对角点重合",
    "type": "2",
    "isShowOTA": "0",
    "reason": "对角点的笛卡尔坐标重合无法生成安全立方体",
    "action": "请检查安全立方体对角点的笛卡尔坐标是否重合",
    "tittle": "安全立方体对角点参数错误",
    "isShowConfirm": "1"
  },
  "0x0F0181": {
    "description": "开机加载安全区域配置文件的参数校验失败",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "global": "SafePlane global config",
        "cube": "SafeCube.Cube",
        "plane": "SafePlane.Plane"
      }
    },
    "reason": "安全区域配置文件<0>{0}存在异常参数,导致安全参数校验失败",
    "action": "控制系统按照默认参数进行生效,如需恢复请重新进行配置安全区域配置",
    "tittle": "初始化加载安全区域配置异常",
    "isShowConfirm": "1"
  },
  "0x0F0190": {
    "description": "轨迹偏移队列已满",
    "type": "1",
    "isShowOTA": "1",
    "reason": "轨迹偏移的队列存储已达最大值",
    "action": "优化轨迹点位或增大轨迹偏移队列数目",
    "tittle": "轨迹偏移队列已满",
    "isShowConfirm": "1"
  },
  "0x0F0191": {
    "description": "轨迹偏移直线与直线无交点，偏移失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基准轨迹偏移之后，直线与直线异面或平行，求解不出交点",
    "action": "调整基准点位或修改轨迹偏移参数",
    "tittle": "轨迹偏移直线与直线无交点，偏移失败",
    "isShowConfirm": "1"
  },
  "0x0F0192": {
    "description": "轨迹偏移时直线与圆弧无交点，偏移失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基准轨迹偏移之后，直线与圆弧没有交点",
    "action": "请调整基准点位或修改轨迹偏移参数",
    "tittle": "轨迹偏移时直线与圆弧无交点，偏移失败",
    "isShowConfirm": "1"
  },
  "0x0F0193": {
    "description": "轨迹偏移队列已满",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基准轨迹偏移之后，圆弧与圆弧没有交点，求解不出交点",
    "action": "请调整基准点位或修改轨迹偏移参数",
    "tittle": "轨迹偏移时圆弧与圆弧无交点，偏移失败",
    "isShowConfirm": "1"
  },
  "0x0F0195": {
    "description": "轨迹偏移队列已空",
    "type": "1",
    "isShowOTA": "1",
    "reason": "轨迹偏移队列数量为0",
    "action": "请检查程序编写是否有误",
    "tittle": "轨迹偏移队列已空",
    "isShowConfirm": "1"
  },
  "0x0F0196": {
    "description": "轨迹偏移中TCP的Z轴与轨迹方向平行，偏移失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "轨迹偏移中TCP的Z轴与轨迹方向平行，偏移失败",
    "action": "请调整偏移的基准点位",
    "tittle": "轨迹偏移中TCP的Z轴与轨迹方向平行，偏移失败",
    "isShowConfirm": "1"
  },
  "0x0F1001": {
    "description": "使能超时 请重新打开电源",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人处于上使能过程中，关节电磁铁出现未吸合情况，提示报错",
    "action": "1.请尝试将机器人下电，重新进行上电上使能操作。\n2.请检查机器人关节电磁铁是否存在异常，或联系技术人员。",
    "tittle": "使能超时 请重新打开电源",
    "isShowConfirm": "1"
  },
  "0x0F1002": {
    "description": "伺服版本号查询超时",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人与电控柜之间CAN通讯存在异常时，提示报错",
    "action": "1.请尝试将机器人下电下使能后，重新再次上电上使能。\n2.请检查机器人与电控柜之间重载连接线是否存在连接异常问题。",
    "tittle": "伺服版本号查询超时",
    "isShowConfirm": "1"
  },
  "0x0F2000": {
    "description": "编程文件语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序中存在参数异常或未定义，导致控制器处理异常",
    "action": "1.请检查当前程序中所用变量定义初始值是否存在异常。\n2.请检查通讯连接变量交互数据是否存在异常。",
    "tittle": "编程文件语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2001": {
    "description": "没有编程文件打开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "没有加载运行程序",
    "action": "1.设置开机默认加载程序\n2.在编程界面打开对应的程序，在点击运行",
    "tittle": "没有编程文件打开",
    "isShowConfirm": "1"
  },
  "0x0F2002": {
    "description": "编程文件打开失败。\n目标文件:{0}。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能的原因:\n1. 开机默认加载的程序丢失。\n2. 保存的程序文件不完整。\n3. 输入的程序文件路径不正确。",
    "action": "1.在设置界面重新选择开机默认加载程序。\n2.在编程界面重新保存程序后再打开。\n3. 检查程序脚本指令中的文件路径是否正确。",
    "tittle": "编程文件打开失败",
    "isShowConfirm": "1"
  },
  "0x0F2003": {
    "description": "编程文件关闭失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "编程文件关闭失败",
    "isShowConfirm": "1"
  },
  "0x0F2004": {
    "description": "程序备份成功",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo: {1}",
    "tittle": "程序备份成功",
    "isShowConfirm": "0"
  },
  "0x0F2005": {
    "description": "自动备份程序失败\nFrom: {0}\nTo: {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能的原因：\n1. 权限不允许，文件写入失败。\n2. 程序文件损坏。\n3. 磁盘空间不够或磁盘读写异常。",
    "action": "1. 在App编程页面对程序进行手动备份。\n2. 检查程序内容是否缺失，打开程序后是否能够正常保存。\n3. 联系技术人员检查目录权限和磁盘状态。",
    "tittle": "自动备份程序失败",
    "isShowConfirm": "1"
  },
  "0x0F2010": {
    "description": "解析错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未匹配的if、while、end、break、continue等关键字。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查脚本文件，尤其是手动编写的脚本子程序，看是否有未匹配的关键字。",
    "tittle": "解析错误",
    "isShowConfirm": "1"
  },
  "0x0F2011": {
    "description": "PyCall()失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "被调用的Python脚本语法错误\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查被调用的Python脚本程序。",
    "tittle": "PyCall()失败",
    "isShowConfirm": "1"
  },
  "0x0F2012": {
    "description": "解析断言失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运动参数设置不合理。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查运动参数设置",
    "tittle": "解析断言失败",
    "isShowConfirm": "1"
  },
  "0x0F2013": {
    "description": "解析失败，圆弧半径为零",
    "type": "1",
    "isShowOTA": "0",
    "reason": "圆弧运动点位设置存在异常，机器人运动轨迹规划失败。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查圆弧运动中机器人点位设置是否存在异常，请重新配置圆弧运动点位信息",
    "tittle": "解析失败，圆弧半径为零",
    "isShowConfirm": "1"
  },
  "0x0F2014": {
    "description": "解析失败，语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "变量交互指令（赋值指令）中存在数据格式异常。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查程序中涉及变量交互指令（赋值指令）中是否存在数据格式异常。",
    "tittle": "解析失败，语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2015": {
    "description": "网络连接失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "创建SOCKET 失败.\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查对应出错的脚本指令",
    "tittle": "网络连接失败",
    "isShowConfirm": "1"
  },
  "0x0F2016": {
    "description": "连接服务端失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket通讯时服务端断开连接。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1.请检查Socket通讯服务端是否关闭。\n2.请尝试与Socket通讯服务端进行网络联通（ping通）测试。\n3.请检查电控柜与Socket通讯服务端网线连接是否存在异常。\n4.请检查Socket通讯服务端防火墙是否关闭。",
    "tittle": "连接服务端失败",
    "isShowConfirm": "1"
  },
  "0x0F2017": {
    "description": "通讯失败未连接服务器",
    "type": "1",
    "isShowOTA": "0",
    "reason": "执行读取视觉参数指令时未连接到camera。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1.请检查Socket通讯服务端是否关闭。\n2.请尝试与Socket通讯服务端进行网络联通（ping通）测试。\n3.请检查电控柜与Socket通讯服务端网线连接是否存在异常。\n4.请检查Socket通讯服务端防火墙是否关闭。",
    "tittle": "通讯失败未连接服务器",
    "isShowConfirm": "1"
  },
  "0x0F2018": {
    "description": "TCP/IP接收数据失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器从相机接收数据失败。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 相机断开连接；\n2. 检查控制器与相机之间的物理连接。",
    "tittle": "TCP/IP接收数据失败",
    "isShowConfirm": "1"
  },
  "0x0F2019": {
    "description": "TCP/IP发送数据失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器向camera发送数据失败。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1.请检查Socket通讯服务端是否关闭。\n2.请尝试与Socket通讯服务端进行网络联通（ping通）测试。\n3.请检查电控柜与Socket通讯服务端网线连接是否存在异常。\n4.请检查Socket通讯服务端防火墙是否关闭。",
    "tittle": "TCP/IP发送数据失败",
    "isShowConfirm": "1"
  },
  "0x0F201A": {
    "description": "加载2D视觉配置失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "加载2D视觉配置失败",
    "isShowConfirm": "1"
  },
  "0x0F201B": {
    "description": "内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本解析器内部错误。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据错误日志信息排查以下情况：\n1. sscanf 指令参数异常\n2. 对只读变量进行写操作",
    "tittle": "内部错误",
    "isShowConfirm": "1"
  },
  "0x0F201C": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F201D": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F201E": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "代码参数错误。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查代码参数是否正确后再进行作业。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F201F": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未识别的运动指令。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查脚本尤其是手动编写的脚本程序中的Move指令",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2020": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运动指令参数错误。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查对应的运动指令",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2021": {
    "description": "方法不该被调用",
    "type": "1",
    "isShowOTA": "0",
    "reason": "圆弧运动中使用了不支持的代码指令。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查功能io是否一直接通，一般外部功能按钮接通1秒后即可断开",
    "tittle": "方法不该被调用",
    "isShowConfirm": "1"
  },
  "0x0F2022": {
    "description": "未知操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本程序中使用了不支持的操作符。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查是否使用了除以下操作符以外的符号：\n +,  -,  /,  *,  **,  and,  mod, or,  xor，]",
    "tittle": "未知操作",
    "isShowConfirm": "1"
  },
  "0x0F2023": {
    "description": "错误数据格式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "定义的变量数据格式不正确。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查变量的数据格式，修改正确后再进行作业。",
    "tittle": "错误数据格式",
    "isShowConfirm": "1"
  },
  "0x0F2024": {
    "description": "参数未定义",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1.SOCKET通讯时定义套接字和发送时套接字不一致\n2.数据赋值时未按指定的格式\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1.检查程序中的通讯指令。确保使用的端口都被打开\n2.检查数据赋值指令。字符串需增加双引号，数组需添加中括号",
    "tittle": "参数未定义",
    "isShowConfirm": "1"
  },
  "0x0F2025": {
    "description": "打开文件失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. 文件格式异常\n2. 文件名称设置过长\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 检查文件格式是否正确，如果不正确，请设置成正确的文件格式。\n2. 请检查文件名是否过长，如果过长请设置到合理范围内",
    "tittle": "打开文件失败",
    "isShowConfirm": "1"
  },
  "0x0F2026": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "程序中的ini参数在ini文件中未定义\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查程序中的ini参数名是否正确",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2027": {
    "description": "内存不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "内存不足，存储字符串时出错。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 请尝试重启控制柜并重新运行程序。\n2. 若频繁出现该错误，请记录问题并联系JAKA技术服务人员。",
    "tittle": "内存不足",
    "isShowConfirm": "1"
  },
  "0x0F2028": {
    "description": "返回值类型错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "函数返回值类型不匹配。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查变量定义类型以及返回值类型，确保返回值的类型正确后再进行作业。",
    "tittle": "返回值类型错误",
    "isShowConfirm": "1"
  },
  "0x0F2029": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "子程序嵌套调用层数过多。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查作业程序中的子程序调用是否存在层层嵌套的情况（建议嵌套层数小于10）",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F202A": {
    "description": "不能添加参数",
    "type": "1",
    "isShowOTA": "0",
    "reason": "参数赋值异常。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查：\n1. 参数名是否正确；\n2. 参数类型是否正确",
    "tittle": "不能添加参数",
    "isShowConfirm": "1"
  },
  "0x0F202B": {
    "description": "用户定义错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "用户定义的变量错误。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请根据报错检查变量参数。",
    "tittle": "用户定义错误",
    "isShowConfirm": "1"
  },
  "0x0F202C": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "期望读取一个整型数（例如数组索引），但是脚本中实际给出的为非整型参数。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "字符相关指令中存在步进值参数设置异常，请设置合理步进值。（步进值只能设置为整数）",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F202D": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关键字出现未知字符。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查作业程序中的关键字。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F202E": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未知的操作符\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查作业程序语法：\n（）内的表达式，不支持单独的 &，|，!，=\n  必须为： &&， ||， !=， ==",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F202F": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "不完整的表达式。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查出错行对应的表达式书写是否正确",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2030": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2031": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2032": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2033": {
    "description": "指令过长",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本指令及参数过长。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "单行脚本指令及参数，总长度不超过255字节（最新版本不超过512字节）",
    "tittle": "指令过长",
    "isShowConfirm": "1"
  },
  "0x0F2034": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "保存系统变量时出错。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 检查系统变量文件jaka_user.var\n2. 检查系统变量文件，变量索引是否按顺序存储。",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2035": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未定义的指令参数。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查出错位置的脚本指令参数是否正确",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2036": {
    "description": "文件没有打开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "打开文件或文件夹失败。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 文件夹或文件名路径是否正确；\n2. 文件夹或文件打开的权限是否正确；\n3. 文件是否损坏。",
    "tittle": "文件没有打开",
    "isShowConfirm": "1"
  },
  "0x0F2037": {
    "description": "重复定义",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本解释器关键字映射出错。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "系统内部错误。记录错误日志和作业程序并联系技术人员",
    "tittle": "重复定义",
    "isShowConfirm": "1"
  },
  "0x0F2038": {
    "description": "作业程序语法错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "脚本解释器关键字映射出错。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "系统内部错误。记录错误日志和作业程序并联系技术人员",
    "tittle": "作业程序语法错误",
    "isShowConfirm": "1"
  },
  "0x0F2039": {
    "description": "重复打开文件",
    "type": "1",
    "isShowOTA": "0",
    "reason": "无法打开文件。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 文件夹或文件名路径是否正确；\n2. 文件夹或文件打开的权限是否正确；\n3. 文件是否损坏。",
    "tittle": "重复打开文件",
    "isShowConfirm": "1"
  },
  "0x0F203A": {
    "description": "脚本程序中存在未匹配的'end'关键字",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本程序中存在未匹配的'end'关键字。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查脚本程序中的end关键字",
    "tittle": "未匹配的'end'关键字",
    "isShowConfirm": "1"
  },
  "0x0F203B": {
    "description": "创建的线程数量过多",
    "type": "1",
    "isShowOTA": "1",
    "reason": "最多允许同时运行5个线程.\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "等待线程结束或销毁线程后再创建",
    "tittle": "创建线程失败",
    "isShowConfirm": "1"
  },
  "0x0F203C": {
    "description": "创建线程失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "线程已经在运行不允许重复创建线程。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "等待线程结束或销毁线程后再创建",
    "tittle": "创建线程失败",
    "isShowConfirm": "1"
  },
  "0x0F203D": {
    "description": "未匹配的elif",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到elif但是没有与之匹配的if。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序的if语句块",
    "tittle": "未匹配的关键字",
    "isShowConfirm": "1"
  },
  "0x0F203E": {
    "description": "未匹配的else",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到else但是没有与之匹配的if。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序的if语句块",
    "tittle": "未匹配的关键字",
    "isShowConfirm": "1"
  },
  "0x0F203F": {
    "description": "未匹配的break",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到break但是没有与之匹配的while。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序的while语句块",
    "tittle": "未匹配的关键字",
    "isShowConfirm": "1"
  },
  "0x0F2040": {
    "description": "未匹配到continue",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到'continue'但是没有与之匹配的'while'。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序的while语句块",
    "tittle": "未匹配的关键字",
    "isShowConfirm": "1"
  },
  "0x0F2041": {
    "description": "未匹配到return",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到return但是没有与之匹配的'sub'。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序的sub语句块",
    "tittle": "未匹配的关键字",
    "isShowConfirm": "1"
  },
  "0x0F2042": {
    "description": "TIO信号量读取失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未定义的信号量",
    "action": "请先定义后访问或检查拼写是否正确",
    "tittle": "TIO信号量读取失败",
    "isShowConfirm": "1"
  },
  "0x0F2043": {
    "description": "添加系统变量失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "变量索引超出范围",
    "action": "请确保变量索引范围在 1到5601",
    "tittle": "添加系统变量失败",
    "isShowConfirm": "1"
  },
  "0x0F2050": {
    "description": "SOCKET id 无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "",
    "tittle": "SOCKET id 无效",
    "isShowConfirm": "1"
  },
  "0x0F2051": {
    "description": "逆解失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "作业程序中使用了逆解计算相关指令，且计算失败。可能与给定参考关节角度以及求解的末端位姿有关。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "手动jog检查能否从参考关节运动通过笛卡尔空间运动到目标点，如果可以，考虑改变当前机器人的姿态，从其它的路径或姿态到达目标点，或者改变目标点的姿态。",
    "tittle": "逆解失败",
    "isShowConfirm": "1"
  },
  "0x0F2052": {
    "description": "正解失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "作业程序中使用了正解计算相关指令，且计算失败。可能与关节角度值设定参数有关。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "手动jog检查能否从参考关节运动通过笛卡尔空间运动到目标点，如果可以，考虑改变当前机器人的姿态，从其它的路径或姿态到达目标点，或者改变目标点的姿态。",
    "tittle": "正解失败",
    "isShowConfirm": "1"
  },
  "0x0F2053": {
    "description": "TCP/IP 通讯接收到错误数据",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查控制器是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "TCP/IP 通讯接收到错误数据",
    "isShowConfirm": "1"
  },
  "0x0F2054": {
    "description": "数组变量无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "数组变量未定义或者变量不是数组类型。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序出错行对应的数组变量使用是否正确",
    "tittle": "数组变量无效",
    "isShowConfirm": "1"
  },
  "0x0F2055": {
    "description": "数组元素索引无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "数组索引值超出数组范围。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请检查脚本程序出错行对应的数组索引是否正确",
    "tittle": "数组元素索引无效",
    "isShowConfirm": "1"
  },
  "0x0F2056": {
    "description": "位姿插值系数无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "位姿插值指令传入的插值系数无效。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查出错位置的位置插值指令参数",
    "tittle": "位姿插值系数无效",
    "isShowConfirm": "1"
  },
  "0x0F2057": {
    "description": "控制块结束符不匹配",
    "type": "1",
    "isShowOTA": "1",
    "reason": "if、while控制块缺少与之匹配的end结束符。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "检查自定义脚本子程序中的if、while语句块是否都有end结束符",
    "tittle": "控制块结束符不匹配",
    "isShowConfirm": "1"
  },
  "0x0F2058": {
    "description": "不支持的转义字符",
    "type": "1",
    "isShowOTA": "0",
    "reason": "脚本程序中使用了不支持的转译字符输入。\n目前仅支持：\n \\n, \\r, \\t, \\\", \\', \\\\,\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "目前支持的转义字符有：\\\\ 反斜杠符号\n\\' 单引号\n\\\" 双引号\n\\n换行\n\\t 横向制表符\n\\r 回车",
    "tittle": "不支持的转义字符",
    "isShowConfirm": "1"
  },
  "0x0F2059": {
    "description": "无效的数组切割间距参数",
    "type": "1",
    "isShowOTA": "0",
    "reason": "切片方式访问数组时使用的步长无效。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查脚本程序：\n  切片方式访问素组时，步长应为大于0的整数",
    "tittle": "无效的数组切割间距参数",
    "isShowConfirm": "1"
  },
  "0x0F2060": {
    "description": "不支持数组嵌套",
    "type": "1",
    "isShowOTA": "0",
    "reason": "数组变量内不支持以数组为元素。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查脚本程序：\n  数组变量内不支持以数组为元素",
    "tittle": "不支持数组嵌套",
    "isShowConfirm": "1"
  },
  "0x0F2061": {
    "description": "不支持字符串数组",
    "type": "1",
    "isShowOTA": "0",
    "reason": "数组变量内不支持以字符串为元素。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "根据报错信息检查脚本程序：\n  数组变量内不支持以字符串为元素",
    "tittle": "不支持字符串数组",
    "isShowConfirm": "1"
  },
  "0x0F2062": {
    "description": "SOCKET资源分配过多而未释放",
    "type": "1",
    "isShowOTA": "0",
    "reason": "创建了过多的SOCKET并且没有关闭。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "1. 请确保使用 SOCKET指令后，在不使用时及时关闭；\n2. 避免在循环语句中打开SOCKET，若打开需在下一次创建前将其及时关闭；\n3. 未关闭情况下，目前最多允许创建256个SOCKET",
    "tittle": "SOCKET资源分配过多而未释放",
    "isShowConfirm": "1"
  },
  "0x0F2063": {
    "description": "SOCKET 接收的数据无效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "SOCKET接收变量指令，接收到的数据格式不正确。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "脚本程序中使用了SOCKET接收变量、接收数组指令时，请确保server端发送的数据格式符合脚本编程指令中定义的返回数据格式。",
    "tittle": "SOCKET 接收的数据无效",
    "isShowConfirm": "1"
  },
  "0x0F2064": {
    "description": "Socket 接收到的数组长度不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket接收数据的数组长度和服务器发送过来的数组长度不匹配。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "脚本程序中使用了SOCKET接收数组指令时，请确保server端返回的数组长度正确",
    "tittle": "Socket 接收到的数组长度不匹配",
    "isShowConfirm": "1"
  },
  "0x0F2065": {
    "description": "Socket 接收到的数据类型不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket接收数据的变量类型和服务器发送过来的数据类型不匹配。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "脚本程序中使用了SOCKET接收变量、接收数组指令时，请确保server端发送回的数据类型正确。",
    "tittle": "Socket 接收到的数据类型不匹配",
    "isShowConfirm": "1"
  },
  "0x0F2066": {
    "description": "程序指令设置碰撞灵敏度等级功能未启用",
    "type": "0",
    "isShowOTA": "0",
    "reason": "此版本未启用在程序中设置碰撞灵敏度等级功能，执行时相关指令将被跳过。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请在安全设置中配置碰撞灵敏度等级，或联系节卡技术人员启用此功能。",
    "tittle": "程序指令设置碰撞灵敏度等级功能未启用",
    "isShowConfirm": "1"
  },
  "0x0F2067": {
    "description": "操作符不支持该变量类型",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "1": "/",
        "2": "%",
        "3": "**",
        "4": "*",
        "5": "&&",
        "6": "^",
        "7": "-",
        "8": "||",
        "9": "+",
        "13": "<",
        "14": "==",
        "15": "!=",
        "16": "<=",
        "17": ">=",
        "18": ">"
      },
      "1": {
        "0": "标量",
        "1": "数组",
        "2": "字符串"
      },
      "2": {
        "0": "标量",
        "1": "数组",
        "2": "字符串"
      }
    },
    "reason": "操作符 \"<0>\" 不支持的操作类型：\"<1>\" 和 \"<2>\"。\n出错的文件为：{0}\n错误行号是：{1}",
    "action": "请根据报错信示检查对应脚本变量的类型。",
    "tittle": "变量类型错误",
    "isShowConfirm": "1"
  },
  "0x0F2068": {
    "description": "程序运行出错",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行出错",
    "action": "程序运行出错",
    "tittle": "程序运行出错",
    "isShowConfirm": "0"
  },
  "0x0F2069": {
    "description": "当IO引脚为输出类型时无法获取数字输入信号",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "获取数字输入信号失败",
    "isShowConfirm": "1"
  },
  "0x0F206A": {
    "description": "当IO引脚为输入类型时无法获取数字输出信号",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "获取数字输出信号失败",
    "isShowConfirm": "1"
  },
  "0x0F206B": {
    "description": "获取数字输入信号异常，等待数字输入指令执行错误",
    "type": "2",
    "isShowOTA": "0",
    "reason": "当IO引脚为输出类型时无法获取数字输入，无法根据此IO引脚的信号状态来执行\"等待\"操作.",
    "action": "请确认被操作IO引脚为输入类型后再执行等待输入信号指令.",
    "tittle": "等待数字输入指令执行失败",
    "isShowConfirm": "1"
  },
  "0x0F3001": {
    "description": "连接指定视觉设备失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器连接视觉设备失败",
    "action": "检查视觉的硬件接线是否正常，检查视觉的供电DC24V正负极线束是否正确。如果仍然无法连接，请联系供应商工程师处理！",
    "tittle": "连接指定视觉设备失败",
    "isShowConfirm": "1"
  },
  "0x0F3002": {
    "description": "没有连接视觉设备",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器无法检测到视觉在线",
    "action": "检查视觉的硬件接线是否正常，检查视觉的供电DC24V正负极线束是否正确。如果仍然无法连接，请联系供应商工程师处理！",
    "tittle": "没有连接视觉设备",
    "isShowConfirm": "1"
  },
  "0x0F4001": {
    "description": "伺服状态读取失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "伺服状态读取失败",
    "isShowConfirm": "1"
  },
  "0x0F4002": {
    "description": "固件升级失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "机器人固件包升级失败",
    "action": "检查固件文件名是否后缀为.tar.gz格式，且没有多余内容，在App界面升级过程中请勿断电、关机操作。",
    "tittle": "固件升级失败",
    "isShowConfirm": "1"
  },
  "0x0F4003": {
    "description": "当前硬件不支持该功能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人本体或控制柜无法支持当前使用的功能",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，联系技术支持工程师处理。",
    "tittle": "当前硬件不支持该功能",
    "isShowConfirm": "1"
  },
  "0x0F4004": {
    "description": "机器人关节{0}存在潜在风险",
    "type": "2",
    "isShowOTA": "0",
    "reason": "关节内部参数自检异常。注：此信息为警告信息，对程序运行无影响。",
    "action": "请联系技术支持工程师对关节进行点检排查。",
    "tittle": "机器人自诊断异常",
    "isShowConfirm": "1"
  },
  "0x0FFFFE": {
    "description": "其它错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "其它错误",
    "isShowConfirm": "1"
  },
  "0x0FFFFF": {
    "description": "未知错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "未知错误",
    "isShowConfirm": "1"
  },
  "0x102230": {
    "description": "关节1母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节1母线过流",
    "isShowConfirm": "1"
  },
  "0x102320": {
    "description": "关节1输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节1输出过流",
    "isShowConfirm": "1"
  },
  "0x102321": {
    "description": "关节1电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节1电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x102350": {
    "description": "关节1模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x103130": {
    "description": "关节1输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节1输入缺相",
    "isShowConfirm": "1"
  },
  "0x103210": {
    "description": "关节1伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节1伺服过压",
    "isShowConfirm": "1"
  },
  "0x103211": {
    "description": "关节1驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节1驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x103220": {
    "description": "关节1伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节1伺服欠压",
    "isShowConfirm": "1"
  },
  "0x103380": {
    "description": "关节1编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节1编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x103381": {
    "description": "关节1输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节1输出缺相",
    "isShowConfirm": "1"
  },
  "0x104210": {
    "description": "关节1电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1电机过温",
    "isShowConfirm": "1"
  },
  "0x104310": {
    "description": "关节1伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节1伺服过温",
    "isShowConfirm": "1"
  },
  "0x105201": {
    "description": "关节1参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节1参数未解锁",
    "isShowConfirm": "1"
  },
  "0x105202": {
    "description": "关节1校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节1校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x105210": {
    "description": "关节1参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节1参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x105211": {
    "description": "关节1型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节1型号选择错误",
    "isShowConfirm": "1"
  },
  "0x105280": {
    "description": "关节1内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节1内部参数错误",
    "isShowConfirm": "1"
  },
  "0x105281": {
    "description": "关节1PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节1PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x105282": {
    "description": "关节1EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节1EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x105283": {
    "description": "关节1上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节1上使能失败",
    "isShowConfirm": "1"
  },
  "0x105441": {
    "description": "关节1内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1内部连接错误",
    "isShowConfirm": "1"
  },
  "0x105480": {
    "description": "关节1伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1伺服过功率",
    "isShowConfirm": "1"
  },
  "0x106000": {
    "description": "关节1绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节1绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x106010": {
    "description": "关节1编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节1编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x107180": {
    "description": "关节1电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节1电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x107181": {
    "description": "关节1电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节1电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x107182": {
    "description": "关节1高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节1高频注入反向",
    "isShowConfirm": "1"
  },
  "0x107185": {
    "description": "关节1电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节1电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x107380": {
    "description": "关节1编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节1编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x107381": {
    "description": "关节1编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节1编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x107382": {
    "description": "关节1编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节1编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x107383": {
    "description": "关节1编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节1编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x107384": {
    "description": "关节1编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节1编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x107385": {
    "description": "关节1双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节1双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x107386": {
    "description": "关节1编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x107387": {
    "description": "关节1Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节1Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x107388": {
    "description": "关节1编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节1编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x107389": {
    "description": "关节1增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节1增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x107580": {
    "description": "关节1转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节1转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x108000": {
    "description": "关节1位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节1位置偏离",
    "isShowConfirm": "1"
  },
  "0x108001": {
    "description": "关节1位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节1位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x108480": {
    "description": "关节1正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节1正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x108481": {
    "description": "关节1负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节1负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x108482": {
    "description": "关节1速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1速度超限",
    "isShowConfirm": "1"
  },
  "0x108483": {
    "description": "关节1速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x108484": {
    "description": "关节1预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节1预留故障",
    "isShowConfirm": "1"
  },
  "0x108485": {
    "description": "关节1速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1速度控制异常",
    "isShowConfirm": "1"
  },
  "0x108501": {
    "description": "关节1反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节1反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x108611": {
    "description": "关节1位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x108612": {
    "description": "关节1位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x108613": {
    "description": "关节1加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1加速度过大",
    "isShowConfirm": "1"
  },
  "0x108614": {
    "description": "关节1位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节1位置指令过大",
    "isShowConfirm": "1"
  },
  "0x108615": {
    "description": "关节1CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节1CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x108616": {
    "description": "关节 1温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 1温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x108617": {
    "description": "关节1侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节1短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节1CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x10FFFF": {
    "description": "关节发生错误",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节{0}发生错误{1}",
    "action": "当前控制器版本无法识别该错误，请联系JAKA技术人员咨询",
    "tittle": "关节发生错误",
    "isShowConfirm": "1"
  },
  "0x112230": {
    "description": "关节2母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节2母线过流",
    "isShowConfirm": "1"
  },
  "0x112320": {
    "description": "关节2输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节2输出过流",
    "isShowConfirm": "1"
  },
  "0x112321": {
    "description": "关节2电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节2电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x112350": {
    "description": "关节2模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x113130": {
    "description": "关节2输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节2输入缺相",
    "isShowConfirm": "1"
  },
  "0x113210": {
    "description": "关节2伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节2伺服过压",
    "isShowConfirm": "1"
  },
  "0x113211": {
    "description": "关节2驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节2驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x113220": {
    "description": "关节2伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节2伺服欠压",
    "isShowConfirm": "1"
  },
  "0x113380": {
    "description": "关节2编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节2编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x113381": {
    "description": "关节2输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节2输出缺相",
    "isShowConfirm": "1"
  },
  "0x114210": {
    "description": "关节2电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2电机过温",
    "isShowConfirm": "1"
  },
  "0x114310": {
    "description": "关节2伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节2伺服过温",
    "isShowConfirm": "1"
  },
  "0x115201": {
    "description": "关节2参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节2参数未解锁",
    "isShowConfirm": "1"
  },
  "0x115202": {
    "description": "关节2校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节2校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x115210": {
    "description": "关节2参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节2参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x115211": {
    "description": "关节2型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节2型号选择错误",
    "isShowConfirm": "1"
  },
  "0x115280": {
    "description": "关节2内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节2内部参数错误",
    "isShowConfirm": "1"
  },
  "0x115281": {
    "description": "关节2PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节2PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x115282": {
    "description": "关节2EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节2EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x115283": {
    "description": "关节2上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节2上使能失败",
    "isShowConfirm": "1"
  },
  "0x115441": {
    "description": "关节2内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2内部连接错误",
    "isShowConfirm": "1"
  },
  "0x115480": {
    "description": "关节2伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2伺服过功率",
    "isShowConfirm": "1"
  },
  "0x116000": {
    "description": "关节2绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节2绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x116010": {
    "description": "关节2编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节2编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x117180": {
    "description": "关节2电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节2电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x117181": {
    "description": "关节2电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节2电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x117182": {
    "description": "关节2高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节2高频注入反向",
    "isShowConfirm": "1"
  },
  "0x117185": {
    "description": "关节2电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节2电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x117380": {
    "description": "关节2编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节2编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x117381": {
    "description": "关节2编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节2编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x117382": {
    "description": "关节2编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节2编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x117383": {
    "description": "关节2编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节2编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x117384": {
    "description": "关节2编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节2编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x117385": {
    "description": "关节2双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节2双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x117386": {
    "description": "关节2编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x117387": {
    "description": "关节2Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节2Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x117388": {
    "description": "关节2编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节2编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x117389": {
    "description": "关节2增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节2增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x117580": {
    "description": "关节2转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节2转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x118000": {
    "description": "关节2位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节2位置偏离",
    "isShowConfirm": "1"
  },
  "0x118001": {
    "description": "关节2位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节2位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x118480": {
    "description": "关节2正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节2正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x118481": {
    "description": "关节2负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节2负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x118482": {
    "description": "关节2速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2速度超限",
    "isShowConfirm": "1"
  },
  "0x118483": {
    "description": "关节2速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x118484": {
    "description": "关节2预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节2预留故障",
    "isShowConfirm": "1"
  },
  "0x118485": {
    "description": "关节2速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2速度控制异常",
    "isShowConfirm": "1"
  },
  "0x118501": {
    "description": "关节2反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节2反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x118611": {
    "description": "关节2位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x118612": {
    "description": "关节2位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x118613": {
    "description": "关节2加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2加速度过大",
    "isShowConfirm": "1"
  },
  "0x118614": {
    "description": "关节2位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节2位置指令过大",
    "isShowConfirm": "1"
  },
  "0x118615": {
    "description": "关节2CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节2CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x118616": {
    "description": "关节 2温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 2温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x118617": {
    "description": "关节2侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节2短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节2CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x122230": {
    "description": "关节3母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节3母线过流",
    "isShowConfirm": "1"
  },
  "0x122320": {
    "description": "关节3输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节3输出过流",
    "isShowConfirm": "1"
  },
  "0x122321": {
    "description": "关节3电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节3电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x122350": {
    "description": "关节3模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x123130": {
    "description": "关节3输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节3输入缺相",
    "isShowConfirm": "1"
  },
  "0x123210": {
    "description": "关节3伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节3伺服过压",
    "isShowConfirm": "1"
  },
  "0x123211": {
    "description": "关节3驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节3驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x123220": {
    "description": "关节3伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节3伺服欠压",
    "isShowConfirm": "1"
  },
  "0x123380": {
    "description": "关节3编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节3编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x123381": {
    "description": "关节3输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节3输出缺相",
    "isShowConfirm": "1"
  },
  "0x124210": {
    "description": "关节3电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3电机过温",
    "isShowConfirm": "1"
  },
  "0x124310": {
    "description": "关节3伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节3伺服过温",
    "isShowConfirm": "1"
  },
  "0x125201": {
    "description": "关节3参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节3参数未解锁",
    "isShowConfirm": "1"
  },
  "0x125202": {
    "description": "关节3校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节3校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x125210": {
    "description": "关节3参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节3参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x125211": {
    "description": "关节3型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节3型号选择错误",
    "isShowConfirm": "1"
  },
  "0x125280": {
    "description": "关节3内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节3内部参数错误",
    "isShowConfirm": "1"
  },
  "0x125281": {
    "description": "关节3PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节3PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x125282": {
    "description": "关节3EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节3EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x125283": {
    "description": "关节3上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节3上使能失败",
    "isShowConfirm": "1"
  },
  "0x125441": {
    "description": "关节3内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3内部连接错误",
    "isShowConfirm": "1"
  },
  "0x125480": {
    "description": "关节3伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3伺服过功率",
    "isShowConfirm": "1"
  },
  "0x126000": {
    "description": "关节3绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节3绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x126010": {
    "description": "关节3编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节3编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x127180": {
    "description": "关节3电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节3电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x127181": {
    "description": "关节3电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节3电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x127182": {
    "description": "关节3高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节3高频注入反向",
    "isShowConfirm": "1"
  },
  "0x127185": {
    "description": "关节3电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节3电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x127380": {
    "description": "关节3编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节3编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x127381": {
    "description": "关节3编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节3编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x127382": {
    "description": "关节3编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节3编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x127383": {
    "description": "关节3编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节3编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x127384": {
    "description": "关节3编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节3编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x127385": {
    "description": "关节3双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节3双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x127386": {
    "description": "关节3编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x127387": {
    "description": "关节3Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节3Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x127388": {
    "description": "关节3编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节3编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x127389": {
    "description": "关节3增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节3增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x127580": {
    "description": "关节3转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节3转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x128000": {
    "description": "关节3位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节3位置偏离",
    "isShowConfirm": "1"
  },
  "0x128001": {
    "description": "关节3位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节3位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x128480": {
    "description": "关节3正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节3正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x128481": {
    "description": "关节3负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节3负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x128482": {
    "description": "关节3速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3速度超限",
    "isShowConfirm": "1"
  },
  "0x128483": {
    "description": "关节3速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x128484": {
    "description": "关节3预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节3预留故障",
    "isShowConfirm": "1"
  },
  "0x128485": {
    "description": "关节3速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3速度控制异常",
    "isShowConfirm": "1"
  },
  "0x128501": {
    "description": "关节3反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节3反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x128611": {
    "description": "关节3位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x128612": {
    "description": "关节3位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x128613": {
    "description": "关节3加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3加速度过大",
    "isShowConfirm": "1"
  },
  "0x128614": {
    "description": "关节3位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节3位置指令过大",
    "isShowConfirm": "1"
  },
  "0x128615": {
    "description": "关节3CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节3CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x128616": {
    "description": "关节 3温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 3温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x128617": {
    "description": "关节3侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节3短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节3CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x132230": {
    "description": "关节4母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节4母线过流",
    "isShowConfirm": "1"
  },
  "0x132320": {
    "description": "关节4输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节4输出过流",
    "isShowConfirm": "1"
  },
  "0x132321": {
    "description": "关节4电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节4电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x132350": {
    "description": "关节4模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x133130": {
    "description": "关节4输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节4输入缺相",
    "isShowConfirm": "1"
  },
  "0x133210": {
    "description": "关节4伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节4伺服过压",
    "isShowConfirm": "1"
  },
  "0x133211": {
    "description": "关节4驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节4驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x133220": {
    "description": "关节4伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节4伺服欠压",
    "isShowConfirm": "1"
  },
  "0x133380": {
    "description": "关节4编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节4编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x133381": {
    "description": "关节4输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节4输出缺相",
    "isShowConfirm": "1"
  },
  "0x134210": {
    "description": "关节4电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4电机过温",
    "isShowConfirm": "1"
  },
  "0x134310": {
    "description": "关节4伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节4伺服过温",
    "isShowConfirm": "1"
  },
  "0x135201": {
    "description": "关节4参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节4参数未解锁",
    "isShowConfirm": "1"
  },
  "0x135202": {
    "description": "关节4校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节4校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x135210": {
    "description": "关节4参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节4参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x135211": {
    "description": "关节4型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节4型号选择错误",
    "isShowConfirm": "1"
  },
  "0x135280": {
    "description": "关节4内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节4内部参数错误",
    "isShowConfirm": "1"
  },
  "0x135281": {
    "description": "关节4PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节4PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x135282": {
    "description": "关节4EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节4EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x135283": {
    "description": "关节4上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节4上使能失败",
    "isShowConfirm": "1"
  },
  "0x135441": {
    "description": "关节4内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4内部连接错误",
    "isShowConfirm": "1"
  },
  "0x135480": {
    "description": "关节4伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4伺服过功率",
    "isShowConfirm": "1"
  },
  "0x136000": {
    "description": "关节4绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节4绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x136010": {
    "description": "关节4编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节4编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x137180": {
    "description": "关节4电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节4电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x137181": {
    "description": "关节4电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节4电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x137182": {
    "description": "关节4高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节4高频注入反向",
    "isShowConfirm": "1"
  },
  "0x137185": {
    "description": "关节4电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节4电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x137380": {
    "description": "关节4编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节4编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x137381": {
    "description": "关节4编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节4编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x137382": {
    "description": "关节4编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节4编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x137383": {
    "description": "关节4编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节4编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x137384": {
    "description": "关节4编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节4编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x137385": {
    "description": "关节4双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节4双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x137386": {
    "description": "关节4编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x137387": {
    "description": "关节4Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节4Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x137388": {
    "description": "关节4编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节4编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x137389": {
    "description": "关节4增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节4增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x137580": {
    "description": "关节4转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节4转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x138000": {
    "description": "关节4位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节4位置偏离",
    "isShowConfirm": "1"
  },
  "0x138001": {
    "description": "关节4位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节4位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x138480": {
    "description": "关节4正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节4正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x138481": {
    "description": "关节4负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节4负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x138482": {
    "description": "关节4速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4速度超限",
    "isShowConfirm": "1"
  },
  "0x138483": {
    "description": "关节4速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x138484": {
    "description": "关节4预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节4预留故障",
    "isShowConfirm": "1"
  },
  "0x138485": {
    "description": "关节4速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4速度控制异常",
    "isShowConfirm": "1"
  },
  "0x138501": {
    "description": "关节4反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节4反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x138611": {
    "description": "关节4位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x138612": {
    "description": "关节4位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x138613": {
    "description": "关节4加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4加速度过大",
    "isShowConfirm": "1"
  },
  "0x138614": {
    "description": "关节4位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节4位置指令过大",
    "isShowConfirm": "1"
  },
  "0x138615": {
    "description": "关节4CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节4CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x138616": {
    "description": "关节 4温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 4温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x138617": {
    "description": "关节4侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节4短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节4CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x142230": {
    "description": "关节5母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节5母线过流",
    "isShowConfirm": "1"
  },
  "0x142320": {
    "description": "关节5输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节5输出过流",
    "isShowConfirm": "1"
  },
  "0x142321": {
    "description": "关节5电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节5电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x142350": {
    "description": "关节5模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x143130": {
    "description": "关节5输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节5输入缺相",
    "isShowConfirm": "1"
  },
  "0x143210": {
    "description": "关节5伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节5伺服过压",
    "isShowConfirm": "1"
  },
  "0x143211": {
    "description": "关节5驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节5驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x143220": {
    "description": "关节5伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节5伺服欠压",
    "isShowConfirm": "1"
  },
  "0x143380": {
    "description": "关节5编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节5编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x143381": {
    "description": "关节5输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节5输出缺相",
    "isShowConfirm": "1"
  },
  "0x144210": {
    "description": "关节5电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5电机过温",
    "isShowConfirm": "1"
  },
  "0x144310": {
    "description": "关节5伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节5伺服过温",
    "isShowConfirm": "1"
  },
  "0x145201": {
    "description": "关节5参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节5参数未解锁",
    "isShowConfirm": "1"
  },
  "0x145202": {
    "description": "关节5校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节5校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x145210": {
    "description": "关节5参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节5参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x145211": {
    "description": "关节5型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节5型号选择错误",
    "isShowConfirm": "1"
  },
  "0x145280": {
    "description": "关节5内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节5内部参数错误",
    "isShowConfirm": "1"
  },
  "0x145281": {
    "description": "关节5PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节5PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x145282": {
    "description": "关节5EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节5EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x145283": {
    "description": "关节5上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节5上使能失败",
    "isShowConfirm": "1"
  },
  "0x145441": {
    "description": "关节5内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5内部连接错误",
    "isShowConfirm": "1"
  },
  "0x145480": {
    "description": "关节5伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5伺服过功率",
    "isShowConfirm": "1"
  },
  "0x146000": {
    "description": "关节5绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节5绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x146010": {
    "description": "关节5编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节5编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x147180": {
    "description": "关节5电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节5电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x147181": {
    "description": "关节5电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节5电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x147182": {
    "description": "关节5高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节5高频注入反向",
    "isShowConfirm": "1"
  },
  "0x147185": {
    "description": "关节5电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节5电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x147380": {
    "description": "关节5编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节5编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x147381": {
    "description": "关节5编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节5编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x147382": {
    "description": "关节5编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节5编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x147383": {
    "description": "关节5编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节5编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x147384": {
    "description": "关节5编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节5编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x147385": {
    "description": "关节5双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节5双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x147386": {
    "description": "关节5编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x147387": {
    "description": "关节5Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节5Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x147388": {
    "description": "关节5编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节5编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x147389": {
    "description": "关节5增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节5增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x147580": {
    "description": "关节5转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节5转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x148000": {
    "description": "关节5位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节5位置偏离",
    "isShowConfirm": "1"
  },
  "0x148001": {
    "description": "关节5位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节5位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x148480": {
    "description": "关节5正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节5正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x148481": {
    "description": "关节5负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节5负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x148482": {
    "description": "关节5速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5速度超限",
    "isShowConfirm": "1"
  },
  "0x148483": {
    "description": "关节5速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x148484": {
    "description": "关节5预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节5预留故障",
    "isShowConfirm": "1"
  },
  "0x148485": {
    "description": "关节5速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5速度控制异常",
    "isShowConfirm": "1"
  },
  "0x148501": {
    "description": "关节5反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节5反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x148611": {
    "description": "关节5位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x148612": {
    "description": "关节5位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x148613": {
    "description": "关节5加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5加速度过大",
    "isShowConfirm": "1"
  },
  "0x148614": {
    "description": "关节5位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节5位置指令过大",
    "isShowConfirm": "1"
  },
  "0x148615": {
    "description": "关节5CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节5CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x148616": {
    "description": "关节 5温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 5温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x148617": {
    "description": "关节5侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节5短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节5CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x152230": {
    "description": "关节6母线过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机反馈电流超出阈值",
    "action": "请将使用异常报错的功能和当前使用的控制器版本信息一并拍照，并将该故障的诊断日志保存后联系技术支持工程师处理。",
    "tittle": "关节6母线过流",
    "isShowConfirm": "1"
  },
  "0x152320": {
    "description": "关节6输出过流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "检测到电机UVW的电流，超出硬件驱动板的过流阈值",
    "action": "1. 请降低机器人负载，进行使用。\n2. 请降低机器人运动速度或加速度。进行使用；\n3. 机器人关节驱动板或减速机异常，请联系技术支持人员；\n4. 通讯异常：请更换重载连接线或电控柜，或联系技术支持人员。",
    "tittle": "关节6输出过流",
    "isShowConfirm": "1"
  },
  "0x152321": {
    "description": "关节6电机寻相过流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能过程中，输出较大的电流，但未检测电机转动",
    "action": "1. 请将机器人下使能，手动释放关节电磁铁，检查是否可推动报警的关节。\n2. 请将机器人本体断电后，拆开后盖，检测线缆是否接触异常，或联系技术支持人员。",
    "tittle": "关节6电机寻相过流",
    "isShowConfirm": "1"
  },
  "0x152350": {
    "description": "关节6模块过载（I2T）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6模块过载（I2T）",
    "isShowConfirm": "1"
  },
  "0x153130": {
    "description": "关节6输入缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节6输入缺相",
    "isShowConfirm": "1"
  },
  "0x153210": {
    "description": "关节6伺服过压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的过压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查电控柜泄放板是否异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。",
    "tittle": "关节6伺服过压",
    "isShowConfirm": "1"
  },
  "0x153211": {
    "description": "关节6驱动板动力电源故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板损坏",
    "action": "联系技术人员处理",
    "tittle": "关节6驱动板动力电源故障",
    "isShowConfirm": "1"
  },
  "0x153220": {
    "description": "关节6伺服欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到母线电压，超出硬件驱动板的欠压阈值",
    "action": "1. 请检查机器人负载或运动加速度是否设置过大，请尝试降低运行工况使用。\n2. 请尝试检查机器人重载线是否连接异常。\n3. 请联系技术人员，协助检查驱动板硬件是否异常。\n4. 请联系技术人员，协助检查通讯或电控柜电源是否异常。",
    "tittle": "关节6伺服欠压",
    "isShowConfirm": "1"
  },
  "0x153380": {
    "description": "关节6编码器校零失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节上使能的过程中，电机转动与预期的不一致",
    "action": "1. 请联系技术人员，检查报警关节的相关参数是否存在异常。\n2. 请尝试对关节进行上下使能操作，检查制动器是否异常。\n3. 请联系技术人员，检查关节ABZ接线或ABZ码盘是否存在异常。",
    "tittle": "关节6编码器校零失败",
    "isShowConfirm": "1"
  },
  "0x153381": {
    "description": "关节6输出缺相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，三相电流输出异常",
    "action": "1. 请联系技术人员检查关节三相接线是否存在异常。\n2. 请联系技术人员检查关节电机线路是否存在异常。\n3. 请联系技术人员检查关节驱动板是否存在异常。",
    "tittle": "关节6输出缺相",
    "isShowConfirm": "1"
  },
  "0x154210": {
    "description": "关节6电机过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6电机过温",
    "isShowConfirm": "1"
  },
  "0x154310": {
    "description": "关节6伺服过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "检测到驱动板上的温度，超出硬件驱动板的过温阈值",
    "action": "1. 请检查当前机器人使用环境温度是否超出机器人使用温度范围。\n2. 请检查关节外表面温度是否大于50℃，若大于50℃，请降低使用工况。\n3. 请联系技术人员进行检查关节驱动板或关节减速机是否存在异常。",
    "tittle": "关节6伺服过温",
    "isShowConfirm": "1"
  },
  "0x155201": {
    "description": "关节6参数未解锁",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R176版本开始伺服关键参数添加了写保护功能避免误操作导致伺服参数错误。",
    "action": "请联系技术人员进行关节参数检查。",
    "tittle": "关节6参数未解锁",
    "isShowConfirm": "1"
  },
  "0x155202": {
    "description": "关节6校零与DH参数冲突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "进行机械零位校准时，伺服会检测当前机型出厂前是否经过DH参数标定，已标定的机型使用机械零位校准功能会造成DH存在错误，最终造成机器人精度丢失。",
    "action": "请联系技术人员协助检查。",
    "tittle": "关节6校零与DH参数冲突",
    "isShowConfirm": "1"
  },
  "0x155210": {
    "description": "关节6参数设置与硬件功率不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板、电机品牌型号、伺服参数，这三者不匹配",
    "action": "1. 请联系技术人员进行检查关节生产参数是否存在异常。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节6参数设置与硬件功率不匹配",
    "isShowConfirm": "1"
  },
  "0x155211": {
    "description": "关节6型号选择错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件驱动板与伺服参数不匹配",
    "action": "请联系技术人员进行检查关节硬件版本与伺服参数是否存在异常。",
    "tittle": "关节6型号选择错误",
    "isShowConfirm": "1"
  },
  "0x155280": {
    "description": "关节6内部参数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服参数超出阈值，该故障只有上电时会报。",
    "action": "请联系技术人员进行检查关节内部参数是否存在异常。",
    "tittle": "关节6内部参数错误",
    "isShowConfirm": "1"
  },
  "0x155281": {
    "description": "关节6PID运算溢出",
    "type": "1",
    "isShowOTA": "0",
    "reason": "伺服PID运算超出限制",
    "action": "联系技术人员处理",
    "tittle": "关节6PID运算溢出",
    "isShowConfirm": "1"
  },
  "0x155282": {
    "description": "关节6EEPROM错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "硬件EEPROM芯片读写出错",
    "action": "1.请尝试对机器人进行重新多次上下电测试，检查是否存在时序波动，若仍存在问题，请联系技术人员。\n2. 请联系技术人员进行检查关节驱动板是否存在异常。",
    "tittle": "关节6EEPROM错误",
    "isShowConfirm": "1"
  },
  "0x155283": {
    "description": "关节6上使能失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上使能过程中，由于系统其他故障导致使能失败",
    "action": "请查看系统中是否存在其他报错信息，将其他报错信息进行处理后，再进行上使能操作。",
    "tittle": "关节6上使能失败",
    "isShowConfirm": "1"
  },
  "0x155441": {
    "description": "关节6内部连接错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6内部连接错误",
    "isShowConfirm": "1"
  },
  "0x155480": {
    "description": "关节6伺服过功率",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6伺服过功率",
    "isShowConfirm": "1"
  },
  "0x156000": {
    "description": "关节6绝对编码器内部状态异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "驱动器检测到绝对编码器的运行状态异常。",
    "action": "确认现场环境是否存在强电场、强磁场干扰；确认绝对编码器供电是否正常；确认绝对编码器与驱动器连接线是否有松动以及检查连接线是否有破损。",
    "tittle": "关节6绝对编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x156010": {
    "description": "关节6编码器温度过热",
    "type": "2",
    "isShowOTA": "0",
    "reason": "编码器温度状态异常",
    "action": "1. 请检查关节温度是否超出使用范围要求，请降低使用工况。\n2. 请联系技术人员检查关节或编码器是否存在异常。",
    "tittle": "关节6编码器温度过热",
    "isShowConfirm": "1"
  },
  "0x157180": {
    "description": "关节6电机过载(I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机输出大电流，并且持续了一段时间",
    "action": "1. 请检查机器人报警过载之前是否发生了碰撞。\n2. 请检查关节实际的负载是否已经严重超出机器人的标称负载。\n3. 请联系技术人员检查报警关节的参数。\n4. 请通过拖拽模式检查关节制动器机构是否异常。\n5. 请联系技术人员检查关节是否出现机械性卡涩。\n6. 请联系技术人员检查转子ABZ编码器是否读取异常。",
    "tittle": "关节6电机过载(I2T)",
    "isShowConfirm": "1"
  },
  "0x157181": {
    "description": "关节6电机抱闸故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "未监测到电磁铁",
    "action": "1. 请检查关节电磁铁接线是否异常。\n2. 请检查测量电磁铁阻值是否正常。",
    "tittle": "关节6电机抱闸故障",
    "isShowConfirm": "1"
  },
  "0x157182": {
    "description": "关节6高频注入反向",
    "type": "1",
    "isShowOTA": "0",
    "reason": "电机实际磁极方向与脉冲注入计算不一致，出现控制异常",
    "action": "1. 请联系技术人员查看电机参数是否正确。\n2. 请检查电机相序接线是否正确。\n3. 请联系技术人员检查关节驱动板是否异常。",
    "tittle": "关节6高频注入反向",
    "isShowConfirm": "1"
  },
  "0x157185": {
    "description": "关节6电机抱闸电流异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6抱闸关闭情况下存在电流或抱闸打开情况下电流超过2A",
    "action": "1.检查关节抱闸线缆是否存在连接异常\n2.检查关节抱闸是否出现短路",
    "tittle": "关节6电机抱闸电流异常",
    "isShowConfirm": "1"
  },
  "0x157380": {
    "description": "关节6编码器连接超时",
    "type": "1",
    "isShowOTA": "0",
    "reason": "绝对编码器的读状态出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员，更换编码器连接排线，查看故障是否消除\n3. 请联系技术人员，检查编码器状态灯是否异常。",
    "tittle": "关节6编码器连接超时",
    "isShowConfirm": "1"
  },
  "0x157381": {
    "description": "关节6编码器电池欠压",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器内部电池欠压",
    "action": "1. 生产参数确认：联系技术人员检查报警关节的生产参数是否正确\n2. 检查排线：拆开关节端盖，检查编码器排线是否松动，联系技术人员更换\n3. 编码器故障，更换关节编码器或更换关节",
    "tittle": "关节6编码器电池欠压",
    "isShowConfirm": "1"
  },
  "0x157382": {
    "description": "关节6编码器电池断开",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器电源错误",
    "action": "1. 如报错仅出现在机器人上电、下电过程中，不影响使用，无需进一步处理\n2. 编码器损坏，如故障持续出现影响使用，联系技术人员更换",
    "tittle": "关节6编码器电池断开",
    "isShowConfirm": "1"
  },
  "0x157383": {
    "description": "关节6编码器存储角度错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节电机位置校准出错",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确。\n2. 请联系技术人员对关节进行重新标定Z值。",
    "tittle": "关节6编码器存储角度错误",
    "isShowConfirm": "1"
  },
  "0x157384": {
    "description": "关节6编码器计数错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器计数异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员检查编码器安装或查看码盘脏污情况",
    "tittle": "关节6编码器计数错误",
    "isShowConfirm": "1"
  },
  "0x157385": {
    "description": "关节6双编码器校验错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节双编码器记录的位置出现偏差，超出一定的阈值",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请确认是否发生严重碰撞或机械失效，并联系技术人员。\n3. 请联系技术人员检查编码器安装或查看码盘脏污情况。",
    "tittle": "关节6双编码器校验错误",
    "isShowConfirm": "1"
  },
  "0x157386": {
    "description": "关节6编码器内部错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6编码器内部错误",
    "isShowConfirm": "1"
  },
  "0x157387": {
    "description": "关节6Z线捕捉故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相对编码器Z线捕捉异常",
    "action": "1. 请联系技术人员检查报警关节的生产参数是否正确\n2. 请联系技术人员对关节相对编码器进行查看修复",
    "tittle": "关节6Z线捕捉故障",
    "isShowConfirm": "1"
  },
  "0x157388": {
    "description": "关节6编码器磁信号异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "编码器信号幅值错误、磁模式错误、信号丢失、信号异常",
    "action": "1. 请查看是否为固定关节报错，请联系技术人员检查关节或编码器是否异常。\n2. 请查看机器人工作环境或本体是否有外部信号或磁信号干扰。",
    "tittle": "关节6编码器磁信号异常",
    "isShowConfirm": "1"
  },
  "0x157389": {
    "description": "关节6增量编码器连接异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6上电后进行脉冲注入微动时获取到的增量编码器数据没有发生变化",
    "action": "1.检查增量编码器线缆连接是否存在异常\n2.检查增量编码器读头是否损坏\n3.检查码盘是否存在大面积脏污",
    "tittle": "关节6增量编码器连接异常",
    "isShowConfirm": "1"
  },
  "0x157580": {
    "description": "关节6转矩前馈超过限制值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "转矩前馈超出伺服阈值",
    "action": "联系技术人员处理",
    "tittle": "关节6转矩前馈超过限制值",
    "isShowConfirm": "1"
  },
  "0x158000": {
    "description": "关节6位置偏离",
    "type": "2",
    "isShowOTA": "1",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节6位置偏离",
    "isShowConfirm": "1"
  },
  "0x158001": {
    "description": "关节6位置偏离预警",
    "type": "2",
    "isShowOTA": "0",
    "reason": "根据伺服位置跟随误差判断碰撞检测",
    "action": "1. 请检查机器人是否发生碰撞。\n2. 请检查机器人运动加速度是否设置过大。\n3. 请检查机器人是否负载超出要求范围。\n4. 请检查软件中机器人安装姿态与实际姿态是否一致。\n5. 请检查运动中是否错误使用运动段转接。",
    "tittle": "关节6位置偏离预警",
    "isShowConfirm": "0"
  },
  "0x158480": {
    "description": "关节6正向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速同向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节6正向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x158481": {
    "description": "关节6负向速度跟踪错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "实际转速与设定转速反向时，转速误差超过设定的报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。",
    "tittle": "关节6负向速度跟踪错误",
    "isShowConfirm": "1"
  },
  "0x158482": {
    "description": "关节6速度超限",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速超出关节额定速度",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6速度超限",
    "isShowConfirm": "1"
  },
  "0x158483": {
    "description": "关节6速度跟踪误差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出报警阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6速度跟踪误差过大",
    "isShowConfirm": "1"
  },
  "0x158484": {
    "description": "关节6预留故障",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "请检查伺服是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "关节6预留故障",
    "isShowConfirm": "1"
  },
  "0x158485": {
    "description": "关节6速度控制异常",
    "type": "1",
    "isShowOTA": "1",
    "reason": "关节实际转速与指令转速偏差超出阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6速度控制异常",
    "isShowConfirm": "1"
  },
  "0x158501": {
    "description": "关节6反向驱动模式下伺服禁止使能",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6反向驱动模式下伺服禁止使能",
    "action": "请退出反向驱动模式后重新进行使能操作",
    "tittle": "关节6反向驱动模式下伺服禁止使能",
    "isShowConfirm": "1"
  },
  "0x158611": {
    "description": "关节6位置偏差过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "实际位置反馈与指令位置偏差超出设定阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6位置偏差过大",
    "isShowConfirm": "1"
  },
  "0x158612": {
    "description": "关节6位置指令增量过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令增量过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6位置指令增量过大",
    "isShowConfirm": "1"
  },
  "0x158613": {
    "description": "关节6加速度过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度过大，超过阈值",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请检查是否出现碰撞，负载设置是否正确。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6加速度过大",
    "isShowConfirm": "1"
  },
  "0x158614": {
    "description": "关节6位置指令过大",
    "type": "1",
    "isShowOTA": "1",
    "reason": "控制器下发的位置指令出错",
    "action": "1. 请检查程序加速度是否设置过大。\n2. 请检查运动段转接参数设置是否存在异常。\n3. 请联系技术人员检查机器人总线通讯是否正常。\n4. 若当时使用为servo模式，请检查发送指令是否连续或异常，位置逆解是否连续或异常。",
    "tittle": "关节6位置指令过大",
    "isShowConfirm": "1"
  },
  "0x158615": {
    "description": "关节6CAN通讯异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人总线通讯异常",
    "action": "请联系技术人员检查机器人总线通讯是否异常。",
    "tittle": "关节6CAN通讯异常",
    "isShowConfirm": "1"
  },
  "0x158616": {
    "description": "关节 6温度传感器通信异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节内部温度传感器异常",
    "action": "请检测IIC接口温度传感器是否异常。",
    "tittle": "关节 6温度传感器通信异常",
    "isShowConfirm": "1"
  },
  "0x158617": {
    "description": "关节6侦测到CAN通讯周期存在波动",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节6短时间内侦测到较多大幅度的CAN通讯周期波动",
    "action": "1.进行故障诊断（可能由于其他报错已经自动进行故障诊断），将保存诊断包，检查CAN通信周期波动情况（4-12ms的周期波动为正常范围）\n2.检查安全控制板S2拨码是否全为OFF状态\n3.检查控制柜、本体、重载线、CAN线连接是否出现松动",
    "tittle": "关节6CAN通信周期波动预警",
    "isShowConfirm": "1"
  },
  "0x201002": {
    "description": "机器人上电后无法初始化TIO",
    "type": "1",
    "isShowOTA": "1",
    "reason": "当机器人所有关节建立通讯后，1s内未接收到TIO数据",
    "action": "检查TIO的通讯线和电源线是否连接良好；检查TIO板是否有可见损坏；联系厂家予以支持",
    "tittle": "TIO初始化失败",
    "isShowConfirm": "0"
  },
  "0x201101": {
    "description": "扩展IO初始化失败 Modbus RTU通讯参数不匹配",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初始化时根据给定配置连接Modbus从站IO模块时出错。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO初始化时Modbus RTU配置错误",
    "isShowConfirm": "1"
  },
  "0x201102": {
    "description": "扩展IO初始化期间 创建Modbus Rtu连接失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初始化时根据给定配置连接Modbus从站IO模块时出错。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO初始化时创建Modbus RTU连接失败",
    "isShowConfirm": "1"
  },
  "0x201104": {
    "description": "扩展IO RTU 串行总线参数不一致",
    "type": "2",
    "isShowOTA": "0",
    "reason": "配置了多个RTU 扩展IO模块且个模块串行总线参数不一致",
    "action": "修改扩展IO RTU 串行总线参数使各模块参数与第一个RTU模块的参数一样",
    "tittle": "扩展IO RTU 串行总线参数不一致",
    "isShowConfirm": "1"
  },
  "0x201201": {
    "description": "扩展IO初始化失败 Modbus TCP通讯参数格式错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初始化时根据给定配置连接Modbus从站IO模块时出错。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO初始化时Modbus TCP配置错误",
    "isShowConfirm": "1"
  },
  "0x201202": {
    "description": "扩展IO初始化期间 创建Modbus TCP连接失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初始化时根据给定配置连接Modbus从站IO模块时出错。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO初始化时创建Modbus TCP连接失败",
    "isShowConfirm": "1"
  },
  "0x201304": {
    "description": "初始化期间未知错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初始化时根据给定配置连接Modbus从站IO模块时出错。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO初始化时未知错误",
    "isShowConfirm": "1"
  },
  "0x202102": {
    "description": "扩展IO运行时失败 Modbus TCP节点断线",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运行过程中Modbus TCP扩展的IO模块与控制器通讯断开。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO运行时Modbus TCP节点掉线",
    "isShowConfirm": "1"
  },
  "0x202103": {
    "description": "扩展IO运行时失败 Modbus RTU节点断线",
    "type": "1",
    "isShowOTA": "0",
    "reason": "运行过程中Modbus RTU扩展的IO模块与控制器通讯断开。",
    "action": "1.请确认扩展IO模块的类型与通讯配置；\n2.请确认控制柜接口与外部扩展IO模块的通讯物理连接正常；\n3.请确认扩展IO模块供电正常；\n4.可以尝试使用Modbus Poll工具连接扩展IO检查扩展IO模块是否异常。",
    "tittle": "扩展IO运行时Modbus RTU节点掉线",
    "isShowConfirm": "1"
  },
  "0x302380": {
    "description": "风扇电流异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜风扇未接或风扇短路。",
    "action": "请检查风扇故障状态。",
    "tittle": "风扇电流异常",
    "isShowConfirm": "1"
  },
  "0x302381": {
    "description": "输出本体供电电流异常1级预警：25A\n机器人本体电流消耗异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板采集到的电流超过设定阈值",
    "action": "请检查安全控制板固件是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "本体电流异常一级报警",
    "isShowConfirm": "1"
  },
  "0x302382": {
    "description": "输出本体供电电流异常2级预警：31.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板采集到的电流超过设定阈值",
    "action": "请检查安全控制板是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "本体电流异常二级报警",
    "isShowConfirm": "1"
  },
  "0x302383": {
    "description": "输出本体供电电流异常3级预警：37.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板采集到的电流超过设定阈值",
    "action": "请检查安全控制板是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "本体电流异常三级报警",
    "isShowConfirm": "1"
  },
  "0x302384": {
    "description": "用户IO供电电流异常（2.3A)",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜面板上24V输出总的电流值超过1.5A",
    "action": "1.请拆除控制柜面板上器件后查看是否还报该故障；\n2.若执行步骤1后未出现报错，则用户外接设备不能使用控制柜进行供电，需要单独供电.\n3.若执行步骤1后仍然报错，尝试关机重启，若仍然报错，请联系技术人员检查硬件是否损坏。",
    "tittle": "用户IO供电电流异常",
    "isShowConfirm": "1"
  },
  "0x302385": {
    "description": "工控机电流异常（工控机电流超过1.5A则认为工控机短路故障，上报错误）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "开机后没有接工控机或工控机电流超过1.5A。",
    "action": "请联系技术人员检查工控机硬件是否异常。",
    "tittle": "IPC电流异常",
    "isShowConfirm": "1"
  },
  "0x302391": {
    "description": "本体功率异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板计算的本体的功率超过设定限制值",
    "action": "1. 请在APP里面重新调整安全设置里的功率设置\n2. 请联系技术服务人员排查是否在硬件上存在功率超限的问题",
    "tittle": "本体功率异常",
    "isShowConfirm": "1"
  },
  "0x303181": {
    "description": "220V供电异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜检测220V信号的幅值和频率异常",
    "action": "1.请确定当前控制柜的供电电压以及频率,当使用110V以上、50~60Hz的交流电时会存在220V掉电检测功能,若使用90~110V AC供电的控制柜时,需要将\"设置-硬件与通讯-辅助硬件设置-控制柜供电选项\"修改为\"其他\"。\n2.请更新到最新版本固件后查看是否还存在该问题。\n3.若1和2均未解决该问题,需要确定供电电源的幅值和频率以及幅值、频率在工作期间的变化。\n4.若1和2均未解决该问题,且3无法测量,需要确定现场是否会存在机器人运行状态下直接切断控制柜供电电源情况(包括但不局限于拔掉220V插头、工厂断电等),若不存在可以将\"设置-硬件与通讯-辅助硬件设置-控制柜供电选项\"修改为\"其他\"临时使用。 ",
    "tittle": "220V供电电压异常",
    "isShowConfirm": "1"
  },
  "0x303182": {
    "description": "主供电继电器异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制48V输出的继电器在未上电情况下检测到输出信号，即控制48V电源的输入信号的继电器出现粘连。",
    "action": "1.请将安全控制板固件更新到最新版本后查看是否还存在该问题；\n2.请确定控制柜的供电电压的幅值和频率，90~110V AC供电的控制柜必须使用带有dis220v字样的固件版本；\n3.前面两步操作后还是报了该故障，请联系技术人员检查电控柜控制48V电源的继电器是否损坏。",
    "tittle": "主供电继电器异常",
    "isShowConfirm": "1"
  },
  "0x303184": {
    "description": "安全数字输入信号存在异常，安全控制板检测到异常故障并未被清除，拒绝对机器人重新上电的要求",
    "type": "2",
    "isShowOTA": "0",
    "reason": "请检查控制柜面板配置的安全数字输入信号是否存在异常，确认安全数字输入信号输入无异常后重新上电清除故障",
    "action": "",
    "tittle": "安全信号异常拒绝上电",
    "isShowConfirm": "1"
  },
  "0x303281": {
    "description": "5V异常（电源电压的波动范围）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜内部5V信号电压值超过内部预设值（3.5~6.1V），可以使用万用表测试5V信号电压值。",
    "action": "1.请检查固件版本是否为最新版本，若不是更新到最新版本后查看是否还存在该问题；\n2.控制柜输入电源断开后重新供电后开机查看是否还存在该问题，若存在请联系技术人员进行检查控制柜硬件；\n3.对于标准220V供电控制柜，拔掉220V电源必定报该故障，属于正常现象。",
    "tittle": "5V供电电压异常",
    "isShowConfirm": "1"
  },
  "0x303282": {
    "description": "12V异常（电源电压的波动范围）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜内部12V信号电压值超过内部预设值(9~14V)，可以使用万用表测量12V信号电压值。",
    "action": "1.请检查固件版本是否为最新版本，若不是更新到最新版本后查看是否还存在该问题；\n2.控制柜输入电源断开后重新供电后开机查看是否还存在该问题，若存在请联系技术人员进行检查控制柜硬件；\n3.对于标准220V供电控制柜，拔掉220V电源必定报该故障，属于正常现象。",
    "tittle": "12V供电电压异常",
    "isShowConfirm": "1"
  },
  "0x303283": {
    "description": "24V异常（电源电压的波动范围）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制柜内部12V信号电压值超过内部预设值（15~31V），可以使用万用表测量12V信号电压值。",
    "action": "1.请检查固件版本是否为最新版本，若不是更新到最新版本后查看是否还存在该问题；\n2.控制柜输入电源断开后重新供电后开机查看是否还存在该问题，若存在请联系技术人员进行检查控制柜硬件；\n3.对于标准220V供电控制柜，拔掉220V电源必定报该故障，属于正常现象。",
    "tittle": "24V供电电压异常",
    "isShowConfirm": "1"
  },
  "0x303381": {
    "description": "本体电压或电压配置异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "MiniCAB设置的泄放电压值小于MiniCAB的输入电压值。",
    "action": "请使用APP重新设置泄放电压。",
    "tittle": "本体输出供电电压异常",
    "isShowConfirm": "1"
  },
  "0x303387": {
    "description": "安全控制板继电器异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "关闭本体电源后，安全控制板检测到的控制本体电源的两个继电器电压值不一致。",
    "action": "1.请更新到最新版本固件后查看是否还存在该问题；\n2.若前面操作后还存在，请联系技术人员检查安全控制板内部继电器是否损坏。",
    "tittle": "安全控制板 继电器异常",
    "isShowConfirm": "1"
  },
  "0x304281": {
    "description": "PDU温度异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "控制柜内部温度超过70℃",
    "action": "1.请检查控制柜内部温度是否超过70℃；\n2.请检查控制柜内部风扇是否工作正常。",
    "tittle": "PDU温度异常",
    "isShowConfirm": "1"
  },
  "0x304282": {
    "description": "制动电阻过温",
    "type": "1",
    "isShowOTA": "0",
    "reason": "MiniCAB内部制动电阻温度超过80℃",
    "action": "1.请检查MiniCAB内部温度；\n2.请降低机器人运行的加速度；\n3.请添加散热风扇。",
    "tittle": "制动电阻过温",
    "isShowConfirm": "1"
  },
  "0x305081": {
    "description": "手柄急停安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请尝试更换手柄，或联系技术人员检查柜子SCB线路。",
    "tittle": "手柄急停安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305082": {
    "description": "外部急停安全输入异常。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查面板p8端子是否接触不良，并检查外接电路是否正常。",
    "tittle": "外部急停安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305083": {
    "description": "保护性停止信号输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查面板p8端子是否接触不良，并检查外接电路是否正常。",
    "tittle": "保护性停止信号输入异常",
    "isShowConfirm": "1"
  },
  "0x305084": {
    "description": "SCB继电器异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查SCB是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "SCB继电器异常",
    "isShowConfirm": "1"
  },
  "0x305085": {
    "description": "制动电阻过温",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查SCB是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "制动电阻过温",
    "isShowConfirm": "1"
  },
  "0x305086": {
    "description": "手柄使能输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查SCB是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "手柄使能输入异常",
    "isShowConfirm": "1"
  },
  "0x305087": {
    "description": "附加急停安全信号输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "附加急停安全信号输入异常",
    "isShowConfirm": "1"
  },
  "0x305088": {
    "description": "附加保护性停止安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "附加保护性停止安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305089": {
    "description": "保护性停止复位安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "保护性停止复位安全输入异常",
    "isShowConfirm": "1"
  },
  "0x30508A": {
    "description": "缩减模式安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "缩减模式安全输入异常",
    "isShowConfirm": "1"
  },
  "0x30508B": {
    "description": "三位置使能安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道,两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "三位置使能安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305090": {
    "description": "关闭碰撞检测安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "关闭碰撞检测安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305091": {
    "description": "设置碰撞灵敏度LV1安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度LV1安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305092": {
    "description": "设置碰撞灵敏度LV2安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度LV2安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305093": {
    "description": "设置碰撞灵敏度LV3安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度LV3安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305094": {
    "description": "设置碰撞灵敏度LV4安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度LV4安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305095": {
    "description": "设置碰撞灵敏度LV5安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度LV5安全输入异常",
    "isShowConfirm": "1"
  },
  "0x305097": {
    "description": "设置碰撞灵敏度极低安全输入异常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号为双冗余通道，两路信号不一致时进入安全状态。",
    "action": "请检查安全输入线路连接是否存在异常。",
    "tittle": "设置碰撞灵敏度极低安全输入异常",
    "isShowConfirm": "1"
  },
  "0x308181": {
    "description": "手柄CAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全控制板与手柄总线的数据出错。",
    "action": "1.请检查手柄与电控柜线缆连接是否正常。\n2.请联系技术人员检查安全控制板与控制柜CAN2之间的CAN总线是否异常。",
    "tittle": "手柄CAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308182": {
    "description": "控制器CAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "打开机器人电源后一段时间没有接收到控制器发送到本体的指令。",
    "action": "1.请将安全控制板固件更新到最新版本后查看是否存在该故障；\n2.在App监控查看1~6关节的数据是否有刷新；\n3.请查看本体末端指示灯是否亮，若不亮请检查接线是否正常。",
    "tittle": "控制器CAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308183": {
    "description": "本体CAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "打开机器人电源后一段时间没有接收到控制器发送到本体的指令。",
    "action": "1.请将安全控制板固件更新到最新版本后查看是否存在该故障；\n2.在App监控或伺服上位机监控页面查看1~6关节的数据是否有刷新；\n3.请查看本体末端指示灯是否亮，若不亮请检查接线是否正常。",
    "tittle": "本体CAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308184": {
    "description": "TIO CAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "打开机器人电源后一段时间没有接收到控制器发送到本体的指令。",
    "action": "1.请将安全控制板固件更新到最新版本后查看是否存在该故障；\n2.在App监控或伺服上位机监控页面查看1~6关节的数据是否有刷新；\n3.请查看本体末端指示灯是否亮，若不亮请检查接线是否正常。",
    "tittle": "TIO CAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308185": {
    "description": "等待CAN通信正常超时",
    "type": "2",
    "isShowOTA": "0",
    "reason": "打开机器人电源后一段时间没有接收到控制器发送到本体的指令。",
    "action": "1.请将安全控制板固件更新到最新版本后查看是否存在该故障；\n2.在App监控或伺服上位机监控页面查看1~6关节的数据是否有刷新；\n3.请查看本体末端指示灯是否亮，若不亮请检查接线是否正常。",
    "tittle": "等待CAN通信正常超时",
    "isShowConfirm": "1"
  },
  "0x309081": {
    "description": "拖拽模式TCP速度超限",
    "type": "2",
    "isShowOTA": "0",
    "reason": "拖拽模式TCP速度超过{0}mm/s限制，当前TCP速度为{1}mm/s。",
    "action": "请降低拖拽速度，在拖拽模式下TCP速度超出限制，机器人将退出拖拽模式。",
    "tittle": "拖拽模式TCP速度超限",
    "isShowConfirm": "1"
  },
  "0x309082": {
    "description": "紧急停止",
    "type": "2",
    "isShowOTA": "0",
    "reason": "手柄急停、用户急停、安全功能IO急停信号中的任意一个被触发。",
    "action": "请检查手柄急停、用户急停、安全功能IO急停信号哪一个被触发。",
    "tittle": "急停触发",
    "isShowConfirm": "1"
  },
  "0x309083": {
    "description": "机器人整机功率报警阈值",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "请检查SCB是否为调试版本，或联系技术服务人员提供相关错误码描述信息。",
    "tittle": "机器人整机功率报警阈值",
    "isShowConfirm": "1"
  },
  "0x3F0001": {
    "description": "力传感器连接初始化失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在传感器打开时，控制器会与传感器间根据通讯配置建立连接。当控制器与传感器间建立通讯连接失败时，会返回该错误。",
    "action": "1.请确认力传感器类型与通讯配置；\n2.请确认控制柜接口与力传感器的通讯物理连接正常；\n3.请确认力传感器供电正常；\n4.可以尝试使用Modbus调试工具或网络调试助手工具连接力传感器检查力传感器是否异常。",
    "tittle": "力传感器通讯初始化失败",
    "isShowConfirm": "1"
  },
  "0x3F0002": {
    "description": "开启力传感器频率过快",
    "type": "1",
    "isShowOTA": "0",
    "reason": "开启传感器并建立通讯需要大约1秒的时间，短时间内频繁尝试开启力传感器会触发此警告。",
    "action": "请稍后再试",
    "tittle": "开启力传感器频率过快",
    "isShowConfirm": "1"
  },
  "0x3F1001": {
    "description": "接收力传感器数据失败",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器与传感器间建立连接后，运行过程中数据断开时报此错误。",
    "action": "1.请确认力传感器类型与通讯配置；\n2.请确认控制柜接口与力传感器的通讯物理连接正常；\n3.请确认力传感器供电正常；\n4.可以尝试使用Modbus调试工具或网络调试助手工具连接力传感器检查力传感器是否异常。",
    "tittle": "接收力传感器数据失败",
    "isShowConfirm": "1"
  },
  "0x3F1002": {
    "description": "接收力传感器数据格式错误",
    "type": "1",
    "isShowOTA": "0",
    "reason": "该错误一般出现在通过TIO扩展力传感器时，接收的力传感器数据格式错误时报错。",
    "action": "1.请确认力传感器类型与通讯协议；\n2.尝试使用Modbus调试工具、网络调试助手工具或串口调试工具分析接收到的力传感器数据，以判断其是否符合JAKA+力传感器的通讯协议。",
    "tittle": "接收力传感器数据格式错误",
    "isShowConfirm": "1"
  },
  "0x3F1003": {
    "description": "力传感器数据异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "在一段时间内从力传感器连续接收到相同数值，该错误一般在传感器无响应时出现。",
    "action": "请稍后尝试重启传感器",
    "tittle": "力传感器数据异常",
    "isShowConfirm": "1"
  },
  "0x3F1004": {
    "description": "力传感器数据异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "超过传感器最大量程",
    "action": "1. 请确认机器人末端是否与外部发生撞击；传感器在发生猛烈撞击后可能发生不可逆损坏",
    "tittle": "力传感器数据异常",
    "isShowConfirm": "1"
  },
  "0x3F1005": {
    "description": "力传感器数据异常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "传感器数据大幅突变且超出安全范围。",
    "action": "请检查机器人末端是否发生了碰撞，如果不是由碰撞引起，可以尝试切断机器人本体电源以及力传感器电源并等待一段时间后重新上电，然后再尝试开启力传感器。",
    "tittle": "力传感器数据异常",
    "isShowConfirm": "1"
  },
  "0x3F1006": {
    "description": "末端力传感器已在此值附近进行标定：{0}。",
    "type": "0",
    "isShowOTA": "0",
    "reason": "上次运行期间下发了传感器标定或标定结果查询指令，在标定成功或查询成功后均会弹出此提示。注意如果是传感器标定指令，则本次弹窗结果为本次标定完成后的结果。",
    "action": "请妥善记录此标定结果：{0}，并在后续使用中确保传感器读数与此数值的和仍在传感器量程范围内。",
    "tittle": "末端力传感器标定结果",
    "isShowConfirm": "1"
  },
  "0x10F0000": {
    "description": "系统急停触发",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "系统急停触发",
    "isShowConfirm": "1"
  },
  "0x10F0001": {
    "description": "系统急停复位",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "系统急停复位",
    "isShowConfirm": "1"
  },
  "0x10F0002": {
    "description": "机器人电源已打开",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人电源已打开",
    "isShowConfirm": "0"
  },
  "0x10F0003": {
    "description": "机器人电源已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人电源已关闭",
    "isShowConfirm": "0"
  },
  "0x10F0004": {
    "description": "机器人伺服使能完成",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人伺服使能完成",
    "isShowConfirm": "0"
  },
  "0x10F0005": {
    "description": "机器人伺服使能关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人伺服使能关闭",
    "isShowConfirm": "0"
  },
  "0x10F0006": {
    "description": "机器人退出倍率模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人退出倍率模式",
    "isShowConfirm": "0"
  },
  "0x10F0007": {
    "description": "机器人进入一级倍率模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入一级倍率模式",
    "isShowConfirm": "0"
  },
  "0x10F0008": {
    "description": "机器人进入二级倍率模式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入二级倍率模式",
    "isShowConfirm": "0"
  },
  "0x10F0009": {
    "description": "机器人进入保护性停止",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入保护性停止",
    "isShowConfirm": "1"
  },
  "0x10F000A": {
    "description": "机器人退出碰撞保护性停止",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人退出碰撞保护性停止",
    "isShowConfirm": "1"
  },
  "0x10F000B": {
    "description": "机器人进入碰撞保护性停止",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入碰撞保护性停止",
    "isShowConfirm": "1"
  },
  "0x10F000C": {
    "description": "机器人关节限位状态恢复",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人关节限位状态恢复",
    "isShowConfirm": "0"
  },
  "0x10F000D": {
    "description": "传送带功能已开启",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "传送带功能已开启",
    "isShowConfirm": "0"
  },
  "0x10F000E": {
    "description": "传送带功能已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "传送带功能已关闭",
    "isShowConfirm": "0"
  },
  "0x10F000F": {
    "description": "柔顺控制功能已开启",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "柔顺控制功能已开启",
    "isShowConfirm": "0"
  },
  "0x10F0010": {
    "description": "柔顺控制功能已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "柔顺控制功能已关闭",
    "isShowConfirm": "0"
  },
  "0x10F0011": {
    "description": "机器人进入拖拽模式",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入拖拽模式",
    "isShowConfirm": "0"
  },
  "0x10F0012": {
    "description": "机器人退出拖拽模式",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人退出拖拽模式",
    "isShowConfirm": "0"
  },
  "0x10F0013": {
    "description": "机器人进入工具拖拽模式",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入工具拖拽模式",
    "isShowConfirm": "0"
  },
  "0x10F0014": {
    "description": "机器人退出工具拖拽模式",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人退出工具拖拽模式",
    "isShowConfirm": "0"
  },
  "0x10F0015": {
    "description": "机器人SERVO运动模式已开启",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人SERVO运动模式已开启",
    "isShowConfirm": "0"
  },
  "0x10F0016": {
    "description": "机器人SERVO运动模式已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人SERVO运动模式已关闭",
    "isShowConfirm": "0"
  },
  "0x10F0017": {
    "description": "机器人进入危险区域",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人已经越过安全区域进入危险区。",
    "action": "请确认安全区域设置是否符合预期,排查时可关闭安全平面功能或者控制器机器人朝安全区域内运动。",
    "tittle": "机器人进入危险区域",
    "isShowConfirm": "1"
  },
  "0x10F0018": {
    "description": "机器人返回安全边界内",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人返回安全边界内",
    "isShowConfirm": "0"
  },
  "0x10F0019": {
    "description": "开始笛卡尔空间限速",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "开启笛卡尔空间限速",
    "isShowConfirm": "0"
  },
  "0x10F001A": {
    "description": "停止笛卡尔空间限速",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "停止笛卡尔空间限速",
    "isShowConfirm": "0"
  },
  "0x10F001B": {
    "description": "作业程序开始执行",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "作业程序开始执行",
    "isShowConfirm": "0"
  },
  "0x10F001C": {
    "description": "作业程序暂停执行",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "作业程序暂停执行",
    "isShowConfirm": "0"
  },
  "0x10F001D": {
    "description": "作业程序恢复执行",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "作业程序恢复执行",
    "isShowConfirm": "0"
  },
  "0x10F001E": {
    "description": "作业程序停止执行",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "作业程序停止执行",
    "isShowConfirm": "0"
  },
  "0x10F001F": {
    "description": "机器人即将进入危险区域",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人即将由安全区域进入危险区域。",
    "action": "请确认安全区域设置是否符合预期,排查时可关闭安全平面功能或者控制器机器人朝安全区域内运动。",
    "tittle": "机器人即将进入危险区域",
    "isShowConfirm": "1"
  },
  "0x10F0020": {
    "description": "机器人进入缩减模式",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人进入缩减模式",
    "isShowConfirm": "0"
  },
  "0x10F0021": {
    "description": "机器人退出缩减模式",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "机器人退出缩减模式",
    "isShowConfirm": "0"
  },
  "0x10F0022": {
    "description": "机器人进入动量缩减",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "机器人进入动量缩减",
    "isShowConfirm": "0"
  },
  "0x10F0023": {
    "description": "机器人进入功率缩减",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "机器人进入功率缩减",
    "isShowConfirm": "0"
  },
  "0x10F0024": {
    "description": "机器人退出保护性停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "机器人退出保护性停止",
    "isShowConfirm": "1"
  },
  "0x10F0025": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "安全参数发生变化",
    "action": "",
    "tittle": "用户安全配置发生变更",
    "isShowConfirm": "0"
  },
  "0x10F0026": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "安全参数中的初始姿态从{2}变为{3}",
    "action": "",
    "tittle": "用户安全配置初始姿态变更",
    "isShowConfirm": "0"
  },
  "0x10F0027": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "安全参数中的初始姿态误差从{2}变为{3}",
    "action": "",
    "tittle": "用户安全配置初始姿态误差变更",
    "isShowConfirm": "0"
  },
  "0x10F0028": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "控制器运行模式从{2}改变到{3}",
    "action": "",
    "tittle": "用户安全配置控制器运行模式变更",
    "isShowConfirm": "0"
  },
  "0x10F0029": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节{2}负限位从{3}改变到{4}",
    "action": "",
    "tittle": "用户安全配置关节负限位变更",
    "isShowConfirm": "0"
  },
  "0x10F002A": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节{2}正限位从{3}改变到{4}",
    "action": "",
    "tittle": "用户安全配置关节正限位变更",
    "isShowConfirm": "0"
  },
  "0x10F002B": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DI{2} 配置的安全功能码从{3}改变到{4}",
    "action": "",
    "tittle": "用户安全功能DI配置变更",
    "isShowConfirm": "0"
  },
  "0x10F002C": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DO{2} 配置的安全功能码从{3}改变到{4}",
    "action": "",
    "tittle": "用户安全功能DO配置变更",
    "isShowConfirm": "0"
  },
  "0x10F002D": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人功率限制配置从{2}变更为{3}",
    "action": "",
    "tittle": "机器人功率限制配置变更",
    "isShowConfirm": "0"
  },
  "0x10F002E": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人末端速度限制从{2}变更为{3}",
    "action": "",
    "tittle": "机器人末端速度限制变更",
    "isShowConfirm": "0"
  },
  "0x10F002F": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "用户安全配置停止距离从{2}变更为{3}",
    "action": "",
    "tittle": "用户安全配置停止距离变更",
    "isShowConfirm": "0"
  },
  "0x10F0030": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "用户安全配置停止时间从{2}变更为{3}",
    "action": "",
    "tittle": "用户安全配置停止时间变更",
    "isShowConfirm": "0"
  },
  "0x10F0031": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "肘部速度限制从{2}变更为{3}",
    "action": "",
    "tittle": "肘部速度限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0032": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "动量限制从{2}变更为{3}",
    "action": "",
    "tittle": "动量限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0033": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节{2}速度限制从{3}改变到{4}",
    "action": "",
    "tittle": "关节速度限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0034": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "关节{2}误差报警阈值从{3}改变到{4}",
    "action": "",
    "tittle": "关节误差报警阈值变更",
    "isShowConfirm": "0"
  },
  "0x10F0035": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "原工具姿态约束为:\n坐标系{2},工具方向x:{3},工具方向Y:{4},限制范围:{5},安全距离:{6},限制方向rx:{7},ry:{8},rz:{9},运行启用:{10},开机启动:{11}；\n现工具姿态约束为:\n坐标系{12},工具方向x:{13},工具方向Y:{14},限制范围:{15},安全距离:{16},限制方向rx:{17},ry:{18},rz:{19},运行启用:{20},开机启动:{21}",
    "action": "",
    "tittle": "工具姿态约束变更",
    "isShowConfirm": "0"
  },
  "0x10F0036": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "原碰撞处理配置为:\n碰撞观测方法:{2},碰撞后处理选项:{3},碰撞反弹角度:{4},碰撞反弹距离:{5},反弹关节加速度:{6},反弹关节速度:{7},反弹直线加速度:{8},反弹直线速度:{9}\n现碰撞处理配置为:\n碰撞观测方法:{10},碰撞后处理选项:{11},碰撞反弹角度:{12},碰撞反弹距离:{13},反弹关节加速度:{14},反弹关节速度:{15},反弹直线加速度:{16},反弹直线速度:{17}",
    "action": "",
    "tittle": "碰撞选项变更",
    "isShowConfirm": "0"
  },
  "0x10F0037": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "力矩限制从{2}变更为{3}",
    "action": "",
    "tittle": "伺服关节力矩限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0038": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "原默认程序配置:\n自动加载:{2},程序名:{3}\n现默认程序配置:\n自动加载:{4},程序名:{5}",
    "action": "",
    "tittle": "开机默认加载配置变更",
    "isShowConfirm": "0"
  },
  "0x10F0039": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "上电自动使能状态从{2}变更为{3}",
    "action": "",
    "tittle": "上电自动使能状态变更",
    "isShowConfirm": "0"
  },
  "0x10F003A": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "使能自动运行程序状态从{2}变更为{3}",
    "action": "",
    "tittle": "使能自动运行程序状态变更",
    "isShowConfirm": "0"
  },
  "0x10F003B": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "原始参数:\n  安全区域启用方式：{2}，到达/超出安全区域后处理方式：{3}，肘部位置限制启用:{4}\n新参数:\n  安全区域启用方式：{5}，到达/超出安全区域后处理方式：{6}，肘部位置限制启用:{7}",
    "action": "",
    "tittle": "安全区域全局配置变更",
    "isShowConfirm": "0"
  },
  "0x10F003C": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "初始化过程检测到安全参数变化",
    "isShowConfirm": "1"
  },
  "0x10F003D": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "力限制从{2}改变到{3}",
    "action": "",
    "tittle": "末端力限制变更",
    "isShowConfirm": "0"
  },
  "0x10F003F": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "灵敏度从{2}改变到{3}",
    "action": "",
    "tittle": "关节灵敏度变更",
    "isShowConfirm": "0"
  },
  "0x10F0040": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "使能状态从{2}改变到{3}",
    "action": "",
    "tittle": "碰撞使能状态变更",
    "isShowConfirm": "0"
  },
  "0x10F0041": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "平面{2}:\n 原始参数:\n  平面名称:{3}, 启用:{4}, 安全距离:{5}, 碰撞等级:{6}, 平面隐藏:{7}\n 新参数:\n  平面名称:{8}, 启用:{9}, 安全距离:{10}, 碰撞等级:{11}, 平面隐藏:{12}",
    "action": "",
    "tittle": "单个安全平面配置变更",
    "isShowConfirm": "0"
  },
  "0x10F0042": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "平面{2}:\n  原始参数:\n  平面点1:{3},平面点2:{4},平面点3:{5},安全面点：{6}\n  新参数:\n  平面点1:{7},平面点2:{8},平面点3:{9},安全面点：{10}",
    "action": "",
    "tittle": "单个安全平面点位变更",
    "isShowConfirm": "0"
  },
  "0x10F0043": {
    "description": "安全参数校验和从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人缩减模式下功率限制配置从{2}变更为{3}",
    "action": "",
    "tittle": "机器人缩减模式下功率限制配置变更",
    "isShowConfirm": "0"
  },
  "0x10F0044": {
    "description": "安全参数校验和从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "缩减模式下动量限制从{2}变更为{3}",
    "action": "",
    "tittle": "缩减模式下动量限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0045": {
    "description": "安全参数校验和从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人缩减模式下末端速度限制从{2}变更为{3}",
    "action": "",
    "tittle": "机器人缩减模式下末端速度限制变更",
    "isShowConfirm": "0"
  },
  "0x10F0046": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "缩减模式下停止距离从{2}变更为{3}",
    "action": "",
    "tittle": "缩减模式下停止距离变更",
    "isShowConfirm": "0"
  },
  "0x10F0047": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "用户安全配置缩减模式下停止时间从{2}变更为{3}",
    "action": "",
    "tittle": "用户安全配置缩减模式下停止时间变更",
    "isShowConfirm": "0"
  },
  "0x10F0048": {
    "description": "急停时禁止上电",
    "type": "2",
    "isShowOTA": "0",
    "reason": "急停发生时无法执行上电操作",
    "action": "请将急停复位然后再次进行上电操作",
    "tittle": "急停时禁止上电",
    "isShowConfirm": "1"
  },
  "0x10F0049": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "机器人末端拖拽速度限制从{2}变更为{3}",
    "action": "",
    "tittle": "机器人末端拖拽速度限制变更",
    "isShowConfirm": "0"
  },
  "0x10F004A": {
    "description": "反向驱动模式下禁止进行使能操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "反向驱动模式下，禁止通过SDK、IO等控制源进行使能操作",
    "action": "请先退出反向驱动模式后再尝试。",
    "tittle": "反向驱动模式下禁止进行使能操作",
    "isShowConfirm": "1"
  },
  "0x10F004B": {
    "description": "",
    "type": "1",
    "isShowOTA": "0",
    "reason": "反向驱动模式下，禁止通过SDK、IO等控制源进行下电操作",
    "action": "请先退出反向驱动模式后再尝试。",
    "tittle": "反向驱动模式下禁止进行下电操作",
    "isShowConfirm": "1"
  },
  "0x10F004C": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "平面{2}:\n 原始参数:\n  平面启用DI配置:{3}, 平面状态DO配置:{4}\n 新参数:\n  平面启用DI配置:{5}, 平面状态DO配置:{6}",
    "action": "",
    "tittle": "单个安全平面配置变更",
    "isShowConfirm": "0"
  },
  "0x10F004D": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "立方体{2}:\n 原始参数:\n  立方体名称:{3}, 启用:{4}, 内部安全:{5}, 立方体隐藏:{6}, 参考坐标系ID:{7}, 碰撞等级:{8}, 安全距离:{9}\n 新参数:\n  立方体名称:{10}, 启用:{11}, 内部安全:{12}, 立方体隐藏:{13}, 参考坐标系ID:{14}, 碰撞等级:{15}, 安全距离:{16}",
    "action": "",
    "tittle": "单个安全立方体配置变更",
    "isShowConfirm": "0"
  },
  "0x10F004E": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "立方体{2}:\n 原始参数:\n  参考坐标:{3}, 对角点1:{4}, 对角点2:{5}\n 新参数:\n  参考坐标:{6}, 对角点1:{7}, 对角点2:{8}",
    "action": "",
    "tittle": "单个安全立方体配置变更",
    "isShowConfirm": "0"
  },
  "0x10F004F": {
    "description": "安全参数校验从{0}改变到{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "立方体{2}:\n 原始参数:\n  立方体启用DI配置:{3}, 立方体状态DO配置:{4}\n 新参数:\n  立方体启用DI配置:{5}, 立方体状态DO配置:{6}",
    "action": "",
    "tittle": "单个安全立方体配置变更",
    "isShowConfirm": "0"
  },
  "0x10F0051": {
    "description": "安全功能触发且未在期望停止时间内减速到安全速度",
    "type": "1",
    "isShowOTA": "0",
    "reason": "安全监控功能触发，监控到机器人速度超出安全限制",
    "action": "",
    "tittle": "安全监控功能触发，监控到机器人速度超出安全限制",
    "isShowConfirm": "1"
  },
  "0x10F0060": {
    "description": "无法恢复程序执行",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保护性停止或碰撞状态下不能恢复程序执行",
    "action": "1.退出保护性停止后自动恢复程序执行.\n2.清除碰撞异常状态后重新尝试恢复程序执行.",
    "tittle": "无法恢复程序执行",
    "isShowConfirm": "1"
  },
  "0x10F0061": {
    "description": "保护性停止状态下无法回到初始位置",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保护性停止状态下无法回到初始位置",
    "action": "退出保护性停止后再次尝试进行回到初始位置操作",
    "tittle": "回到初始位置失败",
    "isShowConfirm": "1"
  },
  "0x10F0100": {
    "description": "力传感器已开启",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力传感器已开启",
    "isShowConfirm": "0"
  },
  "0x10F0101": {
    "description": "力传感器已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力传感器已关闭",
    "isShowConfirm": "0"
  },
  "0x10F0102": {
    "description": "扩展IO模块已启用",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "扩展IO模块已启用",
    "isShowConfirm": "0"
  },
  "0x10F0103": {
    "description": "扩展IO模块已关闭",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "扩展IO模块已关闭",
    "isShowConfirm": "0"
  },
  "0x10F0104": {
    "description": "控制手柄锁定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "控制手柄锁定",
    "isShowConfirm": "1"
  },
  "0x10F0105": {
    "description": "力传感器断连",
    "type": "2",
    "isShowOTA": "0",
    "reason": "机器人控制器与力传感器之间无法通讯。",
    "action": "1.请检查力传感器是否正确安装；\n2.力传感器与机器人之间的连接线是否损坏或松脱。",
    "tittle": "力传感器断连",
    "isShowConfirm": "0"
  },
  "0x10F0106": {
    "description": "力终止条件触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力终止条件触发",
    "isShowConfirm": "0"
  },
  "0x10F0200": {
    "description": "功能DI（执行程序）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（执行程序）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0201": {
    "description": "功能DI（暂停程序）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（暂停程序）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0202": {
    "description": "功能DI（恢复程序）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（恢复程序）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0203": {
    "description": "功能DI（停止程序）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（停止程序）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0204": {
    "description": "功能DI（打开电源）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（打开电源）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0205": {
    "description": "功能DI（关闭电源）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（关闭电源）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0206": {
    "description": "功能DI（伺服使能打开）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（伺服使能打开）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0207": {
    "description": "功能DI（伺服使能关闭）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（伺服使能关闭）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0208": {
    "description": "功能DI（进入一级倍率模式）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（进入一级倍率模式）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0209": {
    "description": "功能DI（进入二级倍率模式）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（进入二级倍率模式）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020A": {
    "description": "功能DI（进入保护性停止）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（进入保护性停止）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020B": {
    "description": "功能DI（返回初始位置）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（返回初始位置）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020C": {
    "description": "功能DI（清除碰撞）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（清除碰撞）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020D": {
    "description": "功能DI（进入拖拽模式）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（进入拖拽模式）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020E": {
    "description": "功能DI（退出拖拽模式）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（退出拖拽模式）已触发",
    "isShowConfirm": "0"
  },
  "0x10F020F": {
    "description": "功能DI（停止程序 或 暂停程序）已触发，（运行程序）不该被执行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（停止程序 或 暂停程序）已触发，（运行程序）不该被执行",
    "isShowConfirm": "1"
  },
  "0x10F0210": {
    "description": "功能DI（暂停程序）已触发，（恢复程序）不该被执行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（暂停程序）已触发，（恢复程序）不该被执行",
    "isShowConfirm": "1"
  },
  "0x10F0211": {
    "description": "功能DI（关闭电源）已触发，（打开电源）不该被执行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（关闭电源）已触发，（打开电源）不该被执行",
    "isShowConfirm": "1"
  },
  "0x10F0212": {
    "description": "功能DI（下使能）已触发，（上使能）不该被执行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DI（下使能）已触发，（上使能）不该被执行",
    "isShowConfirm": "1"
  },
  "0x10F0220": {
    "description": "功能DO（作业空闲）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业空闲）置位",
    "isShowConfirm": "0"
  },
  "0x10F0221": {
    "description": "功能DO（作业空闲）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业空闲）复位",
    "isShowConfirm": "0"
  },
  "0x10F0222": {
    "description": "功能DO（作业程序暂停）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业程序暂停）置位",
    "isShowConfirm": "0"
  },
  "0x10F0223": {
    "description": "功能DO（作业程序暂停）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业程序暂停）复位",
    "isShowConfirm": "0"
  },
  "0x10F0224": {
    "description": "功能DO（作业程序运行中）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业程序运行中）置位",
    "isShowConfirm": "0"
  },
  "0x10F0225": {
    "description": "功能DO（作业程序运行中）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（作业程序运行中）复位",
    "isShowConfirm": "0"
  },
  "0x10F0226": {
    "description": "功能DO（控制系统故障）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（控制系统故障）置位",
    "isShowConfirm": "0"
  },
  "0x10F0227": {
    "description": "功能DO（控制系统故障）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（控制系统故障）复位",
    "isShowConfirm": "0"
  },
  "0x10F0228": {
    "description": "功能DO（机器人电源已打开）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人电源已打开）置位",
    "isShowConfirm": "0"
  },
  "0x10F0229": {
    "description": "功能DO（机器人电源已打开）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人电源已打开）复位",
    "isShowConfirm": "0"
  },
  "0x10F022A": {
    "description": "功能DO（伺服使能已打开）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（伺服使能已打开）置位",
    "isShowConfirm": "0"
  },
  "0x10F022B": {
    "description": "功能DO（伺服使能已打开）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（伺服使能已打开）复位",
    "isShowConfirm": "0"
  },
  "0x10F022C": {
    "description": "功能DO（机器人运动中）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人运动中）置位",
    "isShowConfirm": "0"
  },
  "0x10F022D": {
    "description": "功能DO（机器人运动中）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人运动中）复位",
    "isShowConfirm": "0"
  },
  "0x10F022E": {
    "description": "功能DO（机器人静止）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人静止）置位",
    "isShowConfirm": "0"
  },
  "0x10F022F": {
    "description": "功能DO（机器人静止）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人静止）复位",
    "isShowConfirm": "0"
  },
  "0x10F0230": {
    "description": "功能DO（控制系统已就绪）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（控制系统已就绪）置位",
    "isShowConfirm": "0"
  },
  "0x10F0231": {
    "description": "功能DO（控制系统已就绪）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（控制系统已就绪）复位",
    "isShowConfirm": "0"
  },
  "0x10F0232": {
    "description": "功能DO（机器人急停）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人急停）置位",
    "isShowConfirm": "0"
  },
  "0x10F0233": {
    "description": "功能DO（机器人急停）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人急停）复位",
    "isShowConfirm": "0"
  },
  "0x10F0234": {
    "description": "功能DO（机器人处于二级倍率模式）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于二级倍率模式）置位",
    "isShowConfirm": "0"
  },
  "0x10F0235": {
    "description": "功能DO（机器人处于二级倍率模式）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于二级倍率模式）复位",
    "isShowConfirm": "0"
  },
  "0x10F0236": {
    "description": "功能DO（机器人处于保护性停止）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于保护性停止）置位",
    "isShowConfirm": "0"
  },
  "0x10F0237": {
    "description": "功能DO（机器人处于保护性停止）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于保护性停止）复位",
    "isShowConfirm": "0"
  },
  "0x10F0238": {
    "description": "功能DO（机器人处于初始位）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于初始位）置位",
    "isShowConfirm": "0"
  },
  "0x10F0239": {
    "description": "功能DO（机器人处于初始位）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于初始位）复位",
    "isShowConfirm": "0"
  },
  "0x10F0240": {
    "description": "功能DO（机器人处于一级倍率模式）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于一级倍率模式）置位",
    "isShowConfirm": "0"
  },
  "0x10F0241": {
    "description": "功能DO（机器人处于一级倍率模式）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "功能DO（机器人处于一级倍率模式）复位",
    "isShowConfirm": "0"
  },
  "0x10F0250": {
    "description": "安全功能DI（附加急停）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（附加急停）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0251": {
    "description": "安全功能DI（附加保护性停止）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（附加保护性停止）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0252": {
    "description": "安全功能DI（保护性停止复位）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（保护性停止复位）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0253": {
    "description": "安全功能DI（缩减模式）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（缩减模式）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0254": {
    "description": "安全功能DI（三位置使能）已触发",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（三位置使能）已触发",
    "isShowConfirm": "1"
  },
  "0x10F0255": {
    "description": "安全功能DI设置碰撞灵敏度（level0）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level0）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0256": {
    "description": "安全功能DI设置碰撞灵敏度（level1）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level1）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0257": {
    "description": "安全功能DI设置碰撞灵敏度（level2）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level2）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0258": {
    "description": "安全功能DI设置碰撞灵敏度（level3）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level3）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0259": {
    "description": "安全功能DI设置碰撞灵敏度（level4）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level4）已触发",
    "isShowConfirm": "0"
  },
  "0x10F025A": {
    "description": "安全功能DI设置碰撞灵敏度（level5）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level5）已触发",
    "isShowConfirm": "0"
  },
  "0x10F025B": {
    "description": "安全功能DI设置碰撞灵敏度（level7）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI设置碰撞灵敏度（level7）已触发",
    "isShowConfirm": "0"
  },
  "0x10F025C": {
    "description": "安全功能DI（保护性停止）已触发",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DI（保护性停止）已触发",
    "isShowConfirm": "0"
  },
  "0x10F0260": {
    "description": "安全功能DO（按钮急停触发）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（按钮急停触发）置位",
    "isShowConfirm": "0"
  },
  "0x10F0261": {
    "description": "安全功能DO（按钮急停触发）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（按钮急停触发）复位",
    "isShowConfirm": "0"
  },
  "0x10F0262": {
    "description": "安全功能DO（系统急停触发）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（系统急停触发）置位",
    "isShowConfirm": "0"
  },
  "0x10F0263": {
    "description": "安全功能DO（系统急停触发）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（系统急停触发）复位",
    "isShowConfirm": "0"
  },
  "0x10F0264": {
    "description": "安全功能DO（机器人处于保护性停止）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人处于保护性停止）置位",
    "isShowConfirm": "0"
  },
  "0x10F0265": {
    "description": "安全功能DO（机器人处于保护性停止）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人处于保护性停止）复位",
    "isShowConfirm": "0"
  },
  "0x10F0266": {
    "description": "安全功能DO（机器人运动中）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人运动中）置位",
    "isShowConfirm": "0"
  },
  "0x10F0267": {
    "description": "安全功能DO（机器人运动中）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人运动中）复位",
    "isShowConfirm": "0"
  },
  "0x10F0268": {
    "description": "安全功能DO（机器人处于缩减模式）置位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人处于缩减模式）置位",
    "isShowConfirm": "0"
  },
  "0x10F0269": {
    "description": "安全功能DO（机器人处于缩减模式）复位",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全功能DO（机器人处于缩减模式）复位",
    "isShowConfirm": "0"
  },
  "0x10F0280": {
    "description": "动力学参数辨识完成",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "动力学参数辨识完成",
    "isShowConfirm": "1"
  },
  "0x10F0281": {
    "description": "摩擦力参数辨识完成",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "摩擦力参数辨识完成",
    "isShowConfirm": "1"
  },
  "0x10F0282": {
    "description": "写动力学参数完成，重启或重新上电生效",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "写动力学参数完成",
    "isShowConfirm": "1"
  },
  "0x10F0283": {
    "description": "碰撞点离运动起始点过近，因无法确认反弹路径是否安全，反弹可能被终止",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "碰撞反弹终止",
    "isShowConfirm": "1"
  },
  "0x10F0284": {
    "description": "碰撞点已接近停止或已经停止，本次碰撞不执行反弹",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "本次碰撞无反弹",
    "isShowConfirm": "1"
  },
  "0x10F0285": {
    "description": "制动电阻启动电压设置成功.\n当前值为 {0}V。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "制动电阻启动电压设置成功",
    "isShowConfirm": "0"
  },
  "0x10F0286": {
    "description": "程序已经在运行，不可重复启动程序。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "程序已经在运行",
    "isShowConfirm": "0"
  },
  "0x10F0287": {
    "description": "一键还原已完成",
    "type": "1",
    "isShowOTA": "0",
    "reason": "一键还原已完成，参数已恢复为默认值",
    "action": "一键还原已完成",
    "tittle": "一键还原已完成",
    "isShowConfirm": "1"
  },
  "0x10F0300": {
    "description": "登录初始化失败",
    "type": "1",
    "isShowOTA": "1",
    "reason": "登陆连接时存在数据读取异常",
    "action": "1.请检查当前软件APP版本与控制器版本是否存在版本不匹配。\n2.请检查网络连接是否存在异常。\n3.请尝试重新连接机器人或重启APP操作。",
    "tittle": "登录初始化失败",
    "isShowConfirm": "1"
  },
  "0x10F0301": {
    "description": "此版本为测试版本",
    "type": "1",
    "isShowOTA": "1",
    "reason": "此版本为测试版本",
    "action": "请联系技术人员获取正式版本",
    "tittle": "此版本为测试版本",
    "isShowConfirm": "1"
  },
  "0x10F1000": {
    "description": "程序运行速度倍率变为{1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行速度倍率因{0}发生改变",
    "action": "",
    "tittle": "用户程序运行速度倍率发生变化",
    "isShowConfirm": "0"
  },
  "0x10F2000": {
    "description": "程序运行完成",
    "type": "1",
    "isShowOTA": "0",
    "reason": "程序运行完成",
    "action": "程序运行完成",
    "tittle": "程序运行完成",
    "isShowConfirm": "0"
  },
  "0x10F2001": {
    "description": "终止程序运行",
    "type": "1",
    "isShowOTA": "0",
    "reason": "终止程序运行",
    "action": "终止程序运行",
    "tittle": "终止程序运行",
    "isShowConfirm": "0"
  }
}

export const en = {
  "0x000030": {
    "description": "The speed of Joint 1 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 1 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 1 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x000031": {
    "description": "Joint 1 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 1 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 1 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x000032": {
    "description": "Joint 1 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 1 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 1 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x000033": {
    "description": "Joint 1 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 1 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 1 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x000034": {
    "description": "Joint 1 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 1 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 1 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x000035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 1",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 1",
    "isShowConfirm": "1"
  },
  "0x000036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 1",
    "isShowConfirm": "1"
  },
  "0x000037": {
    "description": "Joint 1 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 1.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 1 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x000042": {
    "description": "Joint 1 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 1 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 1 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x000061": {
    "description": "Joint 1 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 1 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 1 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x000200": {
    "description": "Installation angle is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Installation angle is out of range.",
    "action": "Please check the installation angle and set again.",
    "tittle": "Installation angle is out of range.",
    "isShowConfirm": "0"
  },
  "0x000250": {
    "description": "Can not set motion planner now.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Can not set motion planner now.",
    "action": "Please retry later.",
    "tittle": "Can not set motion planner now.",
    "isShowConfirm": "0"
  },
  "0x000350": {
    "description": "Not in SERVO mode.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Not in SERVO mode.",
    "action": "Please turn on SERVO mode and retry later.",
    "tittle": "Not in SERVO mode.",
    "isShowConfirm": "0"
  },
  "0x000351": {
    "description": "Can not set filter in SERVO mode.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Can not set filter in SERVO mode.",
    "action": "Please turn off SERVO mode, and retry.",
    "tittle": "Can not set filter in SERVO mode.",
    "isShowConfirm": "0"
  },
  "0x000352": {
    "description": "Invalid SERVO parameter.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Invalid SERVO parameter.",
    "action": "Please check the parameter and set again.",
    "tittle": "Invalid SERVO parameter.",
    "isShowConfirm": "0"
  },
  "0x000353": {
    "description": "Installation angle is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Installation angle is out of range.",
    "action": "Please check the parameter and set again.",
    "tittle": "Installation angle is out of range.",
    "isShowConfirm": "0"
  },
  "0x000400": {
    "description": "IO index is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IO index is out of range.",
    "action": "Please check the parameter and set again.",
    "tittle": "IO index is out of range.",
    "isShowConfirm": "0"
  },
  "0x000401": {
    "description": "IO type is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IO type is out of range.",
    "action": "Please check the parameter and set again.",
    "tittle": "IO type is out of range.",
    "isShowConfirm": "0"
  },
  "0x000450": {
    "description": "Installation angle is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Alias already exist.",
    "action": "Please check the parameter and set again.",
    "tittle": "Installation angle is out of range.",
    "isShowConfirm": "0"
  },
  "0x000500": {
    "description": "Installation angle is out of range.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Installation angle is out of range.",
    "action": "Please check the parameter and set again.",
    "tittle": "Installation angle is out of range.",
    "isShowConfirm": "0"
  },
  "0x000550": {
    "description": "Kinematic inverse calculation failed.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "Kinematic inverse calculation failed.",
    "action": "Please check the parameter and try again.",
    "tittle": "Kinematic inverse calculation failed.",
    "isShowConfirm": "0"
  },
  "0x001002": {
    "description": "Joint 1 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 1 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 1 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x001003": {
    "description": "Joint 1 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 1 drive error",
    "isShowConfirm": "1"
  },
  "0x001004": {
    "description": "Joint 1 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 1 following error too high",
    "isShowConfirm": "1"
  },
  "0x010030": {
    "description": "The speed of Joint 2 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 2 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 2 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x010031": {
    "description": "Joint 2 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 2 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 2 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x010032": {
    "description": "Joint 2 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 2 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 2 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x010033": {
    "description": "Joint 2 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 2 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 2 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x010034": {
    "description": "Joint 2 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 2 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 2 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x010035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 2",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 2",
    "isShowConfirm": "1"
  },
  "0x010036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 2",
    "isShowConfirm": "1"
  },
  "0x010037": {
    "description": "Joint 2 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 2.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 2 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x010042": {
    "description": "Joint 2 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 2 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 2 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x010061": {
    "description": "Joint 2 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 2 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 2 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x011002": {
    "description": "Joint 2 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 2 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 2 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x011003": {
    "description": "Joint 2 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 2 drive error",
    "isShowConfirm": "1"
  },
  "0x011004": {
    "description": "Joint 2 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 2 following error too high",
    "isShowConfirm": "1"
  },
  "0x020030": {
    "description": "The speed of Joint 3 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 3 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 3 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x020031": {
    "description": "Joint 3 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 3 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 3 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x020032": {
    "description": "Joint 3 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 3 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 3 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x020033": {
    "description": "Joint 3 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 3 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 3 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x020034": {
    "description": "Joint 3 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 3 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 3 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x020035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 3",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 3",
    "isShowConfirm": "1"
  },
  "0x020036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 3",
    "isShowConfirm": "1"
  },
  "0x020037": {
    "description": "Joint 3 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 3.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 3 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x020042": {
    "description": "Joint 3 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 3 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 3 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x020061": {
    "description": "Joint 3 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 3 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 3 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x021002": {
    "description": "Joint 3 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 3 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 3 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x021003": {
    "description": "Joint 3 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 3 drive error",
    "isShowConfirm": "1"
  },
  "0x021004": {
    "description": "Joint 3 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 3 following error too high",
    "isShowConfirm": "1"
  },
  "0x030030": {
    "description": "The speed of Joint 4 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 4 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 4 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x030031": {
    "description": "Joint 4 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 4 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 4 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x030032": {
    "description": "Joint 4 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 4 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 4 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x030033": {
    "description": "Joint 4 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 4 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 4 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x030034": {
    "description": "Joint 4 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 4 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 4 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x030035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 4",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 4",
    "isShowConfirm": "1"
  },
  "0x030036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 4",
    "isShowConfirm": "1"
  },
  "0x030037": {
    "description": "Joint 4 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 4.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 4 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x030042": {
    "description": "Joint 4 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 4 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 4 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x030061": {
    "description": "Joint 4 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 4 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 4 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x031002": {
    "description": "Joint 4 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 4 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 4 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x031003": {
    "description": "Joint 4 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 4 drive error",
    "isShowConfirm": "1"
  },
  "0x031004": {
    "description": "Joint 4 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 4 following error too high",
    "isShowConfirm": "1"
  },
  "0x040030": {
    "description": "The speed of Joint 5 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 5 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 5 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x040031": {
    "description": "Joint 5 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 5 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 5 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x040032": {
    "description": "Joint 5 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 5 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 5 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x040033": {
    "description": "Joint 5 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 5 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 5 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x040034": {
    "description": "Joint 5 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 5 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 5 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x040035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 5",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 5",
    "isShowConfirm": "1"
  },
  "0x040036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 5",
    "isShowConfirm": "1"
  },
  "0x040037": {
    "description": "Joint 5 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 5.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 5 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x040042": {
    "description": "Joint 5 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 5 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 5 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x040061": {
    "description": "Joint 5 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 5 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 5 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x041002": {
    "description": "Joint 5 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 5 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 5 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x041003": {
    "description": "Joint 5 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 5 drive error",
    "isShowConfirm": "1"
  },
  "0x041004": {
    "description": "Joint 5 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 5 following error too high",
    "isShowConfirm": "1"
  },
  "0x050030": {
    "description": "The speed of Joint 6 has exceeded its limit.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The speed of Joint 6 has exceeded its limit. This error occurs when the speed given by the controller has exceeded the joint's actual speed limit.",
    "action": "1. Please confirm if the current speed limit of the robot was adjusted. If so, please contact the technical service team.\n2. If the speed limit wasn't adjusted, please reduce the speed or acceleration to see whether this error can be corrected or not; If this error still occurs, please export the relevant diagnostic information and contact the technical service team.",
    "tittle": "The speed of Joint 6 has exceeded its limit",
    "isShowConfirm": "1"
  },
  "0x050031": {
    "description": "Joint 6 has reached the positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 6 has reached the positive soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 6 has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x050032": {
    "description": "Joint 6 has reached the negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 6 has reached the negative soft limit during the movement.",
    "action": "Please check the value of each joint's angel to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 6 has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x050033": {
    "description": "Joint 6 is about to reach its positive soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 6 is about to reach its positive soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 6 is about to reach its positive soft limit",
    "isShowConfirm": "1"
  },
  "0x050034": {
    "description": "Joint 6 is about to reach its negative soft limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint 6 is about to reach its negative soft limit if this movement continues.",
    "action": "Please check the robot joints' angel value of the target position to see if any of them has reached the limit. If so, please change the trajectory.",
    "tittle": "Joint 6 is about to reach its negative soft limit",
    "isShowConfirm": "1"
  },
  "0x050035": {
    "description": "JOG target position has exceeded the positive soft limit of Joint 6",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the positive soft limit of Joint 6",
    "isShowConfirm": "1"
  },
  "0x050036": {
    "description": "JOG target position has exceeded the negative soft limit of Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the robot is manually operated, and the target position of such operation has exceeded the limit value of the joint.",
    "action": "1. Please check the Joint Limit in the Safety Settings to see if the value was modified. \n2. Please check if the target position is reachable. If not, please change it.",
    "tittle": "JOG target position has exceeded the negative soft limit of Joint 6",
    "isShowConfirm": "1"
  },
  "0x050037": {
    "description": "Joint 6 acceleration is too high.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When JOG the robot for a Cartesian space movement, it causes excessive acceleration in Joint 6.",
    "action": "1. Please move the robot joint away from the position where this error occurred, then try to JOG the robot in Cartesian space.",
    "tittle": "Joint 6 acceleration is too high",
    "isShowConfirm": "1"
  },
  "0x050042": {
    "description": "Joint 6 is about to reach its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 6 is about to reach its soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "Joint 6 is about to reach its soft limit",
    "isShowConfirm": "1"
  },
  "0x050061": {
    "description": "Joint 6 detects collision and stops.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Joint 6 detects collision and stops.",
    "action": "1. Please check the working environment to see if something collided with the robot. If so, please remove whatever that is;\n2. If not, please check if the settings of payload and mounting angle are all correct;\n3. JOG Joint {jointnum} to check if there are any internal jams.",
    "tittle": "Joint 6 detects collision and stops",
    "isShowConfirm": "1"
  },
  "0x051002": {
    "description": "Joint 6 CAN communication error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 6 CAN bus error causes data acquisition failure or timeout.",
    "action": "1. Disable and power off the robot, remove the lid of error joint, and check the CAN cable.\n2. Contact the JAKA technicians.",
    "tittle": "Joint 6 CAN communication error",
    "isShowConfirm": "1"
  },
  "0x051003": {
    "description": "Joint 6 drive error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller does not receive signal from drive board in joint 1 after the robot powers on.",
    "action": "Check if the APP monitoring page shows the voltage, current and temperature of the joint 1. If not, contact with the JAKA technicians.",
    "tittle": "Joint 6 drive error",
    "isShowConfirm": "1"
  },
  "0x051004": {
    "description": "Joint 6 following error too high",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandoned",
    "action": "Please check whether the controller is the debugging version, or contact the technical service personnel.",
    "tittle": "Joint 6 following error too high",
    "isShowConfirm": "1"
  },
  "0xE0000": {
    "description": "No error",
    "type": "1",
    "isShowOTA": "1",
    "reason": "No error",
    "action": "No error",
    "tittle": "No error",
    "isShowConfirm": "0"
  },
  "0xE0001": {
    "description": "Exception occurs in the call of gRPC interface",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Exception occurs in the call of gRPC interface",
    "action": "Please contact the technical service team.",
    "tittle": "Exception occurs in the call of gRPC interface",
    "isShowConfirm": "0"
  },
  "0xE0002": {
    "description": "Wrong password",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to log in/out, for the password is incorrect.",
    "action": "Please check the password. If it's incorrect, please enter the right one.",
    "tittle": "Wrong password",
    "isShowConfirm": "0"
  },
  "0xE0003": {
    "description": "Wrong username",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to log in/out, for the username is incorrect.",
    "action": "Please check the username. If it's incorrect, please enter the right one.",
    "tittle": "Wrong username",
    "isShowConfirm": "0"
  },
  "0xE0004": {
    "description": "This IP address has already logged in",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This IP address has already logged in",
    "action": "Please log out this IP on other devices first, then log in here.",
    "tittle": "This IP address has already logged in",
    "isShowConfirm": "0"
  },
  "0xE0005": {
    "description": "Not log in yet.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Not log in yet.",
    "action": "Please log in first.",
    "tittle": "Not log in yet",
    "isShowConfirm": "0"
  },
  "0xE0006": {
    "description": "The joint's minimum limit is too small, or the maximum limit is too large, or the minimum limit exceeds the maximum limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The joint's minimum limit is too small, or the maximum limit is too large, or the minimum limit exceeds the maximum limit.",
    "action": "Please adjust the joint limit to a proper position to proceed.",
    "tittle": "The joint limit is not normal",
    "isShowConfirm": "0"
  },
  "0xE0007": {
    "description": "Inverse kinematics calculation failed.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Inverse kinematics calculation failed.",
    "action": "The robot has failed to calculate the inverse kinematics, please re-teach it.",
    "tittle": "Inverse kinematics calculation failed",
    "isShowConfirm": "0"
  },
  "0xE0008": {
    "description": "Forward kinematics calculation failed.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Forward kinematics calculation failed.",
    "action": "Please contact the JAKA technical service team.",
    "tittle": "Forward kinematics calculation failed",
    "isShowConfirm": "0"
  },
  "0xE0009": {
    "description": "Cannot find the file or the folder.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Cannot fine the file or the folder.",
    "action": "Please make sure there is a file or a folder to proceed.",
    "tittle": "Cannot find the file or the folder",
    "isShowConfirm": "0"
  },
  "0xE000A": {
    "description": "MD5 check failed to match.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "MD5 check failed to match.",
    "action": "Please confirm if the MD5 checksum is correct.",
    "tittle": "MD5 check failed to match",
    "isShowConfirm": "0"
  },
  "0xE000B": {
    "description": "Failed to calculate the tool center point.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to calculate the tool center point.",
    "action": "Failed to calculate the tool center point coordinate system, please check if it was set correctly.",
    "tittle": "Failed to calculate the tool center point",
    "isShowConfirm": "0"
  },
  "0xE000C": {
    "description": "Invalid parameters.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Invalid parameters.",
    "action": "The parameters are incorrect, please correct them to proceed.",
    "tittle": "Invalid parameters",
    "isShowConfirm": "0"
  },
  "0xE000D": {
    "description": "Too many outputs are set to the same state.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Too many outputs are set to the same state.",
    "action": "Please modify the state of the DI and DO, so that they can function normally.",
    "tittle": "Too many outputs are set to the same state",
    "isShowConfirm": "0"
  },
  "0xE000E": {
    "description": "This name of the variable already exists.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This name of the variable already exists.",
    "action": "Please change the name of this variable to proceed.",
    "tittle": "This name of the variable already exists",
    "isShowConfirm": "0"
  },
  "0xE000F": {
    "description": "The parameters have exceeded the range.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The parameters have exceeded the range.",
    "action": "Please correct the parameters within its range to proceed.",
    "tittle": "The parameters have exceeded the range",
    "isShowConfirm": "0"
  },
  "0xE0010": {
    "description": "The information ID has exceeded the range.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The information ID has exceeded the range.",
    "action": "Please correct the information ID to the right range.",
    "tittle": "The information ID has exceeded the range",
    "isShowConfirm": "0"
  },
  "0xE0011": {
    "description": "The string should not be more than 16 characters.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The string should not be more than 16 characters.",
    "action": "Please check if the string has exceeded 16 characters, if so, please shorten it to proceed.",
    "tittle": "The string should not be more than 16 characters",
    "isShowConfirm": "0"
  },
  "0xE0012": {
    "description": "You don't have the authority to operate.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "You don't have the authority to operate.",
    "action": "You don't have the authority to operate, please change the authority level and log in again to proceed.",
    "tittle": "You don't have the authority to operate",
    "isShowConfirm": "0"
  },
  "0xE0013": {
    "description": "Wrong user level.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Wrong user level.",
    "action": "This user level doesn't have the authority to operate, please change the authority level and log in again to proceed.",
    "tittle": "Wrong user level ",
    "isShowConfirm": "0"
  },
  "0xE0014": {
    "description": "This username already exists.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This username already exists.",
    "action": "Please change the username first, then log in.",
    "tittle": "This username already exists",
    "isShowConfirm": "0"
  },
  "0xE0015": {
    "description": "This upgrading package is invalid.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This upgrading package is invalid.",
    "action": "Please check the name and format of this package.",
    "tittle": "This upgrading package is invalid",
    "isShowConfirm": "0"
  },
  "0xE0016": {
    "description": "JOG coordinate system is not supported.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "JOG coordinate system is not supported.",
    "action": "Please confirm if the JOG coordinate system is supported. If not, please correct it to proceed.",
    "tittle": "JOG coordinate system is not supported",
    "isShowConfirm": "0"
  },
  "0xE0017": {
    "description": "This mode is not supported.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This mode is not supported.",
    "action": "Please check if the current mode is supported by the robot. If not, please switch to the right mode to proceed.",
    "tittle": "This mode is not supported",
    "isShowConfirm": "0"
  },
  "0xE0018": {
    "description": "The robot is moving.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The robot is moving.",
    "action": "Please make sure if the robot is moving. If so, stop it to proceed.",
    "tittle": "The robot is moving",
    "isShowConfirm": "0"
  },
  "0xE0019": {
    "description": "The program cannot be loaded when another program is running.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The program cannot be loaded when another program is running.",
    "action": "A program is already running, please stop it to start another one.",
    "tittle": "The program cannot be loaded when another program is running",
    "isShowConfirm": "0"
  },
  "0xE001A": {
    "description": "The current pin is being used by other functions.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current pin is being used by other functions.",
    "action": "Please check if this pin is being used by other functions.",
    "tittle": "The current pin is being used by other functions",
    "isShowConfirm": "0"
  },
  "0xE001B": {
    "description": "Failed to set the reduced percentage when in reduced mode.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to set the reduced percentage when in reduced mode.",
    "action": "Please confirm if the robot is now in reduced mode. If so, please set the reduced percentage when the reduced mode is off.",
    "tittle": "Failed to set the reduced percentage when in reduced mode",
    "isShowConfirm": "0"
  },
  "0xE001C": {
    "description": "Failed to generate JKS script during trajectory reproduction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to generate JKS script during trajectory reproduction.",
    "action": "Please check the correctness of the script file.",
    "tittle": "Failed to generate JKS script during trajectory reproduction",
    "isShowConfirm": "0"
  },
  "0xE001D": {
    "description": "Only one TIO RS485 channel can be used for the torque sensor.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Only one TIO RS485 channel can be used for the torque sensor.",
    "action": "Please check if the TIO RS485 channel is allocated to multiple channels. If so, modify it to use a single channel before proceeding.",
    "tittle": "Only one TIO RS485 channel can be used for the torque sensor",
    "isShowConfirm": "0"
  },
  "0xE001E": {
    "description": "Failed to switch the channel of torque sensor.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to switch the channel of torque sensor.",
    "action": "Please confirm if the torque sensor is running currently. If so, stop it to proceed.",
    "tittle": "Failed to switch the channel of torque sensor",
    "isShowConfirm": "0"
  },
  "0xE001F": {
    "description": "The robot's serial number is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The robot's serial number is incorrect.",
    "action": "Please confirm if the robot's serial number is correct. If not, correct it to proceed.",
    "tittle": "The robot's serial number is incorrect",
    "isShowConfirm": "0"
  },
  "0xE0020": {
    "description": "Redis is not activated.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Redis is not activated.",
    "action": "Please activate Redis first to proceed. ",
    "tittle": "Redis is not activated",
    "isShowConfirm": "0"
  },
  "0xE0021": {
    "description": "Unknown robot model.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unknown robot model.",
    "action": "Please check if the robot model is right.",
    "tittle": "Unknown robot model",
    "isShowConfirm": "0"
  },
  "0xE0022": {
    "description": "The number or index of extended IO has exceeded the limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The number or index of extended IO has exceeded the limit.\nThe maximum number of extended IO: 8\nThe index range of extended IO DI/DO: 0~64\nThe index range of extended IO AI/AO: 0~31",
    "action": "Please make sure the number and index of extended IO are correct, then proceed.",
    "tittle": "The number or index of extended IO has exceeded the limit",
    "isShowConfirm": "0"
  },
  "0xE0023": {
    "description": "The 'Trajectory Record' instruction is not supported in single-step debugging mode.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The 'Trajectory Record' instruction is not supported in single-step debugging mode.",
    "action": "Please try again after removing the 'Trajectory Record' instruction",
    "tittle": "The 'Trajectory Record' instruction is not supported in single-step debugging mode.",
    "isShowConfirm": "0"
  },
  "0xE0026": {
    "description": "This operation is not allowed in simulation mode.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This operation is not allowed in simulation mode.",
    "action": "Exit the simulation mode to proceed.",
    "tittle": "This operation is not allowed in simulation mode",
    "isShowConfirm": "0"
  },
  "0xE0027": {
    "description": "Failed to read the network configuration file.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to read the network configuration file.",
    "action": "Try to configure it again. Afterwards, if this issue recurs, please contact the technical service team.",
    "tittle": "Failed to read the network configuration file",
    "isShowConfirm": "0"
  },
  "0xE0028": {
    "description": "Too many inputs are set to the same function.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Too many inputs are set to the same function.",
    "action": "Please check and modify the settings of function DI.",
    "tittle": "Too many inputs are set to the same function",
    "isShowConfirm": "0"
  },
  "0xE002A": {
    "description": "The program is running and file deletion is not allowed.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The program is running and file deletion is not allowed.",
    "action": "The program is running and file deletion is not allowed.",
    "tittle": "The program is running and file deletion is not allowed.",
    "isShowConfirm": "0"
  },
  "0xE002B": {
    "description": "Failed to import configuration files.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to import configuration files.",
    "action": "Failed to import configuration files.",
    "tittle": "Failed to import configuration files",
    "isShowConfirm": "0"
  },
  "0xE002C": {
    "description": "This function interface is not supported",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This function interface is not supported",
    "action": "This function interface is not supported",
    "tittle": "This function interface is not supported",
    "isShowConfirm": "0"
  },
  "0xE002D": {
    "description": "Function setup failed",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Function setup failed",
    "action": "Function setup failed",
    "tittle": "Function setup failed",
    "isShowConfirm": "0"
  },
  "0xE002E": {
    "description": "Input/output pin mismatch",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Input/output pin mismatch",
    "action": "Input/output pin mismatch",
    "tittle": "Input/output pin mismatch",
    "isShowConfirm": "0"
  },
  "0xE002F": {
    "description": "Failed to retrieve control cabinet disk information",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Disk hardware abnormality or disk space full",
    "action": "Please try again later",
    "tittle": "Failed to retrieve control cabinet disk information",
    "isShowConfirm": "0"
  },
  "0xE0030": {
    "description": "The robot model does not support simulation mode.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The robot model does not support simulation mode.",
    "action": "Please check if the robot model is right or try to upgrade the controller.",
    "tittle": "The robot model does not support simulation mode",
    "isShowConfirm": "0"
  },
  "0xE0031": {
    "description": "Failed to calibrate the user coordinate system.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The chosen calibration point is collinear, so it failed to calibrate the user coordinate system.",
    "action": "Please reset the teaching point.",
    "tittle": "Failed to calibrate the user coordinate system",
    "isShowConfirm": "0"
  },
  "0xE0033": {
    "description": "Incorrect username or password.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Incorrect username or password.",
    "action": "Please re-enter the correct username and password.",
    "tittle": "User password verification failed.",
    "isShowConfirm": "0"
  },
  "0xE0034": {
    "description": "Failed to get alignment target pose.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to get alignment target pose.",
    "action": "Unable to get alignment target pose.",
    "tittle": "Failed to get alignment target pose",
    "isShowConfirm": "0"
  },
  "0xE0064": {
    "description": "Collision detected, please confirm if the environment is safe.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "Collision detected, please confirm if the environment is safe.",
    "action": "Collision detected, please confirm if the environment is safe.",
    "tittle": "Collision detected, please confirm if the environment is safe.",
    "isShowConfirm": "0"
  },
  "0xE03E8": {
    "description": "The number of activated AddOn has exceeded the limit.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The number of activated AddOn has exceeded the limit.",
    "action": "The number of activated AddOn has exceeded the limit, please delete some to proceed.",
    "tittle": "The number of activated AddOn has exceeded the limit",
    "isShowConfirm": "0"
  },
  "0xE03E9": {
    "description": "Failed to activate the AddOn.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to activate the AddOn.",
    "action": "Failed to activate the AddOn, please make sure the AddOn configurations are right before proceed.",
    "tittle": "Failed to activate the AddOn",
    "isShowConfirm": "0"
  },
  "0xE03EA": {
    "description": "Failed to end the AddOn.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to end the AddOn.",
    "action": "Failed to end the AddOn, please make sure the AddOn configurations are right before proceed.",
    "tittle": "Failed to end the AddOn",
    "isShowConfirm": "0"
  },
  "0xE03EB": {
    "description": "Invalid configuration file.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Invalid configuration file.",
    "action": "Please make sure the configuration files of the AddOn are correct, then proceed.",
    "tittle": "Invalid configuration file",
    "isShowConfirm": "0"
  },
  "0xE03EC": {
    "description": "The AddOn does not exist.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The AddOn does not exist.",
    "action": "Cannot find this AddOn. It might have been removed or deleted. Please refresh this page and try again.",
    "tittle": "The AddOn does not exist",
    "isShowConfirm": "0"
  },
  "0xE03ED": {
    "description": "The AddOn configuration does not exist.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The AddOn configuration does not exist.",
    "action": "The AddOn configuration does not exist, please check the current version of the software and contact the technical service team.",
    "tittle": "The AddOn configuration does not exist",
    "isShowConfirm": "0"
  },
  "0xE03EE": {
    "description": "The \"convention\" in AddOn configuration is unknown.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"convention\" in AddOn configuration is unknown.",
    "action": "Unable to identify the \"convention\" in AddOn configuration, please check if it is configured correctly.",
    "tittle": "The \"convention\" in AddOn configuration is unknown",
    "isShowConfirm": "0"
  },
  "0xE03EF": {
    "description": "The \"type\" in AddOn configuration file is wrong.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"type\" in AddOn configuration file is wrong.",
    "action": "Unable to identify the \"type\" in AddOn configuration, please make sure it's a number within 1-3. ",
    "tittle": "The \"type\" in AddOn configuration file is wrong",
    "isShowConfirm": "0"
  },
  "0xE03F0": {
    "description": "The \"language\" in AddOn configuration file is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"language\" in AddOn configuration file is incorrect.",
    "action": "Unable to identify the \"language\" in AddOn configuration, please check if it is configured correctly.",
    "tittle": "The \"language\" in AddOn configuration file is incorrect",
    "isShowConfirm": "0"
  },
  "0xE03F1": {
    "description": "The entry point of AddOn configuration file is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The entry point of AddOn configuration file is incorrect.",
    "action": "Unable to identify the \"language\" in AddOn configuration, please make sure the \"service\" is not empty and contains no more than 50 bytes.",
    "tittle": "The entry point of AddOn configuration file is incorrect",
    "isShowConfirm": "0"
  },
  "0xE03F2": {
    "description": "The \"auto-start\" in AddOn configuration file is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"auto-start\" in AddOn configuration file is incorrect.",
    "action": "Unable to identify the \"serviceenable\" in AddOn configuration, please make sure the \"serviceenable\" is True or False.",
    "tittle": "The \"auto-start\" in AddOn configuration file is incorrect",
    "isShowConfirm": "0"
  },
  "0xE03F3": {
    "description": "A necessary setting in the AddOn configuration file is missing.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "A necessary setting in the AddOn configuration file is missing.",
    "action": "A necessary setting in the AddOn configuration file is missing, please check if the configuration files are correct.",
    "tittle": "A necessary setting in the AddOn configuration file is missing",
    "isShowConfirm": "0"
  },
  "0xE03F4": {
    "description": "The \"Name\" in AddOn configuration file is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"Name\" in AddOn configuration file is incorrect.",
    "action": "The \"Name\" in AddOn configuration file has exceeded 40 bytes, please correct it and try again.",
    "tittle": "The \"Name\" in AddOn configuration file is incorrect",
    "isShowConfirm": "0"
  },
  "0xE03F5": {
    "description": "The \"description\" in AddOn configuration file is incorrect.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The \"description\" in AddOn configuration file is incorrect.",
    "action": "The \"description\" in AddOn configuration file has exceeded 40 bytes, please correct it and try again.",
    "tittle": "The \"description\" in AddOn configuration file is incorrect",
    "isShowConfirm": "0"
  },
  "0xE03F6": {
    "description": "Cannot identify the AddOn version.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Cannot identify the AddOn version.",
    "action": "Cannot identify the version of AddOn in its configuration, please make sure the configuration is right to proceed.",
    "tittle": "Cannot identify the AddOn version",
    "isShowConfirm": "0"
  },
  "0xE03F7": {
    "description": "Error occurs in the URL of AddOn configuration files.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Error occurs in the URL of AddOn configuration files.",
    "action": "The URL in the AddOn configuration couldn't be parsed. Please verify the configuration is correct and try again.",
    "tittle": "Error occurs in the URL of AddOn configuration files",
    "isShowConfirm": "0"
  },
  "0xE03F8": {
    "description": "Error occurs when assigning the port number.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Error occurs when assigning the port number.",
    "action": "Failed to assign the AddOn port number. Please verify the configuration is correct and contact the technical service team.",
    "tittle": "Error occurs when assigning the port number",
    "isShowConfirm": "0"
  },
  "0xE03F9": {
    "description": "AddOn is running.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn is running.",
    "action": "AddOn is running, Please stop it first to proceed.",
    "tittle": "AddOn is running",
    "isShowConfirm": "0"
  },
  "0xE03FA": {
    "description": "The directory already exists.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The directory already exists.",
    "action": "Please check if the directory already exists. Select the correct directory to proceed.",
    "tittle": "The directory already exists",
    "isShowConfirm": "0"
  },
  "0xE03FB": {
    "description": "The IP address already exists.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The IP address already exists.",
    "action": "Please check if the IP address already exists. If so, please correct the current one to proceed.",
    "tittle": "The IP address already exists",
    "isShowConfirm": "0"
  },
  "0xE03FC": {
    "description": "Failed to calculate the safety orientation related parameters.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to calculate the safety orientation related parameters.",
    "action": "Please reset the safety orientation of the tool.",
    "tittle": "Failed to calculate the safety orientation related parameters",
    "isShowConfirm": "0"
  },
  "0xE044C": {
    "description": "Checksum files don't match.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Checksum files don't match.",
    "action": "Please check if the files can match, or re-download and upgrade the program.",
    "tittle": "Checksum files don't match",
    "isShowConfirm": "0"
  },
  "0xE044D": {
    "description": "Wrong password",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Wrong password",
    "action": "Please enter the right one.",
    "tittle": "Wrong password",
    "isShowConfirm": "0"
  },
  "0xE044E": {
    "description": "The two passwords you entered are inconsistent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The two passwords you entered are inconsistent.",
    "action": "Please enter the same password twice.",
    "tittle": "The two passwords you entered are inconsistent",
    "isShowConfirm": "0"
  },
  "0xE044F": {
    "description": "Please reset the password the first time you log in.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Please reset the password the first time you log in.",
    "action": "Please reset the password and log in again.",
    "tittle": "Please reset the password the first time you log in",
    "isShowConfirm": "0"
  },
  "0xE0450": {
    "description": "The password you changed cannot be the same with the old one.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The password you changed cannot be the same with the old one.",
    "action": "Please use a different password.",
    "tittle": "The password you changed cannot be the same with the old one",
    "isShowConfirm": "0"
  },
  "0xE0451": {
    "description": "The account is not activated.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The account is not activated.",
    "action": "The account is not activated, please contact whoever is in charge of this robot.",
    "tittle": "The account is not activated",
    "isShowConfirm": "0"
  },
  "0xE0452": {
    "description": "Cannot activate the account.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Cannot activate the account.",
    "action": "Cannot activate the account, for the account is incorrect. Please contact whoever is in charge of this robot.",
    "tittle": "Cannot activate the account",
    "isShowConfirm": "0"
  },
  "0xE0453": {
    "description": "AddOn is installing.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn is installing.",
    "action": "AddOn is installing, please try again later.",
    "tittle": "AddOn is installing",
    "isShowConfirm": "0"
  },
  "0xE0454": {
    "description": "Failed to install AddOn.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to install AddOn.",
    "action": "Failed to install AddOn, please make sure it's a valid package before proceed.",
    "tittle": "Failed to install AddOn",
    "isShowConfirm": "0"
  },
  "0xE0455": {
    "description": "The AddOn package is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The AddOn package is too large.",
    "action": "The AddOn package is too large or contains too many files, please reduce the package size and the number of files, then try again.",
    "tittle": "The AddOn package is too large",
    "isShowConfirm": "0"
  },
  "0xE0456": {
    "description": "Switching between manual and automatic modes in a wrong state.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Switching between manual and automatic modes in a wrong state.",
    "action": "Switch operation mode in a wrong state (the robot is moving, running a program, or being dragged).",
    "tittle": "Switching between manual and automatic modes in a wrong state",
    "isShowConfirm": "0"
  },
  "0xE0457": {
    "description": "There are unsupported characters in the input string.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There are unsupported characters in the input string.",
    "action": " Modify the input parameters and try again.",
    "tittle": "There are unsupported characters in the input string.",
    "isShowConfirm": "0"
  },
  "0xE04B0": {
    "description": "Upgrade is prohibited in the emergency stop state",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Upgrade is prohibited in the emergency stop state",
    "action": "Upgrade is prohibited in the emergency stop state",
    "tittle": "Upgrade is prohibited in the emergency stop state",
    "isShowConfirm": "0"
  },
  "0xEFFFF": {
    "description": "Unknown error",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unknown error",
    "action": "Please contact the technical service team.",
    "tittle": "Unknown error",
    "isShowConfirm": "0"
  },
  "0x0F0001": {
    "description": "The robot is powered off now.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is powered off when the controller executes the command.",
    "action": "Please check if the robot is powered on. If not, power on the robot first.",
    "tittle": "The robot is powered off",
    "isShowConfirm": "1"
  },
  "0x0F0002": {
    "description": "The robot is disabled now.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is disabled when the controller executes the command.",
    "action": "Please check if the robot is enabled. If not, enable the robot first.",
    "tittle": "The robot is disabled",
    "isShowConfirm": "1"
  },
  "0x0F0003": {
    "description": "This operation cannot be performed in the current mode. It's in the {0} mode now. The {1} command is not allowed.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot can only perform certain operations when it is in a specific operating mode. The operation is not allowed in the current mode.",
    "action": "Exit the current mode first, then perform this operation again.",
    "tittle": "This operation cannot be performed in the current mode",
    "isShowConfirm": "1"
  },
  "0x0F0004": {
    "description": "Inverse kinematics calculation failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Inverse kinematics calculation failed, because: \n1. The robot cannot reach the given pose in Cartesian space; \n2. The given pose in Cartesian space is unsolvable in the solution space determined by the given reference angle.",
    "action": "1. Click the Manual Operation, and then click the coordinate editing interface. Enter the position information for verification;\n2. JOG to check if the target position or the pose of the target moving path is reachable. If so, please change a pose for inverse kinematics calculation.",
    "tittle": "Inverse kinematics calculation failed",
    "isShowConfirm": "1"
  },
  "0x0F0005": {
    "description": "The setting value is too large.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "The setting value is too large",
    "isShowConfirm": "1"
  },
  "0x0F0006": {
    "description": "The robot joint has reached the positive hard limit, so the robot is unable to move.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When in JOG mode, the robot joint has reached the limit, but is still commanded to move towards the limit direction.",
    "action": "Please check if the robot joint has reached its limit. The robot cannot move if so.",
    "tittle": "The robot joint has reached the positive hard limit",
    "isShowConfirm": "1"
  },
  "0x0F0007": {
    "description": "The robot joint has reached the negative hard limit, so the robot is unable to move.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When in JOG mode, the robot joint has reached the limit, but is still commanded to move towards the limit direction.",
    "action": "Please check if the robot joint has reached its limit. The robot cannot move if so.",
    "tittle": "The robot joint has reached the negative hard limit",
    "isShowConfirm": "1"
  },
  "0x0F0008": {
    "description": "The robot joint has reached the positive soft limit, so the robot is unable to move.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When in JOG mode, the robot joint has reached the limit, but is still commanded to move towards the limit direction.",
    "action": "Please check if the robot joint has reached its limit. The robot cannot move if so.",
    "tittle": "The robot joint has reached the positive soft limit",
    "isShowConfirm": "1"
  },
  "0x0F0009": {
    "description": "The robot joint has reached the negative soft limit, so the robot is unable to move.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When in JOG mode, the robot joint has reached the limit, but is still commanded to move towards the limit direction.",
    "action": "Please check if the robot joint has reached its limit. The robot cannot move if so.",
    "tittle": "The robot joint has reached the negative soft limit",
    "isShowConfirm": "1"
  },
  "0x0F000A": {
    "description": "The target position has exceeded the maximum position limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The given target Cartesian position exceeds the maximum limit of the joint.",
    "action": "Please check if the target position given in Cartesian space is unreachable for the joint.",
    "tittle": "The target Cartesian position has exceeded the maximum position limit",
    "isShowConfirm": "1"
  },
  "0x0F000B": {
    "description": "The target position has exceeded the minimum position limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The given target Cartesian position exceeds the minimum limit of the joint.",
    "action": "Please check if the target position given in Cartesian space is unreachable for the joint.",
    "tittle": "The target Cartesian position has exceeded the minimum position limit",
    "isShowConfirm": "1"
  },
  "0x0F000E": {
    "description": "Manual operation is not allowed when the joint is returning to the open pose.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Manual operation is performed when the joint is returning to the open pose. ",
    "action": "Please check if the robot is returning to its open pose. If so, please wait until this process is completed.",
    "tittle": "Manual operation is not allowed when the joint is returning to the open pose",
    "isShowConfirm": "1"
  },
  "0x0F000F": {
    "description": "Cannot find the target joint.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When controlling a single-axis movement in Cartesian space or a single-joint movement in joint space, an invalid axis/joint index is provided, resulting in an error.",
    "action": "Please check if the target joint given in the command is correct. If so, please export the log and contact JAKA technical service team for help.",
    "tittle": "Cannot find the target joint",
    "isShowConfirm": "1"
  },
  "0x0F0010": {
    "description": "Invalid speed of the move command.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Reserved for later modification.",
    "action": "Please confirm if it's in debugging mode. Export the diagnostic information and contact the technical service team.",
    "tittle": "Invalid speed of the move command",
    "isShowConfirm": "1"
  },
  "0x0F0011": {
    "description": "The target position in the move command is out of the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The target position of the joint movement or linear movement is beyond the robot joint's limit.    ",
    "action": "JOG the robot to check if the target position can be attained or is within the joint's limit.",
    "tittle": "The target position in the move command is out of the limit",
    "isShowConfirm": "1"
  },
  "0x0F0012": {
    "description": "HOME operation cannot be performed in movements other than MoveJ.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "HOME operation cannot be performed in movements other than MoveJ",
    "isShowConfirm": "1"
  },
  "0x0F0013": {
    "description": "HOME mode is ongoing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "HOME mode is ongoing",
    "isShowConfirm": "1"
  },
  "0x0F0014": {
    "description": "Failed to exit the protection mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Failed to exit the protection mode",
    "isShowConfirm": "1"
  },
  "0x0F0015": {
    "description": "The robot is disabled.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "The robot is disabled",
    "isShowConfirm": "1"
  },
  "0x0F0016": {
    "description": "The robot joint is in its soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot joint is in its soft limit, so the command cannot be run.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or modify the limit value in Setting. ",
    "tittle": "The robot joint is in its soft limit",
    "isShowConfirm": "1"
  },
  "0x0F0017": {
    "description": "The target position of the move command is unreachable",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The target position of the move command is unreachable.",
    "action": "The target position is out of the robot's working range or at the singularity. Please JOG to check if this target point can be attained by MoveJ. If so, try to change the orientation of the robot, and reach the target position through other move trajectory or orientation. ",
    "tittle": "The target position of the move command is unreachable",
    "isShowConfirm": "1"
  },
  "0x0F0018": {
    "description": "Safeguard stop is activated for the robot has reached the singularity.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is about to reach the singularity, therefore it cannot continue the movement in Cartesian space. This error occurs when the inverse kinematics calculation failed or was in a different solution space from the previous movement cycle.",
    "action": "Please check if the current trajectory and orientation is reachable. If not, change the trajectory or orientation to reach the target position. If the commanded trajectory is correct, please collect relevant data and contact the technical service team.",
    "tittle": "Safeguard stop is activated for the robot has reached the singularity",
    "isShowConfirm": "1"
  },
  "0x0F0019": {
    "description": "CAN device initialization failed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "CAN device initialization failed.",
    "action": "With the virtual machine/robot, there is no CAN device, so this error would occur. Modification may be made in the future. With the actual robot, please restart the robot. If this error still continues to occur, contact the technical service team.",
    "tittle": "CAN device initialization failed",
    "isShowConfirm": "1"
  },
  "0x0F001A": {
    "description": "One-click upgrade timeout",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The one-click upgrade takes too long",
    "action": "Please check the network and controller before operate again.",
    "tittle": "One-click upgrade timeout",
    "isShowConfirm": "1"
  },
  "0x0F001B": {
    "description": "One-click upgrade failed, an exception/error has occurred during upgrade",
    "type": "1",
    "isShowOTA": "0",
    "reason": "One-click upgrade failed",
    "action": "Please check the resource and validity of the upgrade package.",
    "tittle": "One-click upgrade failed, an exception/error has occurred during upgrade",
    "isShowConfirm": "1"
  },
  "0x0F001C": {
    "description": "Joint limit data are not normal during controller booting",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "Please modify the joint limit value",
    "tittle": "Joint limit data are not normal during controller booting",
    "isShowConfirm": "1"
  },
  "0x0F001D": {
    "description": "Robot power on timeout",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There are abnormalities in the power on process",
    "action": "Please check if the CAN communication is normal before attempting to power on again",
    "tittle": "Robot power on timeout",
    "isShowConfirm": "1"
  },
  "0x0F001E": {
    "description": "The joint Angle obtained from the inverse kinematics of the robot is not in line with the expected value",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error is reported if the joint position of the robot changes abnormally during movement, which generally occurs when an error occurs during the calculation of the inverse solution or when the difference between the inverse solution and the previous cycle is abnormal.",
    "action": "Check whether the current robot path and attitude are reachable or near a singular position. If so, replace the initial attitude or path. If you confirm that there is no problem with the instruction path, please collect relevant data and contact JAKA technical service personnel",
    "tittle": "The inverse kinematics of the robot is not right when it moves",
    "isShowConfirm": "1"
  },
  "0x0F001F": {
    "description": "The firmware upgrade progress has not been updated for a long time.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "An unknown exception may have occurred during the firmware upgrade process.",
    "action": "The control cabinet will automatically restart in 10 seconds. After the controller restarts, check if the firmware version number has been updated. If not, please try to upload the firmware installation package again for the upgrade.",
    "tittle": "Firmware Upgrade Timeout",
    "isShowConfirm": "1"
  },
  "0x0F0020": {
    "description": "Failed to reach the target position through MoveL",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to reach the target position through MoveL. During general Cartesian movement (MoveL or MoveC), errors are triggered when passing through singularity, especially when the initial or final position is singularity.",
    "action": "For MoveL, if the trajectory position or target position is unreachable or pass through singularity, JOG to check if the target position can be reached by MoveJ. If so, consider change the current orientation of the robot, and make it reach the target position through other trajectory or orientation. \nNote: The indicating arrow might move ahead of its actual corresponding step of the command, so this error might be triggered before the movement that caused the error actually happened. Please check if the position in this command is reachable based on the current position.",
    "tittle": "Failed to reach the target position through MoveL",
    "isShowConfirm": "1"
  },
  "0x0F0021": {
    "description": "Unsupported robot model. In most cases, the newest version of controller software supports all robot models, but when an old version of controller software connects to a new model of robot, this error might occur. When this error occurs, the DH parameter, dynamics parameter and other limits might be wrong. Be careful when enable the robot.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller's version is outdated, therefore this robot model is not supported. Or it might be that the model of robot wasn't included in the robot's servo.",
    "action": "Please check the serial number of the robot on the information page, and contact JAKA for the newest version of softwares.",
    "tittle": "Unsupported robot model",
    "isShowConfirm": "1"
  },
  "0x0F0022": {
    "description": "Invalid robot serial number.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Invalid robot serial number. The controller software supports specific robot models, each with its unique encoding rules. The robot's serial number is read from the servo. If the serial number does not comply with the supported model and rules, this error might be triggered.",
    "action": "Please check the serial number on the App's information page and on the robot, to see if these two are the same. If the serial number is correct, please contact JAKA to get the newest version of software.",
    "tittle": "Invalid robot serial number",
    "isShowConfirm": "1"
  },
  "0x0F0023": {
    "description": "Payload identification trajectory index is invalid",
    "type": "1",
    "isShowOTA": "0",
    "reason": "An internal system error",
    "action": "Please identify the payload again, or upgrade the controller, or contact JAKA for technical support.",
    "tittle": "Payload identification trajectory index is invalid",
    "isShowConfirm": "1"
  },
  "0x0F0024": {
    "description": "Unable to change the decelerated percentage in decelerated mode",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Unable to change the decelerated percentage in decelerated mode. This error occurs when one tries to change the decelerated percentage while the robot is in decelerated mode or safeguard stop.",
    "action": "Please check if the robot is in decelerated mode. If so, please exit this mode first, then change the decelerated percentage. If not, please contact JAKA technical service for help.",
    "tittle": "Unable to change the decelerated percentage in decelerated mode",
    "isShowConfirm": "1"
  },
  "0x0F0025": {
    "description": "Payload identification trajectory does not meet the specifications",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Payload identification trajectory does not meet the specifications. The robot's payload identification process requires adherence to certain specifications to ensure accurate results. This error occurs when the user's input does not meet the specifications.",
    "action": "Please follow the trajectory specifications in the App's payload identification interface to re-identify the payload.",
    "tittle": "Payload identification trajectory does not meet the specifications",
    "isShowConfirm": "1"
  },
  "0x0F0026": {
    "description": "Disable the robot before power it off.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Disable the robot before power it off.",
    "action": "Please disable the robot first, then power it off.",
    "tittle": "Disable the robot before power it off",
    "isShowConfirm": "1"
  },
  "0x0F0027": {
    "description": "Cannot disable the robot while running a program.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Cannot disable the robot while running a program.",
    "action": "Please stop the program first, then disable the robot.",
    "tittle": "Cannot disable the robot while running a program",
    "isShowConfirm": "1"
  },
  "0x0F0028": {
    "description": "Deviation in payload setting is detected, please check.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Deviation in payload setting is detected, please check. Controller will check the payload when the robot is enabled. If the actual output torque deviates from the feedforward torque by a certain range, this error occurs and the robot will disable itself.",
    "action": "1. Please check if the setting of payload and center of mass are correct. \n2. Please check if the robot's model and serial number are correct. \n3. Please check if the robot's mounting angel is correct.",
    "tittle": "Deviation in payload setting is detected",
    "isShowConfirm": "1"
  },
  "0x0F0029": {
    "description": "Failed to execute MoveC command.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The three teaching points of MoveC are collinear, or there is a singularity.",
    "action": "1. Please check if the initial position, the middle position and the end position of MoveC are collinear;\n2. Please check if one of the initial position, the middle position and the end position of MoveC is singularity. ",
    "tittle": "Failed to execute MoveC command",
    "isShowConfirm": "1"
  },
  "0x0F0030": {
    "description": "Joint speed limit is set to 0",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The joint speed limt is set to 0",
    "action": "Please check the Joint Speed Limit in the App's Safety Setting to see if it's set to 0°/s.",
    "tittle": "Joint speed limit is set to 0",
    "isShowConfirm": "1"
  },
  "0x0F0031": {
    "description": "Three-position enabling function is limiting the movement",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The three-position enabling function is turned on in the Safety Settings.",
    "action": "The three-position enabling function can limit the control of robot. Please check if the three-position enabling function is turned on, or try to turn it off if the situation allows and no damage would be caused.",
    "tittle": "Three-position enabling function is limiting the movement",
    "isShowConfirm": "1"
  },
  "0x0F0032": {
    "description": "Unable to track movements other than MoveL or MoveC",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The conveyor tracking can only track movements in Cartesian space, but the conveyor tracking block has nested movements other than MoveL and MoveC.",
    "action": "Please check if movements other than MoveL and MoveC are nested in the conveyor tracking block.",
    "tittle": "The conveyor tracking cannot track movements other than MoveL or MoveC",
    "isShowConfirm": "1"
  },
  "0x0F0033": {
    "description": "Singularity is detected",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The robot is about to reach the singularity in this trajectory, therefore it cannot perform a Cartesian space movement. An inverse kinematics exception occurred during the movement. When an external tracking or compensation is involved, such as in compliant control or conveyor tracking, this error may occur due to exceptional external inputs.",
    "action": "1. Please check if the current trajectory and orientation of the robot is reachable. If not, change the initial orientation or trajectory, or change the target point's orientation;\n2. If currently the robot is in constant force compliant control, please check if there is any unusual force affecting the movement;\n3. If currently the robot is in conveyor tracking mode, please check the speed of the conveyor, and make sure the feedback of the encoder is correct. Large changes of parameters might lead to such issue.",
    "tittle": "Singularity is detected",
    "isShowConfirm": "1"
  },
  "0x0F0034": {
    "description": "Collision detected",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "JOINTG6": "Joint 6 momentum collision alarm",
        "JOINTG4": "Joint 4 momentum collision alarm",
        "JOINTG5": "Joint 5 momentum collision alarm",
        "END": "Robotic arm end sensor",
        "JOINTG3": "Joint 3 momentum collision alarm",
        "JOINTG1": "Joint 1 momentum collision alarm",
        "SENSOR_WRONG_DATA": "Sensor data error",
        "JOINTP3": "Joint 3 servo collision alarm",
        "JOINTP2": "Joint 2 servo collision alarm",
        "JOINTP1": "Joint 1 servo collision alarm",
        "BASE": "Robotic arm base sensor",
        "JOINTP6": "Joint 6 servo collision alarm",
        "JOINTP5": "Joint 5 servo collision alarm",
        "JOINTP4": "Joint 4 servo collision alarm",
        "JOINTG2": "Joint 2 momentum collision alarm"
      }
    },
    "reason": "The system detects a collision alarm, cause of collision: <0>.",
    "action": "1. Check that there is no interference around the robot and that no collision has occurred. \n2. Check that the robot serial number and model number are correctly identified. \n3. Check that the robot load and mounting angle are set correctly. \n4. If a torque sensor is used, check that the maximum force limit of the sensor is appropriate.",
    "tittle": "Collision detected",
    "isShowConfirm": "1"
  },
  "0x0F0035": {
    "description": "Exceeded the orientation limit",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Exceeding of the orientation limit is detected. The tool connected to the robot end has exceeded its limit.",
    "action": "Please check if the current trajectory of the robot is within the working limit of the tool. Or try to change the working limit of the tool.",
    "tittle": "Exceeded the orientation limit",
    "isShowConfirm": "1"
  },
  "0x0F0036": {
    "description": "The tool end has exceeded the maximum position deviation",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the position of the robot's tool end and the target position has exceeded the deviation limit.",
    "action": "Please check whether the robot movement deviates from the command position, or increase the deviation limit value setting in the user profile",
    "tittle": "The tool end has exceeded the maximum position deviation",
    "isShowConfirm": "1"
  },
  "0x0F0037": {
    "description": "The linear velocity of the tool end has exceeded its maximum limit",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The linear velocity of the robot's tool end during MoveJ has exceeded the maximum velocity limit set for the end.",
    "action": "Please check the Collision Settings in Safety Settings to see if the TCP velocity limit is set correctly; If so, please reduce the speed and acceleration of the MoveJ command.",
    "tittle": "The linear velocity of the tool end has exceeded its maximum limit",
    "isShowConfirm": "1"
  },
  "0x0F0038": {
    "description": "Failed to execute MoveJ command.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The MoveJ segment is invalid",
    "action": "Please check to confirm if the robot's current joint position and target joint position are correct. ",
    "tittle": "Failed to execute MoveJ command",
    "isShowConfirm": "1"
  },
  "0x0F0039": {
    "description": "Repeated TCP calibration teaching position",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There are two or two more same teaching positions",
    "action": "Please re-calibrate the TCP, and make sure there are no same teaching positions.",
    "tittle": "Repeated TCP calibration teaching position",
    "isShowConfirm": "1"
  },
  "0x0F003A": {
    "description": "Disabling is not allowed when the robot is running",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Disabling is not allowed when the robot is running",
    "action": "Please stop the program first before disable the robot",
    "tittle": "Disabling is not allowed when the robot is running",
    "isShowConfirm": "1"
  },
  "0x0F003B": {
    "description": "The robot is powered on already, there's no need to power on it again.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is powered on already, there's no need to power on it again.",
    "action": "The robot is powered on already, there's no need to power on it again.",
    "tittle": "The robot is powered on already, there's no need to power on it again",
    "isShowConfirm": "0"
  },
  "0x0F003C": {
    "description": "The robot is enabled already, there's no need to enable it again.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is enabled already, there's no need to enable it again.",
    "action": "The robot is enabled already, there's no need to enable it again.",
    "tittle": "The robot is enabled already, there's no need to enable it again",
    "isShowConfirm": "0"
  },
  "0x0F003D": {
    "description": "The TCP calibration has teaching points on the same line",
    "type": "1",
    "isShowOTA": "0",
    "reason": "If there are teaching points of the TCP calibration are on the same line, the TCP orientation will be failed.",
    "action": "Please reset the teaching points that are proper.",
    "tittle": "The TCP calibration has teaching points on the same line",
    "isShowConfirm": "1"
  },
  "0x0F003E": {
    "description": "The deviation of TCP coordinate system calibration has exceeded the preset threshold.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of TCP coordinate system calibration has exceeded the preset threshold.",
    "action": "Please reset the teaching points that are proper.",
    "tittle": "The deviation of TCP coordinate system calibration has exceeded the preset threshold",
    "isShowConfirm": "1"
  },
  "0x0F003F": {
    "description": "The calibration coordinates of TCP coordinate system are beyond the working space",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The calibration coordinates of TCP coordinate system are beyond the working space.",
    "action": "Please reset a more appropriate teaching point.",
    "tittle": "The calibration coordinates of TCP coordinate system are beyond the working space",
    "isShowConfirm": "1"
  },
  "0x0F0040": {
    "description": "Unable to enter free drive mode when on the soft limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to enter free drive mode when on the soft limit.",
    "action": "Please check if the robot joint has reached its limit. If so, the robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or modify the limit value in Setting. ",
    "tittle": "Unable to enter free drive mode when on the soft limit",
    "isShowConfirm": "1"
  },
  "0x0F0041": {
    "description": "The robot is dragged beyond its soft limit and might stop.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is dragged beyond its soft limit and might stop. This error occurs when the robot is dragged beyond its soft limit.",
    "action": "Please check the current status of the robot. The robot cannot move towards the limit's direction but the opposite. Please JOG the joint that exceeds its limit back to its range, or exit free drive mode and go to Settings to reset the range of soft limit, which cannot exceed the range of hard limit.",
    "tittle": "The robot is dragged beyond its soft limit and might stop",
    "isShowConfirm": "1"
  },
  "0x0F0042": {
    "description": "Compliant parameter setting failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The compliant parameter cannot be set when in force control mode ",
    "action": "Please check if the robot is in force control mode now. Please check if the compliant parameter is set in current command, if so, please exit the compliant mode before run this command.",
    "tittle": "Force control parameter setting failed",
    "isShowConfirm": "1"
  },
  "0x0F0043": {
    "description": "The robot is disabled so it cannot enter free drive mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is disabled so it cannot enter free drive mode. The free drive mode was turned on when the robot is disabled.",
    "action": "Please check if the robot is powered on and enabled; please check if this button was accidentally pressed.",
    "tittle": "The robot is disabled so it cannot enter free drive mode",
    "isShowConfirm": "1"
  },
  "0x0F0044": {
    "description": "The robot is not currently in an idle state and cannot switch into Freedrive mode",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot needs to be in an idle stationary state to activate Freedrive.",
    "action": "Please check if the robot is in motion, running a program, in Tool-Drive mode, or in an error state, stop the current job or restore the robot from error state, then try activate Freedrive again.",
    "tittle": "Currently unable to activate Freedrive.",
    "isShowConfirm": "1"
  },
  "0x0F0045": {
    "description": "The joint torque has exceeded its limit and cannot enter free drive mode.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The joint torque has exceeded its limit and cannot enter free drive mode. This error occurs usually when the robot is dragged too fast or the collision detection is too sensitive.",
    "action": "Try to lower the dragging speed or set the Collision Settings to a higher level.",
    "tittle": "The joint torque has exceeded its limit and cannot enter free drive mode",
    "isShowConfirm": "1"
  },
  "0x0F0046": {
    "description": "The Free button has been disabled and cannot enter free drive mode.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The Free button on the robot end has been disabled, so the free drive mode cannot be entered by pressing the Free button.",
    "action": "Check whether drag and drop is disabled in [Settings - Hardware & Communication - Auxiliary Hardware Settings]. If so, enable it.",
    "tittle": "The Free button has been disabled and cannot enter free drive mode",
    "isShowConfirm": "0"
  },
  "0x0F0047": {
    "description": "Program Pause or Start button is disabled.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The Program Pause or Start button on the robot end has been disabled, so the program cannot be paused or started by pushing this button.",
    "action": "Please check Auxiliary Hardware Settings in Hardware&Communication to see if the Free button is disabled. If so, please enable it.",
    "tittle": "Program Pause or Start button is disabled",
    "isShowConfirm": "0"
  },
  "0x0F0048": {
    "description": "The Point button has been disabled, so the current position cannot be recorded.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The Point button on the robot end has been disabled, so the current position cannot be recorded by pushing the Point button.",
    "action": "Please check Auxiliary Hardware Settings in Hardware&Communication to see if the Free button is disabled. If so, please enable it.",
    "tittle": "The Point button has been disabled, so the current position cannot be recorded",
    "isShowConfirm": "0"
  },
  "0x0F0049": {
    "description": "Unable to enter free drive mode when in simulation mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to enter free drive mode when in simulation mode.",
    "action": "Please check the current mode of the robot. Exit the simulation mode first, then enter the free drive mode.",
    "tittle": "Unable to enter free drive mode when in simulation mode",
    "isShowConfirm": "1"
  },
  "0x0F004A": {
    "description": "Compliant parameter setting failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to directly disable force control in a certain direction while force control is enabled in the program",
    "action": "Please check if force control is enabled in the program and if any force control direction is deselected while enabled. If so, please disable force control and retry",
    "tittle": "Force control parameter setting failed",
    "isShowConfirm": "1"
  },
  "0x0F004B": {
    "description": "Can't zero force sensor manually when a program is running",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Can't zero force sensor manually when a program is running",
    "action": "Stop the current program or wait until the program is finished and then try again",
    "tittle": "Sensor zeroing failed",
    "isShowConfirm": "1"
  },
  "0x0F004C": {
    "description": "Unable to start tool drag",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Currently in joint free-drive mode, which conflicts with tool drag, so the latter cannot be started directly",
    "action": "Please exit the joint drag mode and then start the tool drag",
    "tittle": "Unable to start tool drag",
    "isShowConfirm": "1"
  },
  "0x0F004D": {
    "description": "Constant force compliance control unexpectedly shuts down",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is in servo mode and has the constant force compliance control turned on. Attempting to turn off force control before exiting the servo mode will trigger this error",
    "action": "The current motion has been terminated, please check the program logic to ensure that you exit the servo mode before turning off the constant force compliance control",
    "tittle": "Constant force compliance control unexpectedly shuts down",
    "isShowConfirm": "1"
  },
  "0x0F004E": {
    "description": "Unable to start tool drag",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Tool drag must be enabled when the robot is in normal enabled and idle state. Tool drag cannot be enabled when the robot is in automatic mode, joint dragging mode, or any abnormal state.",
    "action": "Ensure robot state before enabling tool drag",
    "tittle": "Unable to start tool drag",
    "isShowConfirm": "1"
  },
  "0x0F004F": {
    "description": "The joint acceleration is too large when running straight or circular motion near the singular position",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The joint acceleration is too large, especially when the robot runs in a straight line or arc motion near the singular position.",
    "action": "Reduce the acceleration and speed of straight or circular motion, or change the path running.",
    "tittle": "Predictive stop near singular position",
    "isShowConfirm": "1"
  },
  "0x0F0050": {
    "description": "The force sensor is not ready yet, so the force control functions cannot be enabled.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The force sensor is not ready yet, so the force control functions cannot be enabled. This error occurs when trying to use force control functions but the force sensor is still turned off.",
    "action": "Please check if the force sensor is turned on.",
    "tittle": "The force sensor is not ready yet",
    "isShowConfirm": "1"
  },
  "0x0F0051": {
    "description": "Force sensor cannot be disabled in tool drag mode",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The force sensor cannot be directly disabled while tool drag mode is active.",
    "action": "To disable the sensor, first exit tool drag mode, then disable the sensor.",
    "tittle": "Force sensor cannot be disabled in tool drag mode",
    "isShowConfirm": "1"
  },
  "0x0F0052": {
    "description": "Force sensor malfunction during tool drag",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Force sensor malfunction occurs during tool drag. Possible cause is disconnection of communication link between controller and external force sensor.",
    "action": "Please check force sensor communication status including hardware connection cables and software configuration.",
    "tittle": "Force sensor malfunction during tool drag",
    "isShowConfirm": "1"
  },
  "0x0F0053": {
    "description": "Cannot turn on force control when sensor is being zeroed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Sensor is being zeroed.",
    "action": "Please wait until the zeroing finishes, which takes about 0.5s.",
    "tittle": "Cannot turn on force control when sensor is being zeroed",
    "isShowConfirm": "1"
  },
  "0x0F0054": {
    "description": "Single-step debugging cannot be performed when the program is running.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Single-step debugging cannot be performed when the program is running.",
    "action": "Stop the current program first, then use single-step debugging mode.",
    "tittle": "Single-step debugging cannot be performed when the program is running",
    "isShowConfirm": "1"
  },
  "0x0F0055": {
    "description": "Collision sensitivity cannot be set when robot is moving.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Collision sensitivity cannot be set when robot is moving.",
    "action": "Stop the robot first, and then set collision sensitivity.",
    "tittle": "Collision sensitivity cannot be set when robot is moving",
    "isShowConfirm": "1"
  },
  "0x0F0056": {
    "description": "Expansion IO is not running, hence inaccessible.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Expansion IO is not running, hence inaccessible.",
    "action": "Please check the IO Panel to see if the Expansion IO is running.",
    "tittle": "Expansion IO is not running",
    "isShowConfirm": "1"
  },
  "0x0F0057": {
    "description": "Dynamic feedforward control cannot be enabled or disabled during a robot movement.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Dynamic feedforward control cannot be enabled or disabled during a robot movement. This error occurs when using a SDK interface.",
    "action": "Stop the current movement first, then set the dynamic feedforward control.",
    "tittle": "Dynamic feedforward control cannot be set",
    "isShowConfirm": "1"
  },
  "0x0F0058": {
    "description": "Permission for using such function is not detected.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Permission for using such function is not detected. The usage of some functions needs to be authorized. If this error occurs, it means the function being used is unauthorized yet.",
    "action": "Please contact the technical service team to purchase such function.",
    "tittle": "Permission for using such function is not detected",
    "isShowConfirm": "1"
  },
  "0x0F0059": {
    "description": "Safeguard stop is still on.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Safeguard stop is still on. This error occurs when one tries to turn off the safeguard Stop yet it is still on.",
    "action": "Please check the IO Panel to see if the safeguard Stop is still on, if so, please turn it off first before reset it.",
    "tittle": "Safeguard stop is still on",
    "isShowConfirm": "1"
  },
  "0x0F005A": {
    "description": "Operation to set safety parameters is denied",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Setting safety parameters is prohibited when the robot is not in manual mode or when the robot is in manual mode but is moving or is in Tool-drive mode.",
    "action": "Stop any movement and/or turn off Tool-drive, ensure the robot to manual mode for safety parameter configuration.",
    "tittle": "Operation to set safety parameters is denied",
    "isShowConfirm": "1"
  },
  "0x0F005B": {
    "description": "Operation to set safety parameters is denied.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Do not set safety parameters while the robot is enabled.",
    "action": "Please disable the robot before setting safety parameters.",
    "tittle": "Operation to set safety parameters is denied",
    "isShowConfirm": "1"
  },
  "0x0F005C": {
    "description": "The set safety parameters are not within a reasonable range, safety parameters setting failed.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The set safety parameters exceed the functional support range.",
    "action": "Please modify the safety parameters to a reasonable range before setting again.",
    "tittle": "Unreasonable safety parameters",
    "isShowConfirm": "1"
  },
  "0x0F005D": {
    "description": "Setting of safety parameters is denied",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Cannot set safety parameters when the robot program is being executed.",
    "action": "Please stop the program before setting safety parameters.",
    "tittle": "Setting of safety parameters is denied",
    "isShowConfirm": "1"
  },
  "0x0F005E": {
    "description": "<0> exceeds the robot's parameter range.",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "MomentumLimitReduce": "Reduced Mode Momentum Limit",
        "TcpVelLimit": "Robot TCP Speed Limit",
        "StoppingDistance": "Robot Stop Distance",
        "StoppingTimeReduce": "Reduced Mode Stop Time",
        "TcpVelReduce": "Reduced Mode TCP Speed Limit",
        "StoppingTime": "Robot Stop Time",
        "StoppingDistReduce": "Reduced Mode Stop Distance",
        "MomentumLimit": "Robot Momentum Limit",
        "ElbowVelLimitReduce": "Reduced Mode Elbow Speed Limit",
        "RobotPowerLimit": "Robot Power Limit",
        "PoewrLimitReduce": "Reduced Mode Power Limit"
      }
    },
    "reason": "<0> exceeds the robot's parameter range.",
    "action": "Robot serial number: {0}\nSet value of <0>: {1}\nMinimum value of <0>: {2}\nMaximum value of <0>: {3}\nWhen setting safety parameters, please ensure that the <0> parameter is within the configurable range.\nAfter confirming that everything is correct, please click the \"OK\" button to update the settings.",
    "tittle": "Conflicting safety parameters",
    "isShowConfirm": "1"
  },
  "0x0F0060": {
    "description": "Decelerated percentage cannot be adjusted in safeguard stop mode.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Decelerated percentage cannot be adjusted in safeguard stop mode.",
    "action": "Exit the safeguard stop mode first, then set the decelerated percentage of the robot.",
    "tittle": "Decelerated percentage cannot be adjusted in safeguard stop mode",
    "isShowConfirm": "1"
  },
  "0x0F0061": {
    "description": "Failed to calibrate the user coordinate system.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The chosen calibration point is collinear, so it failed to calibrate the user coordinate system.",
    "action": "Please reset the teaching point.",
    "tittle": "Failed to calibrate the user coordinate system",
    "isShowConfirm": "1"
  },
  "0x0F0062": {
    "description": "TIO RS485 channel force sensor mode is not enabled",
    "type": "2",
    "isShowOTA": "0",
    "reason": " The TIO RS485 channel force sensor mode has not been enabled. An abnormal pin multiplexing configuration was detected when enabling the TIO force sensor.",
    "action": "When selecting sensor type VI in force sensor settings, enabling the force sensor will detect whether any TIO channel has been correctly configured for force sensor mode. If not configured properly, the above error message will appear. Please check related configurations.",
    "tittle": "TIO RS485 channel force sensor mode is not enabled ",
    "isShowConfirm": "1"
  },
  "0x0F0063": {
    "description": "TIO RS485 configuration does not meet hardware requirements",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Due to CAN channel bandwidth limitations, TIO RS485 configurations must comply with the following rules: For S-Series robots, only 1 485 channel can be multiplexed, and no 485 channel can be configured in force sensor mode; For other models, only 1 485 channel is allowed to be set in force sensor mode",
    "action": "If this error occurs during configuration, please verify the configuration complies with the rules before reconfiguring. If this message appears during robot startup/power-on, it may indicate user settings mismatch with the new robot model after switching. The robot will automatically ignore problematic user settings and apply default configurations. To eliminate this message, go to IO Panel/Tool-end to reconfigure DO and AI function settings once to overwrite old configurations. Note: Current configuration pages will display the forcibly modified settings, but previously saved user configuration files remain unupdated and may be inconsistent. Manual confirmation is required to update settings.",
    "tittle": "Invalid TIO RS485 Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0064": {
    "description": "Failed to modify communication parameters. The force sensor using this channel is running.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to modify TIO RS485 communication parameters. The force sensor using this channel is running.",
    "action": "Modifying communication parameters is prohibited while the force sensor is running. Please stop operation first, then modify the communication parameters.",
    "tittle": "Failed to modify communication parameters",
    "isShowConfirm": "1"
  },
  "0x0F0065": {
    "description": "The signal definition is invalid.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The signal definition is invalid. The status of the end Modbus claw is queried through a signal mechanism, and the definition of signals needs to meet specific standards, including name, function code, address, and more. This error occurs when the definition fails to meet the standards.",
    "action": "Please verify if the current TIO RS485 channel ID is correct, the specified channel mode is set to Modbus RTU, and whether the supported function codes are available (currently only support function codes 01, 02, 03, 04).",
    "tittle": "The signal definition is invalid",
    "isShowConfirm": "1"
  },
  "0x0F0066": {
    "description": "The number of signals exceeds the maximum supported quantity (8)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Due to bandwidth limitations, there's a restriction on the number of supported signals, with a maximum of 8. Any number beyond this limit will result in an error.",
    "action": "Only up to 8 signal definitions are supported currently. Please delete any unnecessary signal definitions.",
    "tittle": "The number of signals exceeds the maximum supported quantity",
    "isShowConfirm": "1"
  },
  "0x0F0067": {
    "description": "The specified signal does not exist.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The specified signal does not exist. This error occurs when a command uses a signal that does not exist.",
    "action": "Please review the program calls related to signals and signal definitions to check for any references to undefined signals.",
    "tittle": "The specified signal does not exist",
    "isShowConfirm": "1"
  },
  "0x0F0068": {
    "description": "Failed to send TIO RS485 commands. The command queue is full.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The command queue is full. Failed to send TIO RS485 commands. This error occurs during high-frequency signal refresh or command transmissions.",
    "action": "Due to the limited CAN communication bandwidth, queries and configuration commands related to TIO+ will be buffered. This error occurs when the refreshing rate of the application exceeds the bandwidth. Please lower the frequency of calling commands in the program or application.",
    "tittle": "Failed to send TIO RS485 commands.  ",
    "isShowConfirm": "1"
  },
  "0x0F0069": {
    "description": "The TIO RS485 command feedback reception time out.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The TIO RS485 command feedback reception time out. This error occurs when the controller sends a TIO RS485 command and waits for too long to receive the feedback.",
    "action": "Please check if the TIO+ communication setting is correct; Please check if the communication link between the controller and robot is normal.",
    "tittle": "The TIO RS485 command feedback reception time out  ",
    "isShowConfirm": "1"
  },
  "0x0F006A": {
    "description": "The MoveZS instruction generation failed during the program save process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incorrect parameter settings for the MoveZS instruction were detected during the program save process.",
    "action": "Check the parameters of the MoveZS instruction in the program, and after confirming that the 'Start Position', 'End Position', and 'Any Position' are correct, resave the program.",
    "tittle": "Instruction Generation Failed",
    "isShowConfirm": "1"
  },
  "0x0F006B": {
    "description": "The digital output port is unavailable",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The digital output port [{0}: Pin_{1}] was set as function DO or safety DO, therefore it cannot be modified as a general DO.",
    "action": "1. Cancel the function configuration on [{2}: Pin_{3}];\n2. Do not configure the status of [{4}: Pin_{5}] through a command.",
    "tittle": "The digital output port is unavailable",
    "isShowConfirm": "1"
  },
  "0x0F006C": {
    "description": "Decelerated percentage cannot be adjusted in percentage mode.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Decelerated percentage cannot be adjusted in percentage mode.",
    "action": "Exit the percentage mode first, then set the decelerated percentage of the robot.",
    "tittle": "Decelerated percentage cannot be adjusted in percentage mode",
    "isShowConfirm": "1"
  },
  "0x0F006D": {
    "description": "Force sensor feedback value exceeds limit",
    "type": "0",
    "isShowOTA": "0",
    "reason": "The feedback value of the force sensor exceeds the maximum range, and the force or torque applied to the sensor is too great.",
    "action": "Check the load on the force sensor to ensure the applied force or torque remains within the appropriate range.",
    "tittle": "Force sensor feedback value exceeds limit",
    "isShowConfirm": "1"
  },
  "0x0F006E": {
    "description": "Force sensor detects external force",
    "type": "0",
    "isShowOTA": "0",
    "reason": "The sensor detects an external force greater than 3N or 0.2Nm when entering tool drag mode.",
    "action": "Please check that the sensor is not subjected to an external force. If the sensor is not subjected to an external force, it is possible that the sensor has not been calibrated to zero or that the sensor has failed to acquire a reading, thus causing the robot to drift in position.",
    "tittle": "Force sensor detects external force",
    "isShowConfirm": "1"
  },
  "0x0F006F": {
    "description": "Calling <0> interface, which belongs to the legacy version controller. The current version controller has been replaced by <1> interface. This interface is temporarily retained for compatibility considerations but may be removed in future versions.",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "SET_ADMITTANCE_FRAME": "setting up the admittance coordinate system",
        "SET_COMPLIANCE_ENABLE": "sensor initialization",
        "SET_ADMITTANCE_CONFIG": "setting the admittance parameters"
      },
      "1": {
        "SET_FORCE_SENSOR_ZERO": "sensor Zeroing",
        "SET_CSTF_DRAG_FRAME": "configuration of constant force compliance coordinate system and tool drag coordinate system",
        "SET_CSTF_DRAG_CONFIG": "configuration of constant force compliance parameters and tool drag parameters"
      }
    },
    "reason": "This warning may appear when using certain special versions or mismatched versions of APP/SDK. This warning does not affect normal usage and is for informational purposes only.",
    "action": "The current interface has been successfully called and relevant commands have been executed. This warning is informational and does not affect normal usage. To disable this warning, please refer to version release notes to select appropriate version numbers and update your APP/SDK version.",
    "tittle": "Calling Compatibility Interface",
    "isShowConfirm": "1"
  },
  "0x0F0070": {
    "description": "Error occurs in the validation of reading the robot's DH parameters.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "An error occurs when reading the CRC of the servo end DH parameters during powering on.",
    "action": "Please power on the robot again. If this error still occurs, please upgrade the servo.",
    "tittle": "Error occurs in the validation of reading the robot's DH parameters",
    "isShowConfirm": "1"
  },
  "0x0F0071": {
    "description": "An error occurs in the validation of reading the dynamics parameters",
    "type": "2",
    "isShowOTA": "1",
    "reason": "An error occurs when reading the CRC of servo dynamics parameters.",
    "action": "Please power on the robot again. If this error still occurs, please upgrade the servo.",
    "tittle": "Error occurs in the validation of reading the robot's dynamics parameters",
    "isShowConfirm": "1"
  },
  "0x0F0072": {
    "description": "Failed to enable the robot, for it is reading the DH or dynamics parameters from the servo.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Failed to enable the robot, for it is reading the DH or dynamics parameters from the servo. This error occurs when the robot is enabled instantly after it is powered on, which gave no time to read the DH parameters.",
    "action": "When the robot is powered on, the controller would read DH parameters from the servo, during which the robot cannot be enabled. If this error still occurs after waiting for a while, please check the communication link between the controller and the robot. If it still occurs, please contact the technical service team.",
    "tittle": "An error occurs when reading the servo parameters. Failed to enable the robot.",
    "isShowConfirm": "1"
  },
  "0x0F0073": {
    "description": "The robot has reached its momentum limit.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot has reached its momentum limit. The momentum limit can be set in Safety Settings. Warning occurs when this limit is reached.",
    "action": "This error is a warning that doesn't need to deal with. When the absolute value of the robot's momentum exceeds the user-set threshold, the robot will automatically decelerate by rate.",
    "tittle": "The robot has reached its momentum limit",
    "isShowConfirm": "1"
  },
  "0x0F0074": {
    "description": "The robot has reached its TCP speed limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot has reached its TCP speed limit. The TCP speed limit can be set in Safety Settings. Warning occurs when this limit is reached.",
    "action": "This is a warning that doesn't need to deal with. It's OK to check if the TCP Speed Limit is set in Safety Settings.",
    "tittle": "The robot has reached its TCP speed limit  ",
    "isShowConfirm": "1"
  },
  "0x0F0075": {
    "description": "About to exceed the Safety Zone.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "About to exceed the Safety Zone. The robot can only work within the safety zone that has already been set.",
    "action": "Please confirm if the safety zone is set practically. When troubleshooting, you can disable the safety zone function or direct the robot to move within the safety zone.",
    "tittle": "About to exceed the Safety Zone",
    "isShowConfirm": "1"
  },
  "0x0F0076": {
    "description": "The version number of DH parameters in servo is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's kinematic parameter version is not compatible with the controller.",
    "action": "Please upgrade the servo or downgrade the controller",
    "tittle": "The version number of DH parameters in servo is invalid",
    "isShowConfirm": "1"
  },
  "0x0F0077": {
    "description": "The version number of dynamics parameters in servo is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's dynamic parameter version is not compatible with the controller.",
    "action": "Please upgrade the servo or downgrade the controller.",
    "tittle": "The version number of dynamics parameters in servo is invalid",
    "isShowConfirm": "1"
  },
  "0x0F0078": {
    "description": "You enable the servo too frequently.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Enable button on the App was clicked too frequently.",
    "action": "After pressing the Enable button on the App, wait for 1 second to see if the annular light was turning from blue to green. In normal conditions, it would change from blue to green, accompanied by a \"click\" sound as the joints release the brakes.",
    "tittle": "You enable the servo too frequently",
    "isShowConfirm": "1"
  },
  "0x0F0079": {
    "description": "Unable to switch between the simulation mode and the real robot, please turn off the power.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "This error occurs when the user try to switch the robot between its current status and its simulation mode while the robot is powered on and enabled.",
    "action": "Please disable and power off the robot first, then switch the mode.",
    "tittle": "Unable to switch between the simulation mode and the real robot, please turn off the power.",
    "isShowConfirm": "1"
  },
  "0x0F007A": {
    "description": "It does not support setting the IP addresses of two network ports in the same network segment.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The IP address set in the Network Settings is in the 10.5.5.X network segment, conflicting with the controller's built-in network IP address segment.",
    "action": "The IP address in the Network Settings is not allowed to set in the 10.5.5.X network segment. Modify the IP addresses for the standard controller's bottom Ethernet port and MiniCab's LAN2 port to static IP addresses: Network configuration reference settings format: IP: 192.168.10.120 Subnet Mask: 255.255.255.0 Default Gateway: 192.168.10.1",
    "tittle": "It does not support setting the IP addresses of two network ports in the same network segment.",
    "isShowConfirm": "1"
  },
  "0x0F007B": {
    "description": "Be about to exceed tool's orientation constraints",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The tool orientation limits function is enabled, and the robot is about to go out of the tool's orientation constraints.",
    "action": "When controlling the robot movement, move within the tool orientation constraints or change the configuration of tool orientation limits function",
    "tittle": "Be about to exceed tool's orientation constraints",
    "isShowConfirm": "1"
  },
  "0x0F007C": {
    "description": "Unable to switch between the simulation mode and the real robot. ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The virtual machine doesn't have this function.",
    "action": "The virtual machine doesn't have this function.",
    "tittle": "Unable to switch between the simulation mode and the real robot ",
    "isShowConfirm": "1"
  },
  "0x0F007D": {
    "description": "Sensor zeroing is currently not possible.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "A sensor zeroing operation cannot be performed, possibly because the sensor has been turned off, the sensor is in the process of being zeroed, or the robot is in tool drag Mode or Constant Force Compliance Mode.",
    "action": "Make sure that the force sensor is functioning properly and that the robot is not in tool drag Mode or Constant Force Compliance Mode before performing a zero calibration.",
    "tittle": "Sensor zeroing is currently not possible",
    "isShowConfirm": "1"
  },
  "0x0F007E": {
    "description": "Unable to set the decelerated percentage in reduce mode",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Unable to set the decelerated percentage in reduce mode.",
    "action": "Exit reduce mode first, then set the robot's decelerated percentage.",
    "tittle": "Unable to set the decelerated percentage in reduce mode",
    "isShowConfirm": "1"
  },
  "0x0F007F": {
    "description": "The robot is in drag mode and is not allowed to switch off the enable.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is in drag mode and is not allowed to switch off the enable.",
    "action": "Please take the robot out of drag mode, and then switch off the enable.",
    "tittle": "The robot is in drag mode and is not allowed to switch off the enable",
    "isShowConfirm": "1"
  },
  "0x0F0080": {
    "description": "Unable to switch the robot model when it's powered on",
    "type": "2",
    "isShowOTA": "1",
    "reason": "This error occurs when one tries to switch the robot between the simulation mode and real robot while the robot is powered on.",
    "action": "Please disable and power off the robot first, then switch the mode.",
    "tittle": "Unable to switch the robot model when it's powered on",
    "isShowConfirm": "1"
  },
  "0x0F0081": {
    "description": "Unable to reset the password during the robot's movement",
    "type": "2",
    "isShowOTA": "1",
    "reason": "This error occurs when the user tries to change the password while the robot is in a movement.",
    "action": "Please stop the movement, then reset the password.",
    "tittle": "Unable to reset the password during the robot's movement",
    "isShowConfirm": "1"
  },
  "0x0F0082": {
    "description": "Please check if the password reset button is normal for use.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "The password reset button is not normal.",
    "action": "Please check if the password reset button is normal, or contact the technical service team.",
    "tittle": "Please check if the password reset button is normal for use",
    "isShowConfirm": "1"
  },
  "0x0F0083": {
    "description": "Joints failed to decelerate.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unable to lower the joint speed in the current movement to the speed limit.",
    "action": "Please increase the speed limit or lower the speed in the command.",
    "tittle": "Joints failed to decelerate",
    "isShowConfirm": "1"
  },
  "0x0F0084": {
    "description": "The P1, P2 and P3 in the circular conveyor are collinear.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the three points coincide or are collinear, the center coordinate system of the conveyor belt cannot be determined",
    "action": "Please re-teach the three points to avoid overlapping or collinear",
    "tittle": "The P1, P2 and P3 in the circular conveyor are collinear",
    "isShowConfirm": "1"
  },
  "0x0F0085": {
    "description": "The tracking direction of the linear conveyor belt is zero.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Tracking direction cannot be determined when conveyor direction is zero",
    "action": "Please check the conveyor direction of the linear belt tracking instruction block to avoid the start and end of the instruction overlap or the input XYZ value is all zeros",
    "tittle": "The tracking direction of the linear conveyor belt is zero.",
    "isShowConfirm": "1"
  },
  "0x0F0086": {
    "description": "Failed to get payload identification results.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1. Identification data files be missing during the identification process; \n2. Trajectories with and without load are inconsistent; \n3. The identification trajectory is too short.",
    "action": "",
    "tittle": "Failed to get payload identification results",
    "isShowConfirm": "1"
  },
  "0x0F0087": {
    "description": "Failed to find the optimal time panning.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unable to fine the optimal solution when using the time planning.",
    "action": "Please try again after reducing the command speed or use a different motion planner for trajectory planning.",
    "tittle": "Failed to find the optimal time planning",
    "isShowConfirm": "1"
  },
  "0x0F0088": {
    "description": "Payload identification is only supported in floor-mounting",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Payload identification is only supported in floor-mounting",
    "isShowConfirm": "1"
  },
  "0x0F0089": {
    "description": "Trajectory recurrence does not support resuming program operation after emergency stop, and the program will be stopped after emergency stop.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Trajectory not support recovery program after emergency stop",
    "action": "Trajectory not support recovery program after emergency stop",
    "tittle": "Unable to resume program after emergency stop",
    "isShowConfirm": "1"
  },
  "0x0F008A": {
    "description": "Conflicting input/output type of the IO pin set for digital output.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Digital output cannot be set when the IO pin is of input type.",
    "action": "Please confirm that the operated IO pin is of output type before setting the digital output again.",
    "tittle": "Failed to set digital output",
    "isShowConfirm": "1"
  },
  "0x0F008B": {
    "description": "Abnormal digital input signal received, unable to skip motion commands based on the signal status of this IO pin.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Digital input cannot be obtained when the IO pin is of output type.",
    "action": "Please confirm that the operated IO pin is of input type before executing the operation to skip motion commands based on the input signal.",
    "tittle": "Failed to execute: skip motion command by obtaining digital input signal",
    "isShowConfirm": "1"
  },
  "0x0F008C": {
    "description": "IO index out of range, related IO operation is invalid.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "IO index out of range",
    "isShowConfirm": "1"
  },
  "0x0F008E": {
    "description": "Operation to set safety parameters is denied.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Setting safety IO related functions is prohibited when the robot is powered on.",
    "action": "Please power off the robot before setting safety IO functions.",
    "tittle": "Operation to set safety parameters is denied",
    "isShowConfirm": "1"
  },
  "0x0F008F": {
    "description": "Robotic arm enable and disable operations are too frequent",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The servo enable and disable operations of the arm are too frequent and can easily damage the joints of the arm.",
    "action": "Please adjust the time interval of the robot arm enable operation, the recommended enable operation interval is more than 4 seconds.",
    "tittle": "Robotic arm enable and disable operations are too frequent",
    "isShowConfirm": "1"
  },
  "0x0F0090": {
    "description": "Unable to switch between manual/automatic mode while the program is running.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to switch between manual/automatic mode while the program is running.",
    "action": "Please stop the program before switching operation mode.",
    "tittle": "Unable to switch between manual/automatic mode while the program is running",
    "isShowConfirm": "1"
  },
  "0x0F0091": {
    "description": "Unable to switch between manual/automatic mode during robot movement.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to switch between manual/automatic mode during robot movement.",
    "action": "Please stop the movement before switching operation mode.",
    "tittle": "Unable to switch between manual/automatic mode during robot movement",
    "isShowConfirm": "1"
  },
  "0x0F0092": {
    "description": "Cannot trigger this DI function in manual mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Cannot trigger this DI function in manual mode.",
    "action": "Manual mode does not support this function. Please switch mode and try again.",
    "tittle": "Cannot trigger this DI function in manual mode",
    "isShowConfirm": "1"
  },
  "0x0F0093": {
    "description": "Cannot trigger this DI function in auto mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Cannot trigger this DI function in auto mode.",
    "action": "Auto mode does not support this feature. Please switch modes and try again.",
    "tittle": "Cannot trigger this DI function in auto mode",
    "isShowConfirm": "1"
  },
  "0x0F0094": {
    "description": "Unable to switch between manual/automatic mode when robot is in drag mode.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to switch between manual/automatic mode when robot is in drag mode.",
    "action": "Please exit drag mode before switching operation mode.",
    "tittle": "Unable to switch between manual/automatic mode when robot is in drag mode.",
    "isShowConfirm": "1"
  },
  "0x0F0095": {
    "description": "Failed to start the program.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The signal to start the program cannot be automatically triggered in manual mode.",
    "action": "",
    "tittle": "Failed to start the program",
    "isShowConfirm": "1"
  },
  "0x0F0096": {
    "description": "Incorrect function setting",
    "type": "2",
    "isShowOTA": "0",
    "reason": "To automatically load and run the configured default program after triggering the automatic run program signal in auto mode, it is necessary to correctly configure the 'Default Program' and enable 'Default Program Auto-Load'.",
    "action": "1.On the 'Settings'->'Program Settings' page, set the correct 'Default Program' and enable 'Default Program Auto-Load'\n2.'Default program' cannot be 'none'.",
    "tittle": "Auto Start Program function set incorrectly.",
    "isShowConfirm": "1"
  },
  "0x0F0097": {
    "description": "Incorrect function setting",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Both 'Default Program' and 'Default Program Auto-Load' need to be either set or not set together. When both are set, triggering the automatic run program signal will automatically load and run the configured 'Default Program'; when both are not set, triggering the automatic run program signal will run the currently opened program.",
    "action": "1.Correctly set 'Default Program' and 'Default Program Auto-Load' on the 'Settings'->'Program Settings' page.\n2.'Default program' cannot be 'none'.",
    "tittle": "Incorrect function setting",
    "isShowConfirm": "1"
  },
  "0x0F0098": {
    "description": "Failed to auto-enable",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The auto-enable signal cannot be automatically triggered in manual mode",
    "action": "",
    "tittle": "Failed to auto-enable",
    "isShowConfirm": "1"
  },
  "0x0F0099": {
    "description": "The command cannot be executed while the robot is powered on. Target command: {0}",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The command cannot be executed while the robot is powered on.",
    "action": "Please power off the robot and then re-execute the command '{1}'.",
    "tittle": "Command Execution Failed",
    "isShowConfirm": "1"
  },
  "0x0F00A0": {
    "description": "Unable to set program state after PROFINET disconnection during program runtime.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to set program state after PROFINET disconnection during program runtime.",
    "action": "Please stop the program before setting the parameters.",
    "tittle": "Unable to set program state after PROFINET disconnection during program runtime.",
    "isShowConfirm": "1"
  },
  "0x0F00A1": {
    "description": "Unable to set program state after EtherNet/IP disconnection during program runtime.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to set program state after EtherNet/IP disconnection during program runtime.",
    "action": "Please stop the program before setting the parameters.",
    "tittle": "Unable to set program state after EtherNet/IP disconnection during program runtime.",
    "isShowConfirm": "1"
  },
  "0x0F00A2": {
    "description": "Detected PROFINET disconnection, program paused.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Detected PROFINET disconnection, program paused.",
    "action": "Please check the PROFINET connection status.",
    "tittle": "Detected PROFINET disconnection, program paused.",
    "isShowConfirm": "1"
  },
  "0x0F00A3": {
    "description": "Detected PROFINET disconnection, program stopped.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Detected PROFINET disconnection, program stopped.",
    "action": "Please check the PROFINET connection status.",
    "tittle": "Detected PROFINET disconnection, program stopped.",
    "isShowConfirm": "1"
  },
  "0x0F00A4": {
    "description": "Detected EtherNet/IP disconnection, program paused.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Detected EtherNet/IP disconnection, program paused.",
    "action": "Please check the EtherNet/IP connection status.",
    "tittle": "Detected EtherNet/IP disconnection, program paused.",
    "isShowConfirm": "1"
  },
  "0x0F00A5": {
    "description": "Detected EtherNet/IP disconnection, program stopped.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Detected EtherNet/IP disconnection, program stopped.",
    "action": "Please check the EtherNet/IP connection status.",
    "tittle": "Detected EtherNet/IP disconnection, program stopped.",
    "isShowConfirm": "1"
  },
  "0x0F0100": {
    "description": "Exceeded power limit of the robot.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The Power Limit in Collision Processing Settings is lower than the needed power limit of the robot.",
    "action": "Increase the value of Power Limit according to this standard: for JAKA robot with 3kg payload, the power limit should be 1000; 5kg/7kg, 1500; 12kg, 2000; 18kg, 2000.",
    "tittle": "Exceeded power limit of the robot",
    "isShowConfirm": "1"
  },
  "0x0F0101": {
    "description": "Exceeded momentum limit of the robot.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The Momentum Limit in Collision Processing Settings is lower than the needed momentum of the robot.",
    "action": "Increase the value of Momentum Limit according to this standard: for JAKA robot with 3kg payload, the momentum limit should be 5; 5kg/7kg, 10; 12kg, 30; 18kg, 50.",
    "tittle": "Exceeded momentum limit of the robot",
    "isShowConfirm": "1"
  },
  "0x0F0102": {
    "description": "Collision detected by the base sensor.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "For the SP robot, this error occurs when the signal of its base sensor suddenly increased to a level that exceeds its threshold while it is powered on.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Collision detected by the base sensor",
    "isShowConfirm": "1"
  },
  "0x0F0103": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 1.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 1",
    "isShowConfirm": "1"
  },
  "0x0F0104": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 2.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 2",
    "isShowConfirm": "1"
  },
  "0x0F0105": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 3.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 3",
    "isShowConfirm": "1"
  },
  "0x0F0106": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 4.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 4",
    "isShowConfirm": "1"
  },
  "0x0F0107": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 5.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 5",
    "isShowConfirm": "1"
  },
  "0x0F0108": {
    "description": "Force on the robot end exceeded limits. Collision detected on Joint 6.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is running a command, if its joint current suddenly increases beyond the set threshold, it triggers a warning.",
    "action": "1. Check if the robot has collided with any surrounding equipments. \n2. Check if the robot was restricted by any wires during its movement. \n3. Try to lower the robot's acceleration.\n4. Check if the payload on the robot end is correct.\n5. Try to decrease the restriction level of collision in Collision Settings.",
    "tittle": "Force on the robot end exceeded limits. Collision detected on Joint 6",
    "isShowConfirm": "1"
  },
  "0x0F0109": {
    "description": "The points chosen for setting safety zone cannot be collinear or repetitive",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The setting of safety zone requires three points to locate its range, and one safety point to decide the working space of the robot. The three range-locating points are within the Cartesian coordinate system, while the safety point has to be outside the safety zone. This error occurs when the range-locating points are repetitive or collinear, or when the safety point is one the safety zone.",
    "action": "Please check if these three chosen points are repetitive or collinear, and if the safety point is on the safety zone.",
    "tittle": "Inappropriate choice of points to set safety zone",
    "isShowConfirm": "1"
  },
  "0x0F0110": {
    "description": "The dynamics parameters can only be set when the robot is powered",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot is not powered on yet.",
    "action": "Please check the robot, try to power on",
    "tittle": "Unable to set the dynamics parameters",
    "isShowConfirm": "1"
  },
  "0x0F0111": {
    "description": "The setting of dynamics parameters was interrupted",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When setting the dynamics, error of the CAN communication between the robot and control cabinet occurs.",
    "action": "1. Please try to disable and power off the robot, and power on it again. \n2. Please check the connection cable between the robot and the controller to see if everything is OK.",
    "tittle": "The setting of dynamics parameters was interrupted",
    "isShowConfirm": "1"
  },
  "0x0F0112": {
    "description": "The dynamics parameters setting timeout",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When setting the dynamics, error of the CAN communication between the robot and control cabinet occurs.",
    "action": "1. Please try to disable and power off the robot, and power on it again. \n2. Please check the connection cable between the robot and the control cabinet to see if everything is OK.",
    "tittle": "The dynamics parameters setting timeout",
    "isShowConfirm": "1"
  },
  "0x0F0113": {
    "description": "The control cabinet is incompatible.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Controller whose version is newer than 1.7.1 will no longer support {0}.",
    "action": "Please downgrade the controller to the matched version, such as v1.5.",
    "tittle": "The control cabinet is incompatible",
    "isShowConfirm": "1"
  },
  "0x0F0114": {
    "description": "Unable to identify when the robot is disabled.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Unable to identify when the robot is disabled.",
    "action": "Please enable the robot first, then identify.",
    "tittle": "Unable to identify when the robot is disabled",
    "isShowConfirm": "1"
  },
  "0x0F0115": {
    "description": "Failed to get the IP address from the bottom or LAN2 port.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to get the IP address from the bottom or LAN2 port.",
    "action": "Please check the connection status of the bottom or LAN2 port. The virtual machine is failing to acquire an IP, temporarily unable to obtain/set an IP from the virtual machine.",
    "tittle": "Failed to get the IP address from the bottom or LAN2 port",
    "isShowConfirm": "1"
  },
  "0x0F0116": {
    "description": "You can only have no more than 10 AddOn packages",
    "type": "1",
    "isShowOTA": "0",
    "reason": "You can only have no more than 10 AddOn packages",
    "action": "Please delete some AddOn packages to install new ones.",
    "tittle": "The amount of AddOn packages have exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x0F0117": {
    "description": "The service files in AddOn configuration does not exist.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The service files in AddOn configuration does not exist.",
    "action": "Please check if the service files in AddOn packages exist.",
    "tittle": "The AddOn service does not exist",
    "isShowConfirm": "1"
  },
  "0x0F0118": {
    "description": "Failed to check the available port numbers for the AddOn.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to check the available port numbers for the AddOn.",
    "action": "Please save the diagnostic log, and contact the technical service team.",
    "tittle": "Failed to check the available port numbers for the AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0119": {
    "description": "Failed to distribute AddOn port numbers.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to distribute AddOn port numbers.",
    "action": "1. Please restart the control cabinet and try again.",
    "tittle": "Failed to distribute AddOn port numbers",
    "isShowConfirm": "1"
  },
  "0x0F011A": {
    "description": "Failed to operate the AddOn package while it is running.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to operate the AddOn package while it is running.",
    "action": "Failed to operate the AddOn package while it is running.",
    "tittle": "Failed to operate the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F011B": {
    "description": "Unable to stop the AddOn since it's already stopped.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to stop the AddOn since it's already stopped.",
    "action": "Unable to stop the AddOn since it's already stopped.",
    "tittle": "Unable to stop the AddOn",
    "isShowConfirm": "1"
  },
  "0x0F011C": {
    "description": "This operation is not supported",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This operation is not supported",
    "action": "Please upgrade the AddOn kit to the matched version of the controller.",
    "tittle": "Unknown AddOn operation",
    "isShowConfirm": "1"
  },
  "0x0F011D": {
    "description": "The AddOn port is occupied.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The AddOn port is occupied.",
    "action": "1. Please try to restart the controller to see if this could be solved.\n2. Please save the diagnostic log, and contact the technical service team.",
    "tittle": "The AddOn port is occupied",
    "isShowConfirm": "1"
  },
  "0x0F011E": {
    "description": "Unknown AddOn error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unknown AddOn error.",
    "action": "Please save the diagnostic log, and contact the techinical service team.",
    "tittle": "Unknown AddOn error",
    "isShowConfirm": "1"
  },
  "0x0F011F": {
    "description": "Unable to operate the SystemAddOn.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to operate the SystemAddOn.",
    "action": "Unable to operate the SystemAddOn.",
    "tittle": "Unauthorized operation on the SystemAddOn",
    "isShowConfirm": "1"
  },
  "0x0F0120": {
    "description": "This AddOn is ineffective, therefore cannot be operated.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. The AddOn version is outdated.\n2. The AddOn format is incorrect.",
    "action": "Please check if the AddOn package is valid, and re-install it.",
    "tittle": "Unable to operate the AddOn for it's ineffective",
    "isShowConfirm": "1"
  },
  "0x0F0121": {
    "description": "The config.ini files of the AddOn are invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The config.ini files of the AddOn are invalid.",
    "action": "Please contact the AddOn developer for the valid AddOn package, and re-install.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0122": {
    "description": "The necessary configurations of the AddOn are missed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. The necessary configuration for the AddOn convention 2.0/3.0 is [convention,description,version,type,languagetype,service,serviceenabled]\n2. The necessary configuration for the AddOn convention 1.0 is [binname,description,version,enabled,type]",
    "action": "Please contact the AddOn developer to check if any necessary configuration is missed.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0123": {
    "description": "Wrong AddOn port",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unused error",
    "action": "Unused error",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0124": {
    "description": "The Language of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. AddOn convention 3.0 supports language[javascript,python2,python,node-red].\n2. AddOn convention 2.0 supports language[javascript,python2,python].\n3. AddOn convention 1.0 supports language[python].",
    "action": "Please check if the convention in the AddOn package supports corresponding language type.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0125": {
    "description": "The Type of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn convention 2.0/3.0 supports Type [1. Customer command; 2. Customer service; 3. Customer UI]",
    "action": "Please contact the AddOn developer to check if the AddOn package supports corresponding Type.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0126": {
    "description": "The serviceenabled of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The serviceenabled should be 0 or 1.",
    "action": "Please contact the AddOn developer to check if the serviceenabled in the AddOn package configuration meets the standard.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0127": {
    "description": "The Service of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. The Service in configuration is missing.\n2. The Service in configuration cannot be empty and its number of bytes cannot exceed 50.",
    "action": "1. Please check if the Service in configuration exist.\n2. Please check if the number of bytes of the Service in configuration.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F0128": {
    "description": "The configuration file in AddOn is invalid or the AddOn directory name is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. The Name in the AddOn configuration file cannot be empty or longer than 40 bytes.\n2. The name of the AddOn directory cannot be longer than 40 bytes.",
    "action": "Please contact the AddOn developer to modify the name in AddOn configuration or the AddOn directory name.",
    "tittle": "The configuration file in AddOn is invalid or the AddOn directory name is invalid",
    "isShowConfirm": "1"
  },
  "0x0F0129": {
    "description": "The Description of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Description in configuration cannot be longer than 40 bytes.",
    "action": "Please contact the AddOn developer to modify the Description in AddOn configuration.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F012A": {
    "description": "The URL format in the AddOn configuration file is invalid. ",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The URL format in the AddOn configuration file is invalid.",
    "action": "Please contact the AddOn developer to modify the URL format in AddOn configuration.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F012B": {
    "description": "The Convention of the AddOn configuration file is invalid.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The current version of AddOn convention is not matched with the controller.",
    "action": "1. Please contact the AddOn developer to see if the Convention of configuration is correct.\n2. Please change to another version of controller that supports this AddOn.",
    "tittle": "Invalid configuration files in AddOn",
    "isShowConfirm": "1"
  },
  "0x0F012C": {
    "description": "The AddOn package is damaged or cannot be recognized.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The AddOn package is damaged or cannot be recognized.",
    "action": "Please check to see if the AddOn package is still valid, then install again.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F012D": {
    "description": "Failed to install the AddOn package.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The configuration of the system or the code is incorrect.",
    "action": "1. Please contact the technical service team to change the version of controller.\n2. Please contact the technical service team to change the system mirror.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F012E": {
    "description": "Failed to unzip the AddOn package",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Currently it only supports the AddOn package in the format of AddOn.tar.gz",
    "action": "1. Please check if the format is correct.\n2. Please check if the package is damaged.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F012F": {
    "description": "Another AddOn package is installing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Another AddOn package is installing.",
    "action": "1. Please wait for the installation to complete.\n2. Please restart the controller then try again.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F0130": {
    "description": "No AddOn is installing now.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "No AddOn is installing now.",
    "action": "The installation process cannot be checked since no AddOn is being installed now.",
    "tittle": "No AddOn is installing now",
    "isShowConfirm": "1"
  },
  "0x0F0131": {
    "description": "The AddOn package is zipped wrongly.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The system is busy, unable to read the corresponding files.",
    "action": "1. Please wait for a while.\n2. Please contact the technical service team.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F0132": {
    "description": "Timeout occurs when zipping or unzipping the AddOn package.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Too many files in the AddOn package or the AddOn file is too large.",
    "action": "1. Please wait for a while and try again.\n2. Use other version of controller to export.",
    "tittle": "Timeout occurs when zipping or unzipping the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F0133": {
    "description": "Some files are missing in the AddOn package.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. Please confirm if the config.ini file is missing.\n2. Please confirm if any other necessary file is missing.\n3. Please confirm if the file directory is recognizable.",
    "action": "Please contact the AddOn developer to get a correct AddOn package, then try again.",
    "tittle": "Error occurs in the AddOn package",
    "isShowConfirm": "1"
  },
  "0x0F0134": {
    "description": "Program sharing successful.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo : {1}",
    "tittle": "Program sharing successful",
    "isShowConfirm": "0"
  },
  "0x0F0135": {
    "description": "Program sharing failed.\nFrom: {0}\nTo : {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The reason might be: \n1. The shared program file path is incorrect, or the program file is incomplete. \n2. The shared program file already exists in the target controller. \n3. The controller cannot access the IP address of the target controller.",
    "action": "1. Confirm that there is no program file of the same name on the target controller.\n2. Confirm that the current controller (not the host computer that installed the App) can successfully access the target controller.\n3. Confirm if the shared program file is complete (none of the files and subdirectories are missing).",
    "tittle": "Program sharing failed",
    "isShowConfirm": "1"
  },
  "0x0F0136": {
    "description": "The robot exceeds the maximum tracking distance of the conveyor belt.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "As the maximum tracking distance set by the conveyor tracking belt is exceeded,the robot slows down and stops.",
    "action": "1. Please increase the maximum tracking distance parameter or readjust the tracking position.",
    "tittle": "The robot exceeds the maximum tracking distance of the conveyor belt",
    "isShowConfirm": "1"
  },
  "0x0F0137": {
    "description": "Insufficient Disk Space.\nDisk Partition Name:{0}\nDisk space usage: {1}% \nDisk total space: {2} MB \nDisk remaining space: {3} MB",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Disk space usage exceeds 80%, with insufficient remaining space, posing a risk of data loss during subsequent disk writes.",
    "action": "1. Clean up expired diagnostic files.\n2. Clean up redundant job program files and program backup files.\n3. Clean up redundant trace files.\nIf disk space is still not effectively released after performing the above operations, please contact technical support to inspect the disk.",
    "tittle": "Disk Space Insufficient Warning",
    "isShowConfirm": "1"
  },
  "0x0F0138": {
    "description": "When using the belt start tracking distance and distance compensation functions, the first motion cannot be an arc motion.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the first motion is an arc motion,the original arc trajectory will be affected when it comes to the calculation of conveyor belt distance compensation.",
    "action": "1. Please change the first motion of the belt to a linear motion.",
    "tittle": "When using the belt start tracking distance and distance compensation functions, the first motion cannot be an arc motion",
    "isShowConfirm": "1"
  },
  "0x0F0140": {
    "description": "Exceeded the soft limit of the set force.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Exceeded the soft limit of the set force.",
    "action": "Please confirm if the robot end has collided with other object.",
    "tittle": "Exceeded the soft limit of the set force",
    "isShowConfirm": "1"
  },
  "0x0F0141": {
    "description": "Exceeded the maximum range of the sensor.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Exceeded the maximum range of the sensor.",
    "action": "1. Please confirm if the robot end has collided with other object; the sensor might be severely damaged after violent collision, which can be irreversible.",
    "tittle": "Exceeded the maximum range of the sensor",
    "isShowConfirm": "1"
  },
  "0x0F0142": {
    "description": "Profinet communication in unenabled state",
    "type": "2",
    "isShowOTA": "0",
    "reason": "If Profinet communication is not enabled, the relevant IO cannot be operated.",
    "action": "Please enable Profinet communication first, and then operate the IO.",
    "tittle": "Profinet communication in unenabled state",
    "isShowConfirm": "1"
  },
  "0x0F0143": {
    "description": "EtherNet/IP communication in unenabled state",
    "type": "2",
    "isShowOTA": "0",
    "reason": "If EtherNet/IP communication is not enabled, the relevant IO cannot be operated.",
    "action": "Please enable EtherNet/IP communication first, and then operate the IO.",
    "tittle": "EtherNet/IP communication in unenabled state",
    "isShowConfirm": "1"
  },
  "0x0F0144": {
    "description": "The current sensor limit setting exceeds the default soft limit for this model.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The current sensor limit setting exceeds the default soft limit for this model.",
    "action": "The currently set force or torque exceeds the default soft limit for this model. Please check the limit values to ensure that they are within the allowable settings for the model.",
    "tittle": "Sensor limit setting exceeds the default soft limits",
    "isShowConfirm": "1"
  },
  "0x0F0150": {
    "description": "The control system failed to identify the hardware model of the safety control board during the startup phase.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Communication timeout, the CAN communication of the safety control board has timed out abnormally.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Query Safety Control Board Hardware Model",
    "isShowConfirm": "1"
  },
  "0x0F0151": {
    "description": "Failed to set the safety function DI configuration of the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety controller.",
    "action": "1. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n2. Please check the CAN communication of the safety controller.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Safety Control Board Safety Function DI Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0152": {
    "description": "Failed to set the safety function DO configuration of the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety controller.",
    "action": "1. Please check if the upgraded firmware version of the safety control board matches the specified version.\n2. Please check the CAN communication of the safety controller.\n3. If problems persist after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Safety Control Board Safety Function DO Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0153": {
    "description": "Failed to set the power limit configuration on the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety control board firmware.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Power Limit Configuration on Safety Control Board",
    "isShowConfirm": "1"
  },
  "0x0F0154": {
    "description": "Failed to synchronize the tool coordinate system with the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Communication timeout, the CAN communication of the safety control board has abnormally timed out.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Synchronize Tool Coordinate System with Safety Control Board",
    "isShowConfirm": "1"
  },
  "0x0F0155": {
    "description": "Failed to set the CAB ID for the control cabinet serial number",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety controller.",
    "action": "1. Please check the CAN communication of the safety controller.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Control Cabinet Serial Number",
    "isShowConfirm": "1"
  },
  "0x0F0156": {
    "description": "Failed to set the output voltage configuration for the control cabinet",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety controller.",
    "action": "1. Please check the CAN communication of the safety controller.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Control Cabinet Output Voltage Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0157": {
    "description": "Failed to set the shutdown time configuration for the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Safety Control Board Shutdown Time Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0158": {
    "description": "Failed to set the stop distance configuration for the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Safety Control Board Stop Distance Configuration",
    "isShowConfirm": "1"
  },
  "0x0F0159": {
    "description": "Failed to set the end drag speed limit configuration for the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Safety Control Board End Drag Speed Limit Configuration",
    "isShowConfirm": "1"
  },
  "0x0F015A": {
    "description": "Failed to set the production serial number for the control cabinet serial number",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration.\n2. There is an abnormality in the CAN communication of the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board.\n2. Please check if the upgraded firmware version of the safety control board is the specified matching version.\n3. If there are still issues after checking, please contact technical service personnel for consultation.",
    "tittle": "Failure to Set Control Cabinet Serial Number",
    "isShowConfirm": "1"
  },
  "0x0F015B": {
    "description": "Failure to set the production date for the control cabinet serial number",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current firmware version of the safety control board does not support this feature configuration. \n2. There is an abnormality in the CAN communication of the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board. \n2. Please verify that the upgraded firmware version of the safety control board is the specified compatible version. \n3. If the problem persists after checking, please contact technical service personnel for consultation.",
    "tittle": "Failure to Set Control Cabinet Serial Number",
    "isShowConfirm": "1"
  },
  "0x0F015C": {
    "description": "Failed to Set Control Cabinet IO Input/Output Type",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. The current version of the safety control board does not support this function configuration. \n2. There is a CAN communication anomaly with the safety control board.",
    "action": "1. Please check the CAN communication of the safety control board. \n2. Please verify if the upgraded version of the safety control board matches the specified version. \n3. If the issue persists after the above checks, please contact technical service personnel for consultation.",
    "tittle": "Failed to Set Control Cabinet IO Input/Output Type",
    "isShowConfirm": "1"
  },
  "0x0F0160": {
    "description": "Failed to send the controller version number to the safety control board",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Did not receive feedback after sending the version number to the safety control board, the CAN communication of the safety control board timed out abnormally.",
    "action": "1. Please check if the firmware version of the safety control board is the specified matching version.\n2. If confirmed to be the specified version, please check the CAN communication lines of the safety control board.\n3. If there is still a problem after checking, please contact technical service personnel for consultation.",
    "tittle": "Failed to Send Controller Version Number to Safety Control Board",
    "isShowConfirm": "1"
  },
  "0x0F0161": {
    "description": "The firmware version of the safety control board is too low, preventing full support of all safety features.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The firmware version of the safety control board is too low, and not all safety features will be supported.",
    "action": "Using an incompatible firmware version of the safety control board may lead to unknown safety risks. Please upgrade the firmware of the safety control board to ensure the correct version match with the controller.",
    "tittle": "Safety Control Board Firmware Version Too Low",
    "isShowConfirm": "1"
  },
  "0x0F0162": {
    "description": "The SERVO version is too low, not all safety features can be supported",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The SERVO version compatible with the safety features is incorrect; some safety features cannot be supported.",
    "action": "Using the incorrect SERVO version may lead to safety risks. Please upgrade the SERVO firmware to ensure the controller is correctly matched with the SERVO version.",
    "tittle": "Incorrect SERVO version",
    "isShowConfirm": "1"
  },
  "0x0F0163": {
    "description": "PROFINET and ETHERNET/IP functions are disabled.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The current robot model does not support PROFINET and ETHERNET/IP functions.",
    "action": "To use PROFINET and ETHERNET/IP functions, please restart the control cabinet and connect to another robot model.",
    "tittle": "PROFINET and ETHERNET/IP Functions Disabled",
    "isShowConfirm": "1"
  },
  "0x0F0170": {
    "description": "<0> conflicts with <1>",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "CurrentTcpVelLimit": "Current TCP Speed Limitation of the Robot",
        "SettingStoppingDistance": "Set Stopping Distance Limitation of the Robot",
        "CurrentStoppingTime": "Current Stopping Time Limit of the Robot",
        "CurrentStoppingDistance": "Current Stopping Distance Limit of the Robot",
        "CurrentPowerLimit": "Current Power Limitation of the Robot",
        "CurrentMomentumLimit": "Current Momentum Limitation of the Robot",
        "SettingMomentumLimit": "Set Momentum Limitation of the Robot",
        "SettingStoppingTime": "Set Stopping Time Limitation of the Robot",
        "SettingPowerLimit": "Set Power Limitation of the Robot",
        "SettingTcpVelLimit": "Set TCP Speed Limitation of the Robot"
      },
      "1": {
        "SettingPoewrLimitReduce": "Set Power Limitation in Reduced Mode",
        "SettingStoppingDistReduce": "Set Stopping Distance Limitation in Reduced Mode",
        "SettingStoppingTimeReduce": "Set Stopping Time Limitation in Reduced Mode",
        "CurrentTcpVelReduce": "Current TCP Speed Limitation in Reduced Mode",
        "SettingMomentumLimitReduce": "Set Momentum Limitation in Reduced Mode",
        "CurrentPoewrLimitReduce": "Current Power Limitation in Reduced Mode",
        "CurrentStoppingTimeReduce": "Current Stopping Time Limitation in Reduced Mode",
        "SettingTcpVelReduce": "Set TCP Speed Limitation in Reduced Mode",
        "CurrentMomentumLimitReduce": "Current Momentum Limitation in Reduced Mode",
        "CurrentStoppingDistReduce": "Current Stopping Distance Limitation in Reduced Mode"
      },
      "2": {
        "<": "less than",
        ">": "greater than"
      },
      "3": {
        "<": "less than",
        ">": "greater than"
      }
    },
    "reason": "<0><2><1>\n",
    "action": "<0>：{0}\n<1>：{1}\nWhen setting safety parameters, please ensure that <0> <3> <1>.",
    "tittle": "Conflicting safety parameters",
    "isShowConfirm": "1"
  },
  "0x0F0171": {
    "description": "Payload configuration parameters are abnormal, the robot cannot be enabled.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Robot serial number: {0}\nMaximum payload parameter: {1}\nMinimum payload parameter: {2}\nCurrent payload parameter: {3}",
    "action": "Please set the payload parameters within the suitable range for this model and then enable the robot.",
    "tittle": "Payload configuration error. Cannot enable the robot.",
    "isShowConfirm": "1"
  },
  "0x0F0172": {
    "description": "The value of the payload configuration parameter exceeds the range of this model.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Robot serial number: {0}\nMaximum payload parameter: {1}\nMinimum payload parameter: {2}\nSet payload parameters: {3}",
    "action": "Please reset the payload parameters to fit within the range of this model.",
    "tittle": "Incorrect payload configuration parameter value",
    "isShowConfirm": "1"
  },
  "0x0F0173": {
    "description": "Robot cannot perform end button operation in unenabled state",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot cannot perform the following operations with the end buttons in the unenabled state:\n 1. programme pause or start\n 2. enter drag or tool drag mode",
    "action": "Please keep the robot in the enabled state to operate the end buttons.",
    "tittle": "Robot cannot perform end button operation in unenabled state",
    "isShowConfirm": "1"
  },
  "0x0F0174": {
    "description": "The conveyor-tracked queue is empty.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "When using the conveyor queue tracking feature, there are no eligible targets in the queue.",
    "action": "1.Adjust the location of the queue to ensure that the queue is not empty every time the value is taken. 2.Check whether the conditions for queuing are incorrect.",
    "tittle": "The conveyor-tracked queue is empty",
    "isShowConfirm": "0"
  },
  "0x0F0175": {
    "description": "Skip targets in the queue that exceed the maximum tracking distance.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "If the target in the queue exceeds the maximum tracking distance set by the conveyor belt, the target is removed to avoid an exception.",
    "action": "1. Adjust the conveyor belt feeding interval or increase the spillage measures.",
    "tittle": "Skip targets in the queue that exceed the maximum tracking distance",
    "isShowConfirm": "0"
  },
  "0x0F0176": {
    "description": "The conveyor-tracked queue is full.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "When using the conveyor queue tracking feature, the number of eligible targets in the queue exceeds the maximum.",
    "action": "1. Adjust the conveyor belt feeding interval.",
    "tittle": "The conveyor-tracked queue is full",
    "isShowConfirm": "0"
  },
  "0x0F0177": {
    "description": "Password verification failed too many times",
    "type": "1",
    "isShowOTA": "1",
    "reason": "5 consecutive password verification failures within {0} seconds",
    "action": "5 consecutive password verification failures within {1} seconds, please retry after {2} seconds",
    "tittle": "Password verification failed too many times",
    "isShowConfirm": "1"
  },
  "0x0F0180": {
    "description": "The diagonal points of the safety cube coincide",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety cube cannot be generated because the Cartesian coordinates of the diagonal points coincide.",
    "action": "Please check if the Cartesian coordinates of the diagonal points of the safety cube coincide.",
    "tittle": "Diagonal point parameters of the safety cube are incorrect",
    "isShowConfirm": "1"
  },
  "0x0F0181": {
    "description": "Parameter verification failed when loading the safety zone configuration file on startup.",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "global": "SafePlane global config",
        "cube": "SafeCube.Cube",
        "plane": "SafePlane.Plane"
      }
    },
    "reason": "Anomalous parameters in the safety zone configuration file <0>{0} have led to the failure of safety parameter verification.",
    "action": "The control system is activated with default parameters. To restore, please reconfigure the safety zone settings.",
    "tittle": "Exception in initializing and loading safety zone configuration",
    "isShowConfirm": "1"
  },
  "0x0F0190": {
    "description": "The trajectory offset queue is full",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The queue storage for the trajectory offset has reached its maximum value",
    "action": "Optimize the trajectory points or increase the number of trajectory offset queues",
    "tittle": "The trajectory offset queue is full",
    "isShowConfirm": "1"
  },
  "0x0F0191": {
    "description": "The trajectory offset line has no intersection point with the straight line, and the offset fails",
    "type": "1",
    "isShowOTA": "1",
    "reason": "After the datum trajectory is offset, the straight line is different from the straight line or parallel, and the intersection point cannot be solved",
    "action": "Adjust the datum point or modify the trajectory offset parameter",
    "tittle": "The trajectory offset line has no intersection point with the straight line, and the offset fails",
    "isShowConfirm": "1"
  },
  "0x0F0192": {
    "description": "The trajectory offset failed as there are no intersection points between the line and the arc",
    "type": "1",
    "isShowOTA": "1",
    "reason": "After the reference trajectory offset, there are no intersection points between the line and the arc",
    "action": "Please adjust the reference point position or modify the trajectory offset parameters",
    "tittle": "The trajectory offset failed as there are no intersection points between the line and the arc",
    "isShowConfirm": "1"
  },
  "0x0F0193": {
    "description": "Trajectory offset failed as there are no intersection points between the arcs",
    "type": "1",
    "isShowOTA": "1",
    "reason": "After the reference trajectory offset, there are no intersection points between the arcs",
    "action": "Please adjust the reference point position or modify the trajectory offset parameters",
    "tittle": "Trajectory offset failed as there are no intersection points between the arcs",
    "isShowConfirm": "1"
  },
  "0x0F0195": {
    "description": "The trajectory offset queue is empty",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The number of trajectory offset queue entries is 0",
    "action": "Please check if there is an error in the program code",
    "tittle": "The trajectory offset queue is empty",
    "isShowConfirm": "1"
  },
  "0x0F0196": {
    "description": "The Z-axis of the TCP is parallel to the trajectory direction during the trajectory offset, resulting in a failure",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The Z-axis of the TCP is parallel to the trajectory direction during the trajectory offset, resulting in a failure",
    "action": "Please adjust the reference point for the offset",
    "tittle": "The Z-axis of the TCP is parallel to the trajectory direction during the trajectory offset, resulting in a failure",
    "isShowConfirm": "1"
  },
  "0x0F1001": {
    "description": "Enable timeout, please power on again.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "When the robot is powering up, if the electromagnet failed to engage, this error will occur.",
    "action": "1. Please try to power off the robot first, then power on and enable it again. \n2. Please confirm if there is anything wrong with the electromagnet, or contact the technical service team.",
    "tittle": "Enable timeout, please power on again",
    "isShowConfirm": "1"
  },
  "0x0F1002": {
    "description": "Servo version number query timeout.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This error occurs when the CAN communication between the robot and control cabinet is not normal.",
    "action": "1. Please try to disable and power off the robot, then power on and enable it again. \n2. Please check the connection cable between the robot and control cabinet to see if everything is okay.",
    "tittle": "Servo version number query timeout",
    "isShowConfirm": "1"
  },
  "0x0F2000": {
    "description": "Syntax error in programming file.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Some parameters in the program are not normal or undefined, making the controller unable to process.",
    "action": "1. Please check the initial value of the variable used in the program. \n2. Please check the interaction data of the communication connection variable.",
    "tittle": "Syntax error in programming file",
    "isShowConfirm": "1"
  },
  "0x0F2001": {
    "description": "No programming files opened.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "No program is loading or running.",
    "action": "1. Set default program for startup.\n2. Open the corresponding program in the programming interface, then click Run.",
    "tittle": "No programming files opened",
    "isShowConfirm": "1"
  },
  "0x0F2002": {
    "description": "Failed to open the programming file.\nTarget file:{0}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Possible reasons: \n1. The default program for startup is missing. \n2. The saved program file is incomplete. \n3. The input program file path is incorrect.",
    "action": "1. Re-select the program to be loaded by default at startup in Settings. \n2. Re-save the program in Programming before reopening it. \n3. Check if the file paths in the program script instructions are correct.",
    "tittle": "Failed to open the programming file",
    "isShowConfirm": "1"
  },
  "0x0F2003": {
    "description": "Failed to close the programming file.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is a debugging version, or contact the technical service team for detailed information on this error code.",
    "tittle": "Failed to close the programming file",
    "isShowConfirm": "1"
  },
  "0x0F2004": {
    "description": "Program backup is successful.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo: {1}",
    "tittle": "Program backup is successful",
    "isShowConfirm": "0"
  },
  "0x0F2005": {
    "description": "Automatic program backup failed.\nFrom: {0}\nTo: {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Possible reasons:\n1. Permission denied, failed to write to file.\n2. Program file damaged.\n3. Insufficient disk space or disk read/write errors.",
    "action": "1. Manually back up the program on the App programming page.\n2. Check if there is any missing content in the program, and see if it can be saved normally after opening the program.\n3. Contact technical service team to check directory permissions and disk status.",
    "tittle": "Automatic program backup failed",
    "isShowConfirm": "1"
  },
  "0x0F2010": {
    "description": "Syntax error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unmatched keywords, like: if, end, break, continue. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Check the script files, especially manually written script subroutines, to see if are any unmatched keywords.",
    "tittle": "Syntax error",
    "isShowConfirm": "1"
  },
  "0x0F2011": {
    "description": "PyCall() failed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The called Python script has a syntax error.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the called Python script.",
    "tittle": "PyCall() failed",
    "isShowConfirm": "1"
  },
  "0x0F2012": {
    "description": "Parsing assertion failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motion parameters are inappropriate. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the motion parameters.",
    "tittle": "Parsing assertion failed",
    "isShowConfirm": "1"
  },
  "0x0F2013": {
    "description": "Parsing failed, the arc radius is zero.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The points chosen for the MoveC are inappropriate, so the robot failed to plan a trajectory. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the points in the MoveC trajectory are appropriate. If not, please reset the points.",
    "tittle": "Parsing failed, the arc radius is zero",
    "isShowConfirm": "1"
  },
  "0x0F2014": {
    "description": "Parsing failed, the syntax has errors.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There is a data format exception in the variable interaction command (assignment command). \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check for any data format exceptions within the variable interaction commands (assignment commands) in the program.",
    "tittle": "Parsing failed, the syntax has errors",
    "isShowConfirm": "1"
  },
  "0x0F2015": {
    "description": "The network connection has failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Failed to create SOCKET.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Check the script according to the error.",
    "tittle": "The network connection has failed",
    "isShowConfirm": "1"
  },
  "0x0F2016": {
    "description": "Failed to connect to the server.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The server has disconnected during Socket communication. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check if the server for the Socket communication is closed. \n2. Please attempt to establish network connection (ping) with the Socket communication server. \n3. Please check if there is anything wrong in the Ethernet connection between the electrical control cabinet and the Socket communication server. \n4. Please check if the firewall on the Socket communication server is disabled.",
    "tittle": "Failed to connect to the server",
    "isShowConfirm": "1"
  },
  "0x0F2017": {
    "description": "Communication failed, unable to connect to the server.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When executing the command to read visual parameters, the camera is not connected. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check if the server for the Socket communication is closed. \n2. Please attempt to establish network connection (ping) with the Socket communication server. \n3. Please check if there is anything wrong in the Ethernet connection between the electrical control cabinet and the Socket communication server. \n4. Please check if the firewall on the Socket communication server is disabled.",
    "tittle": "Communication failed, unable to connect to the server",
    "isShowConfirm": "1"
  },
  "0x0F2018": {
    "description": "TCP/IP failed to receive data.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller failed to receive data from the camera. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. The camera is disconnected;\n2. Please check if the connection cable between the controller and the camera is functioning normally.",
    "tittle": "TCP/IP failed to receive data",
    "isShowConfirm": "1"
  },
  "0x0F2019": {
    "description": "TCP/IP failed to send data.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller failed to send data to the camera. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check if the server for the Socket communication is closed. \n2. Please attempt to establish network connection (ping) with the Socket communication server. \n3. Please check if there is anything wrong in the Ethernet connection between the electrical control cabinet and the Socket communication server. \n4. Please check if the firewall on the Socket communication server is disabled.",
    "tittle": "TCP/IP failed to send data",
    "isShowConfirm": "1"
  },
  "0x0F201A": {
    "description": "Failed to load the 2D visual configuration.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is a debugging version, or contact the technical service team for detailed information on this error code.",
    "tittle": "Failed to load the 2D visual configuration",
    "isShowConfirm": "1"
  },
  "0x0F201B": {
    "description": "Internal error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Internal error in the script parser. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the following situations according to the error log information: \n1. The parameters in sscanf command are incorrect.\n2. The read-only variables were wrote.",
    "tittle": "Internal error",
    "isShowConfirm": "1"
  },
  "0x0F201C": {
    "description": "Syntax error occurs in the command program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is a debugging version, or contact the technical service team for detailed information on this error code.",
    "tittle": "Syntax error occurs in the command program",
    "isShowConfirm": "1"
  },
  "0x0F201D": {
    "description": "Syntax error occurs in the command program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is a debugging version, or contact the technical service team for detailed information on this error code.",
    "tittle": "Syntax error occurs in the command program",
    "isShowConfirm": "1"
  },
  "0x0F201E": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the code parameters \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the code is correct, then operate.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F201F": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unrecognized command \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Check the script for Move command, especially the manually written ones.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2020": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the move command parameters \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the corresponding Move command according to the error information.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2021": {
    "description": "The method shouldn't be called.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unsupported code command was used in the MoveC. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the function IO is continuously connected. Usually, ",
    "tittle": "The method shouldn't be called",
    "isShowConfirm": "1"
  },
  "0x0F2022": {
    "description": "Unknown operation",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The script program is using unsupported operators. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if any symbols other than the following operators are used, based on the error message: \n +,  -,  /,  *,  **,  and,  mod, or,  xor，]",
    "tittle": "Unknown operation",
    "isShowConfirm": "1"
  },
  "0x0F2023": {
    "description": "Wrong data format",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The format of the defined variables is incorrect. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please correct the format first, then operate.",
    "tittle": "Wrong data format",
    "isShowConfirm": "1"
  },
  "0x0F2024": {
    "description": "Undefined parameters.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1. Inconsistency between socket definition and the one used for sending in communication.\n2. Data assignment wasn't following the specified format.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check the communication command in the program. Make sure all the using ports are open.\n2. Check the data assignment command. Strings need double quotation marks, and arrays need to be enclosed in square brackets.",
    "tittle": "Undefined parameters",
    "isShowConfirm": "1"
  },
  "0x0F2025": {
    "description": "Failed to open file",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. The format is incorrect.\n2. The name of the file is too long.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check the file's format. If it's incorrect, please correct it. \n2. Please check if the name of the file is too long. If so, please shorten it to the valid length.",
    "tittle": "Failed to open file",
    "isShowConfirm": "1"
  },
  "0x0F2026": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The ini parameters in the program are not defined in the ini file.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the ini parameter names are correct.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2027": {
    "description": "Insufficient memory",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Not enough memory to store the string. \nThe error occurred in file: {0}\nline: {1}",
    "action": "1. Please restart the control cabinet and re-run the program. \n2. If this error continues to occur, please record it and contact the technical service team.",
    "tittle": "Insufficient memory",
    "isShowConfirm": "1"
  },
  "0x0F2028": {
    "description": "Incorrect return value type.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unmatched return value type of the function. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the variable definition types and return value types to ensure that the return value's type is correct before proceeding with the task.",
    "tittle": "Incorrect return value type",
    "isShowConfirm": "1"
  },
  "0x0F2029": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There are too many layers of subroutine nested calls. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check whether the subroutine calls in the job program are nested in too many layers (it is recommended that the number of nested layers is less than 10).",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F202A": {
    "description": "Unable to add parameters",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Parameter assignment exception. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the following situations: \n1. If the parameter name is right;\n2. If the parameter type is right.",
    "tittle": "Unable to add parameters",
    "isShowConfirm": "1"
  },
  "0x0F202B": {
    "description": "Error occurs in user-defined content",
    "type": "1",
    "isShowOTA": "0",
    "reason": "User-defined parameter error \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the variable's parameter.",
    "tittle": "Error occurs in user-defined content",
    "isShowConfirm": "1"
  },
  "0x0F202C": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "It is expected to read an integer value (such as an array index), but the script is provided with a non-integer parameter. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "There's a wrong setting in the step value parameter for character-related commands. Please set a reasonable step value. (The step value can only be integer)",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F202D": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unknown character appears in keywords. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the keywords in the operated program.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F202E": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Unknown operator\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the syntax in the operated program: \nThe expressions within () do not support standalone &, |, !, =. They must be as follows: &&， ||， !=， ==",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F202F": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Incomplete expression \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the expression of the line that occurred this error.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2030": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2031": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2032": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2033": {
    "description": "The command is too long.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The script command and parameters are too long. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "The total length of single-line script instructions and parameters should not exceed 255 bytes (512 bytes in the latest version).",
    "tittle": "The command is too long",
    "isShowConfirm": "1"
  },
  "0x0F2034": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Error occurred while saving system variables. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check the system variable file jaka_user.var\n2. Please check the system variable file to see if the variable index is stored by sequence.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2035": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Undefined command parameter. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the parameters in the script are correct.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2036": {
    "description": "Unable to open file.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to open file or folder. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check if the folder or file path is correct;\n2. Please check if the authority to open the folder or file is correct;\n3. Please check if the file is damaged.",
    "tittle": "Unable to open file",
    "isShowConfirm": "1"
  },
  "0x0F2037": {
    "description": "Repetitive definition",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Script interpreter keyword mapping error. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "An internal system error. Please record the error and the operated program, and contact the technical service team.",
    "tittle": "Repetitive definition",
    "isShowConfirm": "1"
  },
  "0x0F2038": {
    "description": "Syntax error occurs in the operated program.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Script interpreter keyword mapping error. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "An internal system error. Please record the error and the operated program, and contact the technical service team.",
    "tittle": "Syntax error occurs in the operated program",
    "isShowConfirm": "1"
  },
  "0x0F2039": {
    "description": "Repeatedly open files",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unable to open files \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please check if the folder or file path is correct;\n2. Please check if the authority to open the folder or file is correct;\n3. Please check if the file is damaged.",
    "tittle": "Repeatedly open files",
    "isShowConfirm": "1"
  },
  "0x0F203A": {
    "description": "There are unmatched 'end' keywords in the script program.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There are unmatched 'end' keywords in the script program. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the 'end' keywords in the script program",
    "tittle": "Unmatched 'end' keywords",
    "isShowConfirm": "1"
  },
  "0x0F203B": {
    "description": "Too many created threads.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "It allows to run 5 threads at the same time at most.\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Wait for the thread to end, or destroy this thread and create another one.",
    "tittle": "Failed to create thread",
    "isShowConfirm": "1"
  },
  "0x0F203C": {
    "description": "Failed to create thread.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This thread was already created, you don't have to create it again. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Wait for the thread to end, or destroy this thread and create another one.",
    "tittle": "Failed to create thread",
    "isShowConfirm": "1"
  },
  "0x0F203D": {
    "description": "Unmatched \"elif\"",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is an \"elif\" but isn't a matched \"if\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the if statement block in the script program.",
    "tittle": "Unmatched keywords",
    "isShowConfirm": "1"
  },
  "0x0F203E": {
    "description": "Unmatched \"else\"",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is an \"else\" but isn't a matched \"if\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the \"if\" statement block in the script program.",
    "tittle": "Unmatched keywords",
    "isShowConfirm": "1"
  },
  "0x0F203F": {
    "description": "Unmatched \"break\"",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is a \"break\" but isn't a matched \"while\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the \"while\" statement block in the script program.",
    "tittle": "Unmatched keywords",
    "isShowConfirm": "1"
  },
  "0x0F2040": {
    "description": "Unmatched \"continue\"",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is a \"continue\" but isn't a matched \"while\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the \"while\" statement block in the script program.",
    "tittle": "Unmatched keywords",
    "isShowConfirm": "1"
  },
  "0x0F2041": {
    "description": "Unmatched \"return\"",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is a \"return\" but isn't a matched \"sub\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the \"sub\" statement block in the script program.",
    "tittle": "Unmatched keywords",
    "isShowConfirm": "1"
  },
  "0x0F2042": {
    "description": "Failed to read the TIO signals.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Undefined signals.",
    "action": "Please define before accessing, or check the spelling.",
    "tittle": "Failed to read the TIO signals",
    "isShowConfirm": "1"
  },
  "0x0F2043": {
    "description": "Failed to add system variables.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The variable index is out of range.",
    "action": "The variable index should be within 1-5601.",
    "tittle": "Failed to add system variables",
    "isShowConfirm": "1"
  },
  "0x0F2050": {
    "description": "Invalid SOCKET id",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "",
    "tittle": "Invalid SOCKET id",
    "isShowConfirm": "1"
  },
  "0x0F2051": {
    "description": "Failed inverse kinematics calculation",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Inverse kinematics calculation was used in the program, and the calculation has failed. It might be related to the specified reference joint angles and the end-effector pose for the solution. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "JOG to check if it's possible to use MoveJ to move to the target point through Cartesian space. If so, consider altering the current robot's pose by exploring alternative trajectories or poses to reach the target point, or modifying the target point's pose.",
    "tittle": "Failed inverse kinematics calculation",
    "isShowConfirm": "1"
  },
  "0x0F2052": {
    "description": "Forward kinematics calculation failed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Forward kinematics calculation was used in the program, and the calculation has failed. It might be related to parameters of the set joint angle values. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "JOG to check if it's possible to use MoveJ to move to the target point through Cartesian space. If so, consider altering the current robot's pose by exploring alternative trajectories or poses to reach the target point, or modifying the target point's pose.",
    "tittle": "Forward kinematics calculation failed",
    "isShowConfirm": "1"
  },
  "0x0F2053": {
    "description": "Wrong data received by the TCP/IP communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Wrong data received by the TCP/IP communication",
    "isShowConfirm": "1"
  },
  "0x0F2054": {
    "description": "Invalid array variable",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The array variable is undefined, or the variable is not an array type. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the array variable corresponding to the error line of the script program is used correctly.",
    "tittle": "Invalid array variable",
    "isShowConfirm": "1"
  },
  "0x0F2055": {
    "description": "Invalid array variable index",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The array index value is beyond the array's range. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if the array index corresponding to the error line of the script program is used correctly.",
    "tittle": "Invalid array variable index",
    "isShowConfirm": "1"
  },
  "0x0F2056": {
    "description": "Invalid pose interpolation coefficient.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The interpolation coefficient provided for the pose interpolation command is invalid. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the parameters of the pose interpolation command which occurred this error.",
    "tittle": "Invalid pose interpolation coefficient",
    "isShowConfirm": "1"
  },
  "0x0F2057": {
    "description": "Unmatched termination delimiter of the control block.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The matched \"end\" termination delimiter is missing in the \"if\", \"while\" control block. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check if all 'if' and 'while' statement blocks in the custom script subroutine have their corresponding 'end' termination delimiters.",
    "tittle": "Unmatched termination delimiter of the control block",
    "isShowConfirm": "1"
  },
  "0x0F2058": {
    "description": "Unsupported escape character",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Unsupported escape character was used in the script program. \nCurrently, the supported are: \n \\n, \\r, \\t, \\\", \\', \\\\,\nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Currently, the supported escape characters are: \\\\ Backslash\n\\' Single quote\n\\\" Double quote\n\\nNewline\n\\t Horizontal tab\n\\r Carriage return",
    "tittle": "Unsupported escape character",
    "isShowConfirm": "1"
  },
  "0x0F2059": {
    "description": "Invalid array slice step parameter.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The step used for array slicing access is invalid. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the script program: \n  When accessing an array using slicing, the step should be a positive integer.",
    "tittle": "Invalid array slice step parameter",
    "isShowConfirm": "1"
  },
  "0x0F2060": {
    "description": "Nested arrays are not supported.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Arrays are not supported as elements in the array variables. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the script program: \n  Arrays are not supported as elements in the array variables.",
    "tittle": "Nested arrays are not supported",
    "isShowConfirm": "1"
  },
  "0x0F2061": {
    "description": "String arrays are not supported.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Strings are not supported as elements in the array variables. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the script program: \n  Strings are not supported as elements in the array variables.",
    "tittle": "String arrays are not supported",
    "isShowConfirm": "1"
  },
  "0x0F2062": {
    "description": "Too many SOCKETs are created.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Too many SOCKETs are created without closing any. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "1. Please make sure to close the SOCKET after using the SOCKET command;\n2. Avoid opening SOCKET within loop statements. If opened, make sure to close it before the next use;\n3. Currently, up to 256 SOCKETS are allowed without closing any.",
    "tittle": "Too many SOCKETs are created",
    "isShowConfirm": "1"
  },
  "0x0F2063": {
    "description": "Invalid data received by SOCKET",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The data format of the variable command received by SOCKET is incorrect. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "When using SOCKET to receive variables and array commands, please make sure the data format sent from the server-side adheres to the defined return data format in the script programming instructions.",
    "tittle": "Invalid data received by SOCKET",
    "isShowConfirm": "1"
  },
  "0x0F2064": {
    "description": "The length of the array received by the socket does not match.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The length of the array received by the socket doesn't match the length of the array sent by the server. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "When using the SOCKET command to receive arrays in the script program, ensure that the length of the array returned by the server is correct.",
    "tittle": "The length of the array received by the socket does not match",
    "isShowConfirm": "1"
  },
  "0x0F2065": {
    "description": "The type of the array received by the socket does not match.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The type of the array received by the socket doesn't match the length of the array sent by the server. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "when using SOCKET to receive variables and arrays in the script program, ensure that the data type sent back by the server is correct.",
    "tittle": "The type of the array received by the socket does not match",
    "isShowConfirm": "1"
  },
  "0x0F2066": {
    "description": "Collision sensitivity level setting in program commands is not enabled.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "This version has not enabled the function to set collision sensitivity levels in program commands, and relevant commands will be skipped when executed. \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please configure the collision sensitivity level in the safety settings or contact JAKA technical service team to enable this function.",
    "tittle": "Collision sensitivity level setting in program commands is not enabled.",
    "isShowConfirm": "1"
  },
  "0x0F2067": {
    "description": "Unsupported operand type(s)",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "1": "/",
        "2": "%",
        "3": "**",
        "4": "*",
        "5": "&&",
        "6": "^",
        "7": "-",
        "8": "||",
        "9": "+",
        "13": "<",
        "14": "==",
        "15": "!=",
        "16": "<=",
        "17": ">=",
        "18": ">"
      },
      "1": {
        "0": "scalar",
        "1": "array",
        "2": "string"
      },
      "2": {
        "0": "scalar",
        "1": "array",
        "2": "string"
      }
    },
    "reason": "Unsupported operand type(s) for \"<0>\": \"<1>\" and \"<2>\". \nThe error occurred in file: {0}\nError line number: {1}",
    "action": "Please check the type of the corresponding script variable based on the error message.",
    "tittle": "Wrong variable type",
    "isShowConfirm": "1"
  },
  "0x0F2068": {
    "description": "Program execution error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Program execution error.",
    "action": "Program execution error.",
    "tittle": "Program execution error",
    "isShowConfirm": "0"
  },
  "0x0F2069": {
    "description": "Digital input signal cannot be obtained when the IO pin is set as output type",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Failed to obtain digital input signal",
    "isShowConfirm": "1"
  },
  "0x0F206A": {
    "description": "Digital output signal cannot be obtained when the IO pin is set as input type",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Failed to obtain digital output signal",
    "isShowConfirm": "1"
  },
  "0x0F206B": {
    "description": "Abnormal digital input signal received, and error occurs when executing the waiting for digital input command.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Digital input cannot be obtained when the IO pin is of output type, unable to perform the 'wait' command based on the signal status of this IO pin",
    "action": "Please confirm that the operated IO pin is of input type before executing the waiting for input signal command.",
    "tittle": "Waiting for digital input command execution failed",
    "isShowConfirm": "1"
  },
  "0x0F3001": {
    "description": "Failed to connect to the target visual device.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller failed to connect to the target visual device.",
    "action": "Please check if the connection cable is functioning normally, and ensure the DC24V power supply for the visual device has the correct polarity. If it still fails to connect, please contact the technical service team.",
    "tittle": "Failed to connect to the target visual device",
    "isShowConfirm": "1"
  },
  "0x0F3002": {
    "description": "No visual device is connected",
    "type": "1",
    "isShowOTA": "0",
    "reason": "No online visual device is detected by the controller.",
    "action": "Please check if the connection cable is functioning normally, and ensure the DC24V power supply for the visual device has the correct polarity. If it still fails to connect, please contact the technical service team.",
    "tittle": "No visual device is connected",
    "isShowConfirm": "1"
  },
  "0x0F4001": {
    "description": "Failed to retrieve the servo's status",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Failed to retrieve the servo's status",
    "isShowConfirm": "1"
  },
  "0x0F4002": {
    "description": "Failed to upgrade the firmware",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Failed to upgrade the robot's firmware.",
    "action": "Check if the firmware file name has the .tar.gz extension and contains no additional content. When upgrading, please avoid turning off or powering off the device.",
    "tittle": "Failed to upgrade the firmware",
    "isShowConfirm": "1"
  },
  "0x0F4003": {
    "description": "This function is not supported by the hardware.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot or the control cabinet does not support this function.",
    "action": "Please take a photo of this function and the version of the controller, and contact the technical service team.",
    "tittle": "This function is not supported by the hardware",
    "isShowConfirm": "1"
  },
  "0x0F4004": {
    "description": "Potential risk detected in Joint {0}",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Internal parameters of the joint have failed the self-check. This is a warning that has no effect on the running of the program.",
    "action": "Please contact the technical service team to troubleshoot.",
    "tittle": "Error occurs in the robot's self-diagnose",
    "isShowConfirm": "1"
  },
  "0x0FFFFE": {
    "description": "Other error",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Other error",
    "isShowConfirm": "1"
  },
  "0x0FFFFF": {
    "description": "Unknown error",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Unknown error",
    "isShowConfirm": "1"
  },
  "0x102230": {
    "description": "Joint 1 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 1 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x102320": {
    "description": "Joint 1 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 1 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x102321": {
    "description": "Joint 1 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 1 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x102350": {
    "description": "Joint 1 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 1 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x103130": {
    "description": "Input phase loss in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 1",
    "isShowConfirm": "1"
  },
  "0x103210": {
    "description": "Servo overvoltage detected in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 1",
    "isShowConfirm": "1"
  },
  "0x103211": {
    "description": "Joint 1 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 1 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x103220": {
    "description": "Servo undervoltage detected in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 1",
    "isShowConfirm": "1"
  },
  "0x103380": {
    "description": "Encoder zero calibration failed in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 1",
    "isShowConfirm": "1"
  },
  "0x103381": {
    "description": "Output phase loss in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 1",
    "isShowConfirm": "1"
  },
  "0x104210": {
    "description": "Joint 1's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 1's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x104310": {
    "description": "The servo in Joint 1 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 1 is overheating",
    "isShowConfirm": "1"
  },
  "0x105201": {
    "description": "Joint 1's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 1's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x105202": {
    "description": "Joint 1's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 1's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x105210": {
    "description": "The parameters set for Joint 1 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 1 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x105211": {
    "description": "Model selection error for Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 1",
    "isShowConfirm": "1"
  },
  "0x105280": {
    "description": "Wrong internal parameters of Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 1",
    "isShowConfirm": "1"
  },
  "0x105281": {
    "description": "Joint 1 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 1 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x105282": {
    "description": "Joint 1 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 1 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x105283": {
    "description": "Failed to enable Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 1",
    "isShowConfirm": "1"
  },
  "0x105441": {
    "description": "Error occurs in Joint 1's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 1's internal connection",
    "isShowConfirm": "1"
  },
  "0x105480": {
    "description": "Servo in Joint 1 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 1 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x106000": {
    "description": "Abnormal internal status of absolute encoder in Joint 1",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 1 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x106010": {
    "description": "Encoder temperature of Joint 1 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 1 is too high",
    "isShowConfirm": "1"
  },
  "0x107180": {
    "description": "Joint 1's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 1's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x107181": {
    "description": "Joint 1's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 1's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x107182": {
    "description": "Joint 1's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 1's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x107185": {
    "description": "Joint 1 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 1 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 1 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x107380": {
    "description": "Joint 1's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 1's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x107381": {
    "description": "Low voltage in the encoder battery for Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 1",
    "isShowConfirm": "1"
  },
  "0x107382": {
    "description": "Encoder battery disconnected in Joint 1.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 1",
    "isShowConfirm": "1"
  },
  "0x107383": {
    "description": "The angle stored in Joint 1's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 1's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x107384": {
    "description": "Wrong count in Joint 1's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 1's encoder",
    "isShowConfirm": "1"
  },
  "0x107385": {
    "description": "Verification error in Joint 1's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 1's two encoders",
    "isShowConfirm": "1"
  },
  "0x107386": {
    "description": "Internal errors of the Joint 1's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 1's encoder",
    "isShowConfirm": "1"
  },
  "0x107387": {
    "description": "Joint 1's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 1's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x107388": {
    "description": "Unusual magnetic signals from the Joint 1's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 1's encoder",
    "isShowConfirm": "1"
  },
  "0x107389": {
    "description": "Joint 1 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 1",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 1 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x107580": {
    "description": "Joint 1 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 1 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x108000": {
    "description": "Joint 1's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 1's position has deviated",
    "isShowConfirm": "1"
  },
  "0x108001": {
    "description": "Joint 1 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 1 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x108480": {
    "description": "Joint 1 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 1 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x108481": {
    "description": "Joint 1 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 1 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x108482": {
    "description": "Excessive speed detected in Joint 1.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 1",
    "isShowConfirm": "1"
  },
  "0x108483": {
    "description": "The speed tracking error for Joint 1 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 1 is too large",
    "isShowConfirm": "1"
  },
  "0x108484": {
    "description": "Joint 1's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 1's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x108485": {
    "description": "Joint 1 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 1 speed control error",
    "isShowConfirm": "1"
  },
  "0x108501": {
    "description": "Joint 1: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 1: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 1: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x108611": {
    "description": "Excessive deviation in Joint 1's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 1's position",
    "isShowConfirm": "1"
  },
  "0x108612": {
    "description": "The increment of Joint 1's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 1's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 1's command position is too large",
    "isShowConfirm": "1"
  },
  "0x108613": {
    "description": "Excessive acceleration in Joint 1.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 1 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 1",
    "isShowConfirm": "1"
  },
  "0x108614": {
    "description": "The distance between Joint 1's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 1's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x108615": {
    "description": "Error occurs in Joint 1's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 1's CAN communication",
    "isShowConfirm": "1"
  },
  "0x108616": {
    "description": "joint 1 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 1 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x108617": {
    "description": "Joint 1 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 1",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 1: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x10FFFF": {
    "description": "Joint Error Occurred",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Joint {0} encountered error {1}",
    "action": "The current controller version cannot recognize this error, please contact JAKA technical staff for consultation",
    "tittle": "Joint Error Occurred",
    "isShowConfirm": "1"
  },
  "0x112230": {
    "description": "Joint 2 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 2 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x112320": {
    "description": "Joint 2 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 2 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x112321": {
    "description": "Joint 2 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 2 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x112350": {
    "description": "Joint 2 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 2 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x113130": {
    "description": "Input phase loss in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 2",
    "isShowConfirm": "1"
  },
  "0x113210": {
    "description": "Servo overvoltage detected in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 2",
    "isShowConfirm": "1"
  },
  "0x113211": {
    "description": "Joint 2 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 2 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x113220": {
    "description": "Servo undervoltage detected in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 2",
    "isShowConfirm": "1"
  },
  "0x113380": {
    "description": "Encoder zero calibration failed in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 2",
    "isShowConfirm": "1"
  },
  "0x113381": {
    "description": "Output phase loss in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 2",
    "isShowConfirm": "1"
  },
  "0x114210": {
    "description": "Joint 2's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 2's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x114310": {
    "description": "The servo in Joint 2 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 2 is overheating",
    "isShowConfirm": "1"
  },
  "0x115201": {
    "description": "Joint 2's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 2's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x115202": {
    "description": "Joint 2's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 2's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x115210": {
    "description": "The parameters set for Joint 2 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 2 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x115211": {
    "description": "Model selection error for Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 2",
    "isShowConfirm": "1"
  },
  "0x115280": {
    "description": "Wrong internal parameters of Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 2",
    "isShowConfirm": "1"
  },
  "0x115281": {
    "description": "Joint 2 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 2 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x115282": {
    "description": "Joint 2 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 2 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x115283": {
    "description": "Failed to enable Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 2",
    "isShowConfirm": "1"
  },
  "0x115441": {
    "description": "Error occurs in Joint 2's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 2's internal connection",
    "isShowConfirm": "1"
  },
  "0x115480": {
    "description": "Servo in Joint 2 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 2 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x116000": {
    "description": "Abnormal internal status of absolute encoder in Joint 2",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 2 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x116010": {
    "description": "Encoder temperature of Joint 2 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 2 is too high",
    "isShowConfirm": "1"
  },
  "0x117180": {
    "description": "Joint 2's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 2's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x117181": {
    "description": "Joint 2's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 2's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x117182": {
    "description": "Joint 2's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 2's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x117185": {
    "description": "Joint 2 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 2 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 2 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x117380": {
    "description": "Joint 2's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 2's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x117381": {
    "description": "Low voltage in the encoder battery for Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 2",
    "isShowConfirm": "1"
  },
  "0x117382": {
    "description": "Encoder battery disconnected in Joint 2.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 2",
    "isShowConfirm": "1"
  },
  "0x117383": {
    "description": "The angle stored in Joint 2's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 2's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x117384": {
    "description": "Wrong count in Joint 2's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 2's encoder",
    "isShowConfirm": "1"
  },
  "0x117385": {
    "description": "Verification error in Joint 2's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 2's two encoders",
    "isShowConfirm": "1"
  },
  "0x117386": {
    "description": "Internal errors of the Joint 2's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 2's encoder",
    "isShowConfirm": "1"
  },
  "0x117387": {
    "description": "Joint 2's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 2's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x117388": {
    "description": "Unusual magnetic signals from the Joint 2's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 2's encoder",
    "isShowConfirm": "1"
  },
  "0x117389": {
    "description": "Joint 2 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 2",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 2 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x117580": {
    "description": "Joint 2 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 2 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x118000": {
    "description": "Joint 2's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 2's position has deviated",
    "isShowConfirm": "1"
  },
  "0x118001": {
    "description": "Joint 2 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 2 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x118480": {
    "description": "Joint 2 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 2 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x118481": {
    "description": "Joint 2 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 2 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x118482": {
    "description": "Excessive speed detected in Joint 2.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 2",
    "isShowConfirm": "1"
  },
  "0x118483": {
    "description": "The speed tracking error for Joint 2 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 2 is too large",
    "isShowConfirm": "1"
  },
  "0x118484": {
    "description": "Joint 2's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 2's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x118485": {
    "description": "Joint 2 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 2 speed control error",
    "isShowConfirm": "1"
  },
  "0x118501": {
    "description": "Joint 2: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 2: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 2: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x118611": {
    "description": "Excessive deviation in Joint 2's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 2's position",
    "isShowConfirm": "1"
  },
  "0x118612": {
    "description": "The increment of Joint 2's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 2's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 2's command position is too large",
    "isShowConfirm": "1"
  },
  "0x118613": {
    "description": "Excessive acceleration in Joint 2.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 2 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 2",
    "isShowConfirm": "1"
  },
  "0x118614": {
    "description": "The distance between Joint 2's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 2's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x118615": {
    "description": "Error occurs in Joint 2's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 2's CAN communication",
    "isShowConfirm": "1"
  },
  "0x118616": {
    "description": "joint 2 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 2 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x118617": {
    "description": "Joint 2 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 2",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 2: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x122230": {
    "description": "Joint 3 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 3 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x122320": {
    "description": "Joint 3 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 3 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x122321": {
    "description": "Joint 3 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 3 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x122350": {
    "description": "Joint 3 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 3 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x123130": {
    "description": "Input phase loss in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 3",
    "isShowConfirm": "1"
  },
  "0x123210": {
    "description": "Servo overvoltage detected in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 3",
    "isShowConfirm": "1"
  },
  "0x123211": {
    "description": "Joint 3 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 3 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x123220": {
    "description": "Servo undervoltage detected in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 3",
    "isShowConfirm": "1"
  },
  "0x123380": {
    "description": "Encoder zero calibration failed in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 3",
    "isShowConfirm": "1"
  },
  "0x123381": {
    "description": "Output phase loss in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 3",
    "isShowConfirm": "1"
  },
  "0x124210": {
    "description": "Joint 3's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 3's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x124310": {
    "description": "The servo in Joint 3 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 3 is overheating",
    "isShowConfirm": "1"
  },
  "0x125201": {
    "description": "Joint 3's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 3's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x125202": {
    "description": "Joint 3's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 3's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x125210": {
    "description": "The parameters set for Joint 3 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 3 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x125211": {
    "description": "Model selection error for Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 3",
    "isShowConfirm": "1"
  },
  "0x125280": {
    "description": "Wrong internal parameters of Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 3",
    "isShowConfirm": "1"
  },
  "0x125281": {
    "description": "Joint 3 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 3 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x125282": {
    "description": "Joint 3 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 3 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x125283": {
    "description": "Failed to enable Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 3",
    "isShowConfirm": "1"
  },
  "0x125441": {
    "description": "Error occurs in Joint 3's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 3's internal connection",
    "isShowConfirm": "1"
  },
  "0x125480": {
    "description": "Servo in Joint 3 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 3 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x126000": {
    "description": "Abnormal internal status of absolute encoder in Joint 3",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 3 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x126010": {
    "description": "Encoder temperature of Joint 3 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 3 is too high",
    "isShowConfirm": "1"
  },
  "0x127180": {
    "description": "Joint 3's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 3's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x127181": {
    "description": "Joint 3's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 3's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x127182": {
    "description": "Joint 3's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 3's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x127185": {
    "description": "Joint 3 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 3 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 3 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x127380": {
    "description": "Joint 3's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 3's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x127381": {
    "description": "Low voltage in the encoder battery for Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 3",
    "isShowConfirm": "1"
  },
  "0x127382": {
    "description": "Encoder battery disconnected in Joint 3.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 3",
    "isShowConfirm": "1"
  },
  "0x127383": {
    "description": "The angle stored in Joint 3's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 3's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x127384": {
    "description": "Wrong count in Joint 3's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 3's encoder",
    "isShowConfirm": "1"
  },
  "0x127385": {
    "description": "Verification error in Joint 3's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 3's two encoders",
    "isShowConfirm": "1"
  },
  "0x127386": {
    "description": "Internal errors of the Joint 3's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 3's encoder",
    "isShowConfirm": "1"
  },
  "0x127387": {
    "description": "Joint 3's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 3's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x127388": {
    "description": "Unusual magnetic signals from the Joint 3's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 3's encoder",
    "isShowConfirm": "1"
  },
  "0x127389": {
    "description": "Joint 3 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 3",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 3 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x127580": {
    "description": "Joint 3 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 3 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x128000": {
    "description": "Joint 3's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 3's position has deviated",
    "isShowConfirm": "1"
  },
  "0x128001": {
    "description": "Joint 3 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 3 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x128480": {
    "description": "Joint 3 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 3 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x128481": {
    "description": "Joint 3 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 3 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x128482": {
    "description": "Excessive speed detected in Joint 3.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 3",
    "isShowConfirm": "1"
  },
  "0x128483": {
    "description": "The speed tracking error for Joint 3 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 3 is too large",
    "isShowConfirm": "1"
  },
  "0x128484": {
    "description": "Joint 3's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 3's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x128485": {
    "description": "Joint 3 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 3 speed control error",
    "isShowConfirm": "1"
  },
  "0x128501": {
    "description": "Joint 3: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 3: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 3: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x128611": {
    "description": "Excessive deviation in Joint 3's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 3's position",
    "isShowConfirm": "1"
  },
  "0x128612": {
    "description": "The increment of Joint 3's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 3's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 3's command position is too large",
    "isShowConfirm": "1"
  },
  "0x128613": {
    "description": "Excessive acceleration in Joint 3.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 3 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 3",
    "isShowConfirm": "1"
  },
  "0x128614": {
    "description": "The distance between Joint 3's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 3's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x128615": {
    "description": "Error occurs in Joint 3's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 3's CAN communication",
    "isShowConfirm": "1"
  },
  "0x128616": {
    "description": "joint 3 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 3 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x128617": {
    "description": "Joint 3 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 3",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 3: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x132230": {
    "description": "Joint 4 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 4 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x132320": {
    "description": "Joint 4 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 4 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x132321": {
    "description": "Joint 4 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 4 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x132350": {
    "description": "Joint 4 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 4 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x133130": {
    "description": "Input phase loss in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 4",
    "isShowConfirm": "1"
  },
  "0x133210": {
    "description": "Servo overvoltage detected in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 4",
    "isShowConfirm": "1"
  },
  "0x133211": {
    "description": "Joint 4 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 4 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x133220": {
    "description": "Servo undervoltage detected in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 4",
    "isShowConfirm": "1"
  },
  "0x133380": {
    "description": "Encoder zero calibration failed in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 4",
    "isShowConfirm": "1"
  },
  "0x133381": {
    "description": "Output phase loss in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 4",
    "isShowConfirm": "1"
  },
  "0x134210": {
    "description": "Joint 4's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 4's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x134310": {
    "description": "The servo in Joint 4 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 4 is overheating",
    "isShowConfirm": "1"
  },
  "0x135201": {
    "description": "Joint 4's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 4's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x135202": {
    "description": "Joint 4's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 4's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x135210": {
    "description": "The parameters set for Joint 4 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 4 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x135211": {
    "description": "Model selection error for Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 4",
    "isShowConfirm": "1"
  },
  "0x135280": {
    "description": "Wrong internal parameters of Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 4",
    "isShowConfirm": "1"
  },
  "0x135281": {
    "description": "Joint 4 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 4 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x135282": {
    "description": "Joint 4 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 4 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x135283": {
    "description": "Failed to enable Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 4",
    "isShowConfirm": "1"
  },
  "0x135441": {
    "description": "Error occurs in Joint 4's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 4's internal connection",
    "isShowConfirm": "1"
  },
  "0x135480": {
    "description": "Servo in Joint 4 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 4 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x136000": {
    "description": "Abnormal internal status of absolute encoder in Joint 4",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 4 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x136010": {
    "description": "Encoder temperature of Joint 4 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 4 is too high",
    "isShowConfirm": "1"
  },
  "0x137180": {
    "description": "Joint 4's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 4's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x137181": {
    "description": "Joint 4's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 4's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x137182": {
    "description": "Joint 4's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 4's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x137185": {
    "description": "Joint 4 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 4 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 4 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x137380": {
    "description": "Joint 4's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 4's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x137381": {
    "description": "Low voltage in the encoder battery for Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 4",
    "isShowConfirm": "1"
  },
  "0x137382": {
    "description": "Encoder battery disconnected in Joint 4.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 4",
    "isShowConfirm": "1"
  },
  "0x137383": {
    "description": "The angle stored in Joint 4's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 4's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x137384": {
    "description": "Wrong count in Joint 4's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 4's encoder",
    "isShowConfirm": "1"
  },
  "0x137385": {
    "description": "Verification error in Joint 4's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 4's two encoders",
    "isShowConfirm": "1"
  },
  "0x137386": {
    "description": "Internal errors of the Joint 4's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 4's encoder",
    "isShowConfirm": "1"
  },
  "0x137387": {
    "description": "Joint 4's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 4's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x137388": {
    "description": "Unusual magnetic signals from the Joint 4's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 4's encoder",
    "isShowConfirm": "1"
  },
  "0x137389": {
    "description": "Joint 4 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 4",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 4 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x137580": {
    "description": "Joint 4 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 4 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x138000": {
    "description": "Joint 4's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 4's position has deviated",
    "isShowConfirm": "1"
  },
  "0x138001": {
    "description": "Joint 4 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 4 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x138480": {
    "description": "Joint 4 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 4 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x138481": {
    "description": "Joint 4 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 4 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x138482": {
    "description": "Excessive speed detected in Joint 4.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 4",
    "isShowConfirm": "1"
  },
  "0x138483": {
    "description": "The speed tracking error for Joint 4 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 4 is too large",
    "isShowConfirm": "1"
  },
  "0x138484": {
    "description": "Joint 4's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 4's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x138485": {
    "description": "Joint 4 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 4 speed control error",
    "isShowConfirm": "1"
  },
  "0x138501": {
    "description": "Joint 4: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 4: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 4: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x138611": {
    "description": "Excessive deviation in Joint 4's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 4's position",
    "isShowConfirm": "1"
  },
  "0x138612": {
    "description": "The increment of Joint 4's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 4's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 4's command position is too large",
    "isShowConfirm": "1"
  },
  "0x138613": {
    "description": "Excessive acceleration in Joint 4.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 4 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 4",
    "isShowConfirm": "1"
  },
  "0x138614": {
    "description": "The distance between Joint 4's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 4's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x138615": {
    "description": "Error occurs in Joint 4's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 4's CAN communication",
    "isShowConfirm": "1"
  },
  "0x138616": {
    "description": "joint 4 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 4 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x138617": {
    "description": "Joint 4 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 4",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 4: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x142230": {
    "description": "Joint 5 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 5 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x142320": {
    "description": "Joint 5 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 5 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x142321": {
    "description": "Joint 5 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 5 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x142350": {
    "description": "Joint 5 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 5 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x143130": {
    "description": "Input phase loss in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 5",
    "isShowConfirm": "1"
  },
  "0x143210": {
    "description": "Servo overvoltage detected in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 5",
    "isShowConfirm": "1"
  },
  "0x143211": {
    "description": "Joint 5 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 5 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x143220": {
    "description": "Servo undervoltage detected in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 5",
    "isShowConfirm": "1"
  },
  "0x143380": {
    "description": "Encoder zero calibration failed in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 5",
    "isShowConfirm": "1"
  },
  "0x143381": {
    "description": "Output phase loss in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 5",
    "isShowConfirm": "1"
  },
  "0x144210": {
    "description": "Joint 5's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 5's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x144310": {
    "description": "The servo in Joint 5 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 5 is overheating",
    "isShowConfirm": "1"
  },
  "0x145201": {
    "description": "Joint 5's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 5's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x145202": {
    "description": "Joint 5's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 5's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x145210": {
    "description": "The parameters set for Joint 5 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 5 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x145211": {
    "description": "Model selection error for Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 5",
    "isShowConfirm": "1"
  },
  "0x145280": {
    "description": "Wrong internal parameters of Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 5",
    "isShowConfirm": "1"
  },
  "0x145281": {
    "description": "Joint 5 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 5 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x145282": {
    "description": "Joint 5 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 5 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x145283": {
    "description": "Failed to enable Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 5",
    "isShowConfirm": "1"
  },
  "0x145441": {
    "description": "Error occurs in Joint 5's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 5's internal connection",
    "isShowConfirm": "1"
  },
  "0x145480": {
    "description": "Servo in Joint 5 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 5 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x146000": {
    "description": "Abnormal internal status of absolute encoder in Joint 5",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 5 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x146010": {
    "description": "Encoder temperature of Joint 5 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 5 is too high",
    "isShowConfirm": "1"
  },
  "0x147180": {
    "description": "Joint 5's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 5's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x147181": {
    "description": "Joint 5's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 5's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x147182": {
    "description": "Joint 5's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 5's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x147185": {
    "description": "Joint 5 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 5 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 5 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x147380": {
    "description": "Joint 5's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 5's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x147381": {
    "description": "Low voltage in the encoder battery for Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 5",
    "isShowConfirm": "1"
  },
  "0x147382": {
    "description": "Encoder battery disconnected in Joint 5.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 5",
    "isShowConfirm": "1"
  },
  "0x147383": {
    "description": "The angle stored in Joint 5's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 5's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x147384": {
    "description": "Wrong count in Joint 5's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 5's encoder",
    "isShowConfirm": "1"
  },
  "0x147385": {
    "description": "Verification error in Joint 5's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 5's two encoders",
    "isShowConfirm": "1"
  },
  "0x147386": {
    "description": "Internal errors of the Joint 5's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 5's encoder",
    "isShowConfirm": "1"
  },
  "0x147387": {
    "description": "Joint 5's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 5's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x147388": {
    "description": "Unusual magnetic signals from the Joint 5's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 5's encoder",
    "isShowConfirm": "1"
  },
  "0x147389": {
    "description": "Joint 5 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 5",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 5 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x147580": {
    "description": "Joint 5 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 5 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x148000": {
    "description": "Joint 5's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 5's position has deviated",
    "isShowConfirm": "1"
  },
  "0x148001": {
    "description": "Joint 5 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 5 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x148480": {
    "description": "Joint 5 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 5 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x148481": {
    "description": "Joint 5 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 5 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x148482": {
    "description": "Excessive speed detected in Joint 5.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 5",
    "isShowConfirm": "1"
  },
  "0x148483": {
    "description": "The speed tracking error for Joint 5 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 5 is too large",
    "isShowConfirm": "1"
  },
  "0x148484": {
    "description": "Joint 5's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 5's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x148485": {
    "description": "Joint 5 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 5 speed control error",
    "isShowConfirm": "1"
  },
  "0x148501": {
    "description": "Joint 5: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 5: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 5: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x148611": {
    "description": "Excessive deviation in Joint 5's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 5's position",
    "isShowConfirm": "1"
  },
  "0x148612": {
    "description": "The increment of Joint 5's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 5's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 5's command position is too large",
    "isShowConfirm": "1"
  },
  "0x148613": {
    "description": "Excessive acceleration in Joint 5.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 5 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 5",
    "isShowConfirm": "1"
  },
  "0x148614": {
    "description": "The distance between Joint 5's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 5's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x148615": {
    "description": "Error occurs in Joint 5's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 5's CAN communication",
    "isShowConfirm": "1"
  },
  "0x148616": {
    "description": "joint 5 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 5 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x148617": {
    "description": "Joint 5 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 5",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 5: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x152230": {
    "description": "Joint 6 busbar overcurrent.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor reports that the current has exceeded the threshold.",
    "action": "Please take a photo of this function and the version of the controller, and save the diagnostic log, and contact the technical service team.",
    "tittle": "Joint 6 busbar overcurrent",
    "isShowConfirm": "1"
  },
  "0x152320": {
    "description": "Joint 6 output overcurrent.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The current in motor UVW exceeds beyond the hardware driver board's overcurrent threshold.",
    "action": "1. Please reduce the robot's payload. \n2. Please decrease the robot's speed and acceleration. 3. The robot's joint driver and reduce is not normal, please contact the technical service team.\n4. The communication is not normal, please replace the robot connection cable or the control cabinet, or to contact the techinical service team.",
    "tittle": "Joint 6 output overcurrent",
    "isShowConfirm": "1"
  },
  "0x152321": {
    "description": "Joint 6 is experiencing overcurrent during the homing process.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, there is a significant current output, but no motor rotation was detected.",
    "action": "1. Please disable the robot, manually release the joint electromagnets, and check if this joint can be moved by hand. \n2. Please power off the robot and remove the back lid to check if the cables are connecting unusually, or please contact the technical service team.",
    "tittle": "Joint 6 is experiencing overcurrent during the homing process",
    "isShowConfirm": "1"
  },
  "0x152350": {
    "description": "Joint 6 module overloaded (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 6 module overloaded (I2T)",
    "isShowConfirm": "1"
  },
  "0x153130": {
    "description": "Input phase loss in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Input phase loss in Joint 6",
    "isShowConfirm": "1"
  },
  "0x153210": {
    "description": "Servo overvoltage detected in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the overvoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the discharge protection board of the control cabinet is functioning normally. \n3. Please contact the technical service team to check the hardware driver board.",
    "tittle": "Servo overvoltage detected in Joint 6",
    "isShowConfirm": "1"
  },
  "0x153211": {
    "description": "Joint 6 driver board power supply failure.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The hardware driver board has been damaged.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 6 driver board power supply failure",
    "isShowConfirm": "1"
  },
  "0x153220": {
    "description": "Servo undervoltage detected in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The busbar voltage has exceeded the undervoltage threshold of the hardware driver board.",
    "action": "1. Please check if the payload and acceleration of the robot are too large. If so, decrease them. \n2. Please check if the robot connection cable is functioning normally. \n3. Please contact the technical service team to check the hardware driver board. \n4. Please contact the technical service team to check the communication or the power supply of the control cabinet.",
    "tittle": "Servo undervoltage detected in Joint 6",
    "isShowConfirm": "1"
  },
  "0x153380": {
    "description": "Encoder zero calibration failed in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the joint is enabling, its motor doesn't rotate as expected.",
    "action": "1. Please contact the technical service team to check if all the parameters are correct in this joint. \n2. Please disable and enable the robot to check if the brake is functioning normally. \n3. Please contact the technical service team to check if the joint's ABZ cables and ABZ encoder disc are functioning normally.",
    "tittle": "Encoder zero calibration failed in Joint 6",
    "isShowConfirm": "1"
  },
  "0x153381": {
    "description": "Output phase loss in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When enabling, the output of three-phase electric power is not normal.",
    "action": "1. Please contact the technical service team to check if the joint's three-phase connection cable is working properly. \n2. Please contact the technical service team to check if the joint's motor circuit is working properly. \n3. Please contact the technical service team to check if the joint's driver board is working properly.",
    "tittle": "Output phase loss in Joint 6",
    "isShowConfirm": "1"
  },
  "0x154210": {
    "description": "Joint 6's motor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 6's motor is overheating",
    "isShowConfirm": "1"
  },
  "0x154310": {
    "description": "The servo in Joint 6 is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the driver board has exceeded the hardware driver board's overheating threshold.",
    "action": "1. Please check if the ambient temperature has exceeded the operating temperature of the robot. \n2. Please check if the temperature of the robot surface has exceeded 50℃. If so, try to decrease it. \n3. Please contact the technical service team to check if the joint driver board and the joint reducer are functioning normally.",
    "tittle": "The servo in Joint 6 is overheating",
    "isShowConfirm": "1"
  },
  "0x155201": {
    "description": "Joint 6's parameters are still locked.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Starting from version R176, the servo's critical parameters have written-protection to prevent inadvertent errors.",
    "action": "Please contact the the technical service team to check the joint's parameters.",
    "tittle": "Joint 6's parameters are still locked",
    "isShowConfirm": "1"
  },
  "0x155202": {
    "description": "Joint 6's zero calibration and DH parameter are in contradiction.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "During zero calibration, the servo detects whether the current model underwent DH parameter calibration before delivery. Using the zero calibration function on an already calibrated model can lead to DH parameter errors, resulting in a loss of robot accuracy.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 6's zero calibration and DH parameter are in contradiction",
    "isShowConfirm": "1"
  },
  "0x155210": {
    "description": "The parameters set for Joint 6 do not match its hardware power.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "There's a mismatch among the hardware driver board, the motor brand and model, and the servo's parameters.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct. \n2. Please contact the technical service team to check if the joint driver board is functioning normally.",
    "tittle": "The parameters set for Joint 6 do not match its hardware power",
    "isShowConfirm": "1"
  },
  "0x155211": {
    "description": "Model selection error for Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Mismatch between the hardware driver board and the servo's parameters.",
    "action": "Please contact the technical service team to check if the joint's hardware version and the servo's parameters are correct.",
    "tittle": "Model selection error for Joint 6",
    "isShowConfirm": "1"
  },
  "0x155280": {
    "description": "Wrong internal parameters of Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's parameters have exceeded the threshold. This error only occurs when powering on the robot. ",
    "action": "Please contact the technical service team to check if the internal parameters of the joint are correct.",
    "tittle": "Wrong internal parameters of Joint 6",
    "isShowConfirm": "1"
  },
  "0x155281": {
    "description": "Joint 6 PID calculation overflow.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The servo's PID calculation has exceeded its limit.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 6 PID calculation overflow",
    "isShowConfirm": "1"
  },
  "0x155282": {
    "description": "Joint 6 EEPROM error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Hardware EEPROM chip read and write error.",
    "action": "1. Please try to power on and off the robot for several times to check the power on sequence. If the error still occurs, please contact the technical service team. \n2. Please contact the technical service team to check if the joint's driver board is working normally.",
    "tittle": "Joint 6 EEPROM error",
    "isShowConfirm": "1"
  },
  "0x155283": {
    "description": "Failed to enable Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabling process failed due to other system errors.",
    "action": "Please check if there are other errors. If so, deal with them first before enable the robot again.",
    "tittle": "Failed to enable Joint 6",
    "isShowConfirm": "1"
  },
  "0x155441": {
    "description": "Error occurs in Joint 6's internal connection.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Error occurs in Joint 6's internal connection",
    "isShowConfirm": "1"
  },
  "0x155480": {
    "description": "Servo in Joint 6 has exceeded the power limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Servo in Joint 6 has exceeded the power limit",
    "isShowConfirm": "1"
  },
  "0x156000": {
    "description": "Abnormal internal status of absolute encoder in Joint 6",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The driver has detected an abnormal operation status of the absolute encoder.",
    "action": "Confirm whether there is strong electric field or strong magnetic field interference in the field environment; confirm whether the power supply of the absolute encoder is normal; confirm whether the connecting wire between the absolute encoder and the driver is loose and check whether the connecting wire is broken.",
    "tittle": "Joint 6 Absolute Encoder Internal Error",
    "isShowConfirm": "1"
  },
  "0x156010": {
    "description": "Encoder temperature of Joint 6 is too high.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The temperature of the encoder exceeds the normal range.",
    "action": "1. Please check the temperature of the joint, if it has exceeded the allowable range, please lower it. \n2. Please contact the technical service team to check if the joint and encoder are functioning normally.",
    "tittle": "Encoder temperature of Joint 6 is too high",
    "isShowConfirm": "1"
  },
  "0x157180": {
    "description": "Joint 6's motor is overloading.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The motor was outputting too much current for a while.",
    "action": "1. Please check for any collision that happened before this error occurs. \n2. Please check if the actual payload of the joint has largely exceeded the standard payload of the robot. \n3. Please contact the technical service team to check the parameters of this joint. \n4. Please manually drag the robot to check if the joint's brake is functioning normally. \n5. Please contact the technical service team to check if the joint was not moving smoothly. \n6. Please contact the technical service team to check if the motor's rotor is functioning normally, or if the ABZ encoder can be read normally.",
    "tittle": "Joint 6's motor is overloading",
    "isShowConfirm": "1"
  },
  "0x157181": {
    "description": "Joint 6's motor brake is not functioning normally.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Electromagnet undetected.",
    "action": "1. Please check if the connection cable of the joint's electromagnet is in normal conditions. \n2. Please check to see if the resistance value of the electromagnet is correct.",
    "tittle": "Joint 6's motor brake is not functioning normally",
    "isShowConfirm": "1"
  },
  "0x157182": {
    "description": "Joint 6's motor is on the opposite moving direction.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The actual magnetic pole direction of the motor doesn't match the calculated pulse injection, causing unusual controlling conditions.",
    "action": "1. Please contact the technical service team to check if the motor's parameters are correct. \n2. Please check if the motor's phrase sequence connection cables are correct. \n3. Please contact the technical service team to check if the joint's driver board is functioning normally.",
    "tittle": "Joint 6's motor is on the opposite moving direction",
    "isShowConfirm": "1"
  },
  "0x157185": {
    "description": "Joint 6 motor brake current is unusual",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Current detected in joint 6 brake when closed, or current exceeds 2A when brake is open.",
    "action": "1. Check if the connection with the joint brake cable is working properly.\n2. Check if there is a short circuit in the joint brake.",
    "tittle": "Joint 6 motor brake current is unusual",
    "isShowConfirm": "1"
  },
  "0x157380": {
    "description": "Joint 6's encoder connection timeout.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in reading the status of the absolute encoder.",
    "action": "1. Please contact the technical service team to check if the production parameters of this joint are correct.\n2. Please contact the technical service team to replace the encoder connection cable to see if the fault is resolved.\n3. Please contact the technical service team to inspect if there are any irregular situations in the encoder's status light.",
    "tittle": "Joint 6's encoder connection timeout",
    "isShowConfirm": "1"
  },
  "0x157381": {
    "description": "Low voltage in the encoder battery for Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The voltage in the encoder battery is low.",
    "action": "1. Production parameter verification: Please contact the technical service team to confirm if the production parameters of this joint are correct.\n2. Wiring inspection: Remove the joint lid to check if any of the encoder's wiring is loose. If so, please contact the technical service team for replacement.\n3. Encoder malfunction: Replace the joint's encoder or replace the entire joint.",
    "tittle": "Low voltage in the encoder battery for Joint 6",
    "isShowConfirm": "1"
  },
  "0x157382": {
    "description": "Encoder battery disconnected in Joint 6.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Encoder power supply error.",
    "action": "1. If this error occurs when power on or off the robot, no further measures need to be taken.\n2. If the encoder is damaged, and this error continues to occur and bother, please contact the technical service team for replacement.",
    "tittle": "Encoder battery disconnected in Joint 6",
    "isShowConfirm": "1"
  },
  "0x157383": {
    "description": "The angle stored in Joint 6's encoder is wrong.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurs in the joint motor's position calibration.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct. \n2. Please contact the technical service team to recalibrate the Z value of the joint.",
    "tittle": "The angle stored in Joint 6's encoder is wrong",
    "isShowConfirm": "1"
  },
  "0x157384": {
    "description": "Wrong count in Joint 6's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Wrong count in the relative encoder.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Wrong count in Joint 6's encoder",
    "isShowConfirm": "1"
  },
  "0x157385": {
    "description": "Verification error in Joint 6's two encoders.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The deviation of position between the absolute encoder and the relative has exceeded the threshold.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please confirm if there has been a severe collision or mechanical failure, and contact the technical service team. \n3. Please contact the technical service team to inspect the encoder's installation or check for any dirt or contamination on the encoder disc.",
    "tittle": "Verification error in Joint 6's two encoders",
    "isShowConfirm": "1"
  },
  "0x157386": {
    "description": "Internal errors of the Joint 6's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the controller is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Internal errors of the Joint 6's encoder",
    "isShowConfirm": "1"
  },
  "0x157387": {
    "description": "Joint 6's Z signal is missing.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The Z signal of the relative encoder is missing.",
    "action": "1. Please contact the technical service team to verify if the production parameters of this joint are correct.\n2. Please contact the technical service team to check the relative encoder for any necessary repair.",
    "tittle": "Joint 6's Z signal is missing",
    "isShowConfirm": "1"
  },
  "0x157388": {
    "description": "Unusual magnetic signals from the Joint 6's encoder.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It can be errors in the encoder's signal amplitude and magnetic mode, or signal loss or signal irregularities.",
    "action": "1. Please check if this error occurs in a specific joint. Contact the technical service team to verify it the joint and the encoder are functioning normally. \n2. Please make sure the robot itself and its working environment are not interfered by external signals, especially magnetic signals.",
    "tittle": "Unusual magnetic signals from the Joint 6's encoder",
    "isShowConfirm": "1"
  },
  "0x157389": {
    "description": "Joint 6 has an incremental encoder connection error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Incremental encoder data did not change during pulse injection micro-movement after powering on joint 6",
    "action": "1. Check if the connection with the incremental encoder cable connection is working properly.\n2. Check if the incremental encoder read head is damaged.\n3. Check if the code disc is smeared for a large area.",
    "tittle": "Joint 6 has an incremental encoder connection error",
    "isShowConfirm": "1"
  },
  "0x157580": {
    "description": "Joint 6 torque feedforward has exceeded the limit.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque feedforward has exceeded the servo threshold.",
    "action": "Please contact the technical service team.",
    "tittle": "Joint 6 torque feedforward has exceeded the limit",
    "isShowConfirm": "1"
  },
  "0x158000": {
    "description": "Joint 6's position has deviated.",
    "type": "2",
    "isShowOTA": "1",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 6's position has deviated",
    "isShowConfirm": "1"
  },
  "0x158001": {
    "description": "Joint 6 position deviation alarm.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "According to the servo's position tracking deviation, a collision might have occurred.",
    "action": "1. Please check if the robot has collided with something. \n2. Please check if the robot's acceleration was too large. \n3. Please check if the robot's payload has exceeded its allowable range. \n4. Please check if the mounting pose of the robot in the software is aligned with its actual pose. \n5. Please check if the motion segment transition is used correctly.",
    "tittle": "Joint 6 position deviation alarm",
    "isShowConfirm": "0"
  },
  "0x158480": {
    "description": "Joint 6 forward speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the same direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 6 forward speed tracking error",
    "isShowConfirm": "1"
  },
  "0x158481": {
    "description": "Joint 6 reverse speed tracking error.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the actual speed and the set speed are in the opposite direction, their speed error exceeds the set alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly.",
    "tittle": "Joint 6 reverse speed tracking error",
    "isShowConfirm": "1"
  },
  "0x158482": {
    "description": "Excessive speed detected in Joint 6.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The actual speed of the joint exceeds its rated speed.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive speed detected in Joint 6",
    "isShowConfirm": "1"
  },
  "0x158483": {
    "description": "The speed tracking error for Joint 6 is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the alarm threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The speed tracking error for Joint 6 is too large",
    "isShowConfirm": "1"
  },
  "0x158484": {
    "description": "Joint 6's acceleration has exceeded the allowable margin of error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Abandon",
    "action": "Please check if the servo is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "Joint 6's acceleration has exceeded the allowable margin of error",
    "isShowConfirm": "1"
  },
  "0x158485": {
    "description": "Joint 6 speed control error.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual joint speed and the demanded speed exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Joint 6 speed control error",
    "isShowConfirm": "1"
  },
  "0x158501": {
    "description": "Joint 6: Servo enabling is prohibited in reverse drive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint 6: Servo enabling is prohibited in reverse drive mode",
    "action": "Please exit the reverse drive mode and enable again.",
    "tittle": "Joint 6: Servo enabling is prohibited in reverse drive mode",
    "isShowConfirm": "1"
  },
  "0x158611": {
    "description": "Excessive deviation in Joint 6's position.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The deviation between the actual position and the commanded position has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive deviation in Joint 6's position",
    "isShowConfirm": "1"
  },
  "0x158612": {
    "description": "The increment of Joint 6's command position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The increment of Joint 6's command position is too large that it exceeds the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The increment of Joint 6's command position is too large",
    "isShowConfirm": "1"
  },
  "0x158613": {
    "description": "Excessive acceleration in Joint 6.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The acceleration in Joint 6 has exceeded the threshold.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please check if the robot has collided with any object, or the payload value was set correctly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "Excessive acceleration in Joint 6",
    "isShowConfirm": "1"
  },
  "0x158614": {
    "description": "The distance between Joint 6's commanded position and the servo's current position is too large.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "The controller gave the wrong position command.",
    "action": "1. Please check if the acceleration of the command is too fast. \n2. Please check if the motion segment transition parameters are correct. \n3. Please contact the technical service team to check if the robot's bus communication is functioning properly. \n4. If it's in servo mode, please check if the command sent was continuous or unusual, and if the inverse kinematics calculation for position was continuous or unusual.",
    "tittle": "The distance between Joint 6's commanded position and the servo's current position is too large",
    "isShowConfirm": "1"
  },
  "0x158615": {
    "description": "Error occurs in Joint 6's CAN communication.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's bus communication is not functioning normally.",
    "action": "Please contact the technical service team to check the bus communication.",
    "tittle": "Error occurs in Joint 6's CAN communication",
    "isShowConfirm": "1"
  },
  "0x158616": {
    "description": "joint 6 temperature sensor communication error",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint internal temperature sensor error",
    "action": "Please check the temperature sensor of the IIC interface.",
    "tittle": "joint 6 temperature sensor communication error",
    "isShowConfirm": "1"
  },
  "0x158617": {
    "description": "Joint 6 detected fluctuation in CAN communication cycle",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Significant fluctuations in the CAN communication cycle were detected multiple times in a short period in joint 6",
    "action": "1.Conduct fault diagnosis (diagnostics may already have been performed automatically due to other errors) and save the diagnostic package. Check for fluctuations in the CAN communication cycle (fluctuations within 4-12ms are considered normal).\n2.Check whether all switches on the SCB S2 are in the OFF position.\n3.Check for any looseness in the control cabinet's cable, the main body's cable, the robot connection cable and the CAN cable.",
    "tittle": "Joint 6: CAN communication cycle fluctuation warning",
    "isShowConfirm": "1"
  },
  "0x201002": {
    "description": "Failed to initialize the TIO after the robot is powered on.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "No TIO data is received within 1s after the communication of all joints has been established.",
    "action": "Please check if the connection cable and power cable of TIO are connected properly; Please check if the TIO panel has seeable damages; Please contact the manufacture for help.",
    "tittle": "Failed to initialize the TIO",
    "isShowConfirm": "0"
  },
  "0x201101": {
    "description": "Failed initialization of extended IO due to mismatched Modbus RTU communication parameters.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurred while attempting to connect Modbus slave IO modules based on the provided configuration.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3.Please confirm the power supply of the extended IO module is normal;\n4.Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Modbus RTU configuration error during extended IO initialization",
    "isShowConfirm": "1"
  },
  "0x201102": {
    "description": "Failed to establish Modbus RTU connection during extended IO initialization.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurred while attempting to connect Modbus slave IO modules based on the provided configuration.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Failed to establish Modbus RTU connection during extended IO initialization",
    "isShowConfirm": "1"
  },
  "0x201104": {
    "description": "The parameters of the extended IO's RTU serial bus are inconsistent.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Multiple RTU extended IO modules are configured, and each module has different serial bus parameters.",
    "action": "Modify the extended IO's RTU serial bus parameters to match those of the first RTU module's parameters across all modules.",
    "tittle": "The parameters of the extended IO's RTU serial bus are inconsistent",
    "isShowConfirm": "1"
  },
  "0x201201": {
    "description": "Failed initialization of extended IO due to mismatched Modbus RTU communication parameters.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurred while attempting to connect Modbus slave IO modules based on the provided configuration.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Modbus RTU configuration error during extended IO initialization",
    "isShowConfirm": "1"
  },
  "0x201202": {
    "description": "Failed to establish Modbus TCP connection during extended IO initialization.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurred while attempting to connect Modbus slave IO modules based on the provided configuration.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Failed to establish Modbus TCP connection during extended IO initialization",
    "isShowConfirm": "1"
  },
  "0x201304": {
    "description": "Unknown error occurs during initialization.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Error occurred while attempting to connect Modbus slave IO modules based on the provided configuration.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Unknown error occurs during extended IO initialization",
    "isShowConfirm": "1"
  },
  "0x202102": {
    "description": "The extended IO failed to run and the Modbus TCP node disconnected.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The connection between the Modbus TCP extended IO and the controller dropped during operation.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Modbus TCP node disconnected during extended IO operation",
    "isShowConfirm": "1"
  },
  "0x202103": {
    "description": "The extended IO failed to run and the Modbus RTU node disconnected.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The connection between the Modbus RTU extended IO and the controller dropped during operation.",
    "action": "1. Please confirm the type of extended IO module and its communication settings;\n2. Please make sure the communication connection between the control cabinet interface and the external extended IO module is normal;\n3. Please confirm the power supply of the extended IO module is normal;\n4. Try using Modbus Poll tool to connect to the extended IO to check if the module is malfunctioning.",
    "tittle": "Modbus RTU node disconnected during extended IO operation",
    "isShowConfirm": "1"
  },
  "0x302380": {
    "description": "The current of the fan is not normal.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The fan in the control cabinet is not normal or a short circuit occurs in the fan.",
    "action": "Please check the status of the fan.",
    "tittle": "The current of the fan is not normal",
    "isShowConfirm": "1"
  },
  "0x302381": {
    "description": "Primary warning for output body power supply current exception: 25A\nAbnormal current consumption of the robot body",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The current collected by the safety control board exceeds the set threshold.",
    "action": "Please check if the safety control board firmware is a debug version, or contact technical service personnel for related error code descriptions.",
    "tittle": "Primary Alarm for Body Current Exception",
    "isShowConfirm": "1"
  },
  "0x302382": {
    "description": "Output body power supply current abnormality level 2 warning: 31.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The current collected by the safety control board exceeds the set threshold.",
    "action": "Please check if the safety control board is a debug version or contact technical support for the error code description.",
    "tittle": "Abnormal Body Current Secondary Alarm",
    "isShowConfirm": "1"
  },
  "0x302383": {
    "description": "Output body power supply current abnormality level 3 warning: 37.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The current collected by the safety control board exceeds the set threshold.",
    "action": "Please check if the safety control board is a debug version or contact technical support for the error code description.",
    "tittle": "Body Current Abnormality Level 3 Alarm",
    "isShowConfirm": "1"
  },
  "0x302384": {
    "description": "The power supply current of the user IO is not normal (2.3A)",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The total current value of the 24V output on the control cabinet panel has exceeded 1.5A.",
    "action": "1. Please remove the devices on the control cabinet's panel to see if this issue persists;\n2. If the issue doesn't occur after step 1, it means user cannot use the control cabinet as the power supply for other devices;\n3. If the issue persists after step 1, try powering off the robot and restarting it. If nothing changes, please contact the technical service team to check for any damage on the hardware.",
    "tittle": "The power supply current of the user IO is not normal",
    "isShowConfirm": "1"
  },
  "0x302385": {
    "description": "The IPC current is not normal (if the current exceeds 1.5A, it indicates a short circuit, triggering an error report).",
    "type": "2",
    "isShowOTA": "0",
    "reason": "After powering up, the IPC is not connected, or the current of the IPC has exceeded 1.5A.",
    "action": "Please contact the technical service team to check if the hardware of the IPC is functioning normally.",
    "tittle": "The IPC current is not normal",
    "isShowConfirm": "1"
  },
  "0x302391": {
    "description": "Power limit of the robot is not normal.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The power limit of the robot calculated by the safety control board has exceeded the set limit.",
    "action": "1. Please reset the power limit in Safety Settings.\n2. Please contact the technical service team to check if it's the hardware's issue that caused the exceeding of the power limit.",
    "tittle": "Power limit of the robot is not normal",
    "isShowConfirm": "1"
  },
  "0x303181": {
    "description": "220V power supply is not normal.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Unusual amplitude and frequency are detected by the control cabinet in the 220V signal.",
    "action": "1. Please verify the current voltage and frequency of the control cabinet's power supply. When using AC power above 110V with a frequency of 50-60Hz, the 220V power failure detection function will be active. If the control cabinet is powered by 90-110V AC, navigate to \"Settings - Hardware & Communication - Auxiliary Hardware Settings - Control Cabinet Power Supply Options\" and change the setting to \"Other\".\n2. Ensure the firmware is updated to the latest version and check if the issue persists.\n3. If steps 1 and 2 do not resolve the issue, check the amplitude and frequency of the power supply, as well as any variations in these parameters during operation.\n4. If steps 1 and 2 fail to resolve the issue and step 3 cannot be measured, check whether the control cabinet's power is being directly cut off during robot operation (including but not limited to unplugging the 220V power cord or factory power outages). If such interruptions are not present, you may temporarily set the \"Control Cabinet Power Supply Options\" to \"Other\" under \"Settings - Hardware & Communication - Auxiliary Hardware Settings\".",
    "tittle": "220V power supply voltage is not normal",
    "isShowConfirm": "1"
  },
  "0x303182": {
    "description": "Main power relay abnormality",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The relay controlling the 48V output has detected an output signal without power, indicating that the relay controlling the 48V power input signal is sticking.",
    "action": "1. Please update the safety control board firmware to the latest version and check if the issue persists;\n2. Please verify the amplitude and frequency of the control cabinet's supply voltage. Control cabinets with 90~110V AC power must use firmware versions with 'dis220v' written on them;\n3. If the issue remains after performing the above steps, please contact technical personnel to check if the relay controlling the 48V power in the control cabinet is damaged.",
    "tittle": "Main Power Relay Abnormality",
    "isShowConfirm": "1"
  },
  "0x303184": {
    "description": "The safety DI signal is not normal. The safety control board has detected this error but has not solved it yet, and it refused to power on the robot again.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Please check if the safety DI signal on the control cabinet's interface panel is normal. Make sure the safety DI signal is normal, then power on the robot again to clear the error.",
    "action": "",
    "tittle": "Safety signal is not normal, unable to power on",
    "isShowConfirm": "1"
  },
  "0x303281": {
    "description": "5V not normal (the fluctuation range of the power voltage)",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The internal 5V signal voltage of the control cabinet has exceeded the preset value (3.5-6.1V). You can use a multimeter to test the 5V signal voltage.",
    "action": "1. Please check if the firmware version is the latest. If not, update to the latest version and check if the issue persists;\n2. Please disconnect and reconnect the power supply of the control cabinet to check if the issue still exists. If so, please contact the technical service team to check the control cabinet;\n3. For standard 220V powered control cabinets, unplugging the 220V power supply will trigger this error, which is a normal occurrence.",
    "tittle": "5V power supply voltage is not normal",
    "isShowConfirm": "1"
  },
  "0x303282": {
    "description": "12V not normal (the fluctuation range of the power voltage)",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The internal 12V signal voltage of the control cabinet has exceeded the preset value (9-14V). You can use a multimeter to test the 12V signal voltage.",
    "action": "1. Please check if the firmware version is the latest. If not, update to the latest version and check if the issue persists;\n2. Please disconnect and reconnect the power supply of the control cabinet, and restart it to check if the issue still exists. If so, please contact the technical service team to check the control cabinet;\n3. For standard 220V powered control cabinets, unplugging the 220V power supply will trigger this error, which is a normal occurrence.",
    "tittle": "12V power supply voltage is not normal",
    "isShowConfirm": "1"
  },
  "0x303283": {
    "description": "24V not normal (the fluctuation range of the power voltage)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The internal 24V signal voltage of the control cabinet has exceeded the preset value (15-31V). You can use a multimeter to test the 24V signal voltage.",
    "action": "1. Please check if the firmware version is the latest. If not, update to the latest version and check if the issue persists;\n2. Please disconnect and reconnect the power supply of the control cabinet, and restart it to check if the issue still exists. If so, please contact the technical service team to check the control cabinet;\n3. For standard 220V powered control cabinets, unplugging the 220V power supply will trigger this error, which is a normal occurrence.",
    "tittle": "24V power supply voltage is not normal",
    "isShowConfirm": "1"
  },
  "0x303381": {
    "description": "The power voltage or its configuration of the robot is not normal.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The discharge voltage set on MiniCAB is lower than its input voltage.",
    "action": "Please reset the discharging voltage on the App.",
    "tittle": "The voltage of the robot's output power supply is not normal",
    "isShowConfirm": "1"
  },
  "0x303387": {
    "description": "Safety Control Board Relay Abnormality",
    "type": "2",
    "isShowOTA": "0",
    "reason": "After turning off the main power, the safety control board detected that the voltage values of the two relays for the main power are inconsistent.",
    "action": "1. Please update to the latest firmware version and check if the issue persists. \n2. If the issue remains after the above steps, please contact technical personnel to inspect whether the internal relays of the safety control board are damaged.",
    "tittle": "Safety Control Board Relay Abnormality",
    "isShowConfirm": "1"
  },
  "0x304281": {
    "description": "PDU temperature is not normal.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The internal temperature of the control cabinet has exceeded 70℃.",
    "action": "1. Please check if the internal temperature of the control cabinet has exceeded 70℃;\n2. Please check if the fan within the control cabinet is functioning.",
    "tittle": "PDU temperature is not normal",
    "isShowConfirm": "1"
  },
  "0x304282": {
    "description": "The breaking resistor is overheating.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The temperature of the resistor within the MiniCAB has exceeded 80℃.",
    "action": "1. Please check the internal temperature of the MiniCAB;\n2. Please lower the robot's acceleration;\n3. Please add a fan to dissipate the heat.",
    "tittle": "The breaking resistor is overheating",
    "isShowConfirm": "1"
  },
  "0x305081": {
    "description": "Control stick emergency stop safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please try another control stick, or contact the JAKA technical service team to check the control cabinet's SCB circuit.",
    "tittle": "Control stick emergency stop safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305082": {
    "description": "External emergency stop safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check the interface panel to see if the P8 port's connection is malfunctioning, and check if the external circuit is functioning properly.",
    "tittle": "External emergency stop safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305083": {
    "description": "The safeguard stop signals differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check the interface panel to see if the P8 port's connection is malfunctioning, and check if the external circuit is functioning properly.",
    "tittle": "The safeguard stop signals differ",
    "isShowConfirm": "1"
  },
  "0x305084": {
    "description": "SCB's relay is malfunctioning",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the SCB is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "SCB's relay is malfunctioning",
    "isShowConfirm": "1"
  },
  "0x305085": {
    "description": "SCB's relay is overheating",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the SCB is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "SCB's relay is overheating",
    "isShowConfirm": "1"
  },
  "0x305086": {
    "description": "The control stick cannot be enabled normally",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the SCB is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "The control stick cannot be enabled normally",
    "isShowConfirm": "1"
  },
  "0x305087": {
    "description": "Additional emergency stop safety signal inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Additional emergency stop safety signal inputs differ",
    "isShowConfirm": "1"
  },
  "0x305088": {
    "description": "The additional safeguard stop safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "The additional safeguard stop safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305089": {
    "description": "The safeguard reset safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "The safeguard reset safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x30508A": {
    "description": "The reduced mode safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "The reduced mode safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x30508B": {
    "description": "Three position enable safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Three position enable safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305090": {
    "description": "Turn off collision detection safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Turn off collision detection safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305091": {
    "description": "Set collision sensitivity LV1 safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity LV1 safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305092": {
    "description": "Set collision sensitivity LV2 safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity LV2 safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305093": {
    "description": "Set collision sensitivity LV3 safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity LV3 safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305094": {
    "description": "Set collision sensitivity LV4 safety inputs differ",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity LV4 safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305095": {
    "description": "Set collision sensitivity LV5 safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity LV5 safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x305097": {
    "description": "Set collision sensitivity extremely low safety inputs differ.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The safety signal has dual redundancy channels, which will enter a safe state when the two signals differ.",
    "action": "Please check if there are any unusual circumstances in the safety input circuit connection.",
    "tittle": "Set collision sensitivity extremely low safety inputs differ",
    "isShowConfirm": "1"
  },
  "0x308181": {
    "description": "Handle CAN Communication Interruption",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Data error between the safety control board and the handlebus.",
    "action": "1. Please check if the cable connection between the handle and the electrical control cabinet is normal.\n2. Please contact technical personnel to inspect if there is any anomaly in the CAN bus between the safety control board and the control cabinet CAN2.",
    "tittle": "Handle CAN Communication Interruption",
    "isShowConfirm": "1"
  },
  "0x308182": {
    "description": "Controller CAN Communication Interruption",
    "type": "2",
    "isShowOTA": "0",
    "reason": "No commands have been received from the controller to the body after powering on the robot for a period of time.",
    "action": "1. Please update the firmware of the safety control board to the latest version and check if the issue persists.\n2. Check the data for joints 1 to 6 in the App monitor to see if it is being refreshed.\n3. Check if the end indicator light on the body is on; if not, check if the wiring is correct.",
    "tittle": "Controller CAN Communication Interruption",
    "isShowConfirm": "1"
  },
  "0x308183": {
    "description": "Robot CAN communication was interrupted.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot has not received any signal send from the controller long after powered on.",
    "action": "1. Please upgrade  the safety control board  firmware to the newest version to see if this error recurs;\n2. Please monitor the data of Joint 1 to 6 on the App for any updates;\n3. Please check if the indicator light on the robot end is shining or not. If not, please check to make sure the wiring is proper.",
    "tittle": "Robot CAN communication was interrupted",
    "isShowConfirm": "1"
  },
  "0x308184": {
    "description": "TIO CAN communication was interrupted.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "No instructions from the controller have been received by the robot's body for a period after powering on.",
    "action": "1. Please update the firmware of the safety control board to the latest version and check if the fault persists.\n2. Monitor the data of joints 1 to 6 on the App or the servo monitoring page to see if it is updating.\n3. Check if the indicator light at the end of the robot is on. If not, verify if the wiring is correct.",
    "tittle": "TIO CAN Communication Interruption",
    "isShowConfirm": "1"
  },
  "0x308185": {
    "description": "Waiting for CAN communication normal timeout",
    "type": "2",
    "isShowOTA": "0",
    "reason": "No instructions have been received from the controller to the robot body for some time after powering on.",
    "action": "1. Please update the firmware of the safety control board to the latest version and check if the fault persists;\n2. Check if the data for joints 1 to 6 is refreshing on the App monitoring page or servo monitoring page;\n3. Check if the indicator light at the end of the robot is on. If not, verify if the wiring is correct.",
    "tittle": "Waiting for CAN Communication Normal Timeout",
    "isShowConfirm": "1"
  },
  "0x309081": {
    "description": "Drag mode TCP speed exceeds the limit",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The TCP speed in drag mode exceeds the limit of {0} mm/s, the current TCP speed is {1} mm/s.",
    "action": "Please reduce the dragging speed. If the TCP speed exceeds the limit in drag mode, the robot will exit drag mode.",
    "tittle": "Drag mode TCP speed exceeds the limit",
    "isShowConfirm": "1"
  },
  "0x309082": {
    "description": "Emergency stop is triggered.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Any of the emergency stop function is triggered among the control stick, SI/EI, and safety function IO.",
    "action": "Please check which one has been triggered.",
    "tittle": "Emergency stop is triggered",
    "isShowConfirm": "1"
  },
  "0x309083": {
    "description": "The power limit of the robot has reached the threshold",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Abandon",
    "action": "Please check if the SCB is in debugging mode, or to contact the technical service team for detailed information on the error code.",
    "tittle": "The power limit of the robot has reached the threshold",
    "isShowConfirm": "1"
  },
  "0x3F0001": {
    "description": "Force sensor communication initialization failed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "When the sensor is activated, the controller would connect with the sensor based on the communication configuration. It will return to this error when the connection failed.",
    "action": "1. Please confirm the type of force sensor and the communication settings;\n2. Please make sure the communication connection between the control cabinet's interface and the force sensor is normal;\n3. Please confirm the power supply of the force sensor is normal;\n4. Try using Modbus debugging tools or network debugging tools to connect to the force sensor and check if it is functioning properly.",
    "tittle": "Force sensor communication initialization failed",
    "isShowConfirm": "1"
  },
  "0x3F0002": {
    "description": "Turning on the force sensor too often",
    "type": "1",
    "isShowOTA": "0",
    "reason": "It takes about 1 second to turn on the sensor and establish communication, frequent attempts to turn on the force sensor within a short period of time will trigger this warning.",
    "action": "Please try again later.",
    "tittle": "Turning on the force sensor too often.",
    "isShowConfirm": "1"
  },
  "0x3F1001": {
    "description": "Failed to receive the data from the force sensor.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the connection between the controller and sensor drops during operation.",
    "action": "1. Please confirm the type of force sensor and the communication settings;\n2. Please make sure the communication connection between the control cabinet's interface and the force sensor is normal;\n3. Please confirm the power supply of the force sensor is normal;\n4. Try using Modbus debugging tools or network debugging tools to connect to the force sensor and check if it is functioning properly.",
    "tittle": "Failed to receive the data from the force sensor",
    "isShowConfirm": "1"
  },
  "0x3F1002": {
    "description": "Wrong format of the received data from the force sensor.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "This error occurs when the format of the data that received by the force sensor is wrong.",
    "action": "1. Please confirm the type of force sensor and its communication protocol;\n2. Try to analyze the received force sensor data by using Modbus debugging tools, network debugging tools, or serial port debugging tools to determine if it complies with the communication protocol of the JAKA+ force sensor.",
    "tittle": "Wrong format of the received data from the force sensor",
    "isShowConfirm": "1"
  },
  "0x3F1003": {
    "description": "Abnormal force sensor data",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Sensor readings remain the same over a period of time. This error generally occurs when the force sensor is not responding.",
    "action": "Please try restarting the sensor later",
    "tittle": "Abnormal force sensor data",
    "isShowConfirm": "1"
  },
  "0x3F1004": {
    "description": "Abnormal force sensor data",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Exceeded the maximum range of the sensor.",
    "action": "1. Please confirm if the robot end has collided with other object; the sensor might be severely damaged after violent collision, which can be irreversible.",
    "tittle": "Abnormal force sensor data",
    "isShowConfirm": "1"
  },
  "0x3F1005": {
    "description": "Abnormal force sensor data",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The sensor data has changed radically and is now outside the safe range.",
    "action": "Please check whether there is a collision at the end of the robot. If it is not caused by a collision, you can try disconnecting the power supply to the robot and the load cell, and wait a while to re-apply power before trying to switch on the load cell.",
    "tittle": "Abnormal force sensor data",
    "isShowConfirm": "1"
  },
  "0x3F1006": {
    "description": "The end force sensor has been calibrated around this value: {0}.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "During the last operation, a sensor calibration or calibration result query command was issued. This prompt will appear after successful calibration or query. Note: If it is a sensor calibration command, the current pop-up result reflects the outcome of the calibration completed this time.",
    "action": "Please properly record this calibration result: {0}, and ensure the sum of sensor readings and this value remains within the sensor's measurement range during subsequent use.",
    "tittle": "End Force Sensor Calibration Result",
    "isShowConfirm": "1"
  },
  "0x10F0000": {
    "description": "System emergency stop has been triggered",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "System emergency stop has been triggered",
    "isShowConfirm": "1"
  },
  "0x10F0001": {
    "description": "System emergency stop has been reset",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "System emergency stop has been reset",
    "isShowConfirm": "1"
  },
  "0x10F0002": {
    "description": "The robot is powered on",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is powered on",
    "isShowConfirm": "0"
  },
  "0x10F0003": {
    "description": "The robot is powered off",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is powered off",
    "isShowConfirm": "0"
  },
  "0x10F0004": {
    "description": "The robot is enabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is enabled",
    "isShowConfirm": "0"
  },
  "0x10F0005": {
    "description": "The robot is disabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is disabled",
    "isShowConfirm": "0"
  },
  "0x10F0006": {
    "description": "The decelerated mode is off",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The decelerated mode is off",
    "isShowConfirm": "0"
  },
  "0x10F0007": {
    "description": "The robot is in level 1 decelerated mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is in level 1 decelerated mode",
    "isShowConfirm": "0"
  },
  "0x10F0008": {
    "description": "The robot is in level 2 decelerated mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot is in level 2 decelerated mode",
    "isShowConfirm": "0"
  },
  "0x10F0009": {
    "description": "Safeguard stop mode is on",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safeguard stop mode is on",
    "isShowConfirm": "1"
  },
  "0x10F000A": {
    "description": "Collision protection is off",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Collision protection is off",
    "isShowConfirm": "1"
  },
  "0x10F000B": {
    "description": "Collision protection is on",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Collision protection is on",
    "isShowConfirm": "1"
  },
  "0x10F000C": {
    "description": "Robot joint limit status has been restored",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Robot joint limit status has been restored",
    "isShowConfirm": "0"
  },
  "0x10F000D": {
    "description": "Conveyor tracking is on",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Conveyor tracking is on",
    "isShowConfirm": "0"
  },
  "0x10F000E": {
    "description": "Conveyor tracking is off",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Conveyor tracking is off",
    "isShowConfirm": "0"
  },
  "0x10F000F": {
    "description": "Compliant control is on",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Compliant control is on",
    "isShowConfirm": "0"
  },
  "0x10F0010": {
    "description": "Compliant control is off",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Compliant control is off",
    "isShowConfirm": "0"
  },
  "0x10F0011": {
    "description": "Freedrive mode is on",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Freedrive mode is on ",
    "isShowConfirm": "0"
  },
  "0x10F0012": {
    "description": "Freedrive mode is off",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Freedrive mode is off",
    "isShowConfirm": "0"
  },
  "0x10F0013": {
    "description": "Robot enters tool drag mode",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Robot enters tool drag mode",
    "isShowConfirm": "0"
  },
  "0x10F0014": {
    "description": "Robot has exited tool drag mode",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Robot has exited tool drag mode",
    "isShowConfirm": "0"
  },
  "0x10F0015": {
    "description": "Robot SERVO move mode is on",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Robot SERVO move mode is on",
    "isShowConfirm": "0"
  },
  "0x10F0016": {
    "description": "Robot SERVO move mode is off",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Robot SERVO move mode is off",
    "isShowConfirm": "0"
  },
  "0x10F0017": {
    "description": "The robot has entered a dangerous area",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot has crossed the safety zone and entered the danger zone.",
    "action": "Please confirm whether the safety zone settings meet expectations. For troubleshooting, you may disable the safety plane function or direct the robot to move within the safety zone.",
    "tittle": "The robot has entered a dangerous area",
    "isShowConfirm": "1"
  },
  "0x10F0018": {
    "description": "The robot has moved back to the safety plane",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The robot has moved back to the safety plane",
    "isShowConfirm": "0"
  },
  "0x10F0019": {
    "description": "The speed limit in Cartesian space is activated",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The speed limit in Cartesian space is activated",
    "isShowConfirm": "0"
  },
  "0x10F001A": {
    "description": "The speed limit in Cartesian space is stopped",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The speed limit in Cartesian space is stopped",
    "isShowConfirm": "0"
  },
  "0x10F001B": {
    "description": "Start the program",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Start the program",
    "isShowConfirm": "0"
  },
  "0x10F001C": {
    "description": "Pause the program",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Pause the program",
    "isShowConfirm": "0"
  },
  "0x10F001D": {
    "description": "Resume the program",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Resume the program",
    "isShowConfirm": "0"
  },
  "0x10F001E": {
    "description": "Stop the program",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Stop the program",
    "isShowConfirm": "0"
  },
  "0x10F001F": {
    "description": "The robot is about to enter a dangerous area",
    "type": "2",
    "isShowOTA": "0",
    "reason": "The robot is about to enter a dangerous area from a safe zone.",
    "action": "Please confirm whether the safety zone settings meet expectations. For troubleshooting, you may disable the safety plane function or direct the robot to move within the safety zone.",
    "tittle": "The robot is about to enter a dangerous area",
    "isShowConfirm": "1"
  },
  "0x10F0020": {
    "description": "Reduced mode on",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Reduced mode on",
    "isShowConfirm": "0"
  },
  "0x10F0021": {
    "description": "Reduced mode off",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Reduced mode off",
    "isShowConfirm": "0"
  },
  "0x10F0022": {
    "description": "Reducing in the robot's momentum is triggered",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Reducing in the robot's momentum is triggered",
    "isShowConfirm": "0"
  },
  "0x10F0023": {
    "description": "Reducing in the robot's power limit is triggered",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Reducing in the robot's power limit is triggered",
    "isShowConfirm": "0"
  },
  "0x10F0024": {
    "description": "Safeguard stop mode off",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "Safeguard stop mode off",
    "isShowConfirm": "1"
  },
  "0x10F0025": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Safety checksum has changed",
    "action": "",
    "tittle": "The Safety Settings have changed",
    "isShowConfirm": "0"
  },
  "0x10F0026": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The initial pose in safety checksum has changed from {2} to {3}",
    "action": "",
    "tittle": "The initial pose in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F0027": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The initial pose tolerance in safety checksum has changed from {2} to {3}",
    "action": "",
    "tittle": "The initial pose tolerance in safety checksum has changed",
    "isShowConfirm": "0"
  },
  "0x10F0028": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The controller's move mode has changed from {2} to {3}",
    "action": "",
    "tittle": "The controller's move mode in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F0029": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint {2}'s negative limit has changed from {3} to {4}",
    "action": "",
    "tittle": "The joint's negative limit in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F002A": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint {2}'s positive limit has changed from {3} to {4}",
    "action": "",
    "tittle": "The joint's positive limit in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F002B": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DI {2}'s configured safety function code has changed from {3} to {4}",
    "action": "",
    "tittle": "The safety function DI in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F002C": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DO {2}'s configured safety function code has changed from {3} to {4}",
    "action": "",
    "tittle": "The safety function DO in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F002D": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's power limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The robot's power limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F002E": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's TCP speed limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The robot's TCP speed limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F002F": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The stop distance has changed from {2} to {3}",
    "action": "",
    "tittle": "The stop distance in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F0030": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The stop time has changed from {2} to {3}",
    "action": "",
    "tittle": "The stop time in Safety Settings has changed",
    "isShowConfirm": "0"
  },
  "0x10F0031": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The elbow limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The elbow limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F0032": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The momentum limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The momentum limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F0033": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint {2}'s speed limit has changed from {3} to {4}",
    "action": "",
    "tittle": "The joint speed limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F0034": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Joint {2}'s error alarm threshold has changed from {3} to {4}",
    "action": "",
    "tittle": "The joint error alarm threshold has changed",
    "isShowConfirm": "0"
  },
  "0x10F0035": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The original tool pose limit were: \nCoordinate System {2}, Tool Direction X: {3}, Tool Direction Y: {4}, Limit Range: {5}, Safe Distance: {6}, Limit Direction RX: {7}, RY: {8}, RZ: {9}, Run Enable: {10}, Power on Enabled: {11};\nThe current tool pose limit are: \nCoordinate System {12}, Tool Direction X: {13}, Tool Direction Y: {14}, Limit Range: {15}, Safe Distance: {16}, Limit Direction RX: {17}, RY: {18}, RZ: {19}, Run Enable: {20}, Power on Enabled: {21}.",
    "action": "",
    "tittle": "The tool pose limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F0036": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The original collision processing settings were: \nCollision Detection Method: {2}, Post-collision Handling Option: {3}, Collision Bounce Angle: {4}, Collision Bounce Distance: {5}, Bounce Joint Acceleration: {6}, Bounce Joint Speed: {7}, Bounce Linear Acceleration: {8}, Bounce Linear Speed: {9}\nThe current collision processing settings are: \nCollision Detection Method: {10}, Post-collision Handling Option: {11}, Collision Bounce Angle: {12}, Collision Bounce Distance: {13}, Bounce Joint Acceleration: {14}, Bounce Joint Speed: {15}, Bounce Linear Acceleration: {16}, Bounce Linear Speed: {17}",
    "action": "",
    "tittle": "The collision processing settings have changed",
    "isShowConfirm": "0"
  },
  "0x10F0037": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The torque limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The servo joint torque limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F0038": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The original startup default loading configuration was: \nDefault loading: {2}; Program: {3}\nThe current startup default loading configuration is: \nDefault loading: {4}; Program: {5}",
    "action": "",
    "tittle": "The default loading configuration at startup has changed",
    "isShowConfirm": "0"
  },
  "0x10F0039": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The automatically enable status has changed from {2} to {3}",
    "action": "",
    "tittle": "\"The robot runs automatically when enabled\" has changed",
    "isShowConfirm": "0"
  },
  "0x10F003A": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "\"Load default program on startup\" has changed from {2} to {3}",
    "action": "",
    "tittle": "\"Load default program on startup\" has changed",
    "isShowConfirm": "0"
  },
  "0x10F003B": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Original parameters:\nSafety zone enable method: {2}, Handling method after reaching/exceeding safety zone: {3}, Elbow position limit enabled: {4}\nNew parameters:\nSafety zone enable method: {5}, Handling method after reaching/exceeding safety zone: {6}, Elbow position limit enabled: {7}",
    "action": "",
    "tittle": "The Safety zone configurations have changed",
    "isShowConfirm": "0"
  },
  "0x10F003C": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety checksum has changed during initialization",
    "isShowConfirm": "1"
  },
  "0x10F003D": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The force limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The force limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F003F": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The joint sensitivity has changed from {2} to {3}",
    "action": "",
    "tittle": "The joint sensitivity has changed",
    "isShowConfirm": "0"
  },
  "0x10F0040": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The enabled status has changed from {2} to {3}",
    "action": "",
    "tittle": "The collision enabled status has changed",
    "isShowConfirm": "0"
  },
  "0x10F0041": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Plane {2}:\n Original Parameters:\n  Plane Name: {3}, Enabled: {4}, Safety Distance: {5}, Collision Level: {6}, Plane Hidden: {7}\n New Parameters:\n  Plane Name: {8}, Enabled: {9}, Safety Distance: {10}, Collision Level: {11}, Plane Hidden: {12}",
    "action": "",
    "tittle": "The single safety zone configuration has changed",
    "isShowConfirm": "0"
  },
  "0x10F0042": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Plane {2}:\nThe original parameters were: \n  Plane Point 1: {3}, Plane Point 2: {4}, Plane Point 3: {5}, Security Point: {6}\nThe current parameters are: \n  Plane Point 1: {7}, Plane Point 2: {8}, Plane Point 3: {9}, Security Point: {10}",
    "action": "",
    "tittle": "The Plane Points of one single plane have changed",
    "isShowConfirm": "0"
  },
  "0x10F0043": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's power limit in reduce mode has changed from {2} to {3}",
    "action": "",
    "tittle": "The robot's power limit in reduce mode has changed",
    "isShowConfirm": "0"
  },
  "0x10F0044": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "momentum limit in reduced mode has changed from {2} to {3}",
    "action": "",
    "tittle": "Momentum limit in reduced mode has changed",
    "isShowConfirm": "0"
  },
  "0x10F0045": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's TCP speed limit in reduced mode has changed from {2} to {3}",
    "action": "",
    "tittle": "The robot's TCP speed limit in reduced mode has changed",
    "isShowConfirm": "0"
  },
  "0x10F0046": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Stop distance in reduce mode has changed from {2} to {3}",
    "action": "",
    "tittle": "Stop distance in reduce mode has changed",
    "isShowConfirm": "0"
  },
  "0x10F0047": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Stop time in reduce mode has changed from {2} to {3}",
    "action": "",
    "tittle": "Stop time in reduce mode has changed",
    "isShowConfirm": "0"
  },
  "0x10F0048": {
    "description": "Do not power on during an emergency stop.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "When an emergency stop occurs, the power-on operation cannot be performed.",
    "action": "Please reset the emergency stop and then perform the power-on operation again.",
    "tittle": "Do not power on during an emergency stop",
    "isShowConfirm": "1"
  },
  "0x10F0049": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The robot's TCP drag speed limit has changed from {2} to {3}",
    "action": "",
    "tittle": "The robot's TCP drag speed limit has changed",
    "isShowConfirm": "0"
  },
  "0x10F004A": {
    "description": "Enabling operation is prohibited in backdrive mode",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Enabling operation via SDK, IO, and other control sources is prohibited in backdrive mode",
    "action": "Please exit reverse drive mode before attempting again.",
    "tittle": "Enabling operation is prohibited in backdrive mode",
    "isShowConfirm": "1"
  },
  "0x10F004B": {
    "description": "",
    "type": "1",
    "isShowOTA": "0",
    "reason": "In backdrive mode, power off operation via SDK, IO, and other control sources is prohibited",
    "action": "Please exit reverse drive mode before attempting again.",
    "tittle": "Power off operation is prohibited in backdrive mode",
    "isShowConfirm": "1"
  },
  "0x10F004C": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Plane {2}:\n Original Parameters:\n  Plane Enable DI Configuration: {3}, Plane Status DO Configuration: {4}\n New Parameters:\n  Plane Enable DI Configuration: {5}, Plane Status DO Configuration: {6}",
    "action": "",
    "tittle": "The single safety zone configuration has changed",
    "isShowConfirm": "0"
  },
  "0x10F004D": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Cube {2}:\n Original Parameters:\n  Cube Name: {3}, Enabled: {4}, Internal Safety: {5}, Cube Hidden: {6}, Reference Coordinate System ID: {7}, Collision Level: {8}, Safety Distance: {9}\n New Parameters:\n  Cube Name: {10}, Enabled: {11}, Internal Safety: {12}, Cube Hidden: {13}, Reference Coordinate System ID: {14}, Collision Level: {15}, Safety Distance: {16}",
    "action": "",
    "tittle": "Single Safety Cube Configuration Change",
    "isShowConfirm": "0"
  },
  "0x10F004E": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Cube {2}:\n Original Parameters:\n  Reference Coordinate: {3}, Diagonal Point 1: {4}, Diagonal Point 2: {5}\n New Parameters:\n  Reference Coordinate: {6}, Diagonal Point 1: {7}, Diagonal Point 2: {8}",
    "action": "",
    "tittle": "Single Safety Cube Configuration Change",
    "isShowConfirm": "0"
  },
  "0x10F004F": {
    "description": "Safety checksum has changed from {0} to {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Cube {2}:\n Original Parameters:\n  Cube Enable DI Configuration: {3}, Cube Status DO Configuration: {4}\n New Parameters:\n  Cube Enable DI Configuration: {5}, Cube Status DO Configuration: {6}",
    "action": "",
    "tittle": "Single Safety Cube Configuration Change",
    "isShowConfirm": "0"
  },
  "0x10F0051": {
    "description": "The safety function is triggered and has not slowed down to a safe speed within the expected stopping time",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The speed and degree monitoring of the safety monitoring function exceed the limit",
    "action": "",
    "tittle": "The speed and degree monitoring of the safety monitoring function exceed the limit",
    "isShowConfirm": "1"
  },
  "0x10F0060": {
    "description": "Cannot resume program execution",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Program execution cannot be resumed during protective stop or collision status.",
    "action": "1. Automatically resume program execution after exiting protective stop.\n2. Attempt to resume program execution again after clearing the collision error state.",
    "tittle": "Cannot resume program execution",
    "isShowConfirm": "1"
  },
  "0x10F0061": {
    "description": "Cannot return to the initial position in the protective stop state.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Cannot return to the initial position in the protective stop state.",
    "action": "Trt to return to the initial position again after exiting the protective stop.",
    "tittle": "Failed to back to the initial position",
    "isShowConfirm": "1"
  },
  "0x10F0100": {
    "description": "Force sensor enabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Force sensor enabled",
    "isShowConfirm": "0"
  },
  "0x10F0101": {
    "description": "Force sensor disabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Force sensor disabled",
    "isShowConfirm": "0"
  },
  "0x10F0102": {
    "description": "The extended IO module is enabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The extended IO module is enabled",
    "isShowConfirm": "0"
  },
  "0x10F0103": {
    "description": "The extended IO module is disabled",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The extended IO module is disabled",
    "isShowConfirm": "0"
  },
  "0x10F0104": {
    "description": "The control stick is locked",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The control stick is locked",
    "isShowConfirm": "1"
  },
  "0x10F0105": {
    "description": "Force sensor lost",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Unable to communicate between the robot controller and the force sensor.",
    "action": "1. Please check if the force sensor is installed correctly;\n2. Check if the connection cable between the force sensor and the robot is damaged or loose.",
    "tittle": "Force sensor lost",
    "isShowConfirm": "0"
  },
  "0x10F0106": {
    "description": "End force condition triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "End force condition triggered",
    "isShowConfirm": "0"
  },
  "0x10F0200": {
    "description": "Function DI (run program) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (run program) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0201": {
    "description": "Function DI (pause program) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (pause program) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0202": {
    "description": "Function DI (resume program) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (resume program) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0203": {
    "description": "Function DI (stop program) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (stop program) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0204": {
    "description": "Function DI (power on the robot) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (power on the robot) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0205": {
    "description": "Function DI (power off the robot) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (power off the robot) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0206": {
    "description": "Function DI (enable the robot) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (enable the robot) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0207": {
    "description": "Function DI (disable the robot) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (disable the robot) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0208": {
    "description": "Function DI (enter the level 1 decelerated mode) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (enter the level 1 decelerated mode) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0209": {
    "description": "Function DI (enter the level 2 decelerated mode) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (enter the level 2 decelerated mode) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020A": {
    "description": "Function DI (enter the safeguard stop mode) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (enter the safeguard stop mode) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020B": {
    "description": "Function DI (return to initial position) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (return to initial position) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020C": {
    "description": "Function DI (clear collision) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (clear collision) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020D": {
    "description": "Function DI (freedrive mode on) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (freedrive mode on) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020E": {
    "description": "Function DI (freedrive mode off) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (freedrive mode off) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F020F": {
    "description": "Function DI (stop program or pause program) has been triggered, (run program) should not be executed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (stop program or pause program) has been triggered, (run program) should not be executed",
    "isShowConfirm": "1"
  },
  "0x10F0210": {
    "description": "Function DI (pause program) has been triggered, (resume program) should not be executed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (pause program) has been triggered, (resume program) should not be executed",
    "isShowConfirm": "1"
  },
  "0x10F0211": {
    "description": "Function DI (power off the robot) has been triggered, (power on the robot) should not be executed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (power off the robot) has been triggered, (power on the robot) should not be executed",
    "isShowConfirm": "1"
  },
  "0x10F0212": {
    "description": "Function DI (disable the robot) has been triggered, (enable the robot) should not be executed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DI (disable the robot) has been triggered, (enable the robot) should not be executed",
    "isShowConfirm": "1"
  },
  "0x10F0220": {
    "description": "Function DO (idle) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (idle) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0221": {
    "description": "Function DO (idle) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (idle) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0222": {
    "description": "Function DO (program paused) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (program paused) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0223": {
    "description": "Function DO (program paused) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (program paused) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0224": {
    "description": "Function DO (program running) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (program running) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0225": {
    "description": "Function DO (program running) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (program running) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0226": {
    "description": "Function DO (control system error) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (control system error) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0227": {
    "description": "Function DO (control system error) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (control system error) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0228": {
    "description": "Function DO (robot powered on) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (robot powered on) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0229": {
    "description": "Function DO (robot powered on) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (robot powered on) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F022A": {
    "description": "Function DO (robot enabled) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (robot enabled) has been set",
    "isShowConfirm": "0"
  },
  "0x10F022B": {
    "description": "Function DO (robot enabled) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (robot enabled) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F022C": {
    "description": "Function DO (moving) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (moving) has been set",
    "isShowConfirm": "0"
  },
  "0x10F022D": {
    "description": "Function DO (moving) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (moving) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F022E": {
    "description": "Function DO (stationary) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (stationary) has been set",
    "isShowConfirm": "0"
  },
  "0x10F022F": {
    "description": "Function DO (stationary) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (stationary) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0230": {
    "description": "Function DO (control system ready) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (control system ready) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0231": {
    "description": "Function DO (control system ready) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (control system ready) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0232": {
    "description": "Function DO (emergency stop state) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (emergency stop state) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0233": {
    "description": "Function DO (emergency stop state) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (emergency stop state) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0234": {
    "description": "Function DO (level 2 decelerated state) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (level 2 decelerated state) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0235": {
    "description": "Function DO (level 2 decelerated state) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (level 2 decelerated state) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0236": {
    "description": "Function DO (safeguard stop state) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (safeguard stop state) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0237": {
    "description": "Function DO (safeguard stop state) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (safeguard stop state) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0238": {
    "description": "Function DO (initial position) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (initial position) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0239": {
    "description": "Function DO (initial position) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (initial position) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0240": {
    "description": "Function DO (level 1 decelerated state) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (level 1 decelerated state) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0241": {
    "description": "Function DO (level 1 decelerated state) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Function DO (level 1 decelerated state) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0250": {
    "description": "Safety Function DI (additional emergency stop input) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI (additional emergency stop input) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0251": {
    "description": "Safety Function DI (additional safeguard stop input) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI (additional safeguard stop input) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0252": {
    "description": "Safety Function DI (safeguard reset input) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI (safeguard reset input) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0253": {
    "description": "Safety Function DI (reduced mode) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI (reduced mode) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0254": {
    "description": "Safety Function DI (3-position enable) has been triggered",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI (3-position enable) has been triggered",
    "isShowConfirm": "1"
  },
  "0x10F0255": {
    "description": "Safety Function DI set collision sensitivity (level0) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level0) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0256": {
    "description": "Safety Function DI set collision sensitivity (level1) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level1) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0257": {
    "description": "Safety Function DI set collision sensitivity (level2) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level2) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0258": {
    "description": "Safety Function DI set collision sensitivity (level3) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level3) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0259": {
    "description": "Safety Function DI set collision sensitivity (level4) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level4) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F025A": {
    "description": "Safety Function DI set collision sensitivity (level5) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level5) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F025B": {
    "description": "Safety Function DI set collision sensitivity (level7) has been triggered",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DI set collision sensitivity (level7) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F025C": {
    "description": "The safety function DI (protective stop) has been triggered.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The safety function DI (protective stop) has been triggered",
    "isShowConfirm": "0"
  },
  "0x10F0260": {
    "description": "Safety Function DO (control stick emergency stop state output) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (control stick emergency stop state output) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0261": {
    "description": "Safety Function DO (control stick emergency stop state output) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (control stick emergency stop state output) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0262": {
    "description": "Safety Function DO (system emergency stop state output) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (system emergency stop state output) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0263": {
    "description": "Safety Function DO (system emergency stop state output) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (system emergency stop state output) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0264": {
    "description": "Safety Function DO (safeguard stop mode on) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (safeguard stop mode on) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0265": {
    "description": "Safety Function DO (safeguard stop mode on) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (safeguard stop mode on) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0266": {
    "description": "Safety Function DO (move state output) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (move state output) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0267": {
    "description": "Safety Function DO (move state output) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (move state output) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0268": {
    "description": "Safety Function DO (reduced mode) has been set",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (reduced mode) has been set",
    "isShowConfirm": "0"
  },
  "0x10F0269": {
    "description": "Safety Function DO (reduced mode) has been reset",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Safety Function DO (reduced mode) has been reset",
    "isShowConfirm": "0"
  },
  "0x10F0280": {
    "description": "Identification of dynamic parameters complete",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Identification of dynamic parameters complete",
    "isShowConfirm": "1"
  },
  "0x10F0281": {
    "description": "Identification of friction parameters complete",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Identification of friction parameters complete",
    "isShowConfirm": "1"
  },
  "0x10F0282": {
    "description": "The writing of dynamic parameters has completed, please reboot to take effect.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Writing of dynamic parameters complete",
    "isShowConfirm": "1"
  },
  "0x10F0283": {
    "description": "The collision point is too close to starting point of the movement, therefore it's uncertain whether the path trajectory of bounce is safe, thus the bounce might be terminated.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "Collision bounce terminated",
    "isShowConfirm": "1"
  },
  "0x10F0284": {
    "description": "When near the collision point, the robot is about to stop or already has stopped, therefore no bounce would occur in this collision.",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "No bounce occurred in this collision",
    "isShowConfirm": "1"
  },
  "0x10F0285": {
    "description": " Brake resistor startup voltage setting successful.\nCurrent value is {0}V",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": " Brake resistor startup voltage setting successful.",
    "isShowConfirm": "0"
  },
  "0x10F0286": {
    "description": " The program is already running and cannot be started again.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "The program is already running",
    "isShowConfirm": "0"
  },
  "0x10F0287": {
    "description": "One-key restore completed",
    "type": "1",
    "isShowOTA": "0",
    "reason": "One-key restore completed, parameters have been restored to default values",
    "action": "One-key restore completed",
    "tittle": "One-key restore completed",
    "isShowConfirm": "1"
  },
  "0x10F0300": {
    "description": "Login initialization failed.",
    "type": "1",
    "isShowOTA": "1",
    "reason": "There is a data reading exception during the login connection.",
    "action": "1. Please check if there is a mismatch between the current App version and controller version. \n2. Please check if the Internet connection is working normally. \n3. Please try to reconnect the robot or restart the App.",
    "tittle": "Login initialization failed",
    "isShowConfirm": "1"
  },
  "0x10F0301": {
    "description": "This is a trial version",
    "type": "1",
    "isShowOTA": "1",
    "reason": "This is a trial version",
    "action": "Please contact the technical service team to get the full version.",
    "tittle": "This is a trial version",
    "isShowConfirm": "1"
  },
  "0x10F1000": {
    "description": "The program's runnning velocity scale is now {1}",
    "type": "1",
    "isShowOTA": "0",
    "reason": "The program's runnning velocity scale has changed due to {0}",
    "action": "",
    "tittle": "The user program's running velocity scale has changed",
    "isShowConfirm": "0"
  },
  "0x10F2000": {
    "description": "Program execution completed.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Program execution completed.",
    "action": "Program execution completed.",
    "tittle": "Program execution completed",
    "isShowConfirm": "0"
  },
  "0x10F2001": {
    "description": "Terminate program execution.",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Terminate program execution.",
    "action": "Terminate program execution.",
    "tittle": "Terminate program execution",
    "isShowConfirm": "0"
  }
}

export const ja = {
  "0x000030": {
    "description": "ジョイント 1 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 1 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 1 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x000031": {
    "description": "ジョイント1 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント1 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント1 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x000032": {
    "description": "ジョイント1負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント1負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント1負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x000033": {
    "description": "ジョイント 1 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 1 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x000034": {
    "description": "ジョイント 1 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 1 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x000035": {
    "description": "JOG 目標位置がジョイント 1 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 1 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x000036": {
    "description": "JOG 目標位置がジョイント 1 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 1 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x000037": {
    "description": "関節1加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節1加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節1加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x000042": {
    "description": "ジョイント 1 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 1 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 1 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x000061": {
    "description": "ジョイント 1衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 1衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 1衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x000200": {
    "description": "設置かくど角度がいきち閾値をこえ超えます",
    "type": "0",
    "isShowOTA": "0",
    "reason": "設置かくど角度がいきち閾値をこえ超えます",
    "action": "取り付けかくど角度のかくにん確認とさい再せっち設置をおねがい願いします。",
    "tittle": "設置かくど角度がいきち閾値をこえ超えます",
    "isShowConfirm": "0"
  },
  "0x000250": {
    "description": "現在、トラックプランナーはせってい設定できません",
    "type": "0",
    "isShowOTA": "0",
    "reason": "現在、トラックプランナーはせってい設定できません",
    "action": "後ほどリトライをおねがい願いします。",
    "tittle": "現在、トラックプランナーはせってい設定できません",
    "isShowConfirm": "0"
  },
  "0x000350": {
    "description": "SERVOモードにはありません",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVOモードにはありません",
    "action": "SERVOモードにはいっ入ってから,げんざい現在のどうさ動作をおためし試しくださいますか。",
    "tittle": "SERVOモードにはありません",
    "isShowConfirm": "0"
  },
  "0x000351": {
    "description": "SERVOモードでフィルタのせってい設定はできません",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVOモードでフィルタのせってい設定はできません",
    "action": "SERVOモードをいったん一旦オフにしてから,フィルタのせってい設定をおねがい願いします。",
    "tittle": "SERVOモードでフィルタのせってい設定はできません",
    "isShowConfirm": "0"
  },
  "0x000352": {
    "description": "SERVOコマンドパラメータをむこう無効にします",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVOコマンドパラメータをむこう無効にします",
    "action": "パラメータがはんい範囲ない内であることをかくにん確認してからさい再せってい設定をおねがい願いします。",
    "tittle": "SERVOコマンドパラメータをむこう無効にします",
    "isShowConfirm": "0"
  },
  "0x000353": {
    "description": "SERVOフィルタパラメータはむこう無効です",
    "type": "0",
    "isShowOTA": "0",
    "reason": "SERVOフィルタパラメータはむこう無効です",
    "action": "パラメータがはんい範囲ない内であることをかくにん確認してからさい再せってい設定をおねがい願いします。",
    "tittle": "SERVOフィルタパラメータはむこう無効です",
    "isShowConfirm": "0"
  },
  "0x000400": {
    "description": "IOばんごう番号がはんい範囲をこえ超えています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IOばんごう番号がはんい範囲をこえ超えています",
    "action": "パラメータがはんい範囲ない内であることをかくにん確認してからさい再せってい設定をおねがい願いします。",
    "tittle": "IOばんごう番号がはんい範囲をこえ超えています",
    "isShowConfirm": "0"
  },
  "0x000401": {
    "description": "IOタイプオーバーです",
    "type": "0",
    "isShowOTA": "0",
    "reason": "IOタイプオーバーです",
    "action": "パラメータがはんい範囲ない内であることをかくにん確認してからさい再せってい設定をおねがい願いします。",
    "tittle": "IOタイプオーバーです",
    "isShowConfirm": "0"
  },
  "0x000450": {
    "description": "別名はすでに既にそんざい存在しています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "別名はすでに既にそんざい存在しています",
    "action": "チェックとさい再せってい設定をおねがい願いします。",
    "tittle": "別名はすでに既にそんざい存在しています",
    "isShowConfirm": "0"
  },
  "0x000500": {
    "description": "衝突レベルちょうか超過です",
    "type": "0",
    "isShowOTA": "0",
    "reason": "衝突レベルちょうか超過です",
    "action": "パラメータがはんい範囲ない内であることをかくにん確認してからさい再せってい設定をおねがい願いします。",
    "tittle": "衝突レベルちょうか超過です",
    "isShowConfirm": "0"
  },
  "0x000550": {
    "description": "運動がく学てき的ぎゃく逆かい解のしっぱい失敗です",
    "type": "0",
    "isShowOTA": "0",
    "reason": "運動がく学てき的ぎゃく逆かい解のしっぱい失敗です",
    "action": "ポイントなどかんれん関連パラメータをチェックしてさい再しこう試行をおねがい願いします。",
    "tittle": "運動がく学てき的ぎゃく逆かい解のしっぱい失敗です",
    "isShowConfirm": "0"
  },
  "0x001002": {
    "description": "Joint 1 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 1 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 1 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x001003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x001004": {
    "description": "ジョイント 1 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 1 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x010030": {
    "description": "ジョイント 2 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 2 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 2 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x010031": {
    "description": "ジョイント2 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント2 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント2 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x010032": {
    "description": "ジョイント2負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント2負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント2負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x010033": {
    "description": "ジョイント 2 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 2 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x010034": {
    "description": "ジョイント 2 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 2 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x010035": {
    "description": "JOG 目標位置がジョイント 2 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 2 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x010036": {
    "description": "JOG 目標位置がジョイント 2 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 2 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x010037": {
    "description": "関節2加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節2加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節2加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x010042": {
    "description": "ジョイント 2 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 2 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 2 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x010061": {
    "description": "ジョイント 2衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 2衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 2衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x011002": {
    "description": "Joint 2 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 2 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 2 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x011003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x011004": {
    "description": "ジョイント 2 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 2 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x020030": {
    "description": "ジョイント 3 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 3 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 3 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x020031": {
    "description": "ジョイント3 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント3 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント3 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x020032": {
    "description": "ジョイント3負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント3負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント3負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x020033": {
    "description": "ジョイント 3 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 3 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x020034": {
    "description": "ジョイント 3 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 3 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x020035": {
    "description": "JOG 目標位置がジョイント 3 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 3 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x020036": {
    "description": "JOG 目標位置がジョイント 3 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 3 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x020037": {
    "description": "関節3加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節3加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節3加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x020042": {
    "description": "ジョイント 3 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 3 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 3 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x020061": {
    "description": "ジョイント 3衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 3衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 3衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x021002": {
    "description": "Joint 3 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 3 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 3 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x021003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x021004": {
    "description": "ジョイント 3 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 3 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x030030": {
    "description": "ジョイント 4 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 4 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 4 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x030031": {
    "description": "ジョイント4 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント4 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント4 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x030032": {
    "description": "ジョイント4負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント4負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント4負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x030033": {
    "description": "ジョイント 4 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 4 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x030034": {
    "description": "ジョイント 4 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 4 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x030035": {
    "description": "JOG 目標位置がジョイント 4 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 4 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x030036": {
    "description": "JOG 目標位置がジョイント 4 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 4 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x030037": {
    "description": "関節4加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節4加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節4加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x030042": {
    "description": "ジョイント 4 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 4 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 4 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x030061": {
    "description": "ジョイント 4衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 4衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 4衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x031002": {
    "description": "Joint 4 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 4 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 4 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x031003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x031004": {
    "description": "ジョイント 4 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 4 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x040030": {
    "description": "ジョイント 5 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 5 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 5 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x040031": {
    "description": "ジョイント5 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント5 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント5 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x040032": {
    "description": "ジョイント5負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント5負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント5負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x040033": {
    "description": "ジョイント 5 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 5 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x040034": {
    "description": "ジョイント 5 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 5 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x040035": {
    "description": "JOG 目標位置がジョイント 5 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 5 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x040036": {
    "description": "JOG 目標位置がジョイント 5 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 5 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x040037": {
    "description": "関節5加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節5加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節5加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x040042": {
    "description": "ジョイント 5 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 5 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 5 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x040061": {
    "description": "ジョイント 5衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 5衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 5衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x041002": {
    "description": "Joint 5 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 5 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 5 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x041003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x041004": {
    "description": "ジョイント 5 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 5 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x050030": {
    "description": "ジョイント 6 の移動速度が限界を超えています",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 6 の移動速度が限界を超えています。このエラーは、通常、コントローラによって発行されたコマンドがジョイントの実際の速度制限を超えたときに報告されます。",
    "action": "1. 現在のロボットの速度制限が人為的に変更および改善されているかどうかを確認してください。ある場合は、JAKA 技術スタッフに連絡してください。\n2. それでも発生する場合は、該当する診断情報をエクスポートし、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "ジョイント 6 の移動速度が限界を超えています",
    "isShowConfirm": "1"
  },
  "0x050031": {
    "description": "ジョイント6 正のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント6 正のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント6 正のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x050032": {
    "description": "ジョイント6負のソフト リミットに達するとすぐに",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント6負のソフト リミットに達すると、通常、ロボットの移動中にロボット リミットがトリガーされると、このエラーが表示されます。",
    "action": "対応するロボットの関節角度の値が限界に達していないか確認してください。その場合は、ジョブ パスを変更してください。",
    "tittle": "ジョイント6負のソフト リミットに達するとすぐに",
    "isShowConfirm": "1"
  },
  "0x050033": {
    "description": "ジョイント 6 が正の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの限界付近で正のソフトリミットに達し、実行を続けるとロボットリミットがトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 6 が正の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x050034": {
    "description": "ジョイント 6 が負の位置制限に達しようとしています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットの関節位置がロボットの負の限界に近く、走り続けることでロボットの限界がトリガーされます",
    "action": "ロボットの目標点に対応する関節角度の値が限界に達しているか確認してください。 その場合は、ジョブ・パスを変更します",
    "tittle": "ジョイント 6 が負の位置制限に達しようとしています",
    "isShowConfirm": "1"
  },
  "0x050035": {
    "description": "JOG 目標位置がジョイント 6 の正のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 6 の正のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x050036": {
    "description": "JOG 目標位置がジョイント 6 の負のソフト リミットを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットを手動で制御 (JOG) して移動させ、移動の目標点がロボットの関節で設定された制限値を超えると、このアラームが表示されます。",
    "action": "1. ロボットの安全設定でジョイント制限値が変更されていないか確認してください。 \n2. 目標点が適切かどうかを確認してください。そうでない場合は、目標点の位置を修正してください。",
    "tittle": "JOG 目標位置がジョイント 6 の負のソフト リミットを超えています",
    "isShowConfirm": "1"
  },
  "0x050037": {
    "description": "関節6加速度が大きすぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "手動制御（JOG）ロボットがデカルト空間運動を行うと、関節6加速度が過大になる。",
    "action": "1.ロボット関節運動をエラー位置から離し、デカルト空間JOGを試してください。",
    "tittle": "関節6加速度が大きすぎる",
    "isShowConfirm": "1"
  },
  "0x050042": {
    "description": "ジョイント 6 がソフト リミットに到達しようとしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 6 はソフト リミットに達しようとしています。",
    "action": "ロボットの現在の関節状態を確認し、関節限界に近づいているか、オーバーランしない方向に移動することをお勧めしますか、ティーチング ページで限界範囲を超えようとしている関節をジョグしてください、または設定ページでソフト リミットを変更し、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ジョイント 6 がソフト リミットに到達しようとしています",
    "isShowConfirm": "1"
  },
  "0x050061": {
    "description": "ジョイント 6衝突が検出されるとすぐに保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ジョイント 6衝突が検出されるとすぐに保護停止",
    "action": "1. 現場環境をチェックして、実際に衝突が発生したかどうかを確認します。はいの場合、操作手順を最適化してください \n2. 誤った衝突が発生した場合は、荷重と取り付け角度が正しく設定されているかどうかを確認してください \n3. エラーを報告するジョイントの動きを手動で制御し、内部ジャムがないかどうかを確認してください対応するジョイントで。",
    "tittle": "ジョイント 6衝突が検出されるとすぐに保護停止",
    "isShowConfirm": "1"
  },
  "0x051002": {
    "description": "Joint 6 CAN接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント 6 の CAN バス異常によりデータ取得が失敗するか、タイムアウトによりエラー プロンプトが表示されます",
    "action": "1. ロボットの電源を切って有効にし、エラーが報告されたジョイントのカバーを開けて、ジョイント内の CAN ラインに異常がないか確認します。 \n2. 技術担当者にご相談ください。",
    "tittle": "Joint 6 CAN接続異常",
    "isShowConfirm": "1"
  },
  "0x051003": {
    "description": "ジョイントドライブの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "本体の電源を入れた後、ジョイント1のドライブボードからコントローラに戻る信号がありません",
    "action": "アプリの監視インターフェースで、ジョイント1の監視電圧、電流、および温度がデータ表示されているかどうかを確認します.本体の電源が正常にオンになっている場合、数値表示があります.数値表示がない場合は、技術スタッフに連絡してください.支援のために。",
    "tittle": "ジョイントドライブの故障",
    "isShowConfirm": "1"
  },
  "0x051004": {
    "description": "ジョイント 6 の追従誤差が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 6 の追従誤差が大きすぎます",
    "isShowConfirm": "1"
  },
  "0xE0000": {
    "description": "間違いありません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "間違いありません。",
    "action": "間違いありません。",
    "tittle": "間違いありません",
    "isShowConfirm": "0"
  },
  "0xE0001": {
    "description": "gRPCは例外を呼び出します。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "gRPCは例外を呼び出します。",
    "action": "JAKA技術者への問い合わせをお願いします。",
    "tittle": "gRPCは例外を呼び出します",
    "isShowConfirm": "0"
  },
  "0xE0002": {
    "description": "パスワードが違います。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ログイン失敗、パスワードエラーです。",
    "action": "パスワードが正しく入力されているかチェックし、間違っていたら正しいパスワードを入力し直してください。",
    "tittle": "パスワードが違います",
    "isShowConfirm": "0"
  },
  "0xE0003": {
    "description": "ユーザー名エラーです。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ログイン失敗、ユーザー名エラーです。",
    "action": "ユーザー名が正しく入力されているかチェックして、間違っていたら正しいユーザー名を入力し直してください。",
    "tittle": "ユーザー名エラーです。",
    "isShowConfirm": "0"
  },
  "0xE0004": {
    "description": "重複登録です。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "重複登録です。",
    "action": "別の端末でオフラインになったことを確認してからログインをお願いします。",
    "tittle": "重複登録です。",
    "isShowConfirm": "0"
  },
  "0xE0005": {
    "description": "ユーザーはまだログインしていません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ユーザーはまだログインしていません",
    "action": "ユーザー名とパスワードをログインしてから作業を実行します。",
    "tittle": "ユーザーはまだログインしていません",
    "isShowConfirm": "0"
  },
  "0xE0006": {
    "description": "関節の最小ストッパが小さすぎるか、最大ストッパが大きすぎるか、または最大ストッパより大きい場合があります。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "関節の最小ストッパが小さすぎるか、最大ストッパが大きすぎるか、または最大ストッパより大きい場合があります。",
    "action": "関節ストッパを適切な位置に調整してから作業を行います。",
    "tittle": "関節ストッパ異常です",
    "isShowConfirm": "0"
  },
  "0xE0007": {
    "description": "運動学的逆解の失敗です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "運動学的逆解の失敗です",
    "action": "ロボットが逆解に失敗しましたので、ロボットを教え直してください。",
    "tittle": "運動学的逆解の失敗です",
    "isShowConfirm": "0"
  },
  "0xE0008": {
    "description": "運動学の正解失敗です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "運動学の正解失敗です",
    "action": "JAKA技術者への問い合わせをお願いします。",
    "tittle": "運動学の正解失敗です",
    "isShowConfirm": "0"
  },
  "0xE0009": {
    "description": "ファイルやフォルダが見当たりません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ファイルやフォルダが見当たりません",
    "action": "ファイルまたはフォルダの存在を確認してから作業をお願いします。",
    "tittle": "ファイルやフォルダが見当たりません",
    "isShowConfirm": "0"
  },
  "0xE000A": {
    "description": "MD5検出は一致しません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "MD5検出は一致しません",
    "action": "MD5チェックが正しいかチェックをお願いします。",
    "tittle": "MD5検出は一致しません",
    "isShowConfirm": "0"
  },
  "0xE000B": {
    "description": "中心点の計算に失敗します",
    "type": "1",
    "isShowOTA": "1",
    "reason": "中心点の計算に失敗します",
    "action": "ツール座標系の計算が間違っています。設定したツール座標系が正しいかチェックしてください。",
    "tittle": "中心点の計算に失敗します",
    "isShowConfirm": "0"
  },
  "0xE000C": {
    "description": "無効なパラメータです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "無効なパラメータです",
    "action": "パラメータが正しくありません。正しいパラメータに修正して作業を行ってください。",
    "tittle": "無効なパラメータです",
    "isShowConfirm": "0"
  },
  "0xE000D": {
    "description": "あまりにも多くの出力が同じ状態に結びつけられています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "あまりにも多くの出力が同じ状態に結びつけられています",
    "action": "出力が正常になるようDI、DOの状態を修正します。",
    "tittle": "あまりにも多くの出力が同じ状態に結びつけられています",
    "isShowConfirm": "0"
  },
  "0xE000E": {
    "description": "変数の別名は既に存在します",
    "type": "1",
    "isShowOTA": "1",
    "reason": "変数の別名は既に存在します",
    "action": "変数別名を修正し直してから作業をお願いします。",
    "tittle": "変数の別名は既に存在します",
    "isShowConfirm": "0"
  },
  "0xE000F": {
    "description": "パラメータ値がオーバーします",
    "type": "1",
    "isShowOTA": "1",
    "reason": "パラメータ値がオーバーします",
    "action": "パラメータ値を適切な範囲に修正してから作業をお願いします。",
    "tittle": "パラメータ値がオーバーします",
    "isShowConfirm": "0"
  },
  "0xE0010": {
    "description": "メッセージIDは範囲外です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "メッセージIDは範囲外です",
    "action": "メッセージIDを適切な範囲に変更願います。",
    "tittle": "メッセージIDは範囲外です",
    "isShowConfirm": "0"
  },
  "0xE0011": {
    "description": "文字列は16文字を超えてはいけません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "文字列は16文字を超えてはいけません",
    "action": "文字列の長さが16文字を超えていないかチェックし、16文字内に修正してから操作します。",
    "tittle": "文字列は16文字を超えてはいけません",
    "isShowConfirm": "0"
  },
  "0xE0012": {
    "description": "操作権限はありません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "操作権限はありません",
    "action": "操作権限がありませんので、切り替え権限を再登録してから操作してください。",
    "tittle": "操作権限はありません",
    "isShowConfirm": "0"
  },
  "0xE0013": {
    "description": "ユーザー権限レベルが不正確です。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ユーザー権限レベルが不正確です。",
    "action": "操作権限が足りませんので、切り替え権限を再登録してから操作を行ってください。",
    "tittle": "ユーザー権限レベルが不正確です。",
    "isShowConfirm": "0"
  },
  "0xE0014": {
    "description": "ユーザー名は既に存在します",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ユーザー名は既に存在します",
    "action": "ユーザー名を変更してからログインをお願いします。",
    "tittle": "ユーザー名は既に存在します",
    "isShowConfirm": "0"
  },
  "0xE0015": {
    "description": "アップグレードインストールパッケージが正しくありません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アップグレードインストールパッケージが正しくありません。",
    "action": "インストールパッケージの名称が正しいか確認をお願いします。",
    "tittle": "アップグレードインストールパッケージが正しくありません。",
    "isShowConfirm": "0"
  },
  "0xE0016": {
    "description": "インストールパッケージの名称が正しいか確認をお願いします。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "インストールパッケージの名称が正しいか確認をお願いします。",
    "action": "jog座標系に対応しているかチェックし、正しく修正してから作業をお願いします。",
    "tittle": "インストールパッケージの名称が正しいか確認をお願いします。",
    "isShowConfirm": "0"
  },
  "0xE0017": {
    "description": "このモードは現在サポートされていません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "このモードは現在サポートされていません。",
    "action": "ロボットが現在のモードに対応しているか確認し、正しいモードに切り替えてから操作をお願いします。",
    "tittle": "このモードは現在サポートされていません。",
    "isShowConfirm": "0"
  },
  "0xE0018": {
    "description": "ロボットが動いています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットが動いています",
    "action": "ロボットが移働しているかどうかチェックして、ロボットを停止状態にしてから働作します。",
    "tittle": "ロボットが動いています",
    "isShowConfirm": "0"
  },
  "0xE0019": {
    "description": "ジョブ実行時にジョブロードを実行できません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョブ実行時にジョブロードを実行できません。",
    "action": "プログラムは実行中で、実行中のプログラムを停止してからプログラムを開きます。",
    "tittle": "ジョブ実行時にジョブロードを実行できません。",
    "isShowConfirm": "0"
  },
  "0xE001A": {
    "description": "現在ピンは他の機能に占有されています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "現在ピンは他の機能に占有されています",
    "action": "現在ピンが他の機能に占有されていないか確認をお願いします。",
    "tittle": "現在ピンは他の機能に占有されています",
    "isShowConfirm": "0"
  },
  "0xE001B": {
    "description": "減衰モードでは各レベルの減衰倍率は設定できません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "減衰モードでは各レベルの減衰倍率は設定できません。",
    "action": "現在減縮モードにあるかどうかを確認してください。各レベルの減衰倍率を非減縮モードで設定すべきです。",
    "tittle": "減衰モードでは各レベルの減衰倍率は設定できません。",
    "isShowConfirm": "0"
  },
  "0xE001C": {
    "description": "軌跡再現ではjksスクリプトの生成に失敗します",
    "type": "1",
    "isShowOTA": "1",
    "reason": "軌跡再現ではjksスクリプトの生成に失敗します",
    "action": "スクリプトファイルが正しいか確認をお願いします。",
    "tittle": "軌跡再現ではjksスクリプトの生成に失敗します",
    "isShowConfirm": "0"
  },
  "0xE001D": {
    "description": "トルクセンサが使えるチャンネルはTIO RS485の1つだけです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "トルクセンサが使えるチャンネルはTIO RS485の1つだけです",
    "action": "TIO RS485チャンネルが復数チャンネルで使用されて1チャンネルに変更されていないか確認してから働作をお願いします。",
    "tittle": "トルクセンサが使えるチャンネルはTIO RS485の1つだけです",
    "isShowConfirm": "0"
  },
  "0xE001E": {
    "description": "モーションセンサチャネル切替失敗です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーションセンサチャネル切替失敗です",
    "action": "モーメントセンサーが作動しているかどうかを確認し、作動を停止してから操作をお願いします。",
    "tittle": "モーションセンサチャネル切替失敗です",
    "isShowConfirm": "0"
  },
  "0xE001F": {
    "description": "ロボット番号が間違っています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボット番号が間違っています",
    "action": "ロボット番号が正しいかチェックし、正しいロボット番号に修正してから作業をお願いします。",
    "tittle": "ロボット番号が間違っています",
    "isShowConfirm": "0"
  },
  "0xE0020": {
    "description": "redisサービスが起動していません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "redisサービスが起動していません",
    "action": "redisサーバが動作しているか確認し、redisが動作していることを確認してから作業を行います。",
    "tittle": "redisサービスが起動していません",
    "isShowConfirm": "0"
  },
  "0xE0021": {
    "description": "未知の模型ロボットです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未知の模型ロボットです",
    "action": "ロボットの模型が正しいか確認をお願いします。",
    "tittle": "未知の模型ロボットです",
    "isShowConfirm": "0"
  },
  "0xE0022": {
    "description": "Extioモジュールの数量またはExtioインデックスが範囲外です。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "Extioモジュールの数量または拡張IOインデックスが範囲外です。\n最大のExtioモジュールの数量：8\nExtio DI/DOのインデックス範囲：0〜64\nExtio AI/AOのインデックス範囲：0〜31",
    "action": "操作を続行する前に、ExtioモジュールまたはExtioインデックス番号を確認してください。",
    "tittle": "Extioモジュールの数量またはExtioインデックスが範囲外です。",
    "isShowConfirm": "0"
  },
  "0xE0023": {
    "description": "「轨跡記録」命令は、シングルステップデバッグモードではサポートされていません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "「轨跡記録」命令は、シングルステップデバッグモードではサポートされていません。",
    "action": "「轨跡記録」の命令を削除してから、再度お試しください。",
    "tittle": "「轨跡記録」命令は、シングルステップデバッグモードではサポートされていません。",
    "isShowConfirm": "0"
  },
  "0xE0026": {
    "description": "シミュレーションモードではこの操作は許可されていません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "シミュレーションモードではこの操作は許可されていません。",
    "action": "シミュレーションモードを終了してから試してください",
    "tittle": "シミュレーションモードではこの操作は許可されていません。",
    "isShowConfirm": "0"
  },
  "0xE0027": {
    "description": "ネットワーク構成ファイルの読み取りに失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ネットワーク構成ファイルの読み取りに失敗しました",
    "action": "セットアップを再試行してください。それでも表示される場合は、技術者に連絡してネットワークプロファイルを確認してください",
    "tittle": "ネットワーク構成ファイルの読み取りに失敗しました",
    "isShowConfirm": "0"
  },
  "0xE0028": {
    "description": "入力が多すぎて同じ機能にバインドされている",
    "type": "1",
    "isShowOTA": "1",
    "reason": "入力が多すぎて同じ機能にバインドされている",
    "action": "機能DI構成を確認して修正してください。",
    "tittle": "入力が多すぎて同じ機能にバインドされている",
    "isShowConfirm": "0"
  },
  "0xE002A": {
    "description": "プログラムが実行中であり、ファイルの削除は許可されていません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "プログラムが実行中であり、ファイルの削除は許可されていません。",
    "action": "プログラムが実行中であり、ファイルの削除は許可されていません。",
    "tittle": "プログラムが実行中であり、ファイルの削除は許可されていません。",
    "isShowConfirm": "0"
  },
  "0xE002B": {
    "description": "設定ファイルのインポートに失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルのインポートに失敗しました",
    "action": "設定ファイルのインポートに失敗しました",
    "tittle": "設定ファイルのインポートに失敗しました",
    "isShowConfirm": "0"
  },
  "0xE002C": {
    "description": "この機能インターフェースはサポートされていません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "この機能インターフェースはサポートされていません",
    "action": "この機能インターフェースはサポートされていません",
    "tittle": "この機能インターフェースはサポートされていません",
    "isShowConfirm": "0"
  },
  "0xE002D": {
    "description": "機能設定に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "機能設定に失敗しました",
    "action": "機能設定に失敗しました",
    "tittle": "機能設定に失敗しました",
    "isShowConfirm": "0"
  },
  "0xE002E": {
    "description": "入出力ピンが一致しません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "入出力ピンが一致しません",
    "action": "入出力ピンが一致しません",
    "tittle": "入出力ピンが一致しません",
    "isShowConfirm": "0"
  },
  "0xE002F": {
    "description": "制御キャビネットのディスク情報の取得に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ディスクハードウェアの異常またはディスクスペースがいっぱいです",
    "action": "後でもう一度お試しください",
    "tittle": "制御キャビネットのディスク情報の取得に失敗しました",
    "isShowConfirm": "0"
  },
  "0xE0030": {
    "description": "ロボットモデルはシミュレーションをサポートしていません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットモデルはシミュレーションをサポートしていません",
    "action": "ロボットの模型が正しいか確認をお願いします。",
    "tittle": "ロボットモデルはシミュレーションをサポートしていません",
    "isShowConfirm": "0"
  },
  "0xE0031": {
    "description": "ユーザー座標系の調整に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "選択したキャリブレーションポイントが適切でないため、ユーザー座標系のキャリブレーションに失敗します。",
    "action": "適切なティーチングポイントをリセットしてください。",
    "tittle": "ユーザー座標系の調整に失敗しました",
    "isShowConfirm": "0"
  },
  "0xE0033": {
    "description": "ユーザー名またはパスワードが間違っています。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ユーザー名またはパスワードが間違っています。",
    "action": "正しいユーザー名とパスワードを再入力してください。",
    "tittle": "ユーザーパスワードの検証に失敗しました。",
    "isShowConfirm": "0"
  },
  "0xE0034": {
    "description": "アライメントターゲットポーズを取得できませんでした",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アライメントターゲットポーズを取得できませんでした",
    "action": "アライメントターゲットポーズを取得できません",
    "tittle": "アライメントターゲットポーズを取得できませんでした",
    "isShowConfirm": "0"
  },
  "0xE0064": {
    "description": "衝突が検出されました。環境が安全か確認してください。",
    "type": "2",
    "isShowOTA": "1",
    "reason": "衝突が検出されました。環境が安全か確認してください。",
    "action": "衝突が検出されました。環境が安全か確認してください。",
    "tittle": "衝突が検出されました。環境が安全か確認してください。",
    "isShowConfirm": "0"
  },
  "0xE03E8": {
    "description": "アドドン起動数が制限を超えました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アドドン起動数が制限を超えました",
    "action": "AddOn起働数に制限がありますので、先に一部AddOnをクリアしてから操作を行ってください。",
    "tittle": "アドドン起動数が制限を超えました",
    "isShowConfirm": "0"
  },
  "0xE03E9": {
    "description": "AddOnサービス開始失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnサービス開始失敗しました",
    "action": "AddOnサービスの起動に失敗した場合、AddOnの設定が正しいか確認してから操作を行います。",
    "tittle": "AddOnサービス開始失敗しました",
    "isShowConfirm": "0"
  },
  "0xE03EA": {
    "description": "AddOnサービス停止失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnサービス停止失敗しました",
    "action": "AddOnサービスの閉鎖に失敗した場合、AddOnの設定が正しいか確認してから操作を行います。",
    "tittle": "AddOnサービス停止失敗しました",
    "isShowConfirm": "0"
  },
  "0xE03EB": {
    "description": "プロファイルは無効です。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "プロファイルは無効です。",
    "action": "AddOnプロファイルが正しいか確認してから作業をお願いします。",
    "tittle": "プロファイルは無効です。",
    "isShowConfirm": "0"
  },
  "0xE03EC": {
    "description": "AddOnサービスは存在しません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnサービスは存在しません",
    "action": "対応するAddOnが検出されません。AddOnは移働または削除されている可能性があります。",
    "tittle": "AddOnサービスは存在しません",
    "isShowConfirm": "0"
  },
  "0xE03ED": {
    "description": "アドドン配置は存在しません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アドドン配置は存在しません",
    "action": "AddOnの構成は存在しません、現在のソフトウェアのバージョンを確認して、JAKA技術のサービスマンに連絡してください。",
    "tittle": "アドドン配置は存在しません",
    "isShowConfirm": "0"
  },
  "0xE03EE": {
    "description": "設定ファイルにAddOn仕様が未知です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルにAddOn仕様が未知です",
    "action": "AddOn構成のconvention構成項目が識別できませんでした。構成conventionが正しいかどうかチェックしてください。",
    "tittle": "設定ファイルにAddOn仕様が未知です",
    "isShowConfirm": "0"
  },
  "0xE03EF": {
    "description": "設定ファイルのAddOnタイプエラーです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルのAddOnタイプエラーです",
    "action": "AddOn構成のtype構成項目が認識できませんでした。typeが1~3の範囲の数字をご確認ください。",
    "tittle": "設定ファイルのAddOnタイプエラーです",
    "isShowConfirm": "0"
  },
  "0xE03F0": {
    "description": "プロファイル言語エラーです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "プロファイル言語エラーです",
    "action": "AddOn構成のlanguageが認識できません。language構成が正しいか確認してください。",
    "tittle": "プロファイル言語エラーです",
    "isShowConfirm": "0"
  },
  "0xE03F1": {
    "description": "設定ファイルAddOnエントリエラーです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルAddOnエントリエラーです",
    "action": "AddOn構成内のlanguageを認識できない場合、サービスが空でなく、サービスバイト数が50バイト以下であることを保証します。",
    "tittle": "設定ファイルAddOnエントリエラーです",
    "isShowConfirm": "0"
  },
  "0xE03F2": {
    "description": "設定ファイルに自己起動設定エラーがあります",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルに自己起動設定エラーがあります",
    "action": "AddOn構成のserviceenable構成項目を識別できませんでした。serviceenableがTrueまたはFalseであることを保証してください。",
    "tittle": "設定ファイルに自己起動設定エラーがあります",
    "isShowConfirm": "0"
  },
  "0xE03F3": {
    "description": "プロファイルに必要な構成項目が欠けています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "プロファイルに必要な構成項目が欠けています",
    "action": "AddOnプロファイルに必要な構成項目が不足しています。プロファイルが正しいかチェックしてください。",
    "tittle": "プロファイルに必要な構成項目が欠けています",
    "isShowConfirm": "0"
  },
  "0xE03F4": {
    "description": "設定ファイルAddOnに名前の設定エラーがあります",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルAddOnに名前の設定エラーがあります",
    "action": "AddOnプロファイルのNameのバイト数が40バイトを超えていますので、設定が正しいことを確認してから再試行してください。",
    "tittle": "設定ファイルAddOnに名前の設定エラーがあります",
    "isShowConfirm": "0"
  },
  "0xE03F5": {
    "description": "設定ファイルにAddOnの記述が間違っています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルにAddOnの記述が間違っています",
    "action": "AddOnプロファイルのdescriptionバイト数が40バイトを超えますので、設定が正しいことを確認してから再試行してください。",
    "tittle": "設定ファイルにAddOnの記述が間違っています",
    "isShowConfirm": "0"
  },
  "0xE03F6": {
    "description": "AddOn版では認識できません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOn版では認識できません",
    "action": "AddOn仕様のversionが認識できませんでした。仕様が正しいことを確認してから再試行してください。",
    "tittle": "AddOn版では認識できません",
    "isShowConfirm": "0"
  },
  "0xE03F7": {
    "description": "設定ファイルAddOnのUrlが間違っています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "設定ファイルAddOnのUrlが間違っています",
    "action": "AddOn設定ファイルのurlの解決に失敗しました。設定が正しいことを確認してから再試行してください。",
    "tittle": "設定ファイルAddOnのUrlが間違っています",
    "isShowConfirm": "0"
  },
  "0xE03F8": {
    "description": "配信ポート番号に異常が発生しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "配信ポート番号に異常が発生しました",
    "action": "AddOnポートの割り当てが失敗しました。設定ファイルが正しいことを確認した後、カード技術者に連絡してサポートしてください。",
    "tittle": "配信ポート番号に異常が発生しました",
    "isShowConfirm": "0"
  },
  "0xE03F9": {
    "description": "AddOnサービスが稼働しています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnサービスが稼働しています",
    "action": "AddOnサービスは稼働中ですので、一旦停止してから作業を再開してください。",
    "tittle": "AddOnサービスが稼働しています",
    "isShowConfirm": "0"
  },
  "0xE03FA": {
    "description": "カタログは既に存在しています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "カタログは既に存在しています",
    "action": "リストがすでに存在するかどうかをチェックし、正しいリストを選択してから作業を行います。",
    "tittle": "カタログは既に存在しています",
    "isShowConfirm": "0"
  },
  "0xE03FB": {
    "description": "IPアドレスは既に存在します",
    "type": "1",
    "isShowOTA": "1",
    "reason": "IPアドレスは既に存在します",
    "action": "IPアドレスが既に存在するか確認し、正しいIPアドレスに修正してから作業をお願いします。",
    "tittle": "IPアドレスは既に存在します",
    "isShowConfirm": "0"
  },
  "0xE03FC": {
    "description": "安全な姿勢に関連するパラメータの計算に失敗しました。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "安全な姿勢に関連するパラメータの計算に失敗しました。",
    "action": "ツールのセキュリティ姿勢をリセットしてください",
    "tittle": "安全な姿勢に関連するパラメータの計算に失敗しました。",
    "isShowConfirm": "0"
  },
  "0xE044C": {
    "description": "チェックファイルが一致しません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "チェックファイルが一致しません。",
    "action": "ファイルがペアになっているか確認するか、アップデートプログラムを再ダウンロードします。",
    "tittle": "チェックファイルが一致しません。",
    "isShowConfirm": "0"
  },
  "0xE044D": {
    "description": "パスワードが違います",
    "type": "1",
    "isShowOTA": "1",
    "reason": "パスワードが違います",
    "action": "正しいパスワードをお願いします。",
    "tittle": "パスワードが違います",
    "isShowConfirm": "0"
  },
  "0xE044E": {
    "description": "パスワードの入力が2回一致しません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "パスワードの入力が2回一致しません",
    "action": "パスワードを2回一致させていただきます。",
    "tittle": "パスワードの入力が2回一致しません",
    "isShowConfirm": "0"
  },
  "0xE044F": {
    "description": "初回のログインにはパスワードのリセットが必要です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "初回のログインにはパスワードのリセットが必要です",
    "action": "パスワードをリセットしてからログイン作業をお願いします。",
    "tittle": "初回のログインにはパスワードのリセットが必要です",
    "isShowConfirm": "0"
  },
  "0xE0450": {
    "description": "前回と同じパスワードの変更はできません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "前回と同じパスワードの変更はできません。",
    "action": "前回とは異なるパスワードに変更願います。",
    "tittle": "前回と同じパスワードの変更はできません。",
    "isShowConfirm": "0"
  },
  "0xE0451": {
    "description": "アカウントが未起動です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アカウントが未起動です",
    "action": "アカウントが起動していません、デバイス管理者に連絡してください",
    "tittle": "アカウントが未起動です",
    "isShowConfirm": "0"
  },
  "0xE0452": {
    "description": "アカウントの起動ができません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アカウントの起動ができません",
    "action": "アカウント名が間違っている場合は、デバイス管理者に連絡します。",
    "tittle": "アカウントの起動ができません",
    "isShowConfirm": "0"
  },
  "0xE0453": {
    "description": "AddOnがインストール中です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnがインストール中です",
    "action": "AddOnインストール中です。後ほどリトライしてください。",
    "tittle": "AddOnがインストール中です",
    "isShowConfirm": "0"
  },
  "0xE0454": {
    "description": "AddOnインストールに失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnインストールに失敗しました",
    "action": "AddOnインストールに失敗した場合は、AddOnパッケージが正しいことを確認してから再試行してください。",
    "tittle": "AddOnインストールに失敗しました",
    "isShowConfirm": "0"
  },
  "0xE0455": {
    "description": "AddOnパケットは大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "AddOnパケットは大きすぎます",
    "action": "AddOnインストールパッケージが大きすぎたり、パッケージ内のファイルが多すぎたりすると、インストールが時間切れになってしまいます。インストールパッケージのサイズとファイルの数を減らしてから、もう一度試してください。",
    "tittle": "AddOnパケットは大きすぎます",
    "isShowConfirm": "0"
  },
  "0xE0456": {
    "description": "エラー状態で手動・自動モードを切り替える",
    "type": "1",
    "isShowOTA": "1",
    "reason": "エラー状態で手動・自動モードを切り替える",
    "action": "AddOnインストールパッケージが大きすぎたり、パッケージ内のファイルが多すぎたりすると、インストールが時間切れになってしまいます。インストールパッケージのサイズとファイルの数を減らしてから、もう一度試してくださいエラー状態で操作モードを切り替える（移動中、プログラム実行中、ドラッグ中）。",
    "tittle": "エラー状態で手動・自動モードを切り替える",
    "isShowConfirm": "0"
  },
  "0xE0457": {
    "description": "入力された文字列にサポートされていない文字があります。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "入力された文字列にサポートされていない文字があります。",
    "action": "入力パラメータを変更して再試行してください。",
    "tittle": "入力された文字列にサポートされていない文字があります。",
    "isShowConfirm": "0"
  },
  "0xE04B0": {
    "description": "緊急停止状態ではアップグレードを禁止します",
    "type": "1",
    "isShowOTA": "0",
    "reason": "緊急停止状態ではアップグレードを禁止します",
    "action": "緊急停止状態ではアップグレードを禁止します",
    "tittle": "緊急停止状態ではアップグレードを禁止します",
    "isShowConfirm": "0"
  },
  "0xEFFFF": {
    "description": "未知の誤りです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未知の誤りです",
    "action": "JAKA技術者への問い合わせをお願いします。",
    "tittle": "未知の誤りです",
    "isShowConfirm": "0"
  },
  "0x0F0001": {
    "description": "ロボット本体は現在電源が入っていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラが状態を実行中に、電源状態のシャットダウンが検出されました",
    "action": "ロボット本体の電源が入っているか確認し、ロボット本体の電源が入っていない場合は、先にロボット本体の電源を入れてください",
    "tittle": "ロボット本体の電源が入っていません",
    "isShowConfirm": "1"
  },
  "0x0F0002": {
    "description": "ロボットは現在有効になっていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラがコマンドを実行すると、ロボットが有効になっていないことが検出されます",
    "action": "ロボットが有効になっているかどうかを確認します。有効になっていない場合は、最初にロボットを有効にしてください",
    "tittle": "ロボットが有効になっていません",
    "isShowConfirm": "1"
  },
  "0x0F0003": {
    "description": "この操作は現在のモードでは実行できません。現在 {0} モードです。{1} コマンドは許可されていません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットは、特定の動作モードにあるときにのみ、特定の操作を行うことができる。その操作はロボットの現在のモードの範囲外である。",
    "action": "まず現在のモードを終了してから、この操作を行う。",
    "tittle": "この操作は現在のモードでは実行できません",
    "isShowConfirm": "1"
  },
  "0x0F0004": {
    "description": "運動学の逆計算に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "逆運動学の解の計算は、次の理由で失敗します: \n1. 指定されたデカルト空間ポーズが、ロボットの到達可能なスペースを超えています。\n2. 指定されたデカルト空間ポーズは、指定された基準角度によって決定される解空間に解がありません。",
    "action": "1. 手動インターフェースで座標編集インターフェースを入力し、検証のためのポイント情報を入力します.\n2.手動jogで、ロボットの目標点または目標経路位置姿勢が到達可能かどうかをチェックし、到達可能であれば姿勢を交換して運動学的逆解計算を行ってください。",
    "tittle": "運動学の逆計算に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0005": {
    "description": "位置の設定が大きすぎます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "位置の設定が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x0F0006": {
    "description": "正のハード リミットに達すると、ロボット ジョイントは移動できなくなります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、JOG 移動中にロボットは限界に達しますが、コマンドは依然として限界の方向に移動し、エラー プロンプトが報告されます。",
    "action": "ロボットの現在位置が限界に達しており、ロボットが限界を超えて移動できないかどうかを確認します。",
    "tittle": "ロボット ジョイントが正のハード リミットに達する",
    "isShowConfirm": "1"
  },
  "0x0F0007": {
    "description": "ロボット ジョイントが負のハード リミットに達し、移動できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、JOG 移動中にロボットは限界に達しますが、コマンドは依然として限界の方向に移動し、エラー プロンプトが報告されます。",
    "action": "ロボットの現在位置が限界に達しており、ロボットが限界を超えて移動できないかどうかを確認します。",
    "tittle": "ロボット ジョイントが負のハード リミットに達する",
    "isShowConfirm": "1"
  },
  "0x0F0008": {
    "description": "ロボットの関節は、正のソフト リミットに達すると移動できなくなります。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、JOG 移動中にロボットは限界に達しますが、コマンドは依然として限界の方向に移動し、エラー プロンプトが報告されます。",
    "action": "ロボットの現在位置が限界に達しており、ロボットが限界を超えて移動できないかどうかを確認します。",
    "tittle": "ロボット ジョイントが正のソフト リミットに達する",
    "isShowConfirm": "1"
  },
  "0x0F0009": {
    "description": "ロボット ジョイントが負のソフト リミットに達し、移動できなくなります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、JOG 移動中にロボットは限界に達しますが、コマンドは依然として限界の方向に移動し、エラー プロンプトが報告されます。",
    "action": "ロボットの現在位置が限界に達しており、ロボットが限界を超えて移動できないかどうかを確認します。",
    "tittle": "ロボット ジョイントが負のソフト リミットに達する",
    "isShowConfirm": "1"
  },
  "0x0F000A": {
    "description": "ターゲット位置が正の最大位置制限を超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、このエラーは、デカルト空間モーションによって指定されたコマンド位置が軸の最大制限を超えた場合に表示されます。",
    "action": "指定されたデカルト空間オブジェクトがアーム スパンを超えているかどうかを確認してください。",
    "tittle": "デカルト ターゲット位置が正の最大位置制限を超えています",
    "isShowConfirm": "1"
  },
  "0x0F000B": {
    "description": "ターゲット位置が負の最大位置制限を超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "通常、このエラーは、デカルト空間モーションによって指定されたコマンド位置が軸の最大制限を超えた場合に表示されます。",
    "action": "指定されたデカルト空間オブジェクトがアーム スパンを超えているかどうかを確認してください。",
    "tittle": "デカルト ターゲット位置が負の最大位置制限を超えています",
    "isShowConfirm": "1"
  },
  "0x0F000E": {
    "description": "ホームプロセス中は手動操作はできません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "このエラーは、一般的にロボットの原点復帰設定プロセス中にロボットの手動モーション制御が実行された場合に表示されます。",
    "action": "ロボットが現在ゼロに戻っているかどうかを確認し、そうであれば、ロボットがゼロに戻るのを待ってから続行します。",
    "tittle": "ジョイント原点復帰中は手動操作不可",
    "isShowConfirm": "1"
  },
  "0x0F000F": {
    "description": "コマンド ジョイント インデックスが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "この問題は通常、デカルト空間で単一の軸を制御するとき、またはジョイント空間で単一のジョイントを制御するときに、指定された軸/ジョイント インデックスが無効であることが原因で発生します。",
    "action": "コマンドで指定されたインデックスが正しいかどうかを確認してください",
    "tittle": "コマンド ジョイント インデックスが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0010": {
    "description": "無効なモーション コマンド速度",
    "type": "1",
    "isShowOTA": "0",
    "reason": "内部予約",
    "action": "内部予約",
    "tittle": "無効なモーション コマンド速度",
    "isShowConfirm": "1"
  },
  "0x0F0011": {
    "description": "モーション命令の目標位置が機械限界を超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節運動または直線運動の目標位置がロボットの限界を超えています。",
    "action": "手動ジョグ、目標位置に到達可能かどうか、ジョイント制限を超えるかどうかを確認します。",
    "tittle": "モーション命令の目標位置が機械限界を超えています",
    "isShowConfirm": "1"
  },
  "0x0F0012": {
    "description": "ノンジョイントモードは原点復帰不可",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ノンジョイントモードは原点復帰不可",
    "isShowConfirm": "1"
  },
  "0x0F0013": {
    "description": "ホーム進行中",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ホーム進行中",
    "isShowConfirm": "1"
  },
  "0x0F0014": {
    "description": "保護モードを終了できませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "保護モードを終了できませんでした",
    "isShowConfirm": "1"
  },
  "0x0F0015": {
    "description": "ロボットが起動しない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ロボットが起動しない",
    "isShowConfirm": "1"
  },
  "0x0F0016": {
    "description": "ロボット関節がソフトリミットにある",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットの関節がソフト リミットにあり、指示操作を完了できません。",
    "action": "ロボットの関節の現在の状態を確認し、関節の限界に達しているかどうかを確認します。限界に達している場合は、オーバーラン方向に移動し続けることはできませんが、オーバーランしない方向にしか移動できません。ティーチングページのジョイントリミット範囲までオーバーランさせるか、設定ページでリミットを修正してください。",
    "tittle": "ロボット関節がソフトリミットにある",
    "isShowConfirm": "1"
  },
  "0x0F0017": {
    "description": "モーション命令の目標位置に到達できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーション命令の目標位置に到達できません。",
    "action": "ターゲット位置が動作範囲外または特異点にあります。手動操作では、ジョイントがターゲット ポイントに移動できるかどうかを確認します。可能であれば、現在のロボットのポーズを変更して、他のパスまたはポーズからターゲット ポイントに到達することを検討してください。",
    "tittle": "モーション命令の目標位置に到達できません",
    "isShowConfirm": "1"
  },
  "0x0F0018": {
    "description": "特異点が保護停止に達した",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットはモーション パスで特異な構成に到達しようとしており、デカルト空間で移動を続けることができません。このエラーは通常、逆解の計算時にエラーが発生した場合、または計算された逆解が前のサイクルとは異なる解空間にある場合に報告されます。",
    "action": "ロボットの現在の経路と姿勢が到達可能かどうかを確認し、そうでない場合は、目標位置に到達するように初期姿勢または経路を変更します。コマンドパスに問題がないことを確認できた場合は、関連資料を採取し、JAKA技術員までご連絡ください。",
    "tittle": "特異点が保護停止に達した",
    "isShowConfirm": "1"
  },
  "0x0F0019": {
    "description": "CAN デバイスの初期化に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "CAN デバイスの初期化に失敗しました。",
    "action": "オフライン シミュレーション環境では、CAN デバイスがない場合、エラーが報告され、その後の最適化が実行されます。実機環境では、ロボットを再起動してください。問題が解決しない場合は、JAKA 技術サービス担当者に連絡してください。",
    "tittle": "CAN デバイスの初期化に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F001A": {
    "description": "ワンクリック アップグレードのタイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ワンクリック アップグレードに時間がかかりすぎる",
    "action": "続行する前に、ネットワークの状態と機器の状態を確認してください。",
    "tittle": "ワンクリック アップグレードのタイムアウト",
    "isShowConfirm": "1"
  },
  "0x0F001B": {
    "description": "ワンクリック アップグレードの例外",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ワンクリック アップグレードに失敗しました",
    "action": "ワンキー アップグレード パッケージのソースと有効性を確認してください。",
    "tittle": "ワンクリック アップグレードの例外",
    "isShowConfirm": "1"
  },
  "0x0F001C": {
    "description": "コントローラ起動中、連合制限データが正常ではありません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "関節限界値を修正してください",
    "tittle": "コントローラ起動中、連合制限データが正常ではありません",
    "isShowConfirm": "1"
  },
  "0x0F001D": {
    "description": "ロボットの電源オンがタイムアウトしました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "電源オンの過程に異常が存在します",
    "action": "CAN通信が正常であるかどうかを確認してから、もう一度電源を入れ直してください",
    "tittle": "ロボットの電源オンがタイムアウトしました",
    "isShowConfirm": "1"
  },
  "0x0F001E": {
    "description": "ロボットの運動学的逆解で得られた関節の角度は期待値とは異なります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットが運働している間に関節の位置が変働するとこれを報告します。一般的には逆解を計算する時に間違ったり、逆解と前の週期の差の異常を計算する時に現れます",
    "action": "現在のロボットの経路と姿勢が到達可能か、または異常な位置の近くにあるかを確認します。そうであれば、初期の姿勢または経路を変更してください。指令経路に問題がないことが確認されましたら、関連データを収集してJAKA技術サービスマンに連絡してください",
    "tittle": "ロボットの運動における逆解異常です",
    "isShowConfirm": "1"
  },
  "0x0F001F": {
    "description": "ファームウェアアップグレードの進捗が長時間更新されていません。",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ファームウェアアップグレード中に未知の例外が発生した可能性があります。",
    "action": "制御キャビネットは10秒後に自動的に再起動します。コントローラーが再起動した後、ファームウェアバージョン番号が更新されているか確認してください。更新されていない場合は、ファームウェアインストールパッケージを再度アップロードしてアップグレードを試みてください。",
    "tittle": "ファームウェアアップグレードタイムアウト",
    "isShowConfirm": "1"
  },
  "0x0F0020": {
    "description": "目標位置への直線移動に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "目標位置への直線移動に失敗しました。一般的な直交運動 (直線または円弧運動) 中に特異点を通過した場合、特に始点または終点が特異点である場合に報告されます。",
    "action": "直動経路の点や目標点に到達できない場合や特異点を通過する場合は、ジョイントが目標点に移動できるか手動で確認し、可能であれば、現在のロボットの姿勢を変更して、他の経路や姿勢から目標点に到達することを検討してください。注: プログラム ポインターは実際のアクション ポインターよりも前にあるため、エラー メッセージは事前にトリガーされる場合があります。この問題に対処するときは、オペレーティング プログラムの後続のコマンドが現在の場所に基づいて到達可能かどうかを確認してください。",
    "tittle": "目標位置への直線移動に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0021": {
    "description": "ロボットモデルはサポートしていません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボット モデルはサポートされていません。一般的に、最新のコントローラ ソフトウェアは既存のすべてのロボット モデルをサポートしますが、この問題は、新しいモデルのロボットを古いコントローラ ソフトウェアに接続するときに発生します。この問題が発生した場合、ロボットの DH パラメータ、動的パラメータ、およびさまざまな制限が間違っている可能性がありますので、慎重に制御を有効にしてください。",
    "action": "APP 情報ページでロボットのシリアル番号を確認し、JAKA に連絡して、サポートされているソフトウェア バージョンを入手してください。",
    "tittle": "ロボットモデルはサポートしていません",
    "isShowConfirm": "1"
  },
  "0x0F0022": {
    "description": "ロボットのシリアル番号が無効です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットのシリアル番号が無効です。コントローラ ソフトウェアは特定のロボット モデルをサポートし、特定のロボット モデルには特定のコーディング ルールがあります。実機のロボットのシリアル番号はサーボから読み取られ、シリアル番号がサポートされているモデルとルールを満たしていない場合、エラーが報告されます。",
    "action": "APP 情報ページでロボットのシリアル番号を確認し、ロボット本体の実際のシリアル番号を確認し、シリアル番号が正しく設定されているかどうかを確認します。シリアル番号が正しい場合は、JAKA に連絡して最新バージョンを入手してください。",
    "tittle": "ロボットのシリアル番号が無効です",
    "isShowConfirm": "1"
  },
  "0x0F0023": {
    "description": "contact JAKA for support",
    "type": "1",
    "isShowOTA": "0",
    "reason": "負荷識別トラック インデックスが無効です",
    "action": "負荷識別トラック インデックスが無効です",
    "tittle": "update controller",
    "isShowConfirm": "1"
  },
  "0x0F0024": {
    "description": "倍率モードでは倍率を設定できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "倍率モードでは倍率の設定はできません。このエラーは通常、ロボットがオーバーライド モードまたはオーバーライドを設定するための保護停止モードにある場合に表示されます。",
    "action": "ロボットが現在拡大モードになっているかどうかを確認してください。拡大モードになっている場合は、まず拡大モードを終了してから倍率を設定してください。ロボットが拡大モードになっていない場合は、現在のソフトウェア バージョンを確認し、JAKA 技術サービス担当者に連絡してください。 .",
    "tittle": "倍率モードでは倍率を設定できません",
    "isShowConfirm": "1"
  },
  "0x0F0025": {
    "description": "荷重識別軌跡の定義が仕様を満たしていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "荷重識別軌跡の定義が仕様を満たしていません。ロボット負荷の識別は、識別結果の精度を確保するために特定の制約を満たす必要があります。ユーザー入力がプロンプト要件を満たしていない場合、質問が表示されます。",
    "action": "アプリの荷重識別インターフェイスでプロンプトが表示される軌道指定に従って操作し、荷重識別を再度実行してください。",
    "tittle": "荷重識別軌跡の定義が仕様を満たしていません",
    "isShowConfirm": "1"
  },
  "0x0F0026": {
    "description": "電源を切る前に有効にしてください",
    "type": "2",
    "isShowOTA": "0",
    "reason": "電源を切る前に有効にしてください",
    "action": "まず有効にしてから電源を切ってください。",
    "tittle": "電源を切る前に有効にしてください",
    "isShowConfirm": "1"
  },
  "0x0F0027": {
    "description": "プログラムの実行中は有効にできません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "プログラムの実行中に有効にすることはできません。",
    "action": "最初にプログラムを停止してから有効にしてください。",
    "tittle": "プログラムの実行中は有効にできません",
    "isShowConfirm": "1"
  },
  "0x0F0028": {
    "description": "負荷設定にずれがあります、ご確認ください",
    "type": "1",
    "isShowOTA": "0",
    "reason": "負荷設定にずれがないか確認してください。通常、このエラー プロンプトは、有効化が完了するとチェックされます。ロボットの実際の出力トルクとフィードフォワード トルクの偏差が特定の範囲を超えると、このエラーが報告され、有効になります。",
    "action": "1. ペイロードと重心の設定が正しいか確認してください。\n2. ロボットの型式、製造番号が正しいか確認してください。\n3. ロボットの取り付け天使が正しいか確認してください。",
    "tittle": "負荷設定に偏りがある",
    "isShowConfirm": "1"
  },
  "0x0F0029": {
    "description": "円運動コマンドの追加に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "円運動ティーチング用に 3 つの共線または特異点を追加",
    "action": "1. 円弧移動の始点、中間点、終点が一致しているかどうかを確認してください\n2. 円弧移動の始点、中間点、終点が特異点であるかどうかを確認してください",
    "tittle": "円運動コマンドの追加に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0030": {
    "description": "ジョイント速度制限は 0 に設定されています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "関節速度の限界値は0です",
    "action": "APP セキュリティ設定インターフェイスの「関節速度制限」値が 0°/s に設定されているかどうかを確認します",
    "tittle": "ジョイント速度制限は 0 に設定されています",
    "isShowConfirm": "1"
  },
  "0x0F0031": {
    "description": "ポジション イネーブル リミット",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全設定で 3 位置有効化安全機能を構成して有効にします。",
    "action": "3 ポジション有効化安全機能には、ロボット制御に制限があります。3 ポジション スイッチの状態を確認するか、安全状況に応じて 3 ポジション有効化機能を無効にすることを選択してください。",
    "tittle": "ポジション イネーブル リミット",
    "isShowConfirm": "1"
  },
  "0x0F0032": {
    "description": "直線または円弧モーション以外のモーション タイプは追跡できません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コンベヤ ベルト トラッキングはデカルト空間モーション タイプのみを追跡できますが、非線形モーションとスムーズ モーションの他のモーション タイプはコンベヤ ベルト トラッキング モジュールにネストされています。",
    "action": "非線形モーションとスムーズ モーションの他のモーション タイプ モジュールがコンベア ベルト トラッキングにネストされているかどうかを確認してください。",
    "tittle": "直線または円弧モーション以外のモーション タイプは追跡できません",
    "isShowConfirm": "1"
  },
  "0x0F0033": {
    "description": "特異点が保護停止に達した",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットはモーション パスで特異な構成に到達しようとしており、デカルト空間で移動を続けることができません。このエラーは通常、移動中に逆解が異常な場合に表示されます。コンプライアンス制御やベルトコンベアトラッキングなどの外部トラッキングや補償がある場合、このエラーは外部入力の異常によっても発生する可能性があります。",
    "action": "1. ロボットの現在の経路と姿勢が到達可能かどうかを確認し、そうでない場合は、目標位置に到達するように初期姿勢または経路を変更するか、目標点の姿勢を変更します \n2. 現在、力制御コンプライアンス制御中の場合は、影響を排除するために異常な外力がないかどうかを確認してください \n3. コンベヤ ベルトが現在トラッキング状態にある場合は、コンベヤ ベルトの速度とエンコーダのフィードバックが正常かどうかを確認してください。大きな変動がこの問題の原因になります。",
    "tittle": "特異点が保護停止に達した",
    "isShowConfirm": "1"
  },
  "0x0F0034": {
    "description": "衝突を検知",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "JOINTG6": "ジョイント6モメンタムコリジョンアラーム",
        "JOINTG4": "ジョイント4モメンタムコリジョンアラーム",
        "JOINTG5": "ジョイント5モメンタムコリジョンアラーム",
        "END": "ロボットアームエンドセンサー",
        "JOINTG3": "ジョイント3モメンタムコリジョンアラーム",
        "JOINTG1": "ジョイント1モメンタムコリジョンアラーム",
        "SENSOR_WRONG_DATA": "センサーデータエラー",
        "JOINTP3": "ジョイント3サーボ衝突アラーム",
        "JOINTP2": "ジョイント2サーボ衝突アラーム",
        "JOINTP1": "ジョイント1サーボ衝突アラーム",
        "BASE": "ロボットアームベースセンサー",
        "JOINTP6": "ジョイント6サーボ衝突アラーム",
        "JOINTP5": "ジョイント5サーボ衝突アラーム",
        "JOINTP4": "ジョイント4サーボ衝突アラーム",
        "JOINTG2": "ジョイント2モメンタムコリジョンアラーム"
      }
    },
    "reason": "システムが衝突アラームを検出した： <0>.",
    "action": "1. ロボットの周囲に干渉物がなく、衝突していないことを確認する。\n2. ロボットのシリアル番号とモデル番号が正しく識別されているか確認してください。\n3. ロボットの荷重と取り付け角度が正しく設定されているか確認してください。\n4. トルクセンサを使用する場合は、センサの最大力制限が適切か確認してください。",
    "tittle": "衝突を検知",
    "isShowConfirm": "1"
  },
  "0x0F0035": {
    "description": "姿勢限界を超えた保護停止",
    "type": "1",
    "isShowOTA": "1",
    "reason": "姿勢限界外での保護停止が検出されました。この問題は、通常、ロボットの端がツールの限界までトリガーされたときに発生します。",
    "action": "現在のロボットの動作軌跡がツールリミットの設定範囲内にあるか確認してください。または、工具限界の有効範囲のサイズを変更してみてください。",
    "tittle": "姿勢限界を超えた保護停止",
    "isShowConfirm": "1"
  },
  "0x0F0036": {
    "description": "工具先端が最大位置偏差限界を超えています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボット ツール エンドの実際の位置と指令位置の間の偏差が、設定された偏差制限値を超えています。",
    "action": "ロボットの働きが指示位置からずれていないか、ユーザープロファイルの偏差制限値設定を大きくしていませんか",
    "tittle": "工具先端が最大位置偏差限界を超えています",
    "isShowConfirm": "1"
  },
  "0x0F0037": {
    "description": "ツールエンドライン速度が最高速度制限を超えています",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイントの移動中に、ロボットの端での線速度が設定された端での最大線速度制限を超えています。",
    "action": "アプリの「セキュリティ設定」--「衝突防止」インターフェースの TCP 速度制限が正しいかどうかを確認してください",
    "tittle": "ツールエンドライン速度が最高速度制限を超えています",
    "isShowConfirm": "1"
  },
  "0x0F0038": {
    "description": "関節動作命令の追加に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節可動域の設定がおかしい",
    "action": "現在のロボット関節位置と目標関節位置が正しいか確認してください",
    "tittle": "関節動作命令の追加に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0039": {
    "description": "TCPキャリブレーション教示ポイントの重複",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ティーチングポイントには2つ以上のティーチングポイントが重複しています",
    "action": "TCPを再較正し、同じ教学位置がないことを確認してください。",
    "tittle": "TCPキャリブレーション教示ポイントの重複",
    "isShowConfirm": "1"
  },
  "0x0F003A": {
    "description": "ロボットの運動中にイネーブルメントをオフにすることはできません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの運動中にイネーブルメントをオフにすることはできません",
    "action": "まずロボットの操作を停止してからエネルギーを下げてください",
    "tittle": "ロボットの運動中にイネーブルメントをオフにすることはできません",
    "isShowConfirm": "1"
  },
  "0x0F003B": {
    "description": "ロボットは電源を入れました繰り返して電源を入れる必要はありません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットは電源を入れました繰り返して電源を入れる必要はありません",
    "action": "ロボットは電源を入れました繰り返して電源を入れる必要はありません",
    "tittle": "ロボットは電源を入れました繰り返して電源を入れる必要はありません",
    "isShowConfirm": "0"
  },
  "0x0F003C": {
    "description": "ロボットが繰り返しなくてもできるようになりました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットが繰り返しなくてもできるようになりました",
    "action": "ロボットが繰り返しなくてもできるようになりました",
    "tittle": "ロボットが繰り返しなくてもできるようになりました",
    "isShowConfirm": "0"
  },
  "0x0F003D": {
    "description": "TCP座標系は、ティーチインポイントが同じ線上にあるときにキャリブレーションされます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "同じ直線上のティーチインポイントは、TCPのポーズを計算できなくなります。",
    "action": "適切なティーチングポイントをリセットしてください。",
    "tittle": "TCP座標系は、ティーチインポイントが同じ線上にあるときにキャリブレーションされます",
    "isShowConfirm": "1"
  },
  "0x0F003E": {
    "description": "TCP座標系のキャリブレーション誤差が事前設定されたしきい値を超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TCP座標系のキャリブレーション誤差が事前設定されたしきい値を超えています",
    "action": "適切なティーチングポイントをリセットしてください。",
    "tittle": "TCP座標系のキャリブレーション誤差が事前設定されたしきい値を超えています",
    "isShowConfirm": "1"
  },
  "0x0F003F": {
    "description": "TCP座標系のキャリブレーション座標が作業スペースを超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TCP座標系のキャリブレーション座標が作業スペースを超えています",
    "action": "適切なティーチングポイントをリセットしてください。",
    "tittle": "TCP座標系のキャリブレーション座標が作業スペースを超えています",
    "isShowConfirm": "1"
  },
  "0x0F0040": {
    "description": "ソフト リミットでドラッグ モードに入ることができません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソフト リミットではドラッグ モードに入ることができません。",
    "action": "ロボットの関節の現在の状態を確認し、関節の限界に達しているかどうかを確認します。限界に達している場合は、オーバーラン方向に移動し続けることはできませんが、オーバーランしない方向にしか移動できません。ティーチングページのジョイントリミット範囲までオーバーランさせるか、設定ページでリミットを修正してください。",
    "tittle": "ソフト リミットでドラッグ モードに入ることができません",
    "isShowConfirm": "1"
  },
  "0x0F0041": {
    "description": "ソフト リミットを超えてドラッグすると、ドラッグが終了します",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソフト リミットを超えてドラッグすると、ドラッグが終了します。このプロンプトは通常、ドラッグが制限を超えたときに表示されます。",
    "action": "ロボットの関節の現在の状態を確認してください。ロボットはオーバーラン方向に移動し続けることはできませんが、非オーバーラン方向にしか移動できません。オーバーランをドラッグして関節制限範囲に戻すか、ドラッグ モードを終了して、設定ページでソフトウェアを変更します.制限、ジョイントのソフト リミット範囲を増やしますが、ソフト リミットの設定範囲はハード リミットを超えることはできません。",
    "tittle": "ソフト リミットを超えてドラッグすると、ドラッグが終了します",
    "isShowConfirm": "1"
  },
  "0x0F0042": {
    "description": "コンプライアンスパラメータの設定に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "開力制御条件下ではソフトパラメータの設定ができない",
    "action": "強制制御が現在有効になっているかどうかを確認してください。 プログラムが柔軟設定命令を使用しているかどうかを確認し、強制力制御が無効になっていることを確認してから命令を実行してください。",
    "tittle": "力制御パラメータの設定に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0043": {
    "description": "ロボットが有効になっておらず、ドラッグに入ることができません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効になっていない場合、ロボットをドラッグすることはできません。この問題は通常、ロボットが有効になっていないときにドラッグ コマンドがトリガーされたことをロボットが検出した場合に発生します。",
    "action": "ロボットの電源が入っていて有効になっているかどうかを確認してください。これは、ドラッグ ボタンの外部トリガーによるものかどうかを確認してください。",
    "tittle": "ロボットが有効になっておらず、ドラッグに入ることができません",
    "isShowConfirm": "1"
  },
  "0x0F0044": {
    "description": "ロボットは現在アイドル状態ではないため、ドラッグ＆ドロップに入ることができません。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ドラッグアンドドロップモードは、ロボットがアイドル状態で静止していないと切り替わりません。",
    "action": "ロボットが動作中か、プログラムを実行中か、ツールドラッグモードか、エラー状態かを確認してください。ドラッグに入る前に、現在のジョブを停止するか、ロボットをエラー状態に戻してください。",
    "tittle": "現在、ロボットはドラッグ＆ドロップを実行できません。",
    "isShowConfirm": "1"
  },
  "0x0F0045": {
    "description": "関節トルクが限界を超えると引きずることができない",
    "type": "1",
    "isShowOTA": "1",
    "reason": "関節トルクが限界を超えると引きずることができません。一般的に言えば、ドラッグが速すぎるか、衝突が敏感すぎることが原因です。",
    "action": "ドラッグ速度を下げるか、設定インターフェイスで衝突レベルを高く設定します。",
    "tittle": "関節トルクが限界を超えると引きずることができない",
    "isShowConfirm": "1"
  },
  "0x0F0046": {
    "description": "ドラッグボタンがブロックされ、ドラッグに入ることができません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボット先端のドラッグボタン(FREE)の機能が無効になり、終了ボタン(FREE)によるドラッグ操作ができなくなります。",
    "action": "[設定-ハードウェアと通信-補助ハードウェア設定]でドラッグ&ドロップ機能を無効にするかどうかを確認してください。無効の場合はこの機能をオンにしてください。",
    "tittle": "ドラッグボタンがブロックされ、ドラッグに入ることができません",
    "isShowConfirm": "0"
  },
  "0x0F0047": {
    "description": "プログラムの一時停止/再開ボタンがブロックされました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボット先端のトップボタンのプログラム一時停止・再開機能が無効となり、トップボタンによるプログラム一時停止・再開操作ができなくなります。",
    "action": "ソフトウェアハードウェアと通信補助ハードウェアの設定で、プログラムの一時停止/再開機能が無効になっているかどうかを確認し、無効になっている場合は、この機能を有効にしてください。",
    "tittle": "プログラムの一時停止/再開ボタンがブロックされました",
    "isShowConfirm": "0"
  },
  "0x0F0048": {
    "description": "ポイントボタンがブロックされており、ポイントを記録できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボット終点ティーチングボタン（POINT）の機能が無効になり、終点ボタン（POINT）によるポイントティーチング操作ができなくなります。",
    "action": "ソフトウェアハードウェアと通信補助ハードウェアの設定でポイント記録機能が無効になっていないか確認し、無効になっている場合は有効にしてください。",
    "tittle": "ポイントボタンがブロックされており、ポイントを記録できません",
    "isShowConfirm": "0"
  },
  "0x0F0049": {
    "description": "エミュレーションモードでドラッグモードに入ることはできません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エミュレーションモードでドラッグモードに入ることはできません",
    "action": "ロボットの実行モードを確認し、シミュレーションを終了してドラッグアンドドロップモードに入ります",
    "tittle": "エミュレーションモードでドラッグモードに入ることはできません",
    "isShowConfirm": "1"
  },
  "0x0F004A": {
    "description": "コンプライアンスパラメータの設定に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムで力制御が有効になっている状態では、特定方向の力制御を直接オフにすることはできません",
    "action": "プログラムで力制御が有効になっているか、および有効状態で特定の力制御方向のチェックが外れていないか確認してください。該当する場合は、力制御をオフにして再試行してください",
    "tittle": "力制御パラメータの設定に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F004B": {
    "description": "プログラム実行中の手動校正は禁止です。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラム実行中の手動校正は禁止です。",
    "action": "現在実行中のプログラムを終了するか、終了するまで待ちます。",
    "tittle": "パワーセンサー校正失敗ゼロです",
    "isShowConfirm": "1"
  },
  "0x0F004C": {
    "description": "ツールを起動できませんドラッグ",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在、本体の関節ドラッグモードにあり、このモードでは、ツールドラッグと衝突し、ツールドラッグを直接起動することはできません。",
    "action": "関節ドラッグモードを外してからツールドラッグを起動します",
    "tittle": "ツールを起動できませんドラッグ",
    "isShowConfirm": "1"
  },
  "0x0F004D": {
    "description": "恒力柔順制御事故がオフになります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットはサーボ運働モードにあり、定力柔軟制御をオンにしています。サーボ運働モードを抜ける前に定力柔軟制御をオフにしようとすると、エラーが発生します。",
    "action": "現在の運働は終了して、プログラム論理を確認してください先にサーボ運働モードを退出してから恒力柔順制御をオフにします",
    "tittle": "恒力柔順制御事故がオフになります",
    "isShowConfirm": "1"
  },
  "0x0F004E": {
    "description": "ツールを起動できませんドラッグ",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ツールドラッグはロボットが正常に有効化されアイドル状態の場合にのみ有効にできます。ロボットが自動モード、関節ドラッグモード、または何らかの異常状態にある場合はツールドラッグを有効にできません。",
    "action": "ツールドラッグを有効にする前にロボットの状態を確認してください",
    "tittle": "ツールを起動できませんドラッグ",
    "isShowConfirm": "1"
  },
  "0x0F004F": {
    "description": "不思議な位置付近で直線や円弧運動をすると関節が加速しすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "デカルト空間で運動すると関節の加速が大きくなりすぎて、特にロボットの不思議な位置付近で直線や円弧運動をしているときに起こりやすいのです",
    "action": "直線や円弧の加速度や速度を落としたり,経路を変えたりします",
    "tittle": "異常な位置付近では停止の見込みです",
    "isShowConfirm": "1"
  },
  "0x0F0050": {
    "description": "トルクセンサが準備できていないので力制御機能を使用できない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルクセンサが準備できていないので力制御機能を使用できない。この問題は一般的に、力制御機能を使用したときに力センサが動作していないことを検出します。",
    "action": "トルクセンサーがONになっていることを確認してください。",
    "tittle": "トルクセンサーの準備ができていません",
    "isShowConfirm": "1"
  },
  "0x0F0051": {
    "description": "ツールドラッグモードでは力センサーを無効にできません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ツールドラッグモードが有効な場合、力センサーを直接無効にすることはできません。",
    "action": "センサーを無効にするには、まずツールドラッグモードを終了し、次にセンサーを無効にしてください",
    "tittle": "ツールドラッグモードでは力センサーを無効にできません",
    "isShowConfirm": "1"
  },
  "0x0F0052": {
    "description": "ツールドラッグ中の力センサー故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ツールドラッグ動作中に力センサーが故障しました。コントローラーと外部力センサー間の通信接続が切断された可能性があります。",
    "action": "ハードウェア接続ケーブル及びソフトウェア設定を含む、力センサーの通信状態を確認してください。",
    "tittle": "ツールドラッグ中の力センサー故障",
    "isShowConfirm": "1"
  },
  "0x0F0053": {
    "description": "センサゼロ校正期間は力制御モードに入ることを禁止し。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサゼロ校正はまだ完了していない。",
    "action": "センサゼロ校正過程は約0.5秒必要で、ゼロ校正が完了してから力制御モードに入るのを待ってください。",
    "tittle": "センサゼロ校正期間は力制御モードに入ることを禁止し",
    "isShowConfirm": "1"
  },
  "0x0F0054": {
    "description": "プログラムの実行中はシングルステップ操作を実行できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "プログラムの実行中は、シングル ステップ操作を実行できません。",
    "action": "シングルステップ デバッグ機能を使用する場合は、まず現在のプログラムの実行を停止してから、シングル ステップ デバッグを実行します。",
    "tittle": "プログラムの実行中はシングルステップ操作を実行できません",
    "isShowConfirm": "1"
  },
  "0x0F0055": {
    "description": "ドラッグ中は衝突感度を設定できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ドラッグ中は衝突感度を設定できません。",
    "action": "まずドラッグ モードを終了してから、感度を設定します。",
    "tittle": "ドラッグ中は衝突感度を設定できません",
    "isShowConfirm": "1"
  },
  "0x0F0056": {
    "description": "拡張 IO モジュールが実行されていないため、アクセスできません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "拡張 IO モジュールが実行されていないため、アクセスできません。",
    "action": "拡張 IO モジュールが IO モニタリング インターフェイスで実行されているかどうかを確認します。",
    "tittle": "拡張 IO モジュールが実行されていません",
    "isShowConfirm": "1"
  },
  "0x0F0057": {
    "description": "ロボットが動いているときは、ダイナミクス フィードフォワードを有効または無効にすることはできません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットが移動しているとき、ダイナミクス フィードフォワードを有効または無効にすることはできません。このエラーは、セカンダリ開発インターフェイスを使用している場合にのみ表示されます。",
    "action": "最初に現在のロボットのモーションを停止してから、ロボットのダイナミクス フィードフォワードを設定します。",
    "tittle": "ダイナミクス フィードフォワードを設定できません",
    "isShowConfirm": "1"
  },
  "0x0F0058": {
    "description": "機能ライセンスが検出されない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "機能使用ライセンスが検出されませんでした。一部の機能の起動にはソフトウェア認証が必要で、機能の使用中にソフトウェアが認証されていないことが検出された場合、このエラーが表示されます。",
    "action": "機能ライセンスを購入するには、JAKA スタッフにお問い合わせください。",
    "tittle": "機能ライセンスが検出されない",
    "isShowConfirm": "1"
  },
  "0x0F0059": {
    "description": "プロテクトストップリセット失敗",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保護停止リセットに失敗しました。一般に、保護停止解除操作中に保護停止機能入力がトリガ状態のままであることを検出した場合に、このエラーが表示されます。",
    "action": "ファンクション IO が保護停止をトリガーするかどうかを確認してください。そうである場合は、最初に保護停止モードを終了してから、保護停止をリセットしてください。",
    "tittle": "プロテクトストップリセット失敗",
    "isShowConfirm": "1"
  },
  "0x0F005A": {
    "description": "安全パラメータの設定操作は拒否されました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットが手動モードでない場合、または手動モードで移動中、またはツールをドラッグ&ドロップでオンにしている場合、セキュリティパラメータの設定を禁止します。",
    "action": "運働/ツールのドラッグ&ドロップを停止し、ロボットを手動モードに切り替えてから安全パラメータの設定を行います。",
    "tittle": "安全パラメータの設定操作は拒否されました",
    "isShowConfirm": "1"
  },
  "0x0F005B": {
    "description": "安全パラメータの設定操作は拒否されました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットが有効状態の場合、安全パラメーターの設定は禁止されています。",
    "action": "安全パラメータを設定する前に、ロボットの電源を切ってください。",
    "tittle": "安全パラメータの設定操作は拒否されました",
    "isShowConfirm": "1"
  },
  "0x0F005C": {
    "description": "設定された安全パラメータが合理的な範囲内にないため、安全パラメータの設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "設定された安全パラメータ値が機能サポート範囲を超えています",
    "action": "安全パラメータを合理的な範囲内に修正してから、再度設定してください。",
    "tittle": "安全パラメータの値が異常です",
    "isShowConfirm": "1"
  },
  "0x0F005D": {
    "description": "安全パラメータの設定操作は拒否されました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットプログラムが実行中の場合、安全パラメータの設定は禁止されています。",
    "action": "安全パラメータを設定する前にプログラムを停止してください。",
    "tittle": "安全パラメータの設定操作は拒否されました",
    "isShowConfirm": "1"
  },
  "0x0F005E": {
    "description": "<0> が機種パラメータの範囲制限を超えています",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "MomentumLimitReduce": "縮小モードの運動量制限",
        "TcpVelLimit": "ロボットのTCP速度制限",
        "StoppingDistance": "ロボットの停止距離",
        "StoppingTimeReduce": "縮小モード停止時間",
        "TcpVelReduce": "縮小モードTCP速度制限",
        "StoppingTime": "ロボットの停止時間",
        "StoppingDistReduce": "縮小モード停止距離",
        "MomentumLimit": "ロボットの運動量制限",
        "ElbowVelLimitReduce": "縮小モードの肘の速度制限",
        "RobotPowerLimit": "ロボットの電力制限",
        "PoewrLimitReduce": "縮小モードの電力制限"
      }
    },
    "reason": "<0> モデルパラメータの範囲制限を超える",
    "action": "ロボットのシリアル番号：{0}\n設定された <0> の値: {1}\n<0>の最小値：{2}\n<0>の最大値：{3}\n安全パラメータを設定する際には、<0> パラメータが設定可能な範囲内にあることを確認してください。\nすべて正しいことを確認したら、「確定」ボタンをクリックして設定を更新してください。",
    "tittle": "安全パラメータの競合",
    "isShowConfirm": "1"
  },
  "0x0F0060": {
    "description": "オーバーライドは保護停止モードでは設定できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "オーバーライドは、保護停止モードでは設定できません。",
    "action": "保護停止モードを解除してから、ロボットの倍速を設定してください。",
    "tittle": "オーバーライドは保護停止モードでは設定できません",
    "isShowConfirm": "1"
  },
  "0x0F0061": {
    "description": "ユーザー座標系の調整に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "選択したキャリブレーションポイントが適切でないため、ユーザー座標系のキャリブレーションに失敗します。",
    "action": "適切なティーチングポイントをリセットしてください。",
    "tittle": "ユーザー座標系の調整に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0062": {
    "description": "TIO RS485チャンネルのフォースセンサーモードが有効でありません",
    "type": "2",
    "isShowOTA": "0",
    "reason": " TIO RS485チャンネルのフォースセンサーモードが有効になっていません。TIOフォースセンサーを有効化する際に異常なピン多重化構成が検出されました。",
    "action": "フォースセンサー設定でセンサータイプVIを選択した場合、フォースセンサーを有効化するとTIOチャンネルが正しくフォースセンサーモードに設定されているかどうかを検出します。正しく設定されていない場合は上記エラーが表示されます。関連設定を確認してください。",
    "tittle": "TIO RS485チャンネルのフォースセンサーモードが有効でありません",
    "isShowConfirm": "1"
  },
  "0x0F0063": {
    "description": "TIO RS485設定がハードウェア要件を満たしていません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "CANチャンネルの帯域幅制限により、TIO RS485の設定は以下の規則に従う必要があります：Sシリーズロボットの場合、1つの485チャンネルのみ多重化が許可され、全ての485チャンネルをフォースセンサーモードで設定することはできません。その他の機種では、1つの485チャンネルのみをフォースセンサーモードに設定することが許可されます",
    "action": "設定中にこのエラーが表示された場合は、規則に準拠していることを確認してから再設定してください。ロボットの起動/通電時にこのメッセージが表示された場合、機種切り替えによるユーザー設定の不一致が原因である可能性があります。ロボットは問題のあるユーザー設定を自動的に無視し、デフォルト設定を適用します。このメッセージを消すには、IOパネル/ツール端末に移動し、DOとAIの機能設定を再設定して旧設定を上書きしてください。注：現在の設定ページには強制変更された設定が表示されますが、以前保存されたユーザー設定ファイルは更新されておらず、表示内容と不一致の場合があります。手動で確認操作が必要です。",
    "tittle": "TIO RS485設定の不正",
    "isShowConfirm": "1"
  },
  "0x0F0064": {
    "description": "通信パラメータの変更に失敗しました。このチャンネルを使用するフォースセンサーが作動中です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TIO RS485通信パラメータの変更に失敗しました。このチャンネルを使用するフォースセンサーが作動中です。",
    "action": "フォースセンサー作動中は通信パラメータの変更が禁止されています。まず運転を停止してから、通信パラメータの変更操作を行ってください。",
    "tittle": "通信パラメータ変更失敗",
    "isShowConfirm": "1"
  },
  "0x0F0065": {
    "description": "セマフォ定義が無効です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "セマフォ定義が無効です。最終的な Modbus グリッパーの状態は、セマフォ メカニズムを通じて照会され、セマフォの定義は、名前、機能コード、アドレスなどを含む特定の仕様を満たす必要があります。このエラーは、定義仕様が満たされていない場合に表示されます。",
    "action": "現在の TIO RS485 チャネル ID が正しいかどうか、指定されたチャネル モード設定が Modbus RTU であるかどうか、機能コードがサポートされているかどうかを確認してください (現在、機能コード 01. 02. 03. および 04 のみがサポートされています)。",
    "tittle": "セマフォ定義が無効です",
    "isShowConfirm": "1"
  },
  "0x0F0066": {
    "description": "セマフォがサポートされている最大数 (8) を超えています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "帯域幅によって制限され、サポートされるセマフォの数には制限があり、最大 8 つまでサポートされ、数がこの数を超えるとエラーが報告されます。",
    "action": "現在、最大 8 つのセマフォを定義できます。不要なセマフォ定義を削除してください。",
    "tittle": "セマフォがサポートされている最大数を超えています",
    "isShowConfirm": "1"
  },
  "0x0F0067": {
    "description": "指定されたセマフォが存在しません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "指定されたセマフォは存在しません。このエラーは通常、ジョブ プログラムに存在しないセマフォを参照します。",
    "action": "セマフォ関連のプログラム呼び出しとセマフォ定義を調べて、未定義のセマフォへの参照がないか確認してください。",
    "tittle": "指定されたセマフォが存在しません",
    "isShowConfirm": "1"
  },
  "0x0F0068": {
    "description": "TIO RS485 コマンドの送信に失敗しました コマンド キューがいっぱいです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コマンド キューがいっぱいで、TIO RS485 コマンドの送信に失敗しました。この問題は、通常、セマフォ リフレッシュを高頻度で呼び出したり、命令を送信したりする場合に発生します。",
    "action": "CAN 通信帯域幅によって制限され、TIO+ 関連のクエリおよび設定コマンドはバッファリングされます。アプリケーション層のリフレッシュ レートが帯域幅よりも高い場合、この情報が表示されます。動作中のプログラムやアプリケーションのコマンド呼び出し頻度を下げてください。",
    "tittle": "TIO RS485 コマンドの送信に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0069": {
    "description": "TIO RS485 コマンド フィードバック タイムアウトの受信",
    "type": "1",
    "isShowOTA": "0",
    "reason": "TIO RS485 コマンド フィードバック タイムアウトの受信",
    "action": "TIO RS485 コマンド フィードバックの受信がタイムアウトしました。この問題は通常、コントローラが RS485 コマンドを送信し、フィードバックがタイムアウトになるまで待機しているときに発生します。",
    "tittle": " check the communication between the controller and the robot.  ",
    "isShowConfirm": "1"
  },
  "0x0F006A": {
    "description": "プログラムの保存過程でMoveZS命令の生成が失敗しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムの保存過程でMoveZS命令のパラメーター設定が不正であることが検出されました。",
    "action": "プログラム内のMoveZS命令のパラメーターを確認し、'開始位置'、'終了位置'、'任意位置' の3つのパラメーターが正しいことを確認後、プログラムを再保存してください。",
    "tittle": "命令生成失敗",
    "isShowConfirm": "1"
  },
  "0x0F006B": {
    "description": "デジタル出力ポートは使用できません。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "出力ポート[{0}: Pin_{1}]は、機能デジタル出力（DO）または安全デジタル出力（DO）として設定されており、一般的なデジタル出力（DO）として変更することは許可されていません。",
    "action": "1: ポート[{2}: pin_{3}]の機能設定を解除します。\n2: 指示によるポート[{4}: pin_{5}]の状態設定は行わないでください。",
    "tittle": "デジタル出力ポートは使用できません。",
    "isShowConfirm": "1"
  },
  "0x0F006C": {
    "description": "倍率モードでは倍率を設定できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "倍率モードで倍率を設定できません。",
    "action": "倍率モードを終了してから、ロボットの速度倍率を設定してください。",
    "tittle": "倍率モードでは倍率を設定できません",
    "isShowConfirm": "1"
  },
  "0x0F006D": {
    "description": "力センサーフィードバック値がリミット超え",
    "type": "0",
    "isShowOTA": "0",
    "reason": "力センサーのフィードバック値が最大測定範囲を超えています。センサーに加わる力やトルクが過大です。",
    "action": "力センサーにかかる負荷を確認し、加わる力やトルクが適正範囲内に収まるようにしてください。",
    "tittle": "力センサーフィードバック値がリミット超え",
    "isShowConfirm": "1"
  },
  "0x0F006E": {
    "description": "力センサーが外力を検知",
    "type": "0",
    "isShowOTA": "0",
    "reason": "ツールドラッグモードに入ると、センサーは3Nまたは0.2Nm以上の外力を検出します。",
    "action": "センサーに外力が加わっていないか確認してください。センサーに外力が加わっていない場合、センサーがゼロ校正されていないか、センサーが読み取り値を取得できず、ロボットの位置がドリフトしている可能性があります。",
    "tittle": "力センサーが外力を検知",
    "isShowConfirm": "1"
  },
  "0x0F006F": {
    "description": "<0>インターフェースを呼び出しています。これは旧バージョンコントローラのインターフェースであり、現行バージョンでは<1>インターフェースに置き換えられています。互換性維持のため現在は保持されていますが、今後のバージョンで削除される可能性があります。",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "SET_ADMITTANCE_FRAME": "アドミタンス座標系の設定",
        "SET_COMPLIANCE_ENABLE": "センサーの初期化",
        "SET_ADMITTANCE_CONFIG": "アドミタンス・パラメーターの設定"
      },
      "1": {
        "SET_FORCE_SENSOR_ZERO": "センサーのゼロ調整",
        "SET_CSTF_DRAG_FRAME": "定力コンプライアンス座標系とツールドラッグ座標系の設定",
        "SET_CSTF_DRAG_CONFIG": "定力コンプライアンス制御用パラメータとツールドラッグ制御用パラメータの設定"
      }
    },
    "reason": "特定の特殊バージョンまたはバージョン不一致のAPP/SDKを使用する場合、この警告が表示される可能性があります。この警告は正常な使用に影響せず、あくまで参考情報です。",
    "action": "現在のインターフェースは正常に呼び出され、関連コマンドが実行されました。この警告は参考情報であり、正常な使用に影響しません。この表示を非表示にするには、バージョンリリースノートを参照し、適切なバージョン番号を選択してAPP/SDKを更新してください。",
    "tittle": "互換性インターフェースの呼び出し中",
    "isShowConfirm": "1"
  },
  "0x0F0070": {
    "description": "オントロジー DH パラメータ読み取り検証例外",
    "type": "2",
    "isShowOTA": "1",
    "reason": "電源投入時にサーバーの DH パラメータを読み取る際の CRC エラー",
    "action": "再起動してください。解決できない場合や頻繁に発生する場合は、サーボをアップグレードしてください。",
    "tittle": "ロボット DH パラメータ読み取り検証例外",
    "isShowConfirm": "1"
  },
  "0x0F0071": {
    "description": "運動パラメータ読み取り検証例外",
    "type": "2",
    "isShowOTA": "1",
    "reason": "電源投入時にサーボエンドの動的パラメータを読み取る際のCRCエラー",
    "action": "再起動してください。解決できない場合や頻繁に発生する場合は、サーボをアップグレードしてください。",
    "tittle": "ロボットの動的パラメータの読み取りと検証が異常です",
    "isShowConfirm": "1"
  },
  "0x0F0072": {
    "description": "サーボから DH またはキネティック パラメータを読み取ると、ロボットが有効にならない",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボから DH またはキネティック パラメータを読み取っても、ロボットを有効にすることはできません。この問題は通常、ロボットの電源を入れた直後に電源を入れると発生します。この時点で DH パラメータが保存され、サーボで有効になっている場合、このエラーが報告される可能性が高くなります。",
    "action": "電源投入後、コントローラはサーボから DH パラメータを読み取ります。その間、ロボットは無効になります。待機後に有効にしても表示される場合は、コントローラとロボット間の通信リンクを確認してください。障害が続く場合は、JAKA 技術担当者に連絡してください。",
    "tittle": "サーボからパラメータを読み取る",
    "isShowConfirm": "1"
  },
  "0x0F0073": {
    "description": "ロボットの運動量の限界に達しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの運動量の限界に達しました。ロボット安全インターフェースは、ロボットの運動量の制限を設定でき、制限に達するとアラームがトリガーされます。",
    "action": "このエラーは警告であり、対処する必要はありません.ロボットの運動量の絶対値がユーザーが設定したしきい値よりも大きい場合、ロボットは自動的に減速します.",
    "tittle": "ロボットの運動量の限界に達しました",
    "isShowConfirm": "1"
  },
  "0x0F0074": {
    "description": "ロボットの TCP 速度制限に達しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットの TCP 速度制限に達しました。ロボット安全インターフェースは、ロボットの TCP 速度制限を設定でき、制限に達するとアラームがトリガーされます。",
    "action": "これは通知ポップアップ警告であり、無視しても問題ありません.セキュリティ設定インターフェイスの下の衝突保護でTCP速度制限が実装されているかどうかを確認できます.",
    "tittle": "ロボットの TCP 速度制限に達しました",
    "isShowConfirm": "1"
  },
  "0x0F0075": {
    "description": "安全面を超えようとしている",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全面を超えようとしており、ロボットは設定された安全面の範囲内でしか動作できません。",
    "action": "安全面の設定が現実に沿っているかどうかを確認してください",
    "tittle": "安全面を超えようとしている",
    "isShowConfirm": "1"
  },
  "0x0F0076": {
    "description": "サーバー側の DH パラメータのバージョン番号が無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットのキネマティクス パラメータのバージョンがコントローラと互換性がありません",
    "action": "サーボをアップグレードするか、コントローラをダウングレードしてください",
    "tittle": "サーバー側の DH パラメータのバージョン番号が無効です",
    "isShowConfirm": "1"
  },
  "0x0F0077": {
    "description": "サーバーの動的パラメーターのバージョン番号が無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラーと互換性のないロボット ダイナミクス パラメーターのバージョン",
    "action": "サーボをアップグレードするか、コントローラをダウングレードしてください",
    "tittle": "サーバーの動的パラメーターのバージョン番号が無効です",
    "isShowConfirm": "1"
  },
  "0x0F0078": {
    "description": "サーボ有効化操作が頻繁すぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アプリのメイン インターフェイス本体の有効化ボタンを連続してクリックします",
    "action": "アプリのメイン インターフェースで有効化ボタンを押した後、本体の端にあるブリージング ライトが 1 秒後に青から緑に変わるかどうかを観察します. 通常は青から緑に変わり、ブレーキ音が鳴ります。ジョイント「スナップ」",
    "tittle": "サーボ有効化操作が頻繁すぎる",
    "isShowConfirm": "1"
  },
  "0x0F0079": {
    "description": "エミュレーション/実機モードの切り替えができません。電源を切ってください",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源がオンで有効になっている場合、APP を使用してロボット シミュレーション/実機モード機能を切り替えると、エラーが表示されます。",
    "action": "ロボットの電源を切って有効にした後、シミュレーション/実機モード切り替え機能を変更してください。",
    "tittle": "エミュレーション/実機モードの切り替えができません。電源を切ってください",
    "isShowConfirm": "1"
  },
  "0x0F007A": {
    "description": "同じネットワーク セグメント内の 2 つのネットワーク ポートの IP を設定することはサポートされていません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "アプリ設定インターフェースのネットワーク設定インターフェースのIPアドレスが10.5.5.Xネットワークセグメントに設定されており、コントローラー自身のネットワークIPアドレスのネットワークセグメントと競合しています。",
    "action": "アプリ設定インターフェイスのネットワーク構成インターフェイスの IP 設定は、10.5.5.X ネットワーク IP セグメントでは許可されていません。標準コントローラーの下部ネットワークポートと MinCab の LAN2 ポートの変更後の IP アドレスは、変更後の静的 IP アドレスです。",
    "tittle": "同じネットワーク セグメント内の 2 つのネットワーク ポートの IP を設定することはサポートされていません",
    "isShowConfirm": "1"
  },
  "0x0F007B": {
    "description": "ツール姿勢安全制限を超えます",
    "type": "2",
    "isShowOTA": "0",
    "reason": "道具の姿勢制約を設定して開放しましたロボットは道具の姿勢制約を超え",
    "action": "ロボットの動きを制御する場合は、ツールの方向制約内で移動するか、ツールの方向制限の設定機能を変更します",
    "tittle": "ツール姿勢安全制限を超えます",
    "isShowConfirm": "1"
  },
  "0x0F007C": {
    "description": "エミュレーション/実機モードの切り替えができません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "VMはこの機能をサポートしていません",
    "action": "VMはこの機能をサポートしていません",
    "tittle": "エミュレーション/実機モードの切り替えができません",
    "isShowConfirm": "1"
  },
  "0x0F007D": {
    "description": "現在、センサーのゼロ調整はできない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサーがオフになっているか、センサーがゼロ調整中であるか、ロボットがツールドラッグまたはコンスタントフォースフレックスコントロールモードであるため、センサーのゼロ調整操作が実行できません。",
    "action": "ゼロキャリブレーションを行う前に、力センサーが正しく機能していること、ロボットがツールドラッグモードまたはコンスタントフォースフレックスコントロールモードでないことを確認してください。",
    "tittle": "現在、センサーのゼロ調整はできない",
    "isShowConfirm": "1"
  },
  "0x0F007E": {
    "description": "縮小モードでは減速率を設定できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "縮小モードでは減速率を設定できません。",
    "action": "まず縮小モードを終了し、その後にロボットの減速率を設定してください。",
    "tittle": "縮小モードでは減速率を設定できません",
    "isShowConfirm": "1"
  },
  "0x0F007F": {
    "description": "ロボットはドラッグモードにあり、イネーブルをオフにすることはできない。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットはドラッグモードにあり、イネーブルをオフにすることはできない。",
    "action": "ロボットをドラッグモードから外し、イネーブルのスイッチを切ってください。",
    "tittle": "ロボットはドラッグモードにあり、イネーブルをオフにすることはできない",
    "isShowConfirm": "1"
  },
  "0x0F0080": {
    "description": "電源オン状態でのロボットモデルの切り替えは許可されていません",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ロボットの電源がオンのときに、APP ロボット シミュレーション/実機モード機能を使用してロボット モデル モデルを切り替えると、エラーが表示されます。",
    "action": "ロボットの電源をオフにして有効にした後、シミュレーション/実機モード機能モデルの切り替え操作を実行します。",
    "tittle": "電源オン状態でのロボットモデルの切り替えは許可されていません",
    "isShowConfirm": "1"
  },
  "0x0F0081": {
    "description": "ロボットの移動中はパスワードのリセットはできません",
    "type": "2",
    "isShowOTA": "1",
    "reason": "ロボットがプログラムの実行状態にある場合、ユーザー権限パスワードを変更する操作を行うと、エラーが表示されます。",
    "action": "ロボットプログラムの動作状態を停止してから、ユーザー権限パスワードの変更をお試しください。",
    "tittle": "ロボットの移動中はパスワードのリセットはできません",
    "isShowConfirm": "1"
  },
  "0x0F0082": {
    "description": "パスワードリセットボタンが正常か確認してください",
    "type": "2",
    "isShowOTA": "1",
    "reason": "パスワードリセットボタンが正しく機能していません。",
    "action": "パスワードリセットボタンが正常かどうかを確認するか、技術サービス担当者に連絡してください。",
    "tittle": "パスワードリセットボタンが正常か確認してください",
    "isShowConfirm": "1"
  },
  "0x0F0083": {
    "description": "ジョイントの減速に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "制限速度を下回る現在のモーションのジョイント速度を自動的に修正できません",
    "action": "安全設定で制限速度を上げるか、指令速度を下げてください",
    "tittle": "ジョイントの減速に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0084": {
    "description": "円形コンベアP1, P2, P3の3点共線",
    "type": "1",
    "isShowOTA": "1",
    "reason": "3点が重なったり、共線の場合は、ベルトコンベアの中心座標系を特定できません",
    "action": "この3点を改めて示し,3点が重なったり,共線になったりしないようにお願いします",
    "tittle": "円形コンベアP1, P2, P3の3点共線",
    "isShowConfirm": "1"
  },
  "0x0F0085": {
    "description": "リニアコンベアトラッキング方向がゼロ",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ベルトコンベヤー方向0時追尾方向を特定できません",
    "action": "直線ベルトトラッキング指示ブロックの ベルト方向 をチェックして、示教の始点と終点が重なったり、入力XYZ値がゼロにならないようにしてください",
    "tittle": "リニアコンベアトラッキング方向がゼロ",
    "isShowConfirm": "1"
  },
  "0x0F0086": {
    "description": "認識結果の取得に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1.アイデンティティ検査中にアイデンティティ検査データファイルが失われた、\n2.荷重のあるトラックと荷重のないトラックは一致しません。\n3.識別軌跡が短すぎる、",
    "action": "",
    "tittle": "認識結果の取得に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0087": {
    "description": "時間的最適解が見つからない",
    "type": "1",
    "isShowOTA": "1",
    "reason": "時間的最適解が見つからない",
    "action": "コマンド速度を下げて再試行するか、モーションプランニングに別のプランナーを使用してください",
    "tittle": "時間的最適解が見つからない",
    "isShowConfirm": "1"
  },
  "0x0F0088": {
    "description": "ペイロード識別はフロアマウントでのみサポートされます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "ペイロード識別はフロアマウントでのみサポートされます",
    "isShowConfirm": "1"
  },
  "0x0F0089": {
    "description": "軌道の繰り返しは、緊急停止後のプログラム操作の再開をサポートしておらず、プログラムは緊急停止後に停止します.",
    "type": "2",
    "isShowOTA": "0",
    "reason": "軌道の繰り返しは、緊急停止後のプログラムの再開をサポートしません",
    "action": "軌道の繰り返しは、緊急停止後のプログラムの再開をサポートしません",
    "tittle": "プログラム操作を再開するための緊急停止を実行できません",
    "isShowConfirm": "1"
  },
  "0x0F008A": {
    "description": "デジタル出力用に設定されたIOピンの入力/出力タイプに矛盾があります",
    "type": "2",
    "isShowOTA": "0",
    "reason": "IOピンが入力タイプの場合、デジタル出力を設定できません",
    "action": "デジタル出力を再設定する前に、操作されるIOピンが出力タイプであることを確認してください。",
    "tittle": "デジタル出力の設定に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F008B": {
    "description": "デジタル入力信号が異常であり、このIOピンの信号状態に基づいて動作指令をスキップすることができません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "IOピンが出力タイプの場合、デジタル入力を取得できません。",
    "action": "入力信号に基づいて動作指令をスキップする操作を実行する前に、操作されるIOピンが入力タイプであることを確認してください。",
    "tittle": "デジタル入力信号を取得して動作指令をスキップすることに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F008C": {
    "description": "IOインデックスが範囲外で、関連するIO操作は無効です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "IOインデックスが範囲外です",
    "isShowConfirm": "1"
  },
  "0x0F008E": {
    "description": "安全パラメータの設定操作は拒否されました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源が入っている時に安全IO関連の機能を設定することは禁止されています.",
    "action": "安全IO機能を設定する前に、ロボットの電源を切ってください.",
    "tittle": "安全パラメータの設定操作は拒否されました",
    "isShowConfirm": "1"
  },
  "0x0F008F": {
    "description": "ロボットアームの有効/無効操作が頻繁すぎる",
    "type": "2",
    "isShowOTA": "0",
    "reason": "アームのサーボ有効／無効操作が頻繁すぎるため、アームの関節を痛めやすい。",
    "action": "ロボットアームのイネーブル操作の時間間隔を調整してください、推奨イネーブル操作間隔は4秒以上です。",
    "tittle": "ロボットアームの有効/無効操作が頻繁すぎる",
    "isShowConfirm": "1"
  },
  "0x0F0090": {
    "description": "プログラム実行中に手動/自動モードを切り替えられない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラム実行中に手動/自動モードを切り替えられない",
    "action": "動作モードを切り替える前にプログラムを停止してください",
    "tittle": "プログラム実行中に手動/自動モードを切り替えられない",
    "isShowConfirm": "1"
  },
  "0x0F0091": {
    "description": "ロボット動作中に手動/自動モードの切り替えができない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボット動作中に手動/自動モードの切り替えができない",
    "action": "動作モードを切り替える前に移動を停止してください",
    "tittle": "ロボット動作中に手動/自動モードの切り替えができない",
    "isShowConfirm": "1"
  },
  "0x0F0092": {
    "description": "このDI機能をトリガーできない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "このDI機能をトリガーできない",
    "action": "この機能は手動モードではサポートされていません。モードを切り替えて再試行してください",
    "tittle": "このDI機能をトリガーできない",
    "isShowConfirm": "1"
  },
  "0x0F0093": {
    "description": "オートモードではこのDI機能をトリガーできない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "オートモードではこのDI機能をトリガーできない",
    "action": "この機能は自動モードではサポートされていません。モードを切り替えて再試行してください",
    "tittle": "オートモードではこのDI機能をトリガーできない",
    "isShowConfirm": "1"
  },
  "0x0F0094": {
    "description": "ロボットをドラッグしている間は手動/自動モードを切り替えることができません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットをドラッグしている間は手動/自動モードを切り替えることができません",
    "action": "操作モードを切り替える前に、ドラッグを停止してください",
    "tittle": "ロボットをドラッグしている間は手動/自動モードを切り替えることができません",
    "isShowConfirm": "1"
  },
  "0x0F0095": {
    "description": "プログラムの起動に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "マニュアルモードでは、起動プログラムシグナルを自動的にトリガーすることはできません。",
    "action": "",
    "tittle": "プログラムの起動に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0096": {
    "description": "機能設定エラー",
    "type": "2",
    "isShowOTA": "0",
    "reason": "自動モードで自動的に実行プログラムのシグナルをトリガーした後、設定されたデフォルトプログラムを自動的に読み込んで実行するには、「デフォルトプログラム」を正しく設定し、「デフォルトプログラムの自動読み込み」を有効にする必要があります。",
    "action": " 1.'設定'->'プログラム設定' ページで、正しい 'デフォルトプログラム' を設定し、 'デフォルトプログラムの自動ロード' を有効にします\n2.「デフォルトプログラム」は「none」にはできません。",
    "tittle": "自動起動プログラム機能の設定が間違っています。",
    "isShowConfirm": "1"
  },
  "0x0F0097": {
    "description": "機能設定エラー",
    "type": "2",
    "isShowOTA": "0",
    "reason": "'デフォルトプログラム' と 'デフォルトプログラム自動ロード' の両方を設定するか、どちらも設定しないようにする必要があります。両方が設定されている場合、自動実行プログラムの信号がトリガされると、設定された 'デフォルトプログラム' が自動的に読み込まれて実行されます。両方が設定されていない場合、自動実行プログラムの信号がトリガされると、現在開いているプログラムが実行されます。",
    "action": "1.'設定'->'プログラム設定' ページで、'デフォルトプログラム' と 'デフォルトプログラム自動ロード' を正しく設定してください。\n2.「デフォルトプログラム」は「none」にはできません。",
    "tittle": "機能設定エラー",
    "isShowConfirm": "1"
  },
  "0x0F0098": {
    "description": "自動でイネーブルに失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "マニュアルモードでは、有効化シグナルを自動的にトリガーすることはできません。",
    "action": "",
    "tittle": "自動でイネーブルに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0099": {
    "description": "ロボットが電源オンの状態でこの命令を実行することはできません。目標指令: {0}",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットが電源オンの状態でこの命令を実行することはできません。",
    "action": "ロボットの電源を切ってから、コマンド「{1}」を再実行してください。",
    "tittle": "指令の実行に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F00A0": {
    "description": "プログラム実行中にPROFINET接続断絶後のプログラム状態を設定できません。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラム実行中にPROFINET接続断絶後のプログラム状態を設定できません。",
    "action": "パラメータを設定する前にプログラムを停止してください。",
    "tittle": "プログラム実行中にPROFINET接続断絶後のプログラム状態を設定できません。",
    "isShowConfirm": "1"
  },
  "0x0F00A1": {
    "description": "プログラム実行中にEtherNet/IP接続断絶後のプログラム状態を設定できません。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラム実行中にEtherNet/IP接続断絶後のプログラム状態を設定できません。",
    "action": "パラメータを設定する前にプログラムを停止してください。",
    "tittle": "プログラム実行中にEtherNet/IP接続断絶後のプログラム状態を設定できません。",
    "isShowConfirm": "1"
  },
  "0x0F00A2": {
    "description": "PROFINETの接続断絶が検出されました。プログラムが一時停止しています。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "PROFINETの接続断絶が検出されました。プログラムが一時停止しています。",
    "action": "PROFINETの接続状態を確認してください。",
    "tittle": "PROFINETの接続断絶が検出されました。プログラムが一時停止しています。",
    "isShowConfirm": "1"
  },
  "0x0F00A3": {
    "description": "PROFINETの接続断絶が検出されました。プログラムが停止しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "PROFINETの接続断絶が検出されました。プログラムが停止しました。",
    "action": "PROFINETの接続状態を確認してください。",
    "tittle": "PROFINETの接続断絶が検出されました。プログラムが停止しました。",
    "isShowConfirm": "1"
  },
  "0x0F00A4": {
    "description": "EtherNet/IPの接続断絶が検出されました。プログラムが一時停止しています。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "EtherNet/IPの接続断絶が検出されました。プログラムが一時停止しています。",
    "action": "EtherNet/IPの接続状態を確認してください。",
    "tittle": "EtherNet/IPの接続断絶が検出されました。プログラムが一時停止しています。",
    "isShowConfirm": "1"
  },
  "0x0F00A5": {
    "description": "EtherNet/IPの接続断絶が検出されました。プログラムが停止しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "EtherNet/IPの接続断絶が検出されました。プログラムが停止しました。",
    "action": "EtherNet/IPの接続状態を確認してください。",
    "tittle": "EtherNet/IPの接続断絶が検出されました。プログラムが停止しました。",
    "isShowConfirm": "1"
  },
  "0x0F0100": {
    "description": "ロボットの電力制限を超えました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アプリの衝突設定インターフェイスの電力設定が、ロボットの動きに必要な電力よりも小さい",
    "action": "アプリ衝突設定インターフェースパワーアップパワー設定値、JAKAモデル荷重3KG参考値1000,荷重5KG\\7KG参考値1500,荷重12KG参考値2000,荷重18KG参考値2000",
    "tittle": "ロボットの電力制限を超えました",
    "isShowConfirm": "1"
  },
  "0x0F0101": {
    "description": "ロボット運動量超過",
    "type": "1",
    "isShowOTA": "1",
    "reason": "アプリの衝突設定インターフェイスの運動量設定が、ロボットの動きに必要な運動量よりも小さい",
    "action": "アプリの衝突設定インターフェースは運動量設定値を増加させます.JAKAモデル負荷3KG基準値は5,負荷5KG\\7KG基準値は10,負荷12KG基準値は30,負荷18KG基準値は50です.",
    "tittle": "ロボット運動量超過",
    "isShowConfirm": "1"
  },
  "0x0F0102": {
    "description": "ベースセンサーが衝突を検出しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "SP モデル ロボットの場合、ロボットが有効な状態にある場合、ベース センサー信号が異常に増加し、設定されたしきい値を超えて、アラームが発生します。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "ベースセンサーが衝突を検出しました",
    "isShowConfirm": "1"
  },
  "0x0F0103": {
    "description": "エンド フォースを超えました。1 つの軸が干渉を検出しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンド フォースを超えました。1 つの軸が干渉を検出しました",
    "isShowConfirm": "1"
  },
  "0x0F0104": {
    "description": "エンド フォースを超えました。2 軸の衝突が検出されました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンド フォースを超えました。2 軸の衝突が検出されました",
    "isShowConfirm": "1"
  },
  "0x0F0105": {
    "description": "エンド フォースを超えました。3 軸が干渉を検出しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンド フォースを超えました。3 軸が干渉を検出しました",
    "isShowConfirm": "1"
  },
  "0x0F0106": {
    "description": "エンド フォースを超えました。4 軸が衝突を検出しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンド フォースを超えました。4 軸が衝突を検出しました",
    "isShowConfirm": "1"
  },
  "0x0F0107": {
    "description": "エンドフォース超過、5軸衝突検出",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンドフォース超過、5軸衝突検出",
    "isShowConfirm": "1"
  },
  "0x0F0108": {
    "description": "エンドフォースが限界を超え、6軸が衝突を検出",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットがプログラム実行状態にあるとき、関節電流が急激に増加し、設定されたしきい値を超え、アラームが通知されます。",
    "action": "1. 機械が周辺機器と衝突していないか確認してください。 \n2. 移動中にロボットがケーブルに引っ張られていないか確認してください。 \n3. ロボットの加速度を適切に下げる 4. ロボットの端の負荷が正しいかどうかを確認する 5. ロボットの衝突レベルを上げてみる",
    "tittle": "エンドフォースが限界を超え、6軸が衝突を検出",
    "isShowConfirm": "1"
  },
  "0x0F0109": {
    "description": "安全面の設定点を同一線上または一致させることはできません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "安全平面の設定には、3 つのサーフェス ポイントと 1 つの安全ポイントが必要です。これらの 3 つのポイントはデカルト座標です。3 つのサーフェス ポイントが一致するか同一線上にある場合、エラーが報告されます。安全ポイントが安全平面上にある場合、エラーが報告されます。報告。",
    "action": "安全点が一致または同一線上にあるかどうか、および安全点が安全平面上にあるかどうかを確認してください。",
    "tittle": "安全面ポイント設定エラー",
    "isShowConfirm": "1"
  },
  "0x0F0110": {
    "description": "動的パラメータ設定が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットの電源が入らない",
    "action": "ロボットの電源が入らない",
    "tittle": "動的パラメータ設定が異常です",
    "isShowConfirm": "1"
  },
  "0x0F0111": {
    "description": "ダイナミクスパラメータ設定割込み",
    "type": "1",
    "isShowOTA": "0",
    "reason": "動的パラメータを設定する過程で、ロボットと電気制御盤の間の CAN 通信が異常です",
    "action": "1. ロボットの電源を切り、再度電源を入れてみてください。 \n2. ロボットと電気制御盤の間の強力な接続ラインに接続異常がないか確認してください。",
    "tittle": "ダイナミクスパラメータ設定割込み",
    "isShowConfirm": "1"
  },
  "0x0F0112": {
    "description": "パラメータ書き込みタイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "動的パラメータを設定する過程で、ロボットと電気制御盤の間の CAN 通信が異常です",
    "action": "1. ロボットの電源を切り、再度電源を入れてみてください。 \n2. ロボットと電気制御盤の間の強力な接続ラインに接続異常がないか確認してください。",
    "tittle": "動的パラメータ設定が異常です",
    "isShowConfirm": "1"
  },
  "0x0F0113": {
    "description": "コントローラソフトウェアはこのハードウェアと互換性がありません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "バージョン1.7.1に更新されたコントローラは、{0}をサポートしなくなります",
    "action": "を使用することを確認した場合は、対応するバージョン (v1.5 など) に更新してください。",
    "tittle": "サポートされていない制御キャビネットのタイプ",
    "isShowConfirm": "1"
  },
  "0x0F0114": {
    "description": "イネーブル状態での認識ができない",
    "type": "2",
    "isShowOTA": "0",
    "reason": "イネーブル状態での認識ができない",
    "action": "ロボットを使用してから識別してください",
    "tittle": "イネーブル状態での認識ができない",
    "isShowConfirm": "1"
  },
  "0x0F0115": {
    "description": "IP アドレスを取得できませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "IP アドレスを取得できませんでした",
    "action": "下部のネットワークポートの接続状態を確認します",
    "tittle": "IP アドレスを取得できませんでした",
    "isShowConfirm": "1"
  },
  "0x0F0116": {
    "description": "現在インストールされているアドオンの数が上限の 10 に達し",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在インストールされているアドオンの数が上限の 10 に達し",
    "action": "インストールを続行する前にいくつかのアドオンを削除してください",
    "tittle": "アドオンの数が制限を超えている",
    "isShowConfirm": "1"
  },
  "0x0F0117": {
    "description": "アドオン構成ファイル内のサービス対応ファイルが存在しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アドオン構成ファイル内のサービス対応ファイルが存在しません",
    "action": "アドオンインストールパッケージ内のサービスファイルが存在するかどうかを確認します",
    "tittle": "アドオンサービスが存在しません",
    "isShowConfirm": "1"
  },
  "0x0F0118": {
    "description": "AddOnポートのアイドルポート番号の表示に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOnポートのアイドルポート番号の表示に失敗しました",
    "action": "診断ログを保存し、技術者に連絡して処理してください",
    "tittle": "AddOnポートのアイドルポート番号の表示に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0119": {
    "description": "AddOnポート番号の割り当てに失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOnポート番号の割り当てに失敗しました",
    "action": "1.制御盤の再起動後に再起動を試みてください",
    "tittle": "AddOnポート番号の割り当てに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F011A": {
    "description": "実行中のAddOnに対して現在の操作を実行できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実行中のAddOnに対して現在の操作を実行できません",
    "action": "実行中のAddOnに対して現在の操作を実行できません",
    "tittle": "実行中のAddOn操作に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F011B": {
    "description": "停止したAddOnに対して現在の操作を実行できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "停止したAddOnに対して現在の操作を実行できません",
    "action": "停止したAddOnに対して現在の操作を実行できません",
    "tittle": "停止したAddOn操作に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F011C": {
    "description": "サポートされていないAddOn操作命令が存在します",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラにサポートされていないAddOn命令が存在する",
    "action": "コントローラの対応するバージョンのAddOnマネージャをアップグレードする",
    "tittle": "不明なAddOnアクション",
    "isShowConfirm": "1"
  },
  "0x0F011D": {
    "description": "システム内のAddOnに重複するポート占有率が存在する",
    "type": "1",
    "isShowOTA": "0",
    "reason": "システム内のAddOnに重複するポート占有率が存在する",
    "action": "1.コントローラを再起動して解決できるかどうかを試す\n2.直ちに診断ログを保存し、技術者に連絡して処理してください",
    "tittle": "システムAddOnポートの繰り返し",
    "isShowConfirm": "1"
  },
  "0x0F011E": {
    "description": "AddOn不明エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn不明エラー",
    "action": "診断ログを保存し、技術者に連絡して処理してください",
    "tittle": "AddOn不明エラー",
    "isShowConfirm": "1"
  },
  "0x0F011F": {
    "description": "システムAddOnに対して現在の操作を実行できませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "システムAddOnに対して現在の操作を実行できませんでした",
    "action": "システムAddOnに対して現在の操作を実行できませんでした",
    "tittle": "built-in AddOnを操作できませ",
    "isShowConfirm": "1"
  },
  "0x0F0120": {
    "description": "現在のバージョンで認識できないAddOnを操作できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOnのバージョンが低すぎる\n2.AddOnパケットフォーマットにエラーがあります",
    "action": "AddOnインストールパッケージが間違っていないことを確認してから再インストールしてください",
    "tittle": "操作が失敗しましたAddOnが失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0121": {
    "description": "AddOn内のconfig.iniファイルが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内のconfig.iniファイルが無効です",
    "action": "AdOn開発者に連絡し、AdOnインストールパッケージに間違いがないことを確認してから再インストールしてください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0122": {
    "description": "AddOnに必要な構成項目がありません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 2.0/3.0必要な構成項目［convention，description，version，type，languagetype，service，serviceenabled］\n2.AddOn convention 1.0必要な構成項目[binname,description,version,enabled,type]",
    "action": "AddOn開発者に問い合わせて、Addonに対応する構成項目がないことを確認してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0123": {
    "description": "AddOnポートエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在のエラーは使用されていません",
    "action": "現在のエラーは使用されていません",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0124": {
    "description": "AddOnプロファイル内のLanguageが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 3.0はlanguage[python 2，python，node-red]をサポートする\n1.AddOn convention 2.0はlanguage[python2,python]をサポートする\n1.AddOn convention 1.0はlanguage[python]をサポートする",
    "action": "AddOnインストールパッケージ内のconventionが対応するlanguageTypeをサポートしているかどうかを確認してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0125": {
    "description": "AddOnプロファイルのtypeエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddOn convention 2.0/3.0サポートtype[1.カスタム命令、2.カスタムサービス、3.カスタムUI]",
    "action": "AdOn開発者に連絡して、AdOnインストールパッケージが対応するtypeに対応しているかどうかを確認してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0126": {
    "description": "AddOnプロファイルのserviceenabledエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "serviceenabledは0または1でなければなりません",
    "action": "AdOn開発者に連絡して、AdOnインストールパッケージ構成serviceenabledが要件を満たしているかどうかを確認してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0127": {
    "description": "AddOnプロファイルのserviceエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.構成におけるサービス構成項目の欠落\n2.構成中のサービスは空ではなく、50を超えてはいけません",
    "action": "1.プロファイルにサービスプロファイルが存在するかどうかを確認する\n2.構成内のサービスバイト数の長さをチェックする",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F0128": {
    "description": "AddOn内のプロファイルが無効またはAdOnディレクトリ名が無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.AddonプロファイルでNameを空白にすることはできず、40バイトを超えてはいけない\n2.AddOnが存在するディレクトリ名は40バイトを超えてはならない",
    "action": "AddOn開発者に連絡して、AddOn構成のnameを変更するか、AddOnが存在するディレクトリ名を変更してください",
    "tittle": "AddOn内のプロファイルが無効またはAdOnディレクトリ名が無効です",
    "isShowConfirm": "1"
  },
  "0x0F0129": {
    "description": "AddOn内部プロファイルでdescriptionが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内部プロファイルのdescriptionは40バイトを超えてはならない",
    "action": "AddOn開発者に連絡して、AddOn構成のDescriptionを変更してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F012A": {
    "description": "AddOn内部プロファイルでurlが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOn内のプロファイルでurl形式が正しくありません",
    "action": "AddOn開発者に連絡して、AddOn構成のurlを変更してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F012B": {
    "description": "AddOn内部プロファイルのconventionが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在のバージョンコントローラは対応するconventionバージョンAddOnをサポートしていません",
    "action": "1.AdOn開発者に連絡して、構成が正しいかどうかを確認してください",
    "tittle": "AddOn内のプロファイルが無効です",
    "isShowConfirm": "1"
  },
  "0x0F012C": {
    "description": "AddOnインストールパッケージが破損しているか、認識できない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOnインストールパッケージが破損しているか、認識できない",
    "action": "AddOnインストールパッケージが間違っていないことを確認してから再インストールしてください",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F012D": {
    "description": "AddOnインストールパッケージエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "システム構成エラーまたはコードにエラーがあります",
    "action": "1.コントローラのバージョンを交換するには技術者に連絡してください\n2.システムミラーを交換するには技術者に連絡してください",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F012E": {
    "description": "AddOnパケットの解凍に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在、AddOn.tar.gz形式圧縮パッケージのみがサポートされています",
    "action": "1.パッケージのフォーマットが正しいかどうかをチェックする\n2.パッケージが破損していないかどうかを確認する",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F012F": {
    "description": "現在別のAddOnをインストールしています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在別のAddOnをインストールしています",
    "action": "1.インストールが完了するまで待ってください\n2.制御盤を再起動してから再度試行する",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F0130": {
    "description": "現在インストールタスクはありません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在インストールタスクはありません",
    "action": "現在インストールタスクはありません",
    "tittle": "現在インストールタスクはありません",
    "isShowConfirm": "1"
  },
  "0x0F0131": {
    "description": "AddOnインストールパッケージ圧縮エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "システム内部がビジーで、対応するファイルを読み込めません",
    "action": "1.しばらくしてからやり直してください\n2.技術者に連絡して処理する",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F0132": {
    "description": "AddOn圧縮に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "AddOnパッケージ内のファイルが多すぎるか、AddOnファイルが大きすぎる",
    "action": "1.しばらく待ってからやり直してください\n2.他のコントローラのバージョンエクスポートを交換してください",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F0133": {
    "description": "AddOnインストールパッケージ内のファイルが見つかりません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1.config.iniファイルの存在を確認する\n2. Confirm if other necessary documents exist\n3. Determine if the file directory structure can be recognized",
    "action": "AddOn開発者に連絡し、インストールパッケージに間違いがないことを確認して再試行してください",
    "tittle": "AddOnインストールパッケージエラー",
    "isShowConfirm": "1"
  },
  "0x0F0134": {
    "description": "プログラムが正常に共有されました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo : {1}",
    "tittle": "プログラムが正常に共有されました。",
    "isShowConfirm": "0"
  },
  "0x0F0135": {
    "description": "プログラムの共有に失敗しました。\nFrom: {0}\nTo : {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能な原因：\n1.共有されるプログラムのファイルパスが正しくないか.プログラムファイルが不完全です。\n2.共有されるプログラムファイルは.対象のコントローラーに既に存在しています。\n3.コントローラーは.対象のコントローラーのIPアドレスにアクセスできません。",
    "action": "1.ターゲットコントローラに同名のプログラムファイルが存在しないか確認してください。\n2.現在のコントローラがターゲットコントローラに正しくアクセスできることを確認してください（アプリが配置されたホストはターゲットコントローラにアクセスできる）。\n3.共有されたプログラムファイルの内容が完全であるかどうかを確認してください（フォルダに対応するファイルおよびサブディレクトリが存在するかどうか）。",
    "tittle": "プログラムの共有に失敗しました。",
    "isShowConfirm": "1"
  },
  "0x0F0136": {
    "description": "ロボットがコンベヤベルトの最大追跡距離を超えている",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コンベアトラッキングベルトで設定された最大トラッキング距離を超えると、ロボットは減速して停止します",
    "action": "1.最大トラッキング距離パラメータを増やすか、トラッキング位置を再調整してください",
    "tittle": "ロボットがコンベヤベルトの最大追跡距離を超えている",
    "isShowConfirm": "1"
  },
  "0x0F0137": {
    "description": "ディスク空き領域不足.\nディスクパーティション名:{0}\nディスクの使用率:{1}% \nディスクの合計容量:{2} MB \nディスクの残りの容量:{3} MB",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ディスクの使用率が80%を超え、残りの空き領域が不足しており、後続のディスク書き込み時にデータの損失のリスクがあります",
    "action": "1. 期限切れの診断ファイルを削除します。\n2. 不要なジョブプログラムファイルおよびプログラムバックアップファイルを削除します。\n3. 不要なトレースファイルを削除します。\n上記の操作を実行してもディスクの空き領域が効果的に解放されない場合は、技術サポートに連絡してディスクを検査してください。",
    "tittle": "ディスク残量不足警告",
    "isShowConfirm": "1"
  },
  "0x0F0138": {
    "description": "ベルトスタートトラッキング距離と距離補正機能を使用する場合、最初のモーションを円弧モーションにすることはできません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "最初のモーションが円弧運動の場合、コンベヤベルト距離補正の計算に関しては、元の円弧軌道が影響を受けます",
    "action": "1.ベルトの最初の動きを直線運動に変える",
    "tittle": "ベルトスタートトラッキング距離と距離補正機能を使用する場合、最初のモーションを円弧モーションにすることはできません",
    "isShowConfirm": "1"
  },
  "0x0F0140": {
    "description": "設定力値を超えるソフトリミット",
    "type": "1",
    "isShowOTA": "0",
    "reason": "設定力値を超えるソフトリミット",
    "action": "1.ロボットの端部が外部と衝突していないか確認してください。",
    "tittle": "設定力値を超えるソフトリミット",
    "isShowConfirm": "1"
  },
  "0x0F0141": {
    "description": "センサの最大レンジを超える",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサの最大レンジを超える",
    "action": "1.ロボットの端部が外部と衝突していないか確認してください。センサーが激突した後に不可逆的な損傷が発生する可能性がある",
    "tittle": "センサの最大レンジを超える",
    "isShowConfirm": "1"
  },
  "0x0F0142": {
    "description": "Profinet通信が有効でない状態",
    "type": "2",
    "isShowOTA": "0",
    "reason": "Profinet 通信が有効になっていないと、関連する IO は操作できない。",
    "action": "まず Profinet 通信を有効にしてから IO を操作してください。",
    "tittle": "Profinet通信が有効でない状態",
    "isShowConfirm": "1"
  },
  "0x0F0143": {
    "description": "EtherNet/IP通信が有効でない状態",
    "type": "2",
    "isShowOTA": "0",
    "reason": "EtherNet/IP通信が有効になっていないと、関連する IO は操作できない。",
    "action": "まずEtherNet/IP通信を有効にしてから IO を操作してください。",
    "tittle": "EtherNet/IP通信が有効でない状態",
    "isShowConfirm": "1"
  },
  "0x0F0144": {
    "description": "現在のセンサーリミット設定が、このモデルのデフォルトのソフトリミットを超えている。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "現在のセンサーリミット設定が、このモデルのデフォルトのソフトリミットを超えている。",
    "action": "現在設定されている力またはトルクが、このモデルのデフォルトのソフトリミットを超えています。 リミット値がモデルの許容設定値内であることを確認してください。",
    "tittle": "センサーのリミット設定がデフォルトのソフトリミットを超えている",
    "isShowConfirm": "1"
  },
  "0x0F0150": {
    "description": "制御システムの起動段階で、安全制御ボードのハードウェアモデルを識別できませんでした。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "通信タイムアウト、安全制御ボードのCAN通信が異常タイムアウトしました。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードハードウェアモデルの照会に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0151": {
    "description": "安全制御ボードの安全機能DI設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全コントローラーのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n2. 安全コントローラーのCAN通信を確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの安全機能DI設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0152": {
    "description": "安全制御ボードの安全機能DO設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全コントローラーのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n2. 安全コントローラーのCAN通信を確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの安全機能DO設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0153": {
    "description": "安全制御ボードの功率制限設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全制御ボードファームウェアのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの功率制限設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0154": {
    "description": "安全制御ボードへのツール座標系の同期に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "通信タイムアウト、安全制御ボードのCAN通信が異常タイムアウトしました。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードへのツール座標系の同期に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0155": {
    "description": "制御箱シリアルナンバーのCAB IDの設定に失敗",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全コントローラーのCAN通信に異常があります。",
    "action": "1. 安全コントローラーのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "制御箱シリアルナンバーの設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0156": {
    "description": "制御箱出力電圧設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全コントローラーのCAN通信に異常があります。",
    "action": "1. 安全コントローラーのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "制御箱出力電圧設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0157": {
    "description": "安全制御ボードの停止時間設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの停止時間設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0158": {
    "description": "安全制御ボードの停止距離設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの停止距離設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F0159": {
    "description": "安全制御ボードの末端ドラッグ速度制限設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードの末端ドラッグ速度制限設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F015A": {
    "description": "制御箱シリアルナンバーの製造ロットナンバーの設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンではこの機能設定をサポートしていません。\n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定されたバージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "制御箱シリアルナンバーの設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F015B": {
    "description": "制御パネルシリアルナンバーの生産日付の設定に失敗",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 当前的安全制御ボードのファームウェアバージョンでは、この機能設定はサポートされていません。\n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。\n2. 安全制御ボードのファームウェアバージョンが指定された互換バージョンであることを確認してください。\n3. 確認後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "制御パネルシリアルナンバーの設定に失敗",
    "isShowConfirm": "1"
  },
  "0x0F015C": {
    "description": "制御盤のIO入力/出力タイプの設定に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "1. 現在の安全制御ボードのバージョンは、この機能構成をサポートしていません。 \n2. 安全制御ボードのCAN通信に異常があります。",
    "action": "1. 安全制御ボードのCAN通信を確認してください。 \n2. アップグレードされた安全制御ボードのバージョンが指定されたバージョンと一致しているか確認してください。 \n3. 上記の確認後も問題が解決しない場合は、技術サービス担当者に相談してください。",
    "tittle": "制御盤のIO入力/出力タイプの設定に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0160": {
    "description": "安全制御ボードへのコントローラーバージョン番号の送信に失敗しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードにバージョン番号を送信してもフィードバックが受信されず、CAN通信が異常でタイムアウトしました。",
    "action": "1. 安全制御ボードのファームウェアバージョンが指定された組み合わせバージョンであるかを確認してください。\n2. 指定されたバージョンであると確認したら、安全制御ボードのCAN通信ラインをチェックしてください。\n3. チェック後も問題が解決しない場合は、技術サービススタッフに相談してください。",
    "tittle": "安全制御ボードへのコントローラーバージョン番号の送信に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0161": {
    "description": "安全制御ボードのファームウェアバージョンが低すぎて、すべての安全機能をサポートできません。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードのファームウェアバージョンが低すぎます。すべての安全機能をサポートすることはできません。",
    "action": "互換性のない安全制御ボードのファームウェアバージョンを使用することは未知の安全リスクを招く可能性があります。安全制御ボードのファームウェアをアップグレードし、コントローラーと安全制御ボードのファームウェアバージョンが正しく組み合わせられるようにしてください。",
    "tittle": "安全制御ボードのファームウェアバージョンが低すぎます",
    "isShowConfirm": "1"
  },
  "0x0F0162": {
    "description": "SERVOのバージョンが低すぎて、すべての安全機能をサポートすることができません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全機能に適合するSERVOバージョンが間違っています。一部の安全機能はサポートできません。",
    "action": "誤ったSERVOバージョンの使用は安全上のリスクを引き起こす可能性があります。SERVOのファームウェアをアップグレードして、コントローラーがSERVOバージョンと正しくマッチしていることを確認してください。",
    "tittle": "SERVOバージョンが間違っています",
    "isShowConfirm": "1"
  },
  "0x0F0163": {
    "description": "PROFINET と ETHERNET/IP機能が無効化されました。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "現在のロボットモデルでは、PROFINET、ETHERNET/IP機能をサポートしていません。",
    "action": "PROFINET と ETHERNET/IP機能を使用するには、コントロールキャビネットを再起動し、他のロボットモデルに接続してください。",
    "tittle": "PROFINET と ETHERNET/IP機能が無効化されました",
    "isShowConfirm": "1"
  },
  "0x0F0170": {
    "description": "<0> が <1> と衝突しています",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "CurrentTcpVelLimit": "現在のロボットのTCP速度制限",
        "SettingStoppingDistance": "設定されたロボットの停止距離制限",
        "CurrentStoppingTime": "現在のロボットの停止時間制限",
        "CurrentStoppingDistance": "現在のロボットの停止距離制限",
        "CurrentPowerLimit": "現在のロボットの電力制限",
        "CurrentMomentumLimit": "現在のロボットの運動量制限",
        "SettingMomentumLimit": "設定されたロボットの運動量制限",
        "SettingStoppingTime": "設定されたロボットの停止時間制限",
        "SettingPowerLimit": "設定されたロボットの電力制限",
        "SettingTcpVelLimit": "設定されたロボットのTCP速度制限"
      },
      "1": {
        "SettingPoewrLimitReduce": "縮小モードで設定された電力制限",
        "SettingStoppingDistReduce": "縮小モードで設定された停止距離制限",
        "SettingStoppingTimeReduce": "縮小モードで設定された停止時間制限",
        "CurrentTcpVelReduce": "縮小モードの現在のTCP速度制限",
        "SettingMomentumLimitReduce": "縮小モードで設定された運動量制限",
        "CurrentPoewrLimitReduce": "縮小モードの現在の電力制限",
        "CurrentStoppingTimeReduce": "縮小モードの現在の停止時間制限",
        "SettingTcpVelReduce": "縮小モードで設定されたTCP速度制限",
        "CurrentMomentumLimitReduce": "縮小モードの現在の運動量制限",
        "CurrentStoppingDistReduce": "縮小モードの現在の停止距離制限"
      },
      "2": {
        "<": "未満",
        ">": "より大きい"
      },
      "3": {
        "<": "未満",
        ">": "より大きい"
      }
    },
    "reason": "<0><2><1>\n",
    "action": "<0>：{0}\n<1>：{1}\n安全パラメータを設定する際は、パラメータ <0> がパラメータ <1> より <3> であることを確認してください",
    "tittle": "安全パラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x0F0171": {
    "description": "負荷設定パラメータに異常があり、ロボットを有効にすることができません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットのシリアル番号：{0}\n最大負荷パラメータ：{1}\n最小負荷パラメータ：{2}\n現在の負荷パラメータ：{3}",
    "action": "この機種に適した範囲内で負荷パラメータを設定し、その後、ロボットを再度有効にしてください",
    "tittle": "負荷設定エラーが有効化を拒否しました",
    "isShowConfirm": "1"
  },
  "0x0F0172": {
    "description": "Giá trị của thông số cấu hình tải vượt quá phạm vi điều chỉnh của mẫu này",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットのシリアル番号：{0}\n最大負荷パラメータ：{1}\n最小負荷パラメータ：{2}\n設定されたペイロードパラメータ：{3}",
    "action": "このモデルに適合する範囲内にペイロードパラメータを再設定してください",
    "tittle": "ペイロード構成パラメータの値が正しくありません",
    "isShowConfirm": "1"
  },
  "0x0F0173": {
    "description": "無効状態でロボットが終了ボタン操作を行えない",
    "type": "2",
    "isShowOTA": "0",
    "reason": "終了ボタンが無効の状態では、ロボットは以下の操作を実行できない：\n 1. プログラムの一時停止または開始\n 2. ドラッグモードまたはツールドラッグモードに入る。",
    "action": "ロボットを有効な状態に保ち、エンドボタンを操作する。",
    "tittle": "無効状態でロボットが終了ボタン操作を行えない",
    "isShowConfirm": "1"
  },
  "0x0F0174": {
    "description": "コンベヤ追跡キューが空です",
    "type": "2",
    "isShowOTA": "0",
    "reason": " コンベヤキュー追跡機能を使用する場合、キューに適格なターゲットはありません",
    "action": "1.キューの位置を調整して、値が取得されるたびにキューが空にならないようにします。2.キューイングの条件が正しくないかどうかを確認します",
    "tittle": "コンベヤ追跡キューが空です",
    "isShowConfirm": "0"
  },
  "0x0F0175": {
    "description": "最大追跡距離を超えるキュー内のターゲットをスキップする",
    "type": "2",
    "isShowOTA": "0",
    "reason": "キュー内のターゲットがコンベヤベルトによって設定された最大追跡距離を超えると、例外を回避するためにターゲットが削除されます",
    "action": "1.コンベヤーベルトの供給間隔を調整するか、こぼれ対策を増やします",
    "tittle": "最大追跡距離を超えるキュー内のターゲットをスキップする",
    "isShowConfirm": "0"
  },
  "0x0F0176": {
    "description": "コンベヤ追跡キューがいっぱいです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コンベヤキュー追跡機能を使用すると、キュー内の適格なターゲットの数が最大数を超えています",
    "action": "1.コンベヤーベルトの供給間隔を調整します",
    "tittle": "コンベヤ追跡キューがいっぱいです",
    "isShowConfirm": "0"
  },
  "0x0F0177": {
    "description": "パスワードの検証が何度も失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "{0} 秒以内に 5 回連続でパスワードの検証に失敗しました",
    "action": "{1} 秒以内に 5 回連続でパスワードの検証に失敗しました、{2} 秒後に再試行してください",
    "tittle": "パスワードの検証が何度も失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F0180": {
    "description": "セーフティキューブの対角点が一致しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "対角点のデカルト座標が一致するため、セーフティキューブを生成できません。",
    "action": "セーフティキューブの対角点のデカルト座標が一致しているかどうか確認してください。",
    "tittle": "セーフティキューブの対角点のパラメーターが誤っています",
    "isShowConfirm": "1"
  },
  "0x0F0181": {
    "description": "起動時に安全エリア設定ファイルをロードする際のパラメータ検証に失敗しました。",
    "type": "2",
    "isShowOTA": "0",
    "param": {
      "0": {
        "global": "SafePlane global config",
        "cube": "SafeCube.Cube",
        "plane": "SafePlane.Plane"
      }
    },
    "reason": "安全エリア設定ファイル<0>{0}に異常なパラメータが存在し、安全パラメータの検証に失敗しました。",
    "action": "制御システムはデフォルトパラメータに従って有効化されます。復元する場合は、安全エリアの設定を再構成してください。",
    "tittle": "安全エリア設定の初期化とロード中に例外が発生しました",
    "isShowConfirm": "1"
  },
  "0x0F0190": {
    "description": "軌道のオフセットキューが満杯です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "軌道オフセットのキューのストレージが最大値に達しました",
    "action": "軌道ポイントを最適化するか、軌道オフセットキューの数を増やしてください",
    "tittle": "軌道のオフセットキューが満杯です",
    "isShowConfirm": "1"
  },
  "0x0F0191": {
    "description": "軌道のオフセットが失敗しました、直線同士の交点がないためです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基準軌道をオフセットした後、直線は異面または平行になり、交点を求めることができません",
    "action": "基準点の位置を調整するか、軌道オフセットのパラメータを変更してください",
    "tittle": "軌道のオフセットが失敗しました、直線同士の交点がないためです",
    "isShowConfirm": "1"
  },
  "0x0F0192": {
    "description": "軌道のオフセットが失敗しました。直線と弧の間に交点がないためです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基準軌道をオフセットした後、直線と弧の間に交点がありません",
    "action": "基準点の位置を調整するか、軌道オフセットパラメータを変更してください",
    "tittle": "軌道のオフセットが失敗しました。直線と弧の間に交点がないためです",
    "isShowConfirm": "1"
  },
  "0x0F0193": {
    "description": "軌道のオフセットが失敗しました 弧同士の交点がないためです",
    "type": "1",
    "isShowOTA": "1",
    "reason": "基準軌道をオフセットした後、弧同士の交点がなく、交点を求めることができません",
    "action": "基準点の位置を調整するか、軌道オフセットパラメータを変更してください",
    "tittle": "軌道のオフセットが失敗しました 弧同士の交点がないためです",
    "isShowConfirm": "1"
  },
  "0x0F0195": {
    "description": "軌道のオフセットキューが空です",
    "type": "1",
    "isShowOTA": "1",
    "reason": "軌道オフセットキューの数は0です",
    "action": "プログラムコードに誤りがないか確認してください",
    "tittle": "軌道のオフセットキューが空です",
    "isShowConfirm": "1"
  },
  "0x0F0196": {
    "description": "軌道オフセット中にTCPのZ軸が軌道方向と平行であるため、オフセットが失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "軌道オフセット中にTCPのZ軸が軌道方向と平行であるため、オフセットが失敗しました",
    "action": "オフセットの基準点を調整してください",
    "tittle": "軌道オフセット中にTCPのZ軸が軌道方向と平行であるため、オフセットが失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F1001": {
    "description": "タイムアウトを有効にします。もう一度電源を入れてください",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットが有効化中の場合、関節電磁石が作動せず、エラーが表示されます",
    "action": "1. ロボットの電源をオフにしてから、電源をオンにして再度有効にしてください。 2. ロボット関節の電磁石に異常がないか確認するか、技術者に連絡してください。",
    "tittle": "タイムアウトを有効にします。もう一度電源を入れてください",
    "isShowConfirm": "1"
  },
  "0x0F1002": {
    "description": "サーバーのバージョン番号のクエリがタイムアウトしました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットと電気制御盤間のCAN通信に異常が発生した場合、エラーメッセージが表示されます",
    "action": "1. ロボットの電源をオフにしてから、再度有効にしてください。 \n2. ロボットと電気制御盤間の重負荷用接続線に接続異常がないか確認してください。",
    "tittle": "サーバーのバージョン番号のクエリがタイムアウトしました",
    "isShowConfirm": "1"
  },
  "0x0F2000": {
    "description": "プログラミング ファイルの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムに異常または未定義のパラメータがあり、コントローラが異常に処理する原因となります",
    "action": "1. 現在のプログラムで使用している変数定義の初期値に異常がないか確認してください。 2. 通信接続変数の対話データに異常がないか確認してください。",
    "tittle": "プログラミング ファイルの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2001": {
    "description": "プログラミングファイルが開いていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実行中のプログラムがロードされていません",
    "action": "1. 起動時にデフォルトの読み込みプログラムを設定します \n2. プログラミング インターフェイスで対応するプログラムを開き、クリックして実行します",
    "tittle": "プログラミングファイルが開いていません",
    "isShowConfirm": "1"
  },
  "0x0F2002": {
    "description": "プログラミング ファイルのオープンに失敗しました. \nターゲットファイル:{0}。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能な原因：\n1. 起動時のデフォルトプログラムが見つからない。\n2. 保存されたプログラムファイルが不完全です。\n3. 入力されたプログラムファイルのパスが正しくありません。",
    "action": "1. 設定画面で起動時にデフォルトでロードするプログラムを再選択してください。\n2. プログラムを再保存してから再度開いてください。\n3. プログラムスクリプトの指示にあるファイルパスが正しいかどうかを確認してください。",
    "tittle": "プログラミング ファイルのオープンに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2003": {
    "description": "プログラミング ファイルのクローズに失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "プログラミング ファイルのクローズに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2004": {
    "description": "プログラムのバックアップが成功しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "From: {0}\nTo : {1}",
    "tittle": "プログラムのバックアップが成功しました。",
    "isShowConfirm": "0"
  },
  "0x0F2005": {
    "description": "自動バックアッププログラムが失敗しました。\nFrom: {0}\nTo: {1}\n",
    "type": "1",
    "isShowOTA": "0",
    "reason": "可能な原因：\n1. アクセス許可が拒否され、ファイルに書き込めませんでした。\n2. プログラムファイルが破損しています。\n3.ディスクの空き容量が不足しているか、ディスクの読み書きに異常があります。",
    "action": "1. APPプログラミングページでプログラムを手動でバックアップします。\n2. プログラムに欠落がないか確認し、プログラムを開いてから正常に保存できるか確認してください。\n3. ディレクトリの権限とディスクの状態を確認するために技術スタッフに連絡してください。 ",
    "tittle": "自動バックアッププログラムが失敗しました。",
    "isShowConfirm": "1"
  },
  "0x0F2010": {
    "description": "解析エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "if、while、end、break、continue などのキーワードが一致しません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "一致しないキーワードがないか、スクリプト ファイル、特に手動で作成されたスクリプト サブルーチンを調べます。",
    "tittle": "解析エラー",
    "isShowConfirm": "1"
  },
  "0x0F2011": {
    "description": "PyCall() に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "呼び出された Python スクリプトに構文エラーがあります。エラー ファイル: {0} エラーの行番号: {1}",
    "action": "呼び出された Python スクリプト プログラムを確認します。",
    "tittle": "PyCall() に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2012": {
    "description": "アサーションの解析に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーションパラメータの設定がおかしい。エラー ファイル: {0} エラー行番号: {1}",
    "action": "モーションパラメータ設定の確認",
    "tittle": "アサーションの解析に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2013": {
    "description": "解析に失敗しました。弧の半径はゼロです",
    "type": "1",
    "isShowOTA": "0",
    "reason": "円弧動作点の設定に例外があり、ロボットの動作軌道計画が失敗します。エラー ファイル: {0} エラー行番号: {1}",
    "action": "円運動中のロボットのポイント設定に異常がないか確認し、円運動のポイント情報を再設定してください。",
    "tittle": "解析に失敗しました。弧の半径はゼロです",
    "isShowConfirm": "1"
  },
  "0x0F2014": {
    "description": "解析に失敗しました、構文エラーです",
    "type": "1",
    "isShowOTA": "0",
    "reason": "変数相互作用命令（代入命令）にデータ形式の例外があります。エラー ファイル: {0} エラー行番号: {1}",
    "action": "プログラム中の変数相互作用命令（代入命令）のデータ形式に異常がないか確認してください。",
    "tittle": "解析に失敗しました、構文エラーです",
    "isShowConfirm": "1"
  },
  "0x0F2015": {
    "description": "ネットワーク接続に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソケットの作成に失敗しました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーメッセージに従って、エラーに対応するスクリプトコマンドを確認します",
    "tittle": "ネットワーク接続に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2016": {
    "description": "サーバーへの接続に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket 通信中にサーバーが切断されます。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. ソケット通信サーバーが閉じているかどうかを確認してください。 \n2. Socket通信サーバーでネットワーク接続(pingパス)テストをお試しください。 \n3. 電気制御盤とソケット通信サーバー間のネットワークケーブル接続に異常がないか確認してください。 \n4. ソケット通信サーバーのファイアウォールが閉じられているか確認してください。",
    "tittle": "サーバーへの接続に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2017": {
    "description": "サーバーに接続されていないため、通信に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ビジョンパラメータ読込コマンド実行時にカメラが接続されていません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. ソケット通信サーバーが閉じているかどうかを確認してください。 \n2. Socket通信サーバーでネットワーク接続(pingパス)テストをお試しください。 \n3. 電気制御盤とソケット通信サーバー間のネットワークケーブル接続に異常がないか確認してください。 \n4. ソケット通信サーバーのファイアウォールが閉じられているか確認してください。",
    "tittle": "サーバーに接続されていないため、通信に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2018": {
    "description": "TCP/IP がデータを受信できませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラーがカメラからデータを受信できませんでした。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. カメラが接続されていない",
    "tittle": "TCP/IP がデータを受信できませんでした",
    "isShowConfirm": "1"
  },
  "0x0F2019": {
    "description": "TCP/IP がデータを送信できませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラーがカメラにデータを送信できませんでした。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. ソケット通信サーバーが閉じているかどうかを確認してください。 \n2. Socket通信サーバーでネットワーク接続(pingパス)テストをお試しください。 \n3. 電気制御盤とソケット通信サーバー間のネットワークケーブル接続に異常がないか確認してください。 \n4. ソケット通信サーバーのファイアウォールが閉じられているか確認してください。",
    "tittle": "TCP/IP がデータを送信できませんでした",
    "isShowConfirm": "1"
  },
  "0x0F201A": {
    "description": "2D ビジョン構成の読み込みに失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "2D ビジョン構成の読み込みに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F201B": {
    "description": "内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "スクリプト パーサーの内部エラー。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーログ情報から以下の状況を確認してください。 1. sscanf コマンドのパラメータ例外 2. 読み取り専用変数への書き込み操作",
    "tittle": "内部エラー",
    "isShowConfirm": "1"
  },
  "0x0F201C": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F201D": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F201E": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コード パラメータが間違っています。エラー ファイル: {0} エラー行番号: {1}",
    "action": "操作を続行する前に、コード パラメータが正しいかどうかを確認してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F201F": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーション コマンドが認識されません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "移動コマンドのスクリプト、特に手動で作成されたスクリプトを確認します",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2020": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーションコマンドのパラメータが間違っています。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーメッセージに従って、対応するモーションコマンドを確認してください",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2021": {
    "description": "メソッドを呼び出してはいけません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "円運動でサポートされていない G コード命令が使用されています。エラー ファイル: {0} エラー行番号: {1}",
    "action": "機能 io が常に接続されているかどうかを確認してください. 通常、外部機能ボタンは 1 秒後に切断できます.",
    "tittle": "メソッドを呼び出してはいけません",
    "isShowConfirm": "1"
  },
  "0x0F2022": {
    "description": "不明な操作",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サポートされていない演算子がスクリプトで使用されました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー メッセージに従って、次の演算子以外の記号が使用されていないか確認してください: +、-、/、*、**、および、mod、または、xor、]",
    "tittle": "不明な操作",
    "isShowConfirm": "1"
  },
  "0x0F2023": {
    "description": "間違ったデータ形式",
    "type": "1",
    "isShowOTA": "0",
    "reason": "定義された変数のデータ形式が正しくありません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "変数のデータ形式を確認し、正しく修正してから操作を進めてください。",
    "tittle": "間違ったデータ形式",
    "isShowConfirm": "1"
  },
  "0x0F2024": {
    "description": "パラメータが定義されていません",
    "type": "1",
    "isShowOTA": "1",
    "reason": "1. ソケット通信時に定義されたソケットと送信時に使用されたソケットが一致しません \n2. データ代入時に指定された形式でエラーが発生しなかったファイル: {0}、エラー行番号: {1}",
    "action": "1. プログラム内の通信命令を確認してください。使用するポートがすべて開いていることを確認してください \n2. データ割付命令を確認してください。文字列は二重引用符を追加する必要があり、配列は角括弧を追加する必要があります",
    "tittle": "パラメータが定義されていません",
    "isShowConfirm": "1"
  },
  "0x0F2025": {
    "description": "ファイルを開くことができません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "1. ファイル形式が異常です \n2. 間違ったファイル名が長すぎます: {0} エラー行番号: {1}",
    "action": "1. ファイル形式が正しいかどうかを確認します。正しくない場合は、正しいファイル形式に設定してください。 \n2. ファイル名が長すぎるかどうかを確認してください。長すぎる場合は、妥当な範囲内で設定してください",
    "tittle": "ファイルを開くことができません",
    "isShowConfirm": "1"
  },
  "0x0F2026": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "プログラムの ini パラメータが ini ファイルで定義されていません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーメッセージに従って、プログラム内のiniパラメーター名が正しいかどうかを確認します",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2027": {
    "description": "ストレージが足りない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "メモリが不足しています。文字列を保存中にエラーが発生しました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. コントロール キャビネットのオペレーティング プログラムを再起動します。 \n2. このエラーが頻繁に発生する場合: 1. メモリ リークがあるかどうかを確認し、問題を記録して製造元に連絡する 2. 管理者に連絡して、システムのスワップ スペース容量を増やす",
    "tittle": "ストレージが足りない",
    "isShowConfirm": "1"
  },
  "0x0F2028": {
    "description": "戻り値の型が間違っている",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関数の戻り値の型が一致しません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "先に進む前に、変数定義の型と戻り値の型をチェックして、戻り値の型が正しいことを確認してください。",
    "tittle": "戻り値の型が間違っている",
    "isShowConfirm": "1"
  },
  "0x0F2029": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サブルーチンのネストされた呼び出しの層が多すぎます。エラー ファイル: {0} エラー行番号: {1}",
    "action": "ジョブプログラムのサブルーチン呼び出しが階層ごとにネストされているかどうかを確認します (ネストする階層の数は 10 未満にすることをお勧めします)。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F202A": {
    "description": "パラメータを追加できません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "パラメータ割り当ての例外。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーメッセージに従って確認してください: \n1. パラメータ名が正しいかどうか \n2. パラメータタイプが正しいかどうか",
    "tittle": "パラメータを追加できません",
    "isShowConfirm": "1"
  },
  "0x0F202B": {
    "description": "ユーザー定義エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ユーザー定義変数エラー。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーに応じて変数パラメータを確認してください。",
    "tittle": "ユーザー定義エラー",
    "isShowConfirm": "1"
  },
  "0x0F202C": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "整数 (配列インデックスなど) が読み取られることが期待されていましたが、実際にはスクリプトで整数以外のパラメーターが指定されました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "キャラクター関連命令のステップ値パラメータ設定に異常があります。妥当なステップ値を設定してください。 (ステップ値は整数のみ設定可能)",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F202D": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "操作語の後に不明な文字が表示されます。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラーメッセージに従って、オペレーティングプログラムのキーワードを確認してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F202E": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ファイルの不明なオペレーター エラー: {0} エラー行番号: {1}",
    "action": "ジョブ プログラムの構文を確認してください: () 内の式は個別の &, |, !, = をサポートしていません: &&, ||, !=, ==",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F202F": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "不完全な表現。エラー ファイル: {0} エラー行番号: {1}",
    "action": "間違った行に対応する式が正しく記述されているかどうかを確認します",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2030": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2031": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2032": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2033": {
    "description": "コマンドが長すぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "スクリプト コマンドとパラメータが長すぎます。エラー ファイル: {0} エラー行番号: {1}",
    "action": "合計長が 255 バイトを超えてはならない単一行のスクリプト命令とパラメーター (最新バージョンは 512 バイトを超えてはなりません)",
    "tittle": "コマンドが長すぎる",
    "isShowConfirm": "1"
  },
  "0x0F2034": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "システム変数の保存中にエラーが発生しました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. システム変数ファイル jaka_user.var を確認します。 \n2. システム変数ファイルを確認し、変数インデックスが順番に格納されているかどうかを確認します。",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2035": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ディレクティブ パラメータが未定義です。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー箇所のスクリプトコマンドパラメータが正しいか確認",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2036": {
    "description": "ファイルが開いていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ファイルまたはフォルダを開けませんでした。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. フォルダまたはファイル名のパスが正しいかどうか \n2. フォルダまたはファイルを開く権限が正しいかどうか \n3. ファイルが破損しているかどうか",
    "tittle": "ファイルが開いていません",
    "isShowConfirm": "1"
  },
  "0x0F2037": {
    "description": "重複定義",
    "type": "1",
    "isShowOTA": "0",
    "reason": "スクリプト インタープリターのキーワード マッピングでエラーが発生しました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "内部システム エラー。エラーログと操作手順を記録し、製造元に連絡してください",
    "tittle": "重複定義",
    "isShowConfirm": "1"
  },
  "0x0F2038": {
    "description": "ジョブプログラムの構文エラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "スクリプト インタープリターのキーワード マッピングでエラーが発生しました。エラー ファイル: {0} エラー行番号: {1}",
    "action": "内部システム エラー。エラーログと操作手順を記録し、製造元に連絡してください",
    "tittle": "ジョブプログラムの構文エラー",
    "isShowConfirm": "1"
  },
  "0x0F2039": {
    "description": "ファイルを繰り返し開けない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ファイルを開くことができません。\nエラーのあるファイルは次のとおりです: {0}\nエラー行番号: {1}",
    "action": "1. フォルダーまたはファイル名のパスが正しいかどうか。\n2. フォルダーまたはファイルを開く権限が正しいかどうか。\n3. ファイルが破損していないか。",
    "tittle": "ファイルを繰り返し開けない",
    "isShowConfirm": "1"
  },
  "0x0F203A": {
    "description": "スクリプト内の一致しない 'end' キーワード",
    "type": "1",
    "isShowOTA": "0",
    "reason": "スクリプト内の一致しない 'end' キーワード.エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの end キーワードを確認してください",
    "tittle": "'end' キーワードが一致しません",
    "isShowConfirm": "1"
  },
  "0x0F203B": {
    "description": "スレッドの作成に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "最大5スレッドの同時実行を許可. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スレッドの終了または破棄後に作成する",
    "tittle": "スレッドの作成に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F203C": {
    "description": "スレッドの作成に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "スレッドはすでに実行中であり、スレッドの再作成は許可されていません.エラー ファイル: {0} エラー行番号: {1}",
    "action": "スレッドの終了または破棄後に作成する",
    "tittle": "スレッドの作成に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F203D": {
    "description": "未一致の'elif'",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'elif'は検出されましたが、それに一致する'if'はありません. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの'if'文ブロックを確認してください",
    "tittle": "一致しないキーワード",
    "isShowConfirm": "1"
  },
  "0x0F203E": {
    "description": "未一致の'else'",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'else'は検出されましたが、それに一致する'if'はありません. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの'if'文ブロックを確認してください",
    "tittle": "一致しないキーワード",
    "isShowConfirm": "1"
  },
  "0x0F203F": {
    "description": "未一致の'break'",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'break'は検出されましたが、それに一致する'while'はありません. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの'while'文ブロックを確認してください",
    "tittle": "一致しないキーワード",
    "isShowConfirm": "1"
  },
  "0x0F2040": {
    "description": "未一致の'continue'",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'continue'は検出されましたが、それに一致する'while'はありません. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの'while'文ブロックを確認してください",
    "tittle": "一致しないキーワード",
    "isShowConfirm": "1"
  },
  "0x0F2041": {
    "description": "未一致の'return'",
    "type": "1",
    "isShowOTA": "1",
    "reason": "'return'は検出されましたが、それに一致する'sub'はありません. エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムの'sub'文ブロックを確認してください",
    "tittle": "一致しないキーワード",
    "isShowConfirm": "1"
  },
  "0x0F2042": {
    "description": "TIO信号量読み出し失敗",
    "type": "1",
    "isShowOTA": "1",
    "reason": "未定義の信号量",
    "action": "事前に定義してからアクセスするか、スペルが正しいかどうかをチェックしてください",
    "tittle": "TIO信号量読み出し失敗",
    "isShowConfirm": "1"
  },
  "0x0F2043": {
    "description": "システム変数の追加に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "変数インデックスが範囲外です",
    "action": "変数インデックスの範囲が1～5601であることを確認してください",
    "tittle": "システム変数の追加に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2050": {
    "description": "SOCKET id 無効",
    "type": "1",
    "isShowOTA": "0",
    "reason": "あきらめる",
    "action": "",
    "tittle": "SOCKET id 無効",
    "isShowConfirm": "1"
  },
  "0x0F2051": {
    "description": "逆解に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "反転に失敗しました。この問題は通常、ジョブ プログラムで逆解計算が失敗した場合に発生します。これは、指定された参照ジョイント角度と解決された終了ポーズに関連している可能性があります。エラー ファイル: {0} エラー行番号: {1}",
    "action": "マニュアル ジョグは、参照ジョイント モーションがデカルト空間を介してターゲット ポイントに移動できるかどうかをチェックします。可能であれば、現在のロボットのポーズを変更するか、他のパスまたはポーズからターゲット ポイントに到達するか、ターゲット ポイントのポーズを変更することを検討してください。",
    "tittle": "逆解に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2052": {
    "description": "正しい解決に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "正しい解決に失敗しました。この問題は通常、ジョブ プログラムで正の解の計算が失敗した場合に発生します。関節角度値設定パラメータが関係している可能性があります。エラー ファイル: {0} エラー行番号: {1}",
    "action": "マニュアル ジョグは、参照ジョイント モーションがデカルト空間を介してターゲット ポイントに移動できるかどうかをチェックします。可能であれば、現在のロボットのポーズを変更するか、他のパスまたはポーズからターゲット ポイントに到達するか、ターゲット ポイントのポーズを変更することを検討してください。",
    "tittle": "正しい解決に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F2053": {
    "description": "TCP/IP 通信が間違ったデータを受信した",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "コントローラがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "TCP/IP 通信が間違ったデータを受信した",
    "isShowConfirm": "1"
  },
  "0x0F2054": {
    "description": "配列変数が無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "配列変数が定義されていないか、変数が配列型ではありません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトプログラムのエラー行に対応する配列変数の使い方が正しいか確認してください",
    "tittle": "配列変数が無効です",
    "isShowConfirm": "1"
  },
  "0x0F2055": {
    "description": "配列要素のインデックスが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "配列のインデックス値が配列の範囲外です。エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプト プログラムのエラー行に対応する配列インデックスが正しいかどうかを確認してください",
    "tittle": "配列要素のインデックスが無効です",
    "isShowConfirm": "1"
  },
  "0x0F2056": {
    "description": "ポーズ補間係数が無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ポーズ補間コマンドで渡された補間係数が無効です。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー位置の位置補間コマンド パラメータを確認してください",
    "tittle": "ポーズ補間係数が無効です",
    "isShowConfirm": "1"
  },
  "0x0F2057": {
    "description": "制御ブロック ターミネータの不一致",
    "type": "1",
    "isShowOTA": "1",
    "reason": "if および while 制御ブロックには、対応する終了ターミネータがありません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "カスタム スクリプト サブルーチンの if および while ステートメント ブロックに終了ターミネータがあるかどうかを確認します",
    "tittle": "制御ブロック ターミネータの不一致",
    "isShowConfirm": "1"
  },
  "0x0F2058": {
    "description": "サポートされていないエスケープ文字",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サポートされていない翻訳文字入力がスクリプトで使用されました。現在サポートされているのは、\\n、\\r、\\t、\\\"、\\'、\\\\、エラー ファイル: {0}、エラー行番号: {1} のみです。",
    "action": "現在サポートされているエスケープ文字は次のとおりです: \\\\ バックスラッシュ \\' 一重引用符 \\\" 二重引用符 \\n改行 \\t 水平タブ \\r 改行",
    "tittle": "サポートされていないエスケープ文字",
    "isShowConfirm": "1"
  },
  "0x0F2059": {
    "description": "配列カット間隔パラメータが無効です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "スライス モードでボクセルにアクセスするときに使用されるストライドが無効です。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー メッセージに従ってスクリプト プログラムを確認してください: スライス モードで要素グループにアクセスする場合、ステップ サイズは 0 より大きい整数である必要があります。",
    "tittle": "配列カット間隔パラメータが無効です",
    "isShowConfirm": "1"
  },
  "0x0F2060": {
    "description": "配列のネストはサポートされていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "配列変数は、配列を要素としてサポートしていません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー メッセージに従ってスクリプト プログラムを確認してください: 配列変数は要素として配列をサポートしていません",
    "tittle": "配列のネストはサポートされていません",
    "isShowConfirm": "1"
  },
  "0x0F2061": {
    "description": "文字列配列はサポートされていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "文字列は配列変数ではサポートされていません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "エラー メッセージに従ってスクリプト プログラムを確認してください: Strings are not supported in array variables",
    "tittle": "文字列配列はサポートされていません",
    "isShowConfirm": "1"
  },
  "0x0F2062": {
    "description": "割り当てられているが解放されていないソケット リソースが多すぎる",
    "type": "1",
    "isShowOTA": "0",
    "reason": "作成されたソケットが多すぎて、閉じられませんでした。エラー ファイル: {0} エラー行番号: {1}",
    "action": "1. open SOCKET コマンドを使用した後、使用していないときは必ず閉じてください。\n2. ループ ステートメントでソケットを開くことは避けてください. 開いた場合は、次の作成の前に閉じる必要があります。 \n3.閉じていない場合、現在の最大許容ソケット数は 256 です。",
    "tittle": "割り当てられているが解放されていないソケット リソースが多すぎる",
    "isShowConfirm": "1"
  },
  "0x0F2063": {
    "description": "ソケットが無効なデータを受信しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソケットが変数命令を受信しましたが、受信したデータの形式が正しくありません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプト プログラムがソケットを使用して変数を受信し、配列命令を受信する場合、サーバーから送信されたデータ フォーマットが、スクリプト プログラミング命令で定義された戻りデータ フォーマットと組み合わされていることを確認してください。",
    "tittle": "ソケットが無効なデータを受信しました",
    "isShowConfirm": "1"
  },
  "0x0F2064": {
    "description": "ソケットが受け取った配列の長さが一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket によって受信されたデータの配列の長さが、サーバーによって送信された配列の長さと一致しません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプト プログラムでソケットを使用して配列命令を受け取る場合は、サーバーから返された配列の長さが正しいことを確認してください。",
    "tittle": "ソケットが受け取った配列の長さが一致しません",
    "isShowConfirm": "1"
  },
  "0x0F2065": {
    "description": "ソケットが受信したデータ型が一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "Socket によって受信されたデータの変数の型が、サーバーによって送信されたデータ型と一致しません。エラー ファイル: {0} エラー行番号: {1}",
    "action": "スクリプトでソケットを使用して変数を受信し、配列コマンドを受信する場合は、サーバーから返されるデータ型が正しいことを確認してください。",
    "tittle": "ソケットが受信したデータ型が一致しません",
    "isShowConfirm": "1"
  },
  "0x0F2066": {
    "description": "jksプログラムコマンドの衝突感度レベルの設定は有効になっていません",
    "type": "0",
    "isShowOTA": "0",
    "reason": "このリリースでは、プログラム内のコリジョン感度レベルを設定する機能は有効にされておらず、実行時に関連するコマンドはスキップされます。エラー ファイル: {0} エラー行番号: {1}",
    "action": "セキュリティ設定で衝突感度レベルを設定するか、JAKAテクニカルサポートに問い合わせてこの機能を有効にしてください。",
    "tittle": "jksプログラムコマンドの衝突感度レベルの設定は有効になっていません",
    "isShowConfirm": "1"
  },
  "0x0F2067": {
    "description": "異なるタイプの変数は'<'>'<='>='比較できません。",
    "type": "1",
    "isShowOTA": "1",
    "param": {
      "0": {
        "1": "/",
        "2": "%",
        "3": "**",
        "4": "*",
        "5": "&&",
        "6": "^",
        "7": "-",
        "8": "||",
        "9": "+",
        "13": "<",
        "14": "==",
        "15": "!=",
        "16": "<=",
        "17": ">=",
        "18": ">"
      },
      "1": {
        "0": "scalar",
        "1": "array",
        "2": "string"
      },
      "2": {
        "0": "scalar",
        "1": "array",
        "2": "string"
      }
    },
    "reason": "異なるタイプの変数は'<'>'<='>='比較できません。\nエラー ファイル: {0}\nエラー行番号: {1}",
    "action": "エラーメッセージの表示に基づいて、対応するスクリプト変数のタイプをチェックしてください。",
    "tittle": "異なるタイプのデータを比較することはできません",
    "isShowConfirm": "1"
  },
  "0x0F2068": {
    "description": "プログラムの実行中にエラーが発生しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムの実行中にエラーが発生しました。",
    "action": "プログラムの実行中にエラーが発生しました。",
    "tittle": "プログラムの実行中にエラーが発生しました。",
    "isShowConfirm": "0"
  },
  "0x0F2069": {
    "description": "IOピンが出力タイプに設定されている場合、デジタル入力信号を取得できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "デジタル入力信号の取得に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F206A": {
    "description": "IOピンが入力タイプに設定されている場合、デジタル出力信号を取得できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "デジタル出力信号の取得に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F206B": {
    "description": "デジタル入力信号が異常であり、デジタル入力待機命令の実行にエラーが発生しました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "IOピンが出力タイプの場合、デジタル入力を取得することができず、このIOピンの信号状態に基づいて「待機」操作を実行することができません",
    "action": "入力信号待機命令を実行する前に、操作されるIOピンが入力タイプであることを確認してください。",
    "tittle": "デジタル入力待機命令の実行に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F3001": {
    "description": "指定されたビジュアル デバイスへの接続に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラがビジョン デバイスに接続できない",
    "action": "ビジュアル ハードウェアの配線が正常かどうかを確認し、ビジュアル電源 DC24V の正と負のワイヤリング ハーネスが正しいかどうかを確認します。それでも接続できない場合は、サプライヤのエンジニアに連絡して対処してください!",
    "tittle": "指定されたビジュアル デバイスへの接続に失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F3002": {
    "description": "ビジョンデバイスが接続されていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラは、ビジョンがオンラインであることを検出できません",
    "action": "ビジュアル ハードウェアの配線が正常かどうかを確認し、ビジュアル電源 DC24V の正と負のワイヤリング ハーネスが正しいかどうかを確認します。それでも接続できない場合は、サプライヤのエンジニアに連絡して対処してください!",
    "tittle": "ビジョンデバイスが接続されていません",
    "isShowConfirm": "1"
  },
  "0x0F4001": {
    "description": "サーボ ステート マシン エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "サーボ ステート マシン エラー",
    "isShowConfirm": "1"
  },
  "0x0F4002": {
    "description": "ファームウェアのアップグレードに失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボット ファームウェア パッケージのアップグレードに失敗しました",
    "action": "ファームウェア ファイル名のサフィックスが .tar.gz 形式であるかどうかを確認し、冗長なコンテンツがないことを確認してください. アプリ インターフェイスのアップグレード プロセス中にアプリの電源を切ったり、シャットダウンしたりしないでください.",
    "tittle": "ファームウェアのアップグレードに失敗しました",
    "isShowConfirm": "1"
  },
  "0x0F4003": {
    "description": "現在のハードウェアはこの機能をサポートしていません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボット本体またはコントローラは、現在使用されている機能をサポートできません",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "現在のハードウェアはこの機能をサポートしていません",
    "isShowConfirm": "1"
  },
  "0x0F4004": {
    "description": "ロボットの関節 {0} に潜在的なリスクがあります",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ジョイントの内部パラメータのセルフテストが異常です。 注: このメッセージは警告メッセージであり、実行中のプログラムには影響しません。",
    "action": "接合部を確認するにはテクニカル サポート エンジニアにご連絡ください。",
    "tittle": "ロボット自己診断異常",
    "isShowConfirm": "1"
  },
  "0x0FFFFE": {
    "description": "その他のエラー",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "その他のエラー",
    "isShowConfirm": "1"
  },
  "0x0FFFFF": {
    "description": "未知の間違い",
    "type": "1",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "未知の間違い",
    "isShowConfirm": "1"
  },
  "0x102230": {
    "description": "ジョイント 1 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 1 バス過電流",
    "isShowConfirm": "1"
  },
  "0x102320": {
    "description": "ジョイント 1出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 1出力過電流",
    "isShowConfirm": "1"
  },
  "0x102321": {
    "description": "ジョイント1ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント1を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント1ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x102350": {
    "description": "ジョイント 1 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 1 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x103130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x103210": {
    "description": "ジョイント 1 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 1 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x103211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x103220": {
    "description": "ジョイント 1 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 1 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x103380": {
    "description": "ジョイント 1 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 1 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x103381": {
    "description": "ジョイント 1 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 1 出力欠相",
    "isShowConfirm": "1"
  },
  "0x104210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x104310": {
    "description": "ジョイント 1 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 1 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x105201": {
    "description": "ジョイント1のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節1パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x105202": {
    "description": "関節1校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節1校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x105210": {
    "description": "ジョイント 1 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 1 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x105211": {
    "description": "ジョイント 1機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 1機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x105280": {
    "description": "ジョイント 1 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 1 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x105281": {
    "description": "ジョイント1 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント1 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x105282": {
    "description": "ジョイント1ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント1ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x105283": {
    "description": "ジョイント 1 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 1 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x105441": {
    "description": "ジョイント 1 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 1 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x105480": {
    "description": "ジョイント 1サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 1サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x106000": {
    "description": "関節 1 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 1 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x106010": {
    "description": "ジョイント 1 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 1 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x107180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x107181": {
    "description": "ジョイント 1 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 1 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x107182": {
    "description": "ジョイント1高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント1高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x107185": {
    "description": "関節1のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節1のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節1のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x107380": {
    "description": "ジョイント1エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント1エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x107381": {
    "description": "ジョイント1エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント1エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x107382": {
    "description": "ジョイント 1 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 1 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x107383": {
    "description": "ジョイント 1 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 1 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x107384": {
    "description": "ジョイント 1 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 1 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x107385": {
    "description": "ジョイント1 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント1 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント1 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x107386": {
    "description": "ジョイント 1 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 1 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x107387": {
    "description": "ジョイント1 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント1 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x107388": {
    "description": "ジョイント 1エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 1エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x107389": {
    "description": "関節1のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節1の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節1のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x107580": {
    "description": "関節1運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節1運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x108000": {
    "description": "ジョイント 1 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 1 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x108001": {
    "description": "関節1位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節1位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x108480": {
    "description": "ジョイント 1 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 1 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x108481": {
    "description": "ジョイント 1 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 1 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x108482": {
    "description": "関節1制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節1制限速度",
    "isShowConfirm": "1"
  },
  "0x108483": {
    "description": "ジョイント1速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント1速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x108484": {
    "description": "許容範囲外の関節1加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節1加速度",
    "isShowConfirm": "1"
  },
  "0x108485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x108501": {
    "description": "関節1: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節1: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節1: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x108611": {
    "description": "関節1位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節1位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x108612": {
    "description": "ジョイント 1 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 1 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x108613": {
    "description": "過剰な関節1加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節1加速度",
    "isShowConfirm": "1"
  },
  "0x108614": {
    "description": "ジョイント 1 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 1 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x108615": {
    "description": "ジョイント1CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント1CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x108616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x108617": {
    "description": "関節1がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節1で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節1: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x10FFFF": {
    "description": "関節エラーが発生しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "関節{0}でエラー{1}が発生しました",
    "action": "現在のコントローラバージョンではこのエラーを認識できません。JAKAの技術スタッフにご相談ください",
    "tittle": "関節エラー発生",
    "isShowConfirm": "1"
  },
  "0x112230": {
    "description": "ジョイント 2 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 2 バス過電流",
    "isShowConfirm": "1"
  },
  "0x112320": {
    "description": "ジョイント 2出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 2出力過電流",
    "isShowConfirm": "1"
  },
  "0x112321": {
    "description": "ジョイント2ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント2を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント2ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x112350": {
    "description": "ジョイント 2 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 2 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x113130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x113210": {
    "description": "ジョイント 2 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 2 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x113211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x113220": {
    "description": "ジョイント 2 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 2 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x113380": {
    "description": "ジョイント 2 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 2 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x113381": {
    "description": "ジョイント 2 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 2 出力欠相",
    "isShowConfirm": "1"
  },
  "0x114210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x114310": {
    "description": "ジョイント 2 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 2 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x115201": {
    "description": "ジョイント2のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節2パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x115202": {
    "description": "関節2校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節2校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x115210": {
    "description": "ジョイント 2 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 2 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x115211": {
    "description": "ジョイント 2機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 2機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x115280": {
    "description": "ジョイント 2 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 2 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x115281": {
    "description": "ジョイント2 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント2 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x115282": {
    "description": "ジョイント2ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント2ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x115283": {
    "description": "ジョイント 2 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 2 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x115441": {
    "description": "ジョイント 2 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 2 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x115480": {
    "description": "ジョイント 2サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 2サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x116000": {
    "description": "関節 2 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 2 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x116010": {
    "description": "ジョイント 2 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 2 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x117180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x117181": {
    "description": "ジョイント 2 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 2 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x117182": {
    "description": "ジョイント2高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント2高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x117185": {
    "description": "関節2のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節2のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節2のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x117380": {
    "description": "ジョイント2エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント2エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x117381": {
    "description": "ジョイント2エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント2エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x117382": {
    "description": "ジョイント 2 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 2 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x117383": {
    "description": "ジョイント 2 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 2 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x117384": {
    "description": "ジョイント 2 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 2 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x117385": {
    "description": "ジョイント2 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント2 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント2 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x117386": {
    "description": "ジョイント 2 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 2 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x117387": {
    "description": "ジョイント2 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント2 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x117388": {
    "description": "ジョイント 2エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 2エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x117389": {
    "description": "関節2のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節2の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節2のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x117580": {
    "description": "関節2運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節2運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x118000": {
    "description": "ジョイント 2 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 2 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x118001": {
    "description": "関節2位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節2位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x118480": {
    "description": "ジョイント 2 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 2 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x118481": {
    "description": "ジョイント 2 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 2 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x118482": {
    "description": "関節2制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節2制限速度",
    "isShowConfirm": "1"
  },
  "0x118483": {
    "description": "ジョイント2速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント2速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x118484": {
    "description": "許容範囲外の関節2加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節2加速度",
    "isShowConfirm": "1"
  },
  "0x118485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x118501": {
    "description": "関節2: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節2: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節2: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x118611": {
    "description": "関節2位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節2位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x118612": {
    "description": "ジョイント 2 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 2 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x118613": {
    "description": "過剰な関節2加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節2加速度",
    "isShowConfirm": "1"
  },
  "0x118614": {
    "description": "ジョイント 2 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 2 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x118615": {
    "description": "ジョイント2CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント2CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x118616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x118617": {
    "description": "関節2がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節2で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節2: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x122230": {
    "description": "ジョイント 3 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 3 バス過電流",
    "isShowConfirm": "1"
  },
  "0x122320": {
    "description": "ジョイント 3出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 3出力過電流",
    "isShowConfirm": "1"
  },
  "0x122321": {
    "description": "ジョイント3ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント3を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント3ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x122350": {
    "description": "ジョイント 3 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 3 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x123130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x123210": {
    "description": "ジョイント 3 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 3 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x123211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x123220": {
    "description": "ジョイント 3 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 3 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x123380": {
    "description": "ジョイント 3 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 3 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x123381": {
    "description": "ジョイント 3 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 3 出力欠相",
    "isShowConfirm": "1"
  },
  "0x124210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x124310": {
    "description": "ジョイント 3 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 3 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x125201": {
    "description": "ジョイント3のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節3パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x125202": {
    "description": "関節3校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節3校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x125210": {
    "description": "ジョイント 3 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 3 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x125211": {
    "description": "ジョイント 3機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 3機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x125280": {
    "description": "ジョイント 3 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 3 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x125281": {
    "description": "ジョイント3 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント3 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x125282": {
    "description": "ジョイント3ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント3ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x125283": {
    "description": "ジョイント 3 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 3 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x125441": {
    "description": "ジョイント 3 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 3 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x125480": {
    "description": "ジョイント 3サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 3サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x126000": {
    "description": "関節 3 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 3 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x126010": {
    "description": "ジョイント 3 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 3 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x127180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x127181": {
    "description": "ジョイント 3 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 3 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x127182": {
    "description": "ジョイント3高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント3高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x127185": {
    "description": "関節3のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節3のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節3のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x127380": {
    "description": "ジョイント3エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント3エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x127381": {
    "description": "ジョイント3エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント3エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x127382": {
    "description": "ジョイント 3 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 3 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x127383": {
    "description": "ジョイント 3 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 3 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x127384": {
    "description": "ジョイント 3 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 3 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x127385": {
    "description": "ジョイント3 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント3 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント3 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x127386": {
    "description": "ジョイント 3 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 3 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x127387": {
    "description": "ジョイント3 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント3 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x127388": {
    "description": "ジョイント 3エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 3エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x127389": {
    "description": "関節3のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節3の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節3のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x127580": {
    "description": "関節3運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節3運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x128000": {
    "description": "ジョイント 3 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 3 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x128001": {
    "description": "関節3位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節3位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x128480": {
    "description": "ジョイント 3 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 3 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x128481": {
    "description": "ジョイント 3 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 3 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x128482": {
    "description": "関節3制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節3制限速度",
    "isShowConfirm": "1"
  },
  "0x128483": {
    "description": "ジョイント3速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント3速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x128484": {
    "description": "許容範囲外の関節3加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節3加速度",
    "isShowConfirm": "1"
  },
  "0x128485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x128501": {
    "description": "関節3: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節3: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節3: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x128611": {
    "description": "関節3位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節3位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x128612": {
    "description": "ジョイント 3 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 3 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x128613": {
    "description": "過剰な関節3加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節3加速度",
    "isShowConfirm": "1"
  },
  "0x128614": {
    "description": "ジョイント 3 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 3 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x128615": {
    "description": "ジョイント3CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント3CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x128616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x128617": {
    "description": "関節3がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節3で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節3: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x132230": {
    "description": "ジョイント 4 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 4 バス過電流",
    "isShowConfirm": "1"
  },
  "0x132320": {
    "description": "ジョイント 4出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 4出力過電流",
    "isShowConfirm": "1"
  },
  "0x132321": {
    "description": "ジョイント4ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント4を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント4ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x132350": {
    "description": "ジョイント 4 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 4 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x133130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x133210": {
    "description": "ジョイント 4 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 4 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x133211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x133220": {
    "description": "ジョイント 4 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 4 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x133380": {
    "description": "ジョイント 4 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 4 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x133381": {
    "description": "ジョイント 4 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 4 出力欠相",
    "isShowConfirm": "1"
  },
  "0x134210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x134310": {
    "description": "ジョイント 4 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 4 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x135201": {
    "description": "ジョイント4のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節4パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x135202": {
    "description": "関節4校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節4校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x135210": {
    "description": "ジョイント 4 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 4 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x135211": {
    "description": "ジョイント 4機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 4機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x135280": {
    "description": "ジョイント 4 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 4 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x135281": {
    "description": "ジョイント4 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント4 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x135282": {
    "description": "ジョイント4ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント4ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x135283": {
    "description": "ジョイント 4 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 4 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x135441": {
    "description": "ジョイント 4 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 4 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x135480": {
    "description": "ジョイント 4サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 4サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x136000": {
    "description": "関節 4 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 4 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x136010": {
    "description": "ジョイント 4 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 4 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x137180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x137181": {
    "description": "ジョイント 4 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 4 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x137182": {
    "description": "ジョイント4高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント4高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x137185": {
    "description": "関節4のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節4のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節4のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x137380": {
    "description": "ジョイント4エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント4エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x137381": {
    "description": "ジョイント4エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント4エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x137382": {
    "description": "ジョイント 4 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 4 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x137383": {
    "description": "ジョイント 4 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 4 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x137384": {
    "description": "ジョイント 4 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 4 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x137385": {
    "description": "ジョイント4 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント4 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント4 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x137386": {
    "description": "ジョイント 4 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 4 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x137387": {
    "description": "ジョイント4 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント4 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x137388": {
    "description": "ジョイント 4エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 4エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x137389": {
    "description": "関節4のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節4の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節4のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x137580": {
    "description": "関節4運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節4運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x138000": {
    "description": "ジョイント 4 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 4 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x138001": {
    "description": "関節4位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節4位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x138480": {
    "description": "ジョイント 4 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 4 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x138481": {
    "description": "ジョイント 4 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 4 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x138482": {
    "description": "関節4制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節4制限速度",
    "isShowConfirm": "1"
  },
  "0x138483": {
    "description": "ジョイント4速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント4速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x138484": {
    "description": "許容範囲外の関節4加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節4加速度",
    "isShowConfirm": "1"
  },
  "0x138485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x138501": {
    "description": "関節4: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節4: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節4: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x138611": {
    "description": "関節4位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節4位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x138612": {
    "description": "ジョイント 4 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 4 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x138613": {
    "description": "過剰な関節4加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節4加速度",
    "isShowConfirm": "1"
  },
  "0x138614": {
    "description": "ジョイント 4 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 4 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x138615": {
    "description": "ジョイント4CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント4CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x138616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x138617": {
    "description": "関節4がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節4で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節4: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x142230": {
    "description": "ジョイント 5 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 5 バス過電流",
    "isShowConfirm": "1"
  },
  "0x142320": {
    "description": "ジョイント 5出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 5出力過電流",
    "isShowConfirm": "1"
  },
  "0x142321": {
    "description": "ジョイント5ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント5を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント5ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x142350": {
    "description": "ジョイント 5 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 5 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x143130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x143210": {
    "description": "ジョイント 5 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 5 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x143211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x143220": {
    "description": "ジョイント 5 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 5 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x143380": {
    "description": "ジョイント 5 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 5 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x143381": {
    "description": "ジョイント 5 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 5 出力欠相",
    "isShowConfirm": "1"
  },
  "0x144210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x144310": {
    "description": "ジョイント 5 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 5 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x145201": {
    "description": "ジョイント5のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節5パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x145202": {
    "description": "関節5校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節5校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x145210": {
    "description": "ジョイント 5 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 5 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x145211": {
    "description": "ジョイント 5機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 5機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x145280": {
    "description": "ジョイント 5 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 5 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x145281": {
    "description": "ジョイント5 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント5 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x145282": {
    "description": "ジョイント5ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント5ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x145283": {
    "description": "ジョイント 5 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 5 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x145441": {
    "description": "ジョイント 5 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 5 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x145480": {
    "description": "ジョイント 5サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 5サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x146000": {
    "description": "関節 5 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 5 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x146010": {
    "description": "ジョイント 5 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 5 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x147180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x147181": {
    "description": "ジョイント 5 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 5 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x147182": {
    "description": "ジョイント5高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント5高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x147185": {
    "description": "関節5のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節5のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節5のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x147380": {
    "description": "ジョイント5エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント5エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x147381": {
    "description": "ジョイント5エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント5エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x147382": {
    "description": "ジョイント 5 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 5 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x147383": {
    "description": "ジョイント 5 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 5 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x147384": {
    "description": "ジョイント 5 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 5 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x147385": {
    "description": "ジョイント5 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント5 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント5 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x147386": {
    "description": "ジョイント 5 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 5 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x147387": {
    "description": "ジョイント5 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント5 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x147388": {
    "description": "ジョイント 5エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 5エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x147389": {
    "description": "関節5のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節5の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節5のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x147580": {
    "description": "関節5運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節5運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x148000": {
    "description": "ジョイント 5 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 5 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x148001": {
    "description": "関節5位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節5位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x148480": {
    "description": "ジョイント 5 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 5 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x148481": {
    "description": "ジョイント 5 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 5 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x148482": {
    "description": "関節5制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節5制限速度",
    "isShowConfirm": "1"
  },
  "0x148483": {
    "description": "ジョイント5速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント5速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x148484": {
    "description": "許容範囲外の関節5加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節5加速度",
    "isShowConfirm": "1"
  },
  "0x148485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x148501": {
    "description": "関節5: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節5: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節5: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x148611": {
    "description": "関節5位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節5位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x148612": {
    "description": "ジョイント 5 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 5 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x148613": {
    "description": "過剰な関節5加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節5加速度",
    "isShowConfirm": "1"
  },
  "0x148614": {
    "description": "ジョイント 5 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 5 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x148615": {
    "description": "ジョイント5CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント5CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x148616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x148617": {
    "description": "関節5がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節5で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節5: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x152230": {
    "description": "ジョイント 6 バス過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーター フィードバック電流がしきい値を超える",
    "action": "異常エラーレポートを使用する機能と現在使用しているコントローラのバージョン情報を撮影し、故障の診断ログを保存し、技術サポートエンジニアに処理を依頼してください。",
    "tittle": "ジョイント 6 バス過電流",
    "isShowConfirm": "1"
  },
  "0x152320": {
    "description": "ジョイント 6出力過電流",
    "type": "1",
    "isShowOTA": "1",
    "reason": "モーター UVW の電流が検出され、ハードウェア ドライバー ボードの過電流しきい値を超えています。",
    "action": "1. ロボットへの負荷を軽減してからご使用ください。 2. ロボットの速度または加速度を下げてください。 3. ロボット ジョイント ドライブ ボードまたは減速機に異常がある場合は、技術サポート担当者に連絡してください。4. 通信に異常がある場合: 頑丈な接続ワイヤまたは電気制御キャビネットを交換するか、技術サポート担当者に連絡してください。",
    "tittle": "ジョイント 6出力過電流",
    "isShowConfirm": "1"
  },
  "0x152321": {
    "description": "ジョイント6ワン自己学習過電流",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント6を有効にする過程で大電流が出力されるが、モーターの回転が検出されない",
    "action": "1. ロボットを有効にし、ジョイント電磁石を手動で解放し、警報ジョイントを押すことができるかどうかを確認してください。 2. ロボット本体の電源を切った後、背面カバーを外し、ケーブルの接触に異常がないか確認するか、技術員に連絡してください。",
    "tittle": "ジョイント6ワン自己学習過電流",
    "isShowConfirm": "1"
  },
  "0x152350": {
    "description": "ジョイント 6 モジュール過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 6 モジュール過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x153130": {
    "description": "ジョイント入力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント入力欠相",
    "isShowConfirm": "1"
  },
  "0x153210": {
    "description": "ジョイント 6 サーボ過電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの過電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. 電気制御盤の放電板に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 6 サーボ過電圧",
    "isShowConfirm": "1"
  },
  "0x153211": {
    "description": "ジョイントドライブボードの電源障害",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードが破損している",
    "action": "お問い合わせ先",
    "tittle": "ジョイントドライブボードの電源障害",
    "isShowConfirm": "1"
  },
  "0x153220": {
    "description": "ジョイント 6 サーボ不足電圧",
    "type": "1",
    "isShowOTA": "0",
    "reason": "バス電圧が検出され、ハードウェア ドライバ ボードの低電圧しきい値を超えています",
    "action": "1. ロボットの負荷または動作加速度の設定が高すぎるかどうかを確認してください。動作条件を下げてみてください。 2. ロボット強力ケーブルの接続に異常がないか確認してください。 3. 技術担当者に連絡して、ドライバ ボードのハードウェアに異常がないかどうかを確認してください。 4. 技術担当者に連絡して、電気制御盤の通信または電源に異常がないか確認してください。",
    "tittle": "ジョイント 6 サーボ不足電圧",
    "isShowConfirm": "1"
  },
  "0x153380": {
    "description": "ジョイント 6 エンコーダのゼロ校正に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイントを有効にするプロセス中に、モーターの回転が予想と一致しません。",
    "action": "1.技術担当者に連絡して、アラームジョイントの関連パラメータが異常かどうかを確認してください。 2. ジョイントを上下させて、ブレーキに異常がないか確認してください。 3. 技術者に連絡して、ジョイントの ABZ 配線または ABZ コードディスクに異常がないか確認してください。",
    "tittle": "ジョイント 6 エンコーダのゼロ校正に失敗しました",
    "isShowConfirm": "1"
  },
  "0x153381": {
    "description": "ジョイント 6 出力欠相",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中、三相電流出力が異常です",
    "action": "1. ジョイントの三相配線に異常がないか、技術者に確認してください。 2. 技術者に連絡して、関節モーター回路に異常がないか確認してください。 3. ジョイントドライブプレートに異常がないか、技術者に確認してください。",
    "tittle": "ジョイント 6 出力欠相",
    "isShowConfirm": "1"
  },
  "0x154210": {
    "description": "ジョイントモーターの過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイントモーターの過熱",
    "isShowConfirm": "1"
  },
  "0x154310": {
    "description": "ジョイント 6 サーボ過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバ ボードで検出された温度が、ハードウェア ドライバ ボードの過熱しきい値を超えています",
    "action": "1. ロボットの現在の周囲温度がロボットの温度範囲を超えていないか確認してください。 2. ジョイントの外面温度が 50°C を超えていないか確認し、50°C を超えている場合は、使用条件を下げてください。 3. ジョイントドライブプレートまたはジョイントレジューサに異常がないか、技術者に連絡して確認してください。",
    "tittle": "ジョイント 6 サーボ過熱",
    "isShowConfirm": "1"
  },
  "0x155201": {
    "description": "ジョイント6のパラメータはロックされたままです",
    "type": "2",
    "isShowOTA": "0",
    "reason": "R 176のリリースから、サーボの重要なパラメータには書き込み保護があり、予期しないエラーを防ぐことができます。",
    "action": "技術サービスチームに連絡してコネクタのパラメータを確認してください",
    "tittle": "関節6パラメータがロック解除されませんでした",
    "isShowConfirm": "1"
  },
  "0x155202": {
    "description": "関節6校正ゼロとDHパラメータの衝突",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ゼロ点キャリブレーションの間、サーボは現在のモデルが納品前にDHパラメータキャリブレーションを受けているかどうかを検出する。すでにキャリブレーションされたモデルにゼロキャリブレーション機能を使用すると、DHパラメータの誤差が生じ、ロボットの精度が失われる可能性があります。",
    "action": "テクニカルサービスチームにお問い合わせください。",
    "tittle": "関節6校正ゼロとDHパラメータの衝突",
    "isShowConfirm": "1"
  },
  "0x155210": {
    "description": "ジョイント 6 のパラメータ設定がハードウェアのパワーと一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェアドライバーボード、モーターブランドモデル、サーボグループ製品シリーズ、これら3つは一致しません",
    "action": "1.技術者に連絡して、ジョイントの製造パラメータに異常がないかどうかを確認してください。 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント 6 のパラメータ設定がハードウェアのパワーと一致しません",
    "isShowConfirm": "1"
  },
  "0x155211": {
    "description": "ジョイント 6機種選定ミス",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア ドライバ ボードがサーボ Zu 製品シリーズと一致しない",
    "action": "連携ハードウェアバージョン、サーボグループパラメータに異常がないか、技術員にご確認ください。",
    "tittle": "ジョイント 6機種選定ミス",
    "isShowConfirm": "1"
  },
  "0x155280": {
    "description": "ジョイント 6 内部パラメータ エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボパラメータがしきい値を超えています。この障害は、電源がオンになっている場合にのみ報告されます。",
    "action": "技術者に連絡して、ジョイントの内部パラメータが異常かどうかを確認してください。",
    "tittle": "ジョイント 6 内部パラメータ エラー",
    "isShowConfirm": "1"
  },
  "0x155281": {
    "description": "ジョイント6 PID 計算オーバーフロー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "サーボ PID 操作が限界を超えています",
    "action": "研究開発スタッフに連絡して対処する",
    "tittle": "ジョイント6 PID 計算オーバーフロー",
    "isShowConfirm": "1"
  },
  "0x155282": {
    "description": "ジョイント6ワンEEPROMエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ハードウェア EEPROM チップの読み取りおよび書き込みエラー",
    "action": "1. ロボットの電源を入れたり切ったりして、タイミングがずれていないか確認してください. それでも問題が解決しない場合は、技術スタッフに連絡してください. 2. 技術者に連絡して、ジョイント ドライブ ボードに異常がないかどうかを確認してください。",
    "tittle": "ジョイント6ワンEEPROMエラー",
    "isShowConfirm": "1"
  },
  "0x155283": {
    "description": "ジョイント 6 を有効にできませんでした",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効化プロセス中に、他のシステム障害が原因で有効化に失敗しました",
    "action": "システムに他のエラー メッセージがあるかどうかを確認し、他のエラー メッセージを処理した後、有効化操作を実行してください。",
    "tittle": "ジョイント 6 を有効にできませんでした",
    "isShowConfirm": "1"
  },
  "0x155441": {
    "description": "ジョイント 6 内部接続エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 6 内部接続エラー",
    "isShowConfirm": "1"
  },
  "0x155480": {
    "description": "ジョイント 6サーボオーバーパワー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 6サーボオーバーパワー",
    "isShowConfirm": "1"
  },
  "0x156000": {
    "description": "関節 6 アブソリュートエンコーダの内部状態異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ドライバがアブソリュートエンコーダの異常な動作状態を検出しました。",
    "action": "現場環境に強電界、強磁界の干渉がないか、アブソリュートエンコーダの電源が正常か、アブソリュートエンコーダとドライバ間の接続線にゆるみがないか、接続線が断線していないか確認してください。",
    "tittle": "ジョイント 6 アブソリュート・エンコーダ内部エラー",
    "isShowConfirm": "1"
  },
  "0x156010": {
    "description": "ジョイント 6 のエンコーダ温度が過熱しています",
    "type": "2",
    "isShowOTA": "0",
    "reason": "エンコーダ温度ステータス異常",
    "action": "1.ジョイントの温度が動作範囲の要件を超えているかどうかを確認し、動作条件を下げてください。 2. 技術者に連絡して、ジョイントまたはエンコーダーに異常がないか確認してください。",
    "tittle": "ジョイント 6 のエンコーダ温度が過熱しています",
    "isShowConfirm": "1"
  },
  "0x157180": {
    "description": "関節モーター過負荷 (I2T)",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モーターが大電流を出力し、しばらく持続する",
    "action": "1. ロボットが過負荷を警告する前に、衝突がないか確認してください。 2. ジョイントの実際の負荷がロボットの公称負荷を大幅に超えていないかどうかを確認してください。 3. 技術者に連絡して、アラーム ジョイントのパラメータを確認してください。 4.引きずりモードで関節ブレーキ機構に異常がないか確認してください。 5. 技術者に連絡して、ジョイントが機械的に固着しているかどうかを確認してください。 6. 技術者に連絡して、ローター ABZ エンコーダーの読み取り値が異常かどうかを確認してください。",
    "tittle": "関節モーター過負荷 (I2T)",
    "isShowConfirm": "1"
  },
  "0x157181": {
    "description": "ジョイント 6 モーター ブレーキの故障",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ソレノイドが検出されない",
    "action": "1.ジョイントソレノイドの配線に異常がないか確認してください。 2. 測定電磁石の抵抗値が正常かどうかを確認してください。",
    "tittle": "ジョイント 6 モーター ブレーキの故障",
    "isShowConfirm": "1"
  },
  "0x157182": {
    "description": "ジョイント6高周波注入リバース",
    "type": "1",
    "isShowOTA": "0",
    "reason": "モータの実際の磁極方向とパルス注入計算が一致せず、制御異常が発生する",
    "action": "1. 技術担当者に連絡して、モーターのパラメーターが正しいかどうかを確認してください。 2. モーターの相順配線が正しいかどうかを確認してください。 3. 技術者に連絡して、ジョイント ドライブ プレートに異常がないかどうかを確認してください。",
    "tittle": "ジョイント6高周波注入リバース",
    "isShowConfirm": "1"
  },
  "0x157185": {
    "description": "関節6のモーターブレーキ電流が異常です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節6のブレーキが閉じている場合に電流が検出される、またはブレーキが開いている場合に電流が2Aを超える",
    "action": "1. 関節ブレーキケーブルに接続異常があるかどうか確認してください。\n2. 関節ブレーキに短絡があるかどうか確認してください。",
    "tittle": "関節6のモーターブレーキ電流が異常です",
    "isShowConfirm": "1"
  },
  "0x157380": {
    "description": "ジョイント6エンコーダ接続タイムアウト",
    "type": "1",
    "isShowOTA": "0",
    "reason": "アブソリュートエンコーダリードステータスエラー",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダ接続ケーブルを交換して、障害が解消されたかどうかを確認してください. 3. 技術者に連絡して、エンコーダが正常かどうかを確認してください.ステータスランプが異常です。",
    "tittle": "ジョイント6エンコーダ接続タイムアウト",
    "isShowConfirm": "1"
  },
  "0x157381": {
    "description": "ジョイント6エンコーダのバッテリ不足",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ内部バッテリ不足電圧",
    "action": "1. 製造パラメータの確認: 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認します. 2. 配線を確認します: ジョイント エンド カバーを取り外し、エンコーダの配線が緩んでいないかどうかを確認し、技術者に連絡して交換してください. 3.エンコーダーが故障している場合は、ジョイント コード デバイスまたはジョイントの交換を交換してください",
    "tittle": "ジョイント6エンコーダのバッテリ不足",
    "isShowConfirm": "1"
  },
  "0x157382": {
    "description": "ジョイント 6 エンコーダのバッテリが切断されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ電源異常",
    "action": "1. ロボットの電源投入時および電源切断時にエラーが発生する場合は、使用に影響はなく、それ以上の処置は必要ありません. 2. エンコーダが損傷しています. 障害が引き続き使用に影響を与える場合は、技術者に連絡して交換してください。",
    "tittle": "ジョイント 6 エンコーダのバッテリが切断されました",
    "isShowConfirm": "1"
  },
  "0x157383": {
    "description": "ジョイント 6 エンコーダ格納角度エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント モーター位置のキャリブレーション エラー",
    "action": "1.技術者に連絡して、アラームジョイントの製造パラメータが正しいかどうかを確認してください。 2. 技術者に連絡して、ジョイントの Z 値を再校正してください。",
    "tittle": "ジョイント 6 エンコーダ格納角度エラー",
    "isShowConfirm": "1"
  },
  "0x157384": {
    "description": "ジョイント 6 エンコーダ カウント エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ数異常",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください.",
    "tittle": "ジョイント 6 エンコーダ カウント エラー",
    "isShowConfirm": "1"
  },
  "0x157385": {
    "description": "ジョイント6 ワン ダブル エンコーダー検証エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント6 デュアル エンコーダーによって記録された位置がずれて、特定のしきい値を超える",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 深刻な衝突または機械的故障がないかどうかを確認し、技術者に連絡してください. 3. 技術者に連絡して、エンコーダの取り付けを確認するか、コード ディスクの汚れを確認してください。",
    "tittle": "ジョイント6 ワン ダブル エンコーダー検証エラー",
    "isShowConfirm": "1"
  },
  "0x157386": {
    "description": "ジョイント 6 エンコーダの内部エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ジョイント 6 エンコーダの内部エラー",
    "isShowConfirm": "1"
  },
  "0x157387": {
    "description": "ジョイント6 Z ライン スナップの失敗",
    "type": "1",
    "isShowOTA": "0",
    "reason": "相対エンコーダ Z ライン キャプチャ例外",
    "action": "1. 技術者に連絡して、アラーム ジョイントの製造パラメータが正しいかどうかを確認してください. 2. 技術者に連絡して、ジョイントの相対エンコーダを確認して修復してください.",
    "tittle": "ジョイント6 Z ライン スナップの失敗",
    "isShowConfirm": "1"
  },
  "0x157388": {
    "description": "ジョイント 6エンコーダ磁気信号異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エンコーダ信号振幅誤差、磁気モード誤差、信号断、信号異常",
    "action": "1. 固定ジョイントでエラーが報告されているかどうかを確認し、技術者に連絡して、ジョイントまたはエンコーダに異常がないかどうかを確認してください。 2. ロボットの作業環境または本体に、外部信号または磁気信号の干渉がないかどうかを確認してください。",
    "tittle": "ジョイント 6エンコーダ磁気信号異常",
    "isShowConfirm": "1"
  },
  "0x157389": {
    "description": "関節6のインクリメンタルエンコーダー接続異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節6の電源投入後のパルス注入微動時にインクリメンタルエンコーダーデータが変化しませんでした",
    "action": "1. インクリメンタルエンコーダーのケーブル接続に異常があるかどうか確認してください。\n2. インクリメンタルエンコーダーの読み取りヘッドが損傷しているかどうか確認してください。\n3. コードディスクが広範囲に汚れているかどうか確認してください。",
    "tittle": "関節6のインクリメンタルエンコーダの接続異常",
    "isShowConfirm": "1"
  },
  "0x157580": {
    "description": "関節6運動オーバーラン",
    "type": "1",
    "isShowOTA": "0",
    "reason": "トルク フィードフォワードがサーボしきい値を超えました",
    "action": "処理のためにコントローラーに連絡する",
    "tittle": "関節6運動オーバーラン",
    "isShowConfirm": "1"
  },
  "0x158000": {
    "description": "ジョイント 6 位置偏差 - 保護停止",
    "type": "2",
    "isShowOTA": "1",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "ジョイント 6 位置偏差 - 保護停止",
    "isShowConfirm": "1"
  },
  "0x158001": {
    "description": "関節6位置ずれ警報",
    "type": "2",
    "isShowOTA": "0",
    "reason": "サーボ位置追従誤差による衝突検出",
    "action": "1. ロボットが衝突を送信するかどうかを確認してください。 2. ロボットの動作加速度の設定が高すぎないか確認してください。 3. ロボットの負荷が規定範囲を超えていないか確認してください。4. ソフトウェア内のロボットの設置姿勢と実際の姿勢が一致しているか確認してください。5. 移動中に移動セグメント遷移が誤って使用されていないかどうかを確認してください。",
    "tittle": "関節6位置ずれ警報",
    "isShowConfirm": "0"
  },
  "0x158480": {
    "description": "ジョイント 6 前方速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と同じ方向にある場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 6 前方速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x158481": {
    "description": "ジョイント 6 の負の速度トラッキング エラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実際の速度が設定速度と逆の場合、速度エラーは設定されたアラームしきい値を超えます",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。",
    "tittle": "ジョイント 6 の負の速度トラッキング エラー",
    "isShowConfirm": "1"
  },
  "0x158482": {
    "description": "関節6制限速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ジョイント実速度がジョイント定格速度を超える",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 2. 移動区間転送のパラメータ設定に異常がないか確認してください。 3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節6制限速度",
    "isShowConfirm": "1"
  },
  "0x158483": {
    "description": "ジョイント6速度トラッキング エラーが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際のジョイント速度とコマンド速度の偏差がアラームしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント6速度トラッキング エラーが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x158484": {
    "description": "許容範囲外の関節6加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "废弃",
    "action": "サーボがデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "許容範囲外の関節6加速度",
    "isShowConfirm": "1"
  },
  "0x158485": {
    "description": "異常な関節速度制御",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の関節速度と指令速度の偏差がしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "異常な関節速度制御",
    "isShowConfirm": "1"
  },
  "0x158501": {
    "description": "関節6: 逆駆動モードではサーボの有効化が禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節6: 逆駆動モードではサーボの有効化が禁止されています",
    "action": "逆駆動モードを終了してから、再度有効化を行ってください。",
    "tittle": "関節6: 逆駆動モードではサーボの有効化が禁止されています",
    "isShowConfirm": "1"
  },
  "0x158611": {
    "description": "関節6位置ずれが大きすぎる",
    "type": "1",
    "isShowOTA": "1",
    "reason": "実際の位置フィードバックと指令位置の間の偏差が、設定されたしきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 衝突がないか、荷重設定が正しいかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "関節6位置ずれが大きすぎる",
    "isShowConfirm": "1"
  },
  "0x158612": {
    "description": "ジョイント 6 の位置コマンドの増分が大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令の増分が大きすぎて、しきい値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 6 の位置コマンドの増分が大きすぎます",
    "isShowConfirm": "1"
  },
  "0x158613": {
    "description": "過剰な関節6加速度",
    "type": "1",
    "isShowOTA": "1",
    "reason": "位置指令加速度が大きすぎて閾値を超えています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "過剰な関節6加速度",
    "isShowConfirm": "1"
  },
  "0x158614": {
    "description": "ジョイント 6 の位置コマンドが大きすぎます",
    "type": "1",
    "isShowOTA": "1",
    "reason": "コントローラが発行した位置指令が間違っています",
    "action": "1. プログラムの加速設定が高すぎるかどうかを確認してください。 \n2. 移動区間転送のパラメータ設定に異常がないか確認してください。 \n3. 技術者に連絡して、ロボット バスの通信に異常がないかどうかを確認してください。 \n4. その際、サーボモードを使用していた場合は、送信コマンドの連続・異常、位置逆解の連続・異常を確認してください。",
    "tittle": "ジョイント 6 の位置コマンドが大きすぎます",
    "isShowConfirm": "1"
  },
  "0x158615": {
    "description": "ジョイント6CAN通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットバス通信異常",
    "action": "ロボットバスの通信に異常がないか、技術者に確認してください。",
    "tittle": "ジョイント6CAN通信異常",
    "isShowConfirm": "1"
  },
  "0x158616": {
    "description": "関節一温度センサ通信異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節内部温度センサ異常",
    "action": "IICインタフェースの温度センサーを確認してください。",
    "tittle": "関節一温度センサ通信異常",
    "isShowConfirm": "1"
  },
  "0x158617": {
    "description": "関節6がCAN通信周期の変動を検出しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節6で短時間にCAN通信周期の大幅な変動が複数回検出されました",
    "action": "1.故障診断を行い（他のエラーにより自動的に診断が行われている可能性があります）、診断パッケージを保存します。CAN通信周期の変動を確認します（4-12msの周期変動は正常範囲と見なされます）。\n2.安全制御ボードS2のすべてのスイッチがOFF状態にあるか確認してください。\n3.制御キャビネット、本体、ペイロードのCANワイヤーの接続が緩んでいないか確認してください。",
    "tittle": "関節6: CAN通信周期の変動警告",
    "isShowConfirm": "1"
  },
  "0x201002": {
    "description": "TIO の電源がオンになりませんでした",
    "type": "1",
    "isShowOTA": "1",
    "reason": "ロボットのすべての関節が通信を確立した後、1 秒以内に TIO データを受信しません。",
    "action": "TIO 通信線と電力線が適切に接続されているかどうかを確認し、TIO ボードに目に見える損傷があるかどうかを確認し、メーカーにサポートを問い合わせてください。",
    "tittle": "TIO の電源がオンになりませんでした",
    "isShowConfirm": "0"
  },
  "0x201101": {
    "description": "拡張 IO の初期化に失敗しました Modbus RTU 通信パラメータが一致しません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初期化中に指定された構成に従って Modbus スレーブ IO モジュールを接続中にエラーが発生しました。",
    "action": "1.拡張 IO モジュールのタイプと通信構成を確認してください。\n2.制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3.拡張 IO モジュールの電源が正常であることを確認してください。\n4.Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO 初期化中の Modbus RTU 構成エラー",
    "isShowConfirm": "1"
  },
  "0x201102": {
    "description": "拡張 IO 初期化中に Modbus Rtu 接続の作成に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初期化中に指定された構成に従って Modbus スレーブ IO モジュールを接続中にエラーが発生しました。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO 初期化中に Modbus RTU 接続の作成に失敗しました",
    "isShowConfirm": "1"
  },
  "0x201104": {
    "description": "拡張 IO RTU シリアル バス パラメータの不一致",
    "type": "2",
    "isShowOTA": "0",
    "reason": "複数の RTU 拡張 IO モジュールが構成されており、各モジュールのシリアル バス パラメータが一致していない",
    "action": "拡張 IO RTU シリアル バス パラメータを変更して、各モジュールのパラメータが最初の RTU モジュールのパラメータと同じになるようにします。",
    "tittle": "拡張 IO RTU シリアル バス パラメータの不一致",
    "isShowConfirm": "1"
  },
  "0x201201": {
    "description": "拡張IO初期化失敗 Modbus TCP通信パラメータフォーマットエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初期化中に指定された構成に従って Modbus スレーブ IO モジュールを接続中にエラーが発生しました。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO 初期化中の Modbus TCP 構成エラー",
    "isShowConfirm": "1"
  },
  "0x201202": {
    "description": "拡張 IO 初期化中に Modbus Tcp 接続の作成に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初期化中に指定された構成に従って Modbus スレーブ IO モジュールを接続中にエラーが発生しました。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO 初期化中に Modbus TCP 接続の作成に失敗しました",
    "isShowConfirm": "1"
  },
  "0x201304": {
    "description": "初期化中の不明なエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "初期化中に指定された構成に従って Modbus スレーブ IO モジュールを接続中にエラーが発生しました。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO 初期化中の不明なエラー",
    "isShowConfirm": "1"
  },
  "0x202102": {
    "description": "拡張 IO Modbus TCP ノードが切断されて実行に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "動作中、Modbus TCP 拡張 IO モジュールはコントローラから切断されます。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO の実行中に Modbus TCP ノードがオフラインになる",
    "isShowConfirm": "1"
  },
  "0x202103": {
    "description": "拡張 IO Modbus RTU ノードが切断されて実行に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "動作中、Modbus RTU 拡張 IO モジュールはコントローラから切断されます。",
    "action": "1. 拡張 IO モジュールのタイプと通信構成を確認してください。\n2. 制御盤インターフェースと外部拡張 IO モジュール間の通信物理接続が正常であることを確認してください。\n3. 拡張 IO モジュールの電源が正常であることを確認してください。\n4. Modbus ポーリング ツールを使用して拡張 IO に接続し、拡張 IO モジュールに異常があるかどうかを確認できます。",
    "tittle": "拡張 IO の実行中に Modbus RTU ノードがオフラインになる",
    "isShowConfirm": "1"
  },
  "0x302380": {
    "description": "ファン電流異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "制御盤のファンが接続されていないか、ファンが短絡しています。",
    "action": "ファンの故障状態を確認してください。",
    "tittle": "ファン電流異常",
    "isShowConfirm": "1"
  },
  "0x302381": {
    "description": "本体電源電流異常1級警報：25A\nロボット本体の電流消費が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードが収集した電流が設定された閾値を超えています。",
    "action": "安全制御ボードのファームウェアがデバッグバージョンかどうかを確認してください、または技術サービススタッフに関連エラーコードの説明情報をお求めください。",
    "tittle": "本体電流異常一级警報",
    "isShowConfirm": "1"
  },
  "0x302382": {
    "description": "出力本体供給電流異常2級警告：31.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードが収集した電流が設定された閾値を超えています。",
    "action": "安全制御ボードがデバッグ版かどうかを確認するか、技術サポートにエラーコードの説明を提供するように連絡してください。",
    "tittle": "本体電流異常二次警報",
    "isShowConfirm": "1"
  },
  "0x302383": {
    "description": "出力本体供給電流異常3級予警：37.25A",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードが収集した電流が設定された閾値を超えています。",
    "action": "安全制御ボードがデバッグ版かどうかを確認するか、技術サポートにエラーコードの説明を提供するように連絡してください。",
    "tittle": "本体電流異常3級警報",
    "isShowConfirm": "1"
  },
  "0x302384": {
    "description": "ユーザー IO 電源電流が異常です (2.3A)",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コントロール キャビネット パネルの 24V 出力の合計電流値が 1.5A を超えています",
    "action": "1. 制御盤のパネル上のコンポーネントを取り外して、障害がまだ報告されているかどうかを確認してください。\n2. 最初のステップが報告されない場合、ユーザー機器は電源に制御キャビネットを使用できず、個別に電力を供給する必要があります。\n3. 最初の手順を行ってもエラーが報告され、シャットダウンして再起動した後もエラーが報告される場合は、技術スタッフに連絡してハードウェアが損傷していないか確認してください。",
    "tittle": "ユーザーIO電源電流異常",
    "isShowConfirm": "1"
  },
  "0x302385": {
    "description": "産業用コンピュータの電流が異常です（産業用コンピュータの電流が1.5Aを超え、産業用コンピュータが短絡していると見なされ、エラーが報告されます）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "産業用コンピュータが起動後に接続されていないか、産業用コンピュータの電流が 1.5A を超えています。",
    "action": "技術者に連絡して、産業用コンピュータのハードウェアに異常がないかどうかを確認してください。",
    "tittle": "IPC電流異常",
    "isShowConfirm": "1"
  },
  "0x302391": {
    "description": "異常な身体能力",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御基板で計算した本体の電力が設定制限値を超えた",
    "action": "1. アプリのセキュリティ設定で電力設定を再調整してください. \n2. 技術サービス担当者に連絡して、ハードウェアの制限を超える電力の問題がないかどうかを確認してください.",
    "tittle": "異常な身体能力",
    "isShowConfirm": "1"
  },
  "0x303181": {
    "description": "220V電源異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コントロール キャビネットは、220V 信号の振幅と周波数が異常であることを検出します。",
    "action": "1.現在の制御盤の電源電圧と周波数を確認してください。110V以上の交流電源を使用し、周波数が50〜60Hzの場合、220Vの電源喪失検出機能が存在します。90〜110Vの交流電源を使用する場合は、「設定 - ハードウェアと通信 - 辅助ハードウェア設定 - 制御盤電源オプション」を「その他」に変更してください；\n2. 最新バージョンのファームウェアにアップデートしてから、問題が依然として存在するか確認してください；\n3. 1および2で問題が解決しない場合、電源の電圧と周波数、および作業中の電圧と周波数の変動を確認してください；\n4. 1および2で問題が解決しない場合、かつ3を測定できない場合、ロボットが稼働中に直接制御盤の電源を切断する可能性があるかどうかを確認してください(220Vプラグを抜く、工場内の電源が落ちるなど)。もしそのような状況がない場合は、「設定 - ハードウェアと通信 - 辅助ハードウェア設定 - 制御盤電源オプション」を「その他」に変更して一時的に使用できます。",
    "tittle": "220V電源電圧異常",
    "isShowConfirm": "1"
  },
  "0x303182": {
    "description": "主供電リレー異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "48V出力を制御するリレーが電源が入っていない状態で出力信号を検出しており、48V電源の入力信号を制御するリレーが粘着している可能性があります。",
    "action": "1. 安全制御ボードのファームウェアを最新バージョンに更新し、問題が解決するか確認してください。\n2. 制御盤の供給電圧の振幅と周波数を確認してください。90〜110V ACの電源を持つ制御盤は、'dis220v'という文字が記載されたファームウェアバージョンを使用する必要があります。\n3. 上記の手順を実施後も問題が解決しない場合は、技術者に連絡して制御盤の48V電源を制御するリレーが損傷していないか確認してください。",
    "tittle": "主供電リレー異常",
    "isShowConfirm": "1"
  },
  "0x303184": {
    "description": "安全デジタル入力信号に異常があり、安全制御盤が異常故障を検出してもクリアされず、ロボットの再電源要求を拒否した",
    "type": "2",
    "isShowOTA": "0",
    "reason": "制御盤パネルに配置された安全なデジタル入力信号に異常がないかどうかを確認し、安全なデジタル入力信号入力に異常がないことを確認してから再電源を入れて故障を取り除いてください",
    "action": "",
    "tittle": "安全信号異常電源投入拒否",
    "isShowConfirm": "1"
  },
  "0x303281": {
    "description": "5V異常（電源電圧の変動幅）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コントロール キャビネット内の 5V 信号電圧値が内部プリセット値 (3.5~6.1V) を超えている場合、マルチメータを使用して 5V 信号電圧値をテストできます。",
    "action": "1. ファームウェアのバージョンが最新バージョンであるかどうかを確認してください。最新バージョンではない場合は、最新バージョンに更新した後も問題が存在するかどうかを確認してください。\n2. 制御盤の入力電源が切断された後、電源を再起動し、問題がまだ存在するかどうかを確認し、問題がまだ存在する場合は、技術担当者に連絡して制御盤のハードウェアを確認してください。\n3. 標準の 220V 電源制御キャビネットの場合、220V 電源が抜かれていると障害が報告されますが、これは正常な現象です。",
    "tittle": "5V電源電圧異常",
    "isShowConfirm": "1"
  },
  "0x303282": {
    "description": "12V異常（電源電圧の変動幅）",
    "type": "2",
    "isShowOTA": "0",
    "reason": "コントロール キャビネット内の 12V 信号電圧値は、内部プリセット値 (9 ~ 14V) を超えており、12V 信号電圧値はマルチメータで測定できます。",
    "action": "1. ファームウェアのバージョンが最新バージョンであるかどうかを確認してください。最新バージョンではない場合は、最新バージョンに更新した後も問題が存在するかどうかを確認してください。\n2. 制御盤の入力電源が切断された後、電源を再起動し、問題がまだ存在するかどうかを確認し、問題がまだ存在する場合は、技術担当者に連絡して制御盤のハードウェアを確認してください。\n3. 標準の 220V 電源制御キャビネットの場合、220V 電源が抜かれていると障害が報告されますが、これは正常な現象です。",
    "tittle": "12V電源電圧異常",
    "isShowConfirm": "1"
  },
  "0x303283": {
    "description": "24V異常（電源電圧の変動幅）",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントロール キャビネット内の 12V 信号電圧が内部プリセット値 (15 ～ 31V) を超えている場合、マルチメータを使用して 12V 信号電圧値を測定できます。",
    "action": "1. ファームウェアのバージョンが最新バージョンであるかどうかを確認してください。最新バージョンではない場合は、最新バージョンに更新した後も問題が存在するかどうかを確認してください。\n2. 制御盤の入力電源が切断された後、電源を再起動し、問題がまだ存在するかどうかを確認し、問題がまだ存在する場合は、技術担当者に連絡して制御盤のハードウェアを確認してください。\n3. 標準の 220V 電源制御キャビネットの場合、220V 電源が抜かれていると障害が報告されますが、これは正常な現象です。",
    "tittle": "24V電源電圧異常",
    "isShowConfirm": "1"
  },
  "0x303381": {
    "description": "ボディ電圧または電圧構成が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "MiniCAB で設定された放電電圧値は、MiniCAB の入力電圧値よりも小さくなっています。",
    "action": "アプリを使用して放電電圧をリセットしてください。",
    "tittle": "本体出力電源電圧異常",
    "isShowConfirm": "1"
  },
  "0x303387": {
    "description": "安全制御ボードリレー異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "本体の電源を切った後、安全制御ボードは本体電源の2つのリレーの電圧値が一致しないことを検出しました。",
    "action": "1. 最新のファームウェアバージョンに更新し、問題が解決するか確認してください。 \n2. 上記の操作後も問題が解決しない場合は、技術者に安全制御ボード内部のリレーが損傷していないか確認してください。",
    "tittle": "安全制御ボード リレー異常",
    "isShowConfirm": "1"
  },
  "0x304281": {
    "description": "異常な PDU 温度",
    "type": "2",
    "isShowOTA": "0",
    "reason": "制御盤内温度が69℃を超える",
    "action": "1. コントロール キャビネット内の温度が 70°C を超えているかどうかを確認してください. 1. コントロール キャビネット内のファンが正常に動作しているかどうかを確認してください。",
    "tittle": "異常な PDU 温度",
    "isShowConfirm": "1"
  },
  "0x304282": {
    "description": "ブレーキ抵抗器の過熱",
    "type": "1",
    "isShowOTA": "0",
    "reason": "MiniCAB の内部制動抵抗器の温度が 80°C を超えています",
    "action": "1. MiniCAB の内部温度を確認してください。\n2. ロボットの加速度を下げてください。\n3. 冷却ファンを追加してください。",
    "tittle": "ブレーキ抵抗器の過熱",
    "isShowConfirm": "1"
  },
  "0x305081": {
    "description": "コントロールスティックの緊急停止安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "ハンドルを交換するか、技術者に連絡してキャビネットの SCB 回路を確認してください。",
    "tittle": "コントロールスティックの緊急停止安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305082": {
    "description": "外部緊急停止の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "パネルのp8端子の接触不良や、外部回路が正常かどうかを確認してください",
    "tittle": "外部緊急停止の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305083": {
    "description": "保護停止信号入力異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "パネルのp8端子の接触不良や、外部回路が正常かどうかを確認してください",
    "tittle": "保護停止信号入力異常",
    "isShowConfirm": "1"
  },
  "0x305084": {
    "description": "SCBリレー異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "SCB がデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "SCBリレー異常",
    "isShowConfirm": "1"
  },
  "0x305085": {
    "description": "ブレーキ抵抗過熱",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "SCB がデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ブレーキ抵抗過熱",
    "isShowConfirm": "1"
  },
  "0x305086": {
    "description": "ハンドルイネーブル入力異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "SCB がデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ハンドルイネーブル入力異常",
    "isShowConfirm": "1"
  },
  "0x305087": {
    "description": "追加の緊急停止安全信号入力が異なります。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります。",
    "action": "安全入力回路の接続に異常がないか確認してください。",
    "tittle": "追加の緊急停止安全信号入力が異なります",
    "isShowConfirm": "1"
  },
  "0x305088": {
    "description": "追加の保護追加の保護停止安全入力が異常です停止入力異常",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "追加の保護停止安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305089": {
    "description": "保護停止リセットの安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "保護停止リセットの安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x30508A": {
    "description": "縮小モードの安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "縮小モードの安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x30508B": {
    "description": "三位置有効化の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "三位置有効化の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305090": {
    "description": "衝突検出の安全入力停止が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突検出の安全入力停止が異常です",
    "isShowConfirm": "1"
  },
  "0x305091": {
    "description": "衝突感度LV1設定の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度LV1設定の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305092": {
    "description": "衝突感度LV2設定の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度LV2設定の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305093": {
    "description": "衝突感度LV3設定の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度LV3設定の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305094": {
    "description": "衝突感度LV4設定の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度LV4設定の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305095": {
    "description": "衝突感度LV5設定の安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度LV5設定の安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x305097": {
    "description": "衝突感度を極端に低く設定する安全入力が異常です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全信号は二重冗長チャネルを有しており、2つの信号が一致しない場合に安全状態に入ります.",
    "action": "安全入力回路の接続に異常がないか確認してください.",
    "tittle": "衝突感度を極端に低く設定する安全入力が異常です",
    "isShowConfirm": "1"
  },
  "0x308181": {
    "description": "ハンドルCAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "安全制御ボードとハンドルバス間でデータエラーが発生しています。",
    "action": "1. ハンドルと電気制御キャビネット間のケーブル接続が正常であることを確認してください。\n2. 技術者に連絡し、安全制御ボードと制御キャビネットCAN2間のCANバスに異常がないか確認してください。",
    "tittle": "ハンドルCAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308182": {
    "description": "コントローラCAN通信中断",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源を入れてから、一定時間コントローラから本体への指令が受信されていません。",
    "action": "1. 安全制御ボードのファームウェアを最新バージョンに更新し、問題が解決するか確認してください。\n2. アプリのモニタで1〜6関節のデータが更新されているか確認してください。\n3. 本体の末端インジケーターライトが点灯しているか確認してください。点灯していない場合は、配線が正常かどうかを確認してください。",
    "tittle": "コントローラCAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308183": {
    "description": "ロボットCAN通信が中断されました。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源を入れてから、長時間コントローラからの信号を受信していません。",
    "action": "1. 安全制御ボードのファームウェアを最新バージョンにアップグレードし、エラーが再発するか確認してください。\n2. アプリで関節1から6のデータを監視し、更新があるか確認してください。\n3. ロボットの末端のインジケーターライトが点灯しているか確認してください。点灯していない場合は、配線が正しいか確認してください。",
    "tittle": "ロボットCAN通信の中断",
    "isShowConfirm": "1"
  },
  "0x308184": {
    "description": "TIO CAN通信が中断されました。",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源を入れてから、コントローラーから本体への指示をしばらく受信していません。",
    "action": "1. 安全制御ボードのファームウェアを最新バージョンに更新し、故障が続くか確認してください。\n2. アプリまたはサーボモニタリングページで関節1から6のデータが更新されているか監視してください。\n3. ロボットの末端のインジケーターライトが点灯しているか確認してください。点灯していない場合は、配線が正しいか確認してください。",
    "tittle": "TIO CAN通信中断",
    "isShowConfirm": "1"
  },
  "0x308185": {
    "description": "CAN通信正常待機タイムアウト",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットの電源を入れてから、コントローラーから本体への指示をしばらく受信していません。",
    "action": "1. 安全制御ボードのファームウェアを最新バージョンに更新し、故障が続くか確認してください。\n2. アプリの監視ページまたはサーボ監視ページで、1〜6の関節のデータが更新されているか確認してください。\n3. ロボットの末端のインジケーターライトが点灯しているか確認してください。点灯していない場合は、配線が正しいか確認してください。",
    "tittle": "CAN通信正常待機タイムアウト",
    "isShowConfirm": "1"
  },
  "0x309081": {
    "description": "ドラッグモードのTCP速度が制限を超えました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ドラッグモードのTCP速度が{0}mm/sの制限を超えています、現在のTCP速度は{1}mm/sです。",
    "action": "ドラッグ速度を下げてください。ドラッグモードでTCP速度が制限を超えた場合、ロボットはドラッグモードを終了します。",
    "tittle": "ドラッグモードのTCP速度が制限を超えました",
    "isShowConfirm": "1"
  },
  "0x309082": {
    "description": "緊急停止",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ハンドル非常停止、ユーザー非常停止、安全機能IO非常停止信号のいずれかがトリガされます。",
    "action": "ハンドル非常停止、ユーザ非常停止、セーフティ機能IO非常停止信号のどれが発生しているか確認してください。",
    "tittle": "非常停止トリガー",
    "isShowConfirm": "1"
  },
  "0x309083": {
    "description": "ロボット マシンの電源アラームしきい値",
    "type": "1",
    "isShowOTA": "0",
    "reason": "废弃",
    "action": "SCB がデバッグ バージョンであるかどうかを確認するか、技術サービス担当者に連絡して、関連するエラー コードの説明情報を提供してください。",
    "tittle": "ロボット マシンの電源アラームしきい値",
    "isShowConfirm": "1"
  },
  "0x3F0001": {
    "description": "力センサー接続の初期化に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサーでオープンすると、通信設定に従ってセンサーとの接続が確立されます。このエラーは、コントローラーとセンサー間の通信接続が失敗した場合に返されます。",
    "action": "1. 力センサーの種類と通信構成を確認してください。\n2. 制御盤インターフェースと力センサー間の通信物理接続が正常であることを確認してください。\n3. 力センサーの電源が正常であることを確認してください。\n4. Modbus デバッグ ツールまたはネットワーク デバッグ アシスタント ツールを使用して力センサーを接続し、力センサーが異常かどうかを確認できます。",
    "tittle": "力センサー通信の初期化に失敗しました",
    "isShowConfirm": "1"
  },
  "0x3F0002": {
    "description": "力センサーのスイッチが頻繁にオンになりすぎました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサーをオンにして通信を確立するには約1秒かかり、短時間で力センサーを頻繁にオンにしようとするとこの警告がトリガーされる",
    "action": "後で再試行してください",
    "tittle": "力センサーのスイッチが頻繁にオンになりすぎました。",
    "isShowConfirm": "1"
  },
  "0x3F1001": {
    "description": "力センサーデータの受信に失敗しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "このエラーは、コントローラとセンサ間の通信が確立され、接続は正常に確立されているが、動作中にデータが切断された場合に報告されます。",
    "action": "1. 力センサーの種類と通信構成を確認してください。\n2. 制御盤インターフェースと力センサー間の通信物理接続が正常であることを確認してください。\n3. 力センサーの電源が正常であることを確認してください。\n4. Modbus デバッグ ツールまたはネットワーク デバッグ アシスタント ツールを使用して力センサーを接続し、力センサーが異常かどうかを確認できます。",
    "tittle": "力センサーデータの受信に失敗しました",
    "isShowConfirm": "1"
  },
  "0x3F1002": {
    "description": "受信力センサーデータフォーマットエラー",
    "type": "1",
    "isShowOTA": "0",
    "reason": "このエラーは通常、力センサーが TIO を介して拡張されている場合に発生し、受信した力センサーデータのフォーマットが間違っている場合にエラーが報告されます。",
    "action": "1. 力センサーの種類と通信プロトコルを確認してください。\n2. Modbus デバッグ ツール、ネットワーク デバッグ アシスタント ツール、またはシリアル ポート デバッグ ツールを使用して、受信した力センサーデータを分析して、JAKA+ 力センサーの通信プロトコルに準拠しているかどうかを判断できます。",
    "tittle": "受信力センサーデータフォーマットエラー",
    "isShowConfirm": "1"
  },
  "0x3F1003": {
    "description": "力センサーのデータ異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "フォースセンサから一定時間連続して同じ数値が受信されます。このエラーは、センサが応答しないときに発生します。",
    "action": "後でセンサーの再起動をお試しください。",
    "tittle": "力センサーのデータ異常",
    "isShowConfirm": "1"
  },
  "0x3F1004": {
    "description": "力センサーのデータ異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサの最大レンジを超える",
    "action": "1.ロボットの端部が外部と衝突していないか確認してください。センサーが激突した後に不可逆的な損傷が発生する可能性がある",
    "tittle": "力センサーのデータ異常",
    "isShowConfirm": "1"
  },
  "0x3F1005": {
    "description": "力センサーのデータ異常",
    "type": "1",
    "isShowOTA": "0",
    "reason": "センサデータが大幅に急変し、安全範囲を超えています。",
    "action": "ロボットの末端に沖突が発生していないかチェックしてください。沖突が原因でない場合は、ロボット本体の電源とパワーセンサーの電源を切って、しばらく待ってからパワーセンサーをオンにします。",
    "tittle": "力センサーのデータ異常",
    "isShowConfirm": "1"
  },
  "0x3F1006": {
    "description": "エンドフォースセンサーはこの値付近で校正されました：{0}。",
    "type": "0",
    "isShowOTA": "0",
    "reason": "前回の稼働時にセンサー校正または校正結果照会の指令が発行されました。校正の成功または照会の成功後にこの通知が表示されます。注記：センサー校正指令の場合、今回のポップアップ結果は今回の校正完了後の結果を示します。",
    "action": "この校正結果を適切に記録し：{0}、以降の使用時にセンサー測定値とこの数値の合計がセンサーの測定範囲内に収まるようにしてください。",
    "tittle": "エンドフォースセンサー校正結果",
    "isShowConfirm": "1"
  },
  "0x10F0000": {
    "description": "システム非常停止トリガー",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "システム非常停止トリガー",
    "isShowConfirm": "1"
  },
  "0x10F0001": {
    "description": "システム非常停止リセット",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "システム非常停止リセット",
    "isShowConfirm": "1"
  },
  "0x10F0002": {
    "description": "ロボットの電源が入っています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットの電源が入っています",
    "isShowConfirm": "0"
  },
  "0x10F0003": {
    "description": "ロボットの電源がオフになっています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットの電源がオフになっています",
    "isShowConfirm": "0"
  },
  "0x10F0004": {
    "description": "ロボットサーボ有効化完了",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットサーボ有効化完了",
    "isShowConfirm": "0"
  },
  "0x10F0005": {
    "description": "ロボットサーボ有効オフ",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットサーボ有効オフ",
    "isShowConfirm": "0"
  },
  "0x10F0006": {
    "description": "ロボットは拡大モードを終了します",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは拡大モードを終了します",
    "isShowConfirm": "0"
  },
  "0x10F0007": {
    "description": "ロボットは第 1 レベルの拡大モードに入ります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは第 1 レベルの拡大モードに入ります",
    "isShowConfirm": "0"
  },
  "0x10F0008": {
    "description": "ロボットは二次拡大モードに入ります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは二次拡大モードに入ります",
    "isShowConfirm": "0"
  },
  "0x10F0009": {
    "description": "ロボットは保護停止に入ります",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは保護停止に入ります",
    "isShowConfirm": "1"
  },
  "0x10F000A": {
    "description": "ロボットが衝突防止停止を終了",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットが衝突防止停止を終了",
    "isShowConfirm": "1"
  },
  "0x10F000B": {
    "description": "ロボットは衝突防止停止に入ります",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは衝突防止停止に入ります",
    "isShowConfirm": "1"
  },
  "0x10F000C": {
    "description": "ロボット関節限界状態回復",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボット関節限界状態回復",
    "isShowConfirm": "0"
  },
  "0x10F000D": {
    "description": "カルーセル機能がオンになっています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "カルーセル機能がオンになっています",
    "isShowConfirm": "0"
  },
  "0x10F000E": {
    "description": "カルーセル機能はオフです",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "カルーセル機能はオフです",
    "isShowConfirm": "0"
  },
  "0x10F000F": {
    "description": "ソフトコントロールオン",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ソフトコントロールオン",
    "isShowConfirm": "0"
  },
  "0x10F0010": {
    "description": "柔らかさコントロールはオフです",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "柔らかさコントロールはオフです",
    "isShowConfirm": "0"
  },
  "0x10F0011": {
    "description": "ロボットがドラッグモードに入る",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットがドラッグモードに入る",
    "isShowConfirm": "0"
  },
  "0x10F0012": {
    "description": "ロボットはドラッグ モードを終了します",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットはドラッグ モードを終了します",
    "isShowConfirm": "0"
  },
  "0x10F0013": {
    "description": "ロボットがツールドラッグモードに入りました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットがツールドラッグモードに入りました",
    "isShowConfirm": "0"
  },
  "0x10F0014": {
    "description": "ロボットがツールドラッグモードを終了しました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットがツールドラッグモードを終了しました",
    "isShowConfirm": "0"
  },
  "0x10F0015": {
    "description": "ロボット SERVO モーション モードがオンです",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボット SERVO モーション モードがオンです",
    "isShowConfirm": "0"
  },
  "0x10F0016": {
    "description": "ロボット SERVO モーション モードがオフです",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボット SERVO モーション モードがオフです",
    "isShowConfirm": "0"
  },
  "0x10F0017": {
    "description": "ロボットが危険区域に入りました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットは安全区域を越えて危険区域に入りました。",
    "action": "安全エリアの設定が期待どおりであるか確認してください。トラブルシューティング時には、安全平面機能を無効にするか、ロボットを安全エリア内で動かすことができます。",
    "tittle": "ロボットが危険区域に入りました",
    "isShowConfirm": "1"
  },
  "0x10F0018": {
    "description": "ロボットは安全な範囲内に戻ります",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは安全な範囲内に戻ります",
    "isShowConfirm": "0"
  },
  "0x10F0019": {
    "description": "デカルト空間レート制限を開始",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "デカルト空間レート制限を開始",
    "isShowConfirm": "0"
  },
  "0x10F001A": {
    "description": "デカルト空間レート制限を停止",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "デカルト空間レート制限を停止",
    "isShowConfirm": "0"
  },
  "0x10F001B": {
    "description": "ジョブプログラムの実行開始",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ジョブプログラムの実行開始",
    "isShowConfirm": "0"
  },
  "0x10F001C": {
    "description": "オペレーティングプログラムは中断されています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "オペレーティングプログラムは中断されています",
    "isShowConfirm": "0"
  },
  "0x10F001D": {
    "description": "ジョブプログラムは実行を再開します",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ジョブプログラムは実行を再開します",
    "isShowConfirm": "0"
  },
  "0x10F001E": {
    "description": "オペレーティングプログラムの実行が停止します",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "オペレーティングプログラムの実行が停止します",
    "isShowConfirm": "0"
  },
  "0x10F001F": {
    "description": "ロボットが間もなく危険区域に入る予定です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットが安全エリアから危険エリアに進入しようとしています。",
    "action": "安全エリアの設定が期待どおりであるか確認してください。トラブルシューティング時には、安全平面機能を無効にするか、ロボットを安全エリア内で動かすことができます。",
    "tittle": "ロボットが間もなく危険区域に入る予定です",
    "isShowConfirm": "1"
  },
  "0x10F0020": {
    "description": "ロボットが縮小モードに入る",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットが縮小モードに入る",
    "isShowConfirm": "0"
  },
  "0x10F0021": {
    "description": "ロボットは縮小モードを終了します",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ロボットは縮小モードを終了します",
    "isShowConfirm": "0"
  },
  "0x10F0022": {
    "description": "ロボットは運動量削減モードに入りました。",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "ロボットは運動量削減モードに入りました。",
    "isShowConfirm": "0"
  },
  "0x10F0023": {
    "description": "ロボットは電力削減モードに入りました。",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "ロボットは電力削減モードに入りました。",
    "isShowConfirm": "0"
  },
  "0x10F0024": {
    "description": "ロボットは保護停止モードから復帰しました。",
    "type": "2",
    "isShowOTA": "1",
    "reason": "",
    "action": "",
    "tittle": "ロボットは保護停止モードから復帰しました。",
    "isShowConfirm": "1"
  },
  "0x10F0025": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "セキュリティパラメータが変更されました",
    "action": "",
    "tittle": "セキュリティ構成が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0026": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "セキュリティパラメータのセキュリティ姿勢は{2}から{3}に変わります",
    "action": "",
    "tittle": "セキュリティ構成が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0027": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "セキュリティパラメータ内のセーフティポーズ誤差が{2}から{3}に変わります",
    "action": "",
    "tittle": "セキュリティ構成のセーフティポーズ誤差が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0028": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "コントローラの運転モードが{2}から{3}に変更され",
    "action": "",
    "tittle": "ユーザーセキュリティ構成コントローラの運転モード変更",
    "isShowConfirm": "0"
  },
  "0x10F0029": {
    "description": "セキュリティ パラメータのチェックサムが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント {2} のマイナス制限が {3} から {4} に変更されました",
    "action": "",
    "tittle": "ユーザー安全設定ジョイントの正の制限の変更",
    "isShowConfirm": "0"
  },
  "0x10F002A": {
    "description": "セキュリティ パラメータのチェックサムが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ジョイント {2} の正の制限が {3} から {4} に変更されました",
    "action": "",
    "tittle": "ユーザー安全設定ジョイントの正の制限の変更",
    "isShowConfirm": "0"
  },
  "0x10F002B": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DI {2} で構成されたセキュリティ関数コードが {3} から {4} に変更されました",
    "action": "",
    "tittle": "ユーザーセキュリティ機能DI設定変更",
    "isShowConfirm": "0"
  },
  "0x10F002C": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "DO {2} で構成されたセキュリティ関数コードが {3} から {4} に変更されました",
    "action": "",
    "tittle": "ユーザーセキュリティ機能DO設定変更",
    "isShowConfirm": "0"
  },
  "0x10F002D": {
    "description": "安全性パラメーターの検証が {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットの電力制限構成が {2} から {3} に変更されました",
    "action": "",
    "tittle": "ロボットの電力制限構成が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F002E": {
    "description": "安全性パラメータの検証が {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボット端末の速度制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "ロボット端末の速度制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F002F": {
    "description": "安全パラメータの検証が {0} から {1} に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ユーザー セキュリティ構成の停止距離が {2} から {3} に変更されました",
    "action": "",
    "tittle": "ユーザー安全設定の停止距離が変更され",
    "isShowConfirm": "0"
  },
  "0x10F0030": {
    "description": "セキュリティ パラメーターの検証が {0} から {1} に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ユーザー セキュリティ構成の停止時間が {2} から {3} に変更されました。",
    "action": "",
    "tittle": "ユーザー セキュリティ構成の停止時間が変更され",
    "isShowConfirm": "0"
  },
  "0x10F0031": {
    "description": "安全性パラメータチェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "エルボ速度制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "エルボ速度制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0032": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "運動量制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "運動量制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0033": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節{2}の速度制限が{3}から{4}に変更されました",
    "action": "",
    "tittle": "関節速度制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0034": {
    "description": "セキュリティパラメータチェックが{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "関節{2}の誤差警報閾値が{3}から{4}に変更されました",
    "action": "",
    "tittle": "関節誤差警報閾値が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0035": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されます",
    "type": "1",
    "isShowOTA": "0",
    "reason": "元のツール姿勢制約は次のとおりです:\n座標系 {2}、工具方向 x: {3}、工具方向 Y: {4}、制限範囲: {5}、安全距離: {6}、制限方向 rx: {7}、ry: {8}、 rz: {9}、実行可能: {10}、起動中: {11}；\n現在のツール ポーズ制約は次のとおりです:\n座標系 {12}、工具方向 x: {13}、工具方向 Y: {14}、制限範囲: {15}、安全距離: {16}、制限方向 rx: {17}、ry: {18}、 rz: {19}、実行イネーブル: {20}、ブート開始: {21}",
    "action": "",
    "tittle": "ツール姿勢制約が変更され",
    "isShowConfirm": "0"
  },
  "0x10F0036": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "元の衝突処理設定は次のとおりです:\n衝突観察方法: {2}、衝突後処理オプション: {3}、衝突バウンス角度: {4}、衝突バウンス距離: {5}、バウンス ジョイント加速度: {6}、バウンス ジョイント速度: {7}、バウンス線加速度: {8}、リバウンド線速度: {9}\n現在の衝突処理設定は次のとおりです:\n衝突観察方法: {10}、衝突後処理オプション: {11}、衝突バウンス角度: {12}、衝突バウンス距離: {13}、バウンス ジョイント加速度: {14}、バウンス ジョイント速度: {15}、バウンス線加速度: {16}、リバウンド線速度: {17}",
    "action": "",
    "tittle": "衝突オプションが変更され",
    "isShowConfirm": "0"
  },
  "0x10F0037": {
    "description": "安全性パラメータの検証が {0} から {1} に変更されました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "衝突感度が {2} から {3} に変更されました。",
    "action": "",
    "tittle": "サーボトルク制限変更。",
    "isShowConfirm": "0"
  },
  "0x10F0038": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} ",
    "type": "1",
    "isShowOTA": "0",
    "reason": "元のデフォルトのプログラム構成) に変更されました。\n自動ロード: {2}、プログラム名: {3}\n現在のデフォルトのプログラム構成) に変更されました。\n自動ロード: {4}、プログラム名: {5}",
    "action": "",
    "tittle": "起動時のデフォルトのロード構成が変更され",
    "isShowConfirm": "0"
  },
  "0x10F0039": {
    "description": "セキュリティ パラメータ検証が {0} から {1} に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "電源投入時自動有効化ステータスが {2} から {3} に変更されました",
    "action": "",
    "tittle": "電源投入時自動有効化ステータスが変更され",
    "isShowConfirm": "0"
  },
  "0x10F003A": {
    "description": "セキュリティ パラメータの検証を {0} から {1} に変更し",
    "type": "1",
    "isShowOTA": "0",
    "reason": "実行中のプログラムのステータスの自動変更を有効にして {2} から {3} に変更します",
    "action": "",
    "tittle": "実行中のプログラムのステータスの自動変更を有効にし",
    "isShowConfirm": "0"
  },
  "0x10F003B": {
    "description": "安全パラメータの検証が{0}から{1}に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "元のパラメータ:\n安全区域の有効方法：{2}、安全区域到達/超過後の処理方法：{3}、肘位置制限の有効化：{4}\n新しいパラメータ:\n安全区域の有効方法：{5}、安全区域到達/超過後の処理方法：{6}、肘位置制限の有効化：{7}",
    "action": "",
    "tittle": "セキュリティプレーンのグローバル設定の変更",
    "isShowConfirm": "0"
  },
  "0x10F003C": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "初期化プロセスでセキュリティ パラメータの変更が検出され",
    "isShowConfirm": "1"
  },
  "0x10F003D": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "強制力制限を{2}から{3}に変更",
    "action": "",
    "tittle": "終了力制限の変更",
    "isShowConfirm": "0"
  },
  "0x10F003F": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "感度を{2}から{3}に変更",
    "action": "",
    "tittle": "関節感度の変化",
    "isShowConfirm": "0"
  },
  "0x10F0040": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "有効状態が {2} から {3} に変更されました",
    "action": "",
    "tittle": "コリジョンイネーブル状態の変更",
    "isShowConfirm": "0"
  },
  "0x10F0041": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "平面{2}:\n 原始パラメーター:\n  平面名：{3}, 有効：{4}, 安全距離：{5}, 衝突レベル：{6}, 平面隠し：{7}\n 新しいパラメーター:\n  平面名：{8}, 有効：{9}, 安全距離：{10}, 衝突レベル：{11}, 平面隠し：{12}",
    "action": "",
    "tittle": "個々のセキュリティ プレーン構成の変更",
    "isShowConfirm": "0"
  },
  "0x10F0042": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "フラット{2}:\n  元のパラメータ:\n  平面点1:{3}、平面点2:{4}、平面点3:{5}、安全点:{6}\n  新しいパラメータ:\n  平面点1:{7}、平面点2:{8}、平面点3:{9}、安全点:{10}",
    "action": "",
    "tittle": "個々の安全平面ポイントの変更",
    "isShowConfirm": "0"
  },
  "0x10F0043": {
    "description": "安全性パラメーターの検証が {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "減少モードでのロボットの電力制限構成が {2} から {3} に変更されました",
    "action": "",
    "tittle": "減少モードでのロボットの電力制限構成が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0044": {
    "description": "セキュリティ パラメータ チェックが {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "減少モードでの運動量制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "減少モードでの運動量制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0045": {
    "description": "安全性パラメータの検証が {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "減少モードでのロボット端末の速度制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "減少モードでのロボット端末の速度制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0046": {
    "description": "安全パラメータの検証が {0} から {1} に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "減少モードのユーザー セキュリティ構成の停止距離が {2} から {3} に変更されました",
    "action": "",
    "tittle": "減少モードのユーザーセキュリティ構成停止距離が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F0047": {
    "description": "セキュリティ パラメーターの検証が {0} から {1} に変更され",
    "type": "1",
    "isShowOTA": "0",
    "reason": "減少モードのユーザー セキュリティ構成の停止時間が {2} から {3} に変更されました。",
    "action": "",
    "tittle": "減少モードのユーザー セキュリティ構成の停止時間が変更され",
    "isShowConfirm": "0"
  },
  "0x10F0048": {
    "description": "緊急停止時の電源投入は禁止です",
    "type": "2",
    "isShowOTA": "0",
    "reason": "緊急停止が発生した場合、電源を入れる操作はできません",
    "action": "緊急停止をリセットしてから、もう一度電源を入れる操作を行ってください",
    "tittle": "緊急停止時の電源投入は禁止です",
    "isShowConfirm": "1"
  },
  "0x10F0049": {
    "description": "安全性パラメータの検証が {0} から {1} に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ロボットのエンドエフェクタのドラッグ速度制限が {2} から {3} に変更されました",
    "action": "",
    "tittle": "ロボットのエンドエフェクタのドラッグ速度制限が変更されました",
    "isShowConfirm": "0"
  },
  "0x10F004A": {
    "description": "逆ドライブモードでは有効化操作は禁止されています",
    "type": "1",
    "isShowOTA": "0",
    "reason": "リバースドライブモードでは、SDK、IO、およびその他の制御ソースを介した有効化操作は禁止されています",
    "action": "再試行する前にリバースドライブモードを終了してください。",
    "tittle": "逆ドライブモードでは有効化操作は禁止されています",
    "isShowConfirm": "1"
  },
  "0x10F004B": {
    "description": "",
    "type": "1",
    "isShowOTA": "0",
    "reason": "逆走行モードでは、SDK、IO、およびその他の制御ソースを介した電源オフ操作は禁止されています",
    "action": "再試行する前にリバースドライブモードを終了してください。",
    "tittle": "逆ドライブモードでは電源オフ操作が禁止されています",
    "isShowConfirm": "1"
  },
  "0x10F004C": {
    "description": "セキュリティ パラメーターの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "平面 {2}:\n 原始パラメーター:\n  平面有効化DI設定:{3}, 平面状態DO設定:{4}\n 新しいパラメーター:\n  平面有効化DI設定:{5}, 平面状態DO設定:{6}",
    "action": "",
    "tittle": "個々のセキュリティ プレーン構成の変更",
    "isShowConfirm": "0"
  },
  "0x10F004D": {
    "description": "安全パラメータの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "キューブ{2}:\n 初期パラメータ:\n  キューブ名：{3}、有効：{4}、内部安全：{5}、キューブ隠し：{6}、参照座標系ID：{7}、衝突レベル：{8}、安全距離：{9}\n 新しいパラメータ:\n  キューブ名：{10}、有効：{11}、内部安全：{12}、キューブ隠し：{13}、参照座標系ID：{14}、衝突レベル：{15}、安全距離：{16}",
    "action": "",
    "tittle": "単一の安全キューブの設定変更",
    "isShowConfirm": "0"
  },
  "0x10F004E": {
    "description": "安全パラメータの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "キューブ {2}:\n 初期パラメータ:\n  参照座標：{3}, 対角点1：{4}, 対角点2：{5}\n 新しいパラメータ:\n  参照座標：{6}, 対角点1：{7}, 対角点2：{8}",
    "action": "",
    "tittle": "単一の安全キューブの設定変更",
    "isShowConfirm": "0"
  },
  "0x10F004F": {
    "description": "安全パラメータの検証が{0}から{1}に変更されました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "キューブ {2}:\n 初期設定:\n  キューブ有効化DI設定：{3}, キューブ状態DO設定：{4}\n 新しい設定:\n  キューブ有効化DI設定：{5}, キューブ状態DO設定：{6}",
    "action": "",
    "tittle": "単一の安全キューブの設定変更",
    "isShowConfirm": "0"
  },
  "0x10F0051": {
    "description": "安全機能が起動し、所望の停止時間内に安全速度に減速しない",
    "type": "1",
    "isShowOTA": "0",
    "reason": "安全監視機能が起動し、ロボットの速度が安全制限を超えていることを監視する",
    "action": "",
    "tittle": "安全監視機能が起動し、ロボットの速度が安全制限を超えていることを監視する",
    "isShowConfirm": "1"
  },
  "0x10F0060": {
    "description": "プログラムの実行を再開できません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保護停止または衝突状態ではプログラムの実行を再開できません",
    "action": "1.保護停止からの退出後、プログラムの実行を自動的に再開します.\n2.衝突異常状態をクリアした後、プログラムの実行を再試行します.",
    "tittle": "プログラムの実行を再開できません",
    "isShowConfirm": "1"
  },
  "0x10F0061": {
    "description": "保護停止状態では初期位置に戻ることはできません",
    "type": "2",
    "isShowOTA": "0",
    "reason": "保護停止状態では初期位置に戻ることはできません",
    "action": "保護停止を解除してから初期位置に再度戻る試みを行います",
    "tittle": "初期位置への戻りに失敗しました",
    "isShowConfirm": "1"
  },
  "0x10F0100": {
    "description": "力センサーON",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力センサーON",
    "isShowConfirm": "0"
  },
  "0x10F0101": {
    "description": "力センサーがオフになる",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力センサーがオフになる",
    "isShowConfirm": "0"
  },
  "0x10F0102": {
    "description": "拡張 IO モジュールが有効になっています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "拡張 IO モジュールが有効になっています",
    "isShowConfirm": "0"
  },
  "0x10F0103": {
    "description": "拡張 IO モジュールが閉じています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "拡張 IO モジュールが閉じています",
    "isShowConfirm": "0"
  },
  "0x10F0104": {
    "description": "コントロールハンドルロック",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "コントロールハンドルロック",
    "isShowConfirm": "1"
  },
  "0x10F0105": {
    "description": "力センサーの断線",
    "type": "2",
    "isShowOTA": "0",
    "reason": "ロボットコントローラーと力センサー間の通信ができません。",
    "action": "1. 力センサーが正しく取り付けられているか確認してください。\n2. 力センサーとロボット間の接続ケーブルが損傷していないか、または緩んでいないか確認してください。",
    "tittle": "力センサーの断線",
    "isShowConfirm": "0"
  },
  "0x10F0106": {
    "description": "力終了条件がトリガーされた",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "力終了条件がトリガーされた",
    "isShowConfirm": "0"
  },
  "0x10F0200": {
    "description": "関数 DI (プログラムの実行) のトリガー",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "関数 DI (プログラムの実行) のトリガー",
    "isShowConfirm": "0"
  },
  "0x10F0201": {
    "description": "ファンクション DI（プログラムの一時停止）がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ファンクション DI（プログラムの一時停止）がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F0202": {
    "description": "関数 DI (再開手順) がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "関数 DI (再開手順) がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F0203": {
    "description": "機能 DI (プログラム停止) がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (プログラム停止) がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F0204": {
    "description": "機能 DI (電源オン) トリガー",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (電源オン) トリガー",
    "isShowConfirm": "0"
  },
  "0x10F0205": {
    "description": "機能 DI (電源オフ) トリガー",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (電源オフ) トリガー",
    "isShowConfirm": "0"
  },
  "0x10F0206": {
    "description": "機能 DI (サーボ有効オン) がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (サーボ有効オン) がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F0207": {
    "description": "機能 DI (サーボ有効オフ) がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (サーボ有効オフ) がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F0208": {
    "description": "機能 DI (第 1 オーバーライド モードに入る) がトリガーされる",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (第 1 オーバーライド モードに入る) がトリガーされる",
    "isShowConfirm": "0"
  },
  "0x10F0209": {
    "description": "機能 DI (2 次オーバーライド モードに入る) がトリガーされる",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (2 次オーバーライド モードに入る) がトリガーされる",
    "isShowConfirm": "0"
  },
  "0x10F020A": {
    "description": "機能 DI (保護停止への移行) がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (保護停止への移行) がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F020B": {
    "description": "ファンクションDI（初期位置復帰）発動",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ファンクションDI（初期位置復帰）発動",
    "isShowConfirm": "0"
  },
  "0x10F020C": {
    "description": "ファンクション DI（衝突をクリア）がトリガーされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ファンクション DI（衝突をクリア）がトリガーされました",
    "isShowConfirm": "0"
  },
  "0x10F020D": {
    "description": "機能 DI (Enter Drag Mode) のトリガー",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (Enter Drag Mode) のトリガー",
    "isShowConfirm": "0"
  },
  "0x10F020E": {
    "description": "関数 DI (ドラッグ モードの終了) のトリガー",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "関数 DI (ドラッグ モードの終了) のトリガー",
    "isShowConfirm": "0"
  },
  "0x10F020F": {
    "description": "機能 DI (プログラムの停止またはプログラムの中断) がトリガーされました。(プログラムの実行) を実行しないでください",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (プログラムの停止またはプログラムの中断) がトリガーされました。(プログラムの実行) を実行しないでください",
    "isShowConfirm": "1"
  },
  "0x10F0210": {
    "description": "関数 DI (プログラムの一時停止) がトリガーされ、(プログラムの再開) は実行されません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "関数 DI (プログラムの一時停止) がトリガーされ、(プログラムの再開) は実行されません",
    "isShowConfirm": "1"
  },
  "0x10F0211": {
    "description": "機能 DI (電源オフ) がトリガーされ、 (電源オン) は実行されません",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (電源オフ) がトリガーされ、 (電源オン) は実行されません",
    "isShowConfirm": "1"
  },
  "0x10F0212": {
    "description": "機能 DI (Enable Down) がトリガーされました。(Enable Up) は実行しないでください",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DI (Enable Down) がトリガーされました。(Enable Up) は実行しないでください",
    "isShowConfirm": "1"
  },
  "0x10F0220": {
    "description": "機能DO（ジョブアイドル）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（ジョブアイドル）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0221": {
    "description": "機能 DO（ジョブアイドル）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ジョブアイドル）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0222": {
    "description": "機能 DO（ジョブプログラム一時停止）設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ジョブプログラム一時停止）設定",
    "isShowConfirm": "0"
  },
  "0x10F0223": {
    "description": "機能 DO（ジョブプログラム一時停止）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ジョブプログラム一時停止）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0224": {
    "description": "機能 DO（ワークプログラム実行）設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ワークプログラム実行）設定",
    "isShowConfirm": "0"
  },
  "0x10F0225": {
    "description": "機能 DO（作業プログラム実行中）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（作業プログラム実行中）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0226": {
    "description": "機能DO（制御系異常）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（制御系異常）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0227": {
    "description": "機能 DO（制御系異常）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（制御系異常）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0228": {
    "description": "機能 DO（ロボット電源オン）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット電源オン）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0229": {
    "description": "機能 DO (ロボット電源オン) リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO (ロボット電源オン) リセット",
    "isShowConfirm": "0"
  },
  "0x10F022A": {
    "description": "機能DO（サーボイネーブルON）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（サーボイネーブルON）を設定",
    "isShowConfirm": "0"
  },
  "0x10F022B": {
    "description": "機能 DO（サーボイネーブルオン）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（サーボイネーブルオン）リセット",
    "isShowConfirm": "0"
  },
  "0x10F022C": {
    "description": "機能DO（ロボットインモーション）セット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（ロボットインモーション）セット",
    "isShowConfirm": "0"
  },
  "0x10F022D": {
    "description": "機能 DO（ロボット動作中）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット動作中）リセット",
    "isShowConfirm": "0"
  },
  "0x10F022E": {
    "description": "機能DO（ロボット固定）セット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（ロボット固定）セット",
    "isShowConfirm": "0"
  },
  "0x10F022F": {
    "description": "機能 DO（ロボット固定）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット固定）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0230": {
    "description": "機能DO（制御系レディ）の設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（制御系レディ）の設定",
    "isShowConfirm": "0"
  },
  "0x10F0231": {
    "description": "機能 DO（制御系レディ）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（制御系レディ）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0232": {
    "description": "機能 DO（ロボット非常停止）設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット非常停止）設定",
    "isShowConfirm": "0"
  },
  "0x10F0233": {
    "description": "機能 DO（ロボット非常停止）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット非常停止）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0234": {
    "description": "機能 DO (ロボットは二次オーバーライド モード) が設定されています",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO (ロボットは二次オーバーライド モード) が設定されています",
    "isShowConfirm": "0"
  },
  "0x10F0235": {
    "description": "機能 DO（二次オーバーライドモードのロボット）のリセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（二次オーバーライドモードのロボット）のリセット",
    "isShowConfirm": "0"
  },
  "0x10F0236": {
    "description": "機能 DO（ロボット急停止）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット急停止）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0237": {
    "description": "機能 DO（ロボット急停止）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット急停止）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0238": {
    "description": "機能DO（ロボット初期位置）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能DO（ロボット初期位置）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0239": {
    "description": "機能 DO（ロボット初期位置）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO（ロボット初期位置）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0240": {
    "description": "機能 DO (ロボットは一次オーバーライド モード) の設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO (ロボットは一次オーバーライド モード) の設定",
    "isShowConfirm": "0"
  },
  "0x10F0241": {
    "description": "機能 DO (ロボットは一次オーバーライド モード) リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "機能 DO (ロボットは一次オーバーライド モード) リセット",
    "isShowConfirm": "0"
  },
  "0x10F0250": {
    "description": "安全機能 DI（追加非常停止）作動",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI（追加非常停止）作動",
    "isShowConfirm": "0"
  },
  "0x10F0251": {
    "description": "安全機能 DI (追加の保護停止) が作動",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI (追加の保護停止) が作動",
    "isShowConfirm": "0"
  },
  "0x10F0252": {
    "description": "安全機能 DI（保護停止リセット）作動",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI（保護停止リセット）作動",
    "isShowConfirm": "0"
  },
  "0x10F0253": {
    "description": "安全機能 DI（Reduced Mode）作動",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI（Reduced Mode）作動",
    "isShowConfirm": "0"
  },
  "0x10F0254": {
    "description": "安全機能 DI (3 ポジション イネーブル) がトリガされました",
    "type": "2",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI (3 ポジション イネーブル) がトリガされました",
    "isShowConfirm": "1"
  },
  "0x10F0255": {
    "description": "安全機能 DI （衝突感度レベル0の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル0の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F0256": {
    "description": "安全機能 DI （衝突感度レベル1の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル1の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F0257": {
    "description": "安全機能 DI （衝突感度レベル2の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル2の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F0258": {
    "description": "安全機能 DI （衝突感度レベル3の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル3の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F0259": {
    "description": "安全機能 DI （衝突感度レベル4の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル4の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F025A": {
    "description": "安全機能 DI （衝突感度レベル5の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル5の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F025B": {
    "description": "安全機能 DI （衝突感度レベル7の設定） がトリガされました",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DI （衝突感度レベル7の設定） がトリガされました",
    "isShowConfirm": "0"
  },
  "0x10F025C": {
    "description": "安全機能DI（保護停止）が作動しました。",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DI（保護停止）が作動しました。",
    "isShowConfirm": "0"
  },
  "0x10F0260": {
    "description": "安全機能DO（押しボタンによる非常停止）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（押しボタンによる非常停止）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0261": {
    "description": "安全機能 DO（ボタン非常停止作動）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DO（ボタン非常停止作動）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0262": {
    "description": "安全機能DO（システム非常停止トリガ）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（システム非常停止トリガ）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0263": {
    "description": "安全機能 DO（システム非常停止トリガ）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DO（システム非常停止トリガ）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0264": {
    "description": "安全機能DO（ロボット急停止）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（ロボット急停止）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0265": {
    "description": "安全機能 DO（ロボット急停止）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DO（ロボット急停止）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0266": {
    "description": "安全機能DO（ロボット動作中）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（ロボット動作中）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0267": {
    "description": "安全機能DO（ロボット動作中）を設定",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（ロボット動作中）を設定",
    "isShowConfirm": "0"
  },
  "0x10F0268": {
    "description": "安全機能DO（ロボットの縮小モード）が設定されている",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能DO（ロボットの縮小モード）が設定されている",
    "isShowConfirm": "0"
  },
  "0x10F0269": {
    "description": "安全機能 DO（ロボット縮退モード）リセット",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "安全機能 DO（ロボット縮退モード）リセット",
    "isShowConfirm": "0"
  },
  "0x10F0280": {
    "description": "動力学パラメータの認識完了",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "動力学パラメータの認識完了",
    "isShowConfirm": "1"
  },
  "0x10F0281": {
    "description": "摩擦力パラメータの認識完了",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "摩擦力パラメータの認識完了",
    "isShowConfirm": "1"
  },
  "0x10F0282": {
    "description": "ライトダイナミクスパラメータが完了し、再起動または再電源オンが有効になります",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "ライトダイナミクスパラメータが完了し、再起動または再電源オンが有効になります",
    "isShowConfirm": "1"
  },
  "0x10F0283": {
    "description": "衝突点は運動開始点に近すぎ、リバウンドパスが安全かどうかを確認できないため、リバウンドが終了する可能性があります",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "衝突バウンスの終了",
    "isShowConfirm": "1"
  },
  "0x10F0284": {
    "description": "衝突点に近づくと、ロボットは停止したり停止したりするので、この衝突でリバウンドは発生しません。",
    "type": "0",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "この衝突にはリバウンドはありません",
    "isShowConfirm": "1"
  },
  "0x10F0285": {
    "description": "制動抵抗起動電圧設定成功しました。\n現在の値は{0}Vです。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "制動抵抗起動電圧設定成功しました。",
    "isShowConfirm": "0"
  },
  "0x10F0286": {
    "description": "プログラムは既に実行中であり、再起動できません。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "",
    "action": "",
    "tittle": "プログラムは既に実行中であり。",
    "isShowConfirm": "0"
  },
  "0x10F0287": {
    "description": "ワンクリック復元が完了しました",
    "type": "1",
    "isShowOTA": "0",
    "reason": "ワンクリック復元が完了しました。パラメータはデフォルト値に復元されました",
    "action": "ワンクリック復元が完了しました",
    "tittle": "ワンクリック復元が完了しました",
    "isShowConfirm": "1"
  },
  "0x10F0300": {
    "description": "ログインの初期化に失敗しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "接続へのログイン時にデータの読み取りに例外があります",
    "action": "1. 現在のソフトウェア APP のバージョンとコントローラのバージョンの間にバージョンの不一致があるかどうかを確認してください。 \n2. ネットワーク接続に異常がないか確認してください。 \n3. ロボットを再接続するか、APP 操作を再起動してください。",
    "tittle": "ログインの初期化に失敗しました",
    "isShowConfirm": "1"
  },
  "0x10F0301": {
    "description": "内部テストバージョンが失効しました",
    "type": "1",
    "isShowOTA": "1",
    "reason": "内部テストバージョンが失効しました",
    "action": "社内テストバージョン、技術者への正式バージョンの更新",
    "tittle": "内部テストバージョンが失効しました",
    "isShowConfirm": "1"
  },
  "0x10F1000": {
    "description": "プログラムの実行速度スケールは現在{1}です",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムの実行速度スケールが{0}に変更されました",
    "action": "",
    "tittle": "ユーザープログラムの実行速度スケールが変更されました",
    "isShowConfirm": "0"
  },
  "0x10F2000": {
    "description": "プログラムの実行が完了しました。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムの実行が完了しました。",
    "action": "プログラムの実行が完了しました。",
    "tittle": "程序运行プログラムの実行が完了しました。完成",
    "isShowConfirm": "0"
  },
  "0x10F2001": {
    "description": "プログラムの実行を中止します。",
    "type": "1",
    "isShowOTA": "0",
    "reason": "プログラムの実行を中止します。",
    "action": "プログラムの実行を中止します。",
    "tittle": "プログラムの実行を中止します。",
    "isShowConfirm": "0"
  }
}
